import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  CountryName: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  GUID: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: any; output: any; }
  MAC: { input: any; output: any; }
  MongoID: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RegExpAsString: { input: any; output: any; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  Upload: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AdherenceCampaignResults = {
  __typename?: 'AdherenceCampaignResults';
  currentCampaign: Maybe<Array<Maybe<MediaChannelStats>>>;
  previousCampaign: Maybe<Array<Maybe<MediaChannelStats>>>;
};

export type AdherenceReviewDealerSummary = {
  __typename?: 'AdherenceReviewDealerSummary';
  bestMediaChannel: Maybe<Scalars['String']['output']>;
  dealershipName: Maybe<Scalars['String']['output']>;
  failed: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  passed: Maybe<Scalars['Int']['output']>;
  topMediaChannel: Maybe<Scalars['String']['output']>;
  zone: Maybe<Scalars['String']['output']>;
};

export type AdherenceRole =
  | 'ADHERENCE_REVIEWER'
  | 'DEVELOPER'
  | 'SUPER_ADMIN';

export type Adherence_Cards = {
  __typename?: 'Adherence_Cards';
  _id: Scalars['MongoID']['output'];
  description: Scalars['String']['output'];
  featured: Scalars['Boolean']['output'];
  image: Maybe<Adherence_CardsImage>;
  key: Scalars['String']['output'];
  language: EnumAdherence_CardsLanguage;
  link_label: Scalars['String']['output'];
  link_url: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  source: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Adherence_CardsImage = {
  __typename?: 'Adherence_CardsImage';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type Adherence_Content = {
  __typename?: 'Adherence_Content';
  _id: Scalars['MongoID']['output'];
  alternatePath: Scalars['String']['output'];
  children: Maybe<Array<Maybe<Adherence_Content>>>;
  content: Scalars['String']['output'];
  itemtype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  language: EnumAdherence_ContentLanguage;
  next: Maybe<Adherence_Content>;
  noContent: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Float']['output'];
  parent: Maybe<Scalars['MongoID']['output']>;
  path: Scalars['String']['output'];
  pathFr: Maybe<Scalars['String']['output']>;
  previous: Maybe<Adherence_Content>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleFr: Maybe<Scalars['String']['output']>;
};

export type Adherence_Criteria = {
  __typename?: 'Adherence_Criteria';
  _id: Scalars['MongoID']['output'];
  category: Scalars['String']['output'];
  category_order: Scalars['Float']['output'];
  correct_response: Scalars['String']['output'];
  criteria_image: Maybe<Scalars['String']['output']>;
  fail_response: Maybe<Scalars['String']['output']>;
  media_channels: Array<Maybe<Scalars['String']['output']>>;
  periods: Array<Maybe<Scalars['String']['output']>>;
  question: Scalars['String']['output'];
  question_dependencies: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  question_key: Scalars['String']['output'];
  question_order: Scalars['Float']['output'];
};

export type Adherence_Reviews = {
  __typename?: 'Adherence_Reviews';
  _id: Scalars['MongoID']['output'];
  answerState: Maybe<Scalars['JSON']['output']>;
  campaign: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  dealershipId: Maybe<Scalars['String']['output']>;
  dealershipName: Maybe<Scalars['String']['output']>;
  feedback: Maybe<Scalars['String']['output']>;
  invoiceNumber: Maybe<Scalars['String']['output']>;
  mediaChannel: Maybe<Scalars['String']['output']>;
  mediaFilename: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  stats: Maybe<ReviewPassStats>;
  submittedDate: Maybe<Scalars['Date']['output']>;
  updatedAt: Maybe<Scalars['Date']['output']>;
  vendor: Maybe<Scalars['String']['output']>;
  zone: Maybe<Scalars['String']['output']>;
};

export type Adherence_Submissions = {
  __typename?: 'Adherence_Submissions';
  _id: Scalars['MongoID']['output'];
  accepted: Maybe<Scalars['String']['output']>;
  activity: Maybe<Scalars['String']['output']>;
  attachments: Maybe<Array<Maybe<Adherence_SubmissionsAttachments>>>;
  audience: Maybe<Scalars['String']['output']>;
  campaign: Maybe<Scalars['String']['output']>;
  carModel: Maybe<Scalars['String']['output']>;
  claimMonth: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['Date']['output']>;
  criteria: Maybe<Array<Maybe<Adherence_Criteria>>>;
  currency: Maybe<Scalars['String']['output']>;
  dealerContribution: Maybe<Scalars['Float']['output']>;
  dealershipId: Maybe<Scalars['Float']['output']>;
  dealershipName: Maybe<Scalars['String']['output']>;
  districts: Maybe<Scalars['String']['output']>;
  documentNumber: Maybe<Scalars['String']['output']>;
  feedback: Maybe<Scalars['String']['output']>;
  history: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  invoiceNumber: Maybe<Scalars['String']['output']>;
  lastUpdated: Maybe<Scalars['Date']['output']>;
  mediaChannel: Maybe<Scalars['String']['output']>;
  paymentDate: Maybe<Scalars['String']['output']>;
  paymentDateYearMonth: Maybe<Scalars['String']['output']>;
  period: Maybe<Scalars['String']['output']>;
  program: Maybe<Scalars['String']['output']>;
  qtAdjBudget: Maybe<Scalars['Float']['output']>;
  region: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  requestedPerDealership: Maybe<Scalars['Float']['output']>;
  reviewed: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<Scalars['String']['output']>;
  totalCost: Maybe<Scalars['Float']['output']>;
  updatedAt: Maybe<Scalars['Date']['output']>;
};

export type Adherence_SubmissionsAttachments = {
  __typename?: 'Adherence_SubmissionsAttachments';
  _id: Maybe<Scalars['MongoID']['output']>;
  filename: Maybe<Scalars['String']['output']>;
  filesize: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['String']['output']>;
  preview: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};


export type Adherence_SubmissionsAttachmentsUrlArgs = {
  requestId: InputMaybe<Scalars['String']['input']>;
};

export type Adherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

/** List of items with pagination. */
export type Adherence_SubmissionsPagination = {
  __typename?: 'Adherence_SubmissionsPagination';
  /** Total object count. */
  count: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items: Maybe<Array<Adherence_Submissions>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Answer = {
  __typename?: 'Answer';
  answer: Maybe<Scalars['Int']['output']>;
  comments: Maybe<Scalars['String']['output']>;
  comments_fr: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  question: Question;
  screenshots: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type AnswerQuestionArgs = {
  assessmentCode: Scalars['String']['input'];
};

export type AssessmentDetails = {
  __typename?: 'AssessmentDetails';
  categories: Array<Category>;
  code: Scalars['String']['output'];
  date: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  title_fr: Maybe<Scalars['String']['output']>;
};

export type AssessmentSummaryGroup = {
  __typename?: 'AssessmentSummaryGroup';
  assessment_code: Scalars['String']['output'];
  assessment_label: Maybe<Scalars['String']['output']>;
  assessment_label_fr: Maybe<Scalars['String']['output']>;
  best_category: CategorySummary;
  category_scores: Array<CategorySummary>;
  final_score: Scalars['Float']['output'];
  group_id: Scalars['String']['output'];
  improvement_category: CategorySummary;
  max_score: Scalars['Int']['output'];
  percent_in_group: Scalars['Float']['output'];
  preferred_vendor: Maybe<Scalars['Boolean']['output']>;
  review_category_responses: Array<Category>;
  review_details: Maybe<AssessmentSummaryOld>;
  total_score: Scalars['Int']['output'];
  units_in_group: Scalars['Int']['output'];
  units_in_rank: RankCount;
  units_in_total: Scalars['Int']['output'];
};

export type AssessmentSummaryGroupPreQuery = {
  __typename?: 'AssessmentSummaryGroupPreQuery';
  edges: Array<AssessmentSummaryGroup>;
  meta: Maybe<Meta>;
};

export type AssessmentSummaryOld = {
  __typename?: 'AssessmentSummaryOld';
  date: Scalars['String']['output'];
  district_code: Scalars['String']['output'];
  district_label: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  preferred_vendor: Maybe<Scalars['Boolean']['output']>;
  region_code: Scalars['String']['output'];
  region_label: Scalars['String']['output'];
  reviewer_name: Scalars['String']['output'];
  unit_code: Scalars['String']['output'];
  unit_name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  vendor_name: Scalars['String']['output'];
};

export type Assessment_Summary = {
  __typename?: 'Assessment_Summary';
  _id: Scalars['MongoID']['output'];
  assessment_code: Scalars['String']['output'];
  assessment_label: Scalars['String']['output'];
  assessment_label_fr: Scalars['String']['output'];
  category_scores: Array<Maybe<Assessment_SummaryCategory_Scores>>;
  date: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  final_score: Scalars['Float']['output'];
  max_score: Scalars['Float']['output'];
  preferred_vendor: Maybe<Scalars['Boolean']['output']>;
  reviewer_name: Scalars['String']['output'];
  segment_0_code: Scalars['String']['output'];
  segment_0_label: Scalars['String']['output'];
  segment_1_code: Scalars['String']['output'];
  segment_1_label: Scalars['String']['output'];
  total_score: Scalars['Float']['output'];
  unit_code: Scalars['String']['output'];
  unit_name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  vendor: Maybe<Vendors>;
  vendor_name: Scalars['String']['output'];
};

export type Assessment_SummaryCategory_Scores = {
  __typename?: 'Assessment_SummaryCategory_scores';
  _id: Maybe<Scalars['MongoID']['output']>;
  category_code: Scalars['String']['output'];
  category_label: Scalars['String']['output'];
  category_label_fr: Scalars['String']['output'];
  final_score: Scalars['Float']['output'];
  max_score: Scalars['Float']['output'];
  total_score: Scalars['Float']['output'];
};

export type Assessments = {
  __typename?: 'Assessments';
  _id: Scalars['MongoID']['output'];
  categories: Array<Maybe<Scalars['String']['output']>>;
  categoryDetails: Maybe<Array<Maybe<Category>>>;
  code: Scalars['String']['output'];
  date: Scalars['String']['output'];
  end_date: Scalars['String']['output'];
  remote_id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  title_fr: Maybe<Scalars['String']['output']>;
};

export type Categories = {
  __typename?: 'Categories';
  _id: Scalars['MongoID']['output'];
  assessment_code: Scalars['String']['output'];
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
  label_fr: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  questions: Array<Maybe<CategoriesQuestions>>;
};

export type CategoriesQuestions = {
  __typename?: 'CategoriesQuestions';
  _id: Maybe<Scalars['MongoID']['output']>;
  improvement_EN: Scalars['String']['output'];
  improvement_FR: Scalars['String']['output'];
  label: Scalars['String']['output'];
  label_french: Scalars['String']['output'];
  layout: EnumCategoriesQuestionsLayout;
  name: Scalars['String']['output'];
  number: Scalars['Float']['output'];
  rationale_EN: Scalars['String']['output'];
  rationale_FR: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  resources: Array<Maybe<CategoriesQuestionsResources>>;
  resources_french: Array<Maybe<CategoriesQuestionsResources>>;
  video_link_EN: Scalars['String']['output'];
  video_link_FR: Scalars['String']['output'];
};

export type CategoriesQuestionsResources = {
  __typename?: 'CategoriesQuestionsResources';
  _id: Maybe<Scalars['MongoID']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  code: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  label_fr: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  review: Maybe<Review>;
};


export type CategoryReviewArgs = {
  assessmentCode: Scalars['String']['input'];
  unitCode: Scalars['String']['input'];
};

export type CategoryScoreAggregate = {
  __typename?: 'CategoryScoreAggregate';
  code: Scalars['String']['output'];
  finalScore: Scalars['Int']['output'];
};

export type CategoryScoreAggregatePackage = {
  __typename?: 'CategoryScoreAggregatePackage';
  best: CategoryScoreAggregate;
  growth: CategoryScoreAggregate;
  scores: Array<CategoryScoreAggregate>;
};

export type CategorySummary = {
  __typename?: 'CategorySummary';
  category_code: Scalars['String']['output'];
  category_label: Scalars['String']['output'];
  category_label_fr: Scalars['String']['output'];
  final_score: Scalars['Float']['output'];
  max_score: Scalars['Int']['output'];
  total_score: Scalars['Int']['output'];
};

export type CoeRole =
  | 'ADMIN'
  | 'DEVELOPER'
  | 'MANAGER'
  | 'READ_ONLY'
  | 'STANDARDS_ONLY'
  | 'SUPER_ADMIN'
  | 'UNIT'
  | 'VENDOR';

export type ComplianceRole =
  | 'BLVD'
  | 'COMMITTEE'
  | 'DEALER'
  | 'HYUNDAI'
  | 'ZONE_MANAGER';

export type ConfigurationType =
  | 'STARTUP';

export type Configurations = {
  __typename?: 'Configurations';
  _id: Scalars['MongoID']['output'];
  district_label_en: Scalars['String']['output'];
  district_label_fr: Scalars['String']['output'];
  maintenance_message_en: Maybe<Scalars['String']['output']>;
  maintenance_message_fr: Maybe<Scalars['String']['output']>;
  oem: EnumConfigurationsOem;
  region_label_en: Scalars['String']['output'];
  region_label_fr: Scalars['String']['output'];
  type: EnumConfigurationsType;
};

export type Content = {
  __typename?: 'Content';
  _id: Scalars['MongoID']['output'];
  alternatePath: Scalars['String']['output'];
  ancestors: Maybe<Array<Maybe<ContentAncestor>>>;
  children: Maybe<Array<Maybe<Content>>>;
  content: Scalars['String']['output'];
  content_search: Scalars['String']['output'];
  itemtype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  language: EnumContentLanguage;
  next: Maybe<Content>;
  noContent: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Float']['output'];
  parent: Maybe<Scalars['MongoID']['output']>;
  path: Scalars['String']['output'];
  pathFr: Maybe<Scalars['String']['output']>;
  previous: Maybe<Content>;
  status: Scalars['String']['output'];
  tags: Array<Maybe<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  titleFr: Maybe<Scalars['String']['output']>;
  wordpress_id: Scalars['Float']['output'];
};

export type ContentAncestor = {
  __typename?: 'ContentAncestor';
  path: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type ContentOld = {
  __typename?: 'ContentOld';
  alternatePath: Scalars['String']['output'];
  children: Maybe<Array<Maybe<ContentOld>>>;
  content: Scalars['String']['output'];
  itemtype: Scalars['String']['output'];
  key: Scalars['String']['output'];
  nextPath: Scalars['String']['output'];
  nextTitle: Scalars['String']['output'];
  noContent: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  pathFr: Maybe<Scalars['String']['output']>;
  previousPath: Scalars['String']['output'];
  previousTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleFr: Maybe<Scalars['String']['output']>;
};

export type Content_Business_Insights = {
  __typename?: 'Content_Business_Insights';
  _id: Scalars['MongoID']['output'];
  alternate_path: Scalars['String']['output'];
  body: Maybe<Scalars['String']['output']>;
  button_label: Scalars['String']['output'];
  button_link: Scalars['String']['output'];
  categories: Maybe<Array<Maybe<Content_Business_InsightsCategories>>>;
  created_by: Maybe<Scalars['String']['output']>;
  created_date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  hero_image: Maybe<Content_Business_InsightsHero_Image>;
  key: Scalars['String']['output'];
  language: EnumContent_Business_InsightsLanguage;
  legacy_id: Maybe<Scalars['String']['output']>;
  modified_by: Maybe<Scalars['String']['output']>;
  modified_date: Maybe<Scalars['String']['output']>;
  new: Maybe<Scalars['Boolean']['output']>;
  path: Scalars['String']['output'];
  post_date: Maybe<Scalars['String']['output']>;
  preview_image: Content_Business_InsightsPreview_Image;
  title: Scalars['String']['output'];
};

export type Content_Business_InsightsCategories = {
  __typename?: 'Content_Business_InsightsCategories';
  code: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type Content_Business_InsightsHero_Image = {
  __typename?: 'Content_Business_InsightsHero_image';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type Content_Business_InsightsPreview_Image = {
  __typename?: 'Content_Business_InsightsPreview_image';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type Content_Notifications = {
  __typename?: 'Content_Notifications';
  _id: Scalars['MongoID']['output'];
  alternate_path: Scalars['String']['output'];
  button_label: Scalars['String']['output'];
  button_link: Scalars['String']['output'];
  categories: Maybe<Array<Maybe<Content_NotificationsCategories>>>;
  created_by: Maybe<Scalars['String']['output']>;
  created_date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  language: EnumContent_NotificationsLanguage;
  legacy_id: Maybe<Scalars['String']['output']>;
  modified_by: Maybe<Scalars['String']['output']>;
  modified_date: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  post_date: Maybe<Scalars['String']['output']>;
  preview_image: Content_NotificationsPreview_Image;
  title: Scalars['String']['output'];
};

export type Content_NotificationsCategories = {
  __typename?: 'Content_NotificationsCategories';
  code: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type Content_NotificationsPreview_Image = {
  __typename?: 'Content_NotificationsPreview_image';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type Content_Program_Updates = {
  __typename?: 'Content_Program_Updates';
  _id: Scalars['MongoID']['output'];
  alternate_path: Scalars['String']['output'];
  body: Scalars['String']['output'];
  button_label: Scalars['String']['output'];
  button_link: Scalars['String']['output'];
  created_by: Maybe<Scalars['String']['output']>;
  created_date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  hero_image: Content_Program_UpdatesHero_Image;
  important: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  language: EnumContent_Program_UpdatesLanguage;
  legacy_id: Maybe<Scalars['String']['output']>;
  modified_by: Maybe<Scalars['String']['output']>;
  modified_date: Maybe<Scalars['String']['output']>;
  new: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  post_date: Maybe<Scalars['String']['output']>;
  preview_image: Content_Program_UpdatesPreview_Image;
  title: Scalars['String']['output'];
};

export type Content_Program_UpdatesHero_Image = {
  __typename?: 'Content_Program_UpdatesHero_image';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type Content_Program_UpdatesPreview_Image = {
  __typename?: 'Content_Program_UpdatesPreview_image';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type Content_Vendor = {
  __typename?: 'Content_Vendor';
  _id: Scalars['MongoID']['output'];
  cancellation_notice: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  created_by: Maybe<Scalars['String']['output']>;
  created_date: Scalars['String']['output'];
  dedicated_support_team: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  emailHACC: Maybe<Scalars['String']['output']>;
  emailMMSC: Maybe<Scalars['String']['output']>;
  language: EnumContent_VendorLanguage;
  languages: Scalars['String']['output'];
  location: Scalars['String']['output'];
  maximum_price: Scalars['Float']['output'];
  minimum_contract: Maybe<Scalars['String']['output']>;
  minimum_price: Scalars['Float']['output'];
  modified_by: Maybe<Scalars['String']['output']>;
  modified_date: Maybe<Scalars['String']['output']>;
  number_of_employees: Maybe<Scalars['String']['output']>;
  preferred: Maybe<Content_VendorPreferred>;
  service_area: Scalars['String']['output'];
  services: Array<Maybe<Content_VendorServices>>;
  title: Scalars['String']['output'];
  value_added_services: Array<Maybe<Content_VendorValue_Added_Services>>;
  website: Scalars['String']['output'];
  websiteHACC: Maybe<Scalars['String']['output']>;
  websiteMMSC: Maybe<Scalars['String']['output']>;
  years_of_operation: Scalars['String']['output'];
};

export type Content_VendorPreferred = {
  __typename?: 'Content_VendorPreferred';
  DEMO: Maybe<Scalars['Boolean']['output']>;
  HACC: Maybe<Scalars['Boolean']['output']>;
  MMSC: Maybe<Scalars['Boolean']['output']>;
  _id: Maybe<Scalars['MongoID']['output']>;
};

export type Content_VendorServices = {
  __typename?: 'Content_VendorServices';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Content_VendorValue_Added_Services = {
  __typename?: 'Content_VendorValue_added_services';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Content_Webinars = {
  __typename?: 'Content_Webinars';
  _id: Scalars['MongoID']['output'];
  alternate_path: Scalars['String']['output'];
  body: Scalars['String']['output'];
  categories: Maybe<Array<Maybe<Content_WebinarsCategories>>>;
  created_by: Maybe<Scalars['String']['output']>;
  created_date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duration: Maybe<Scalars['Float']['output']>;
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  language: EnumContent_WebinarsLanguage;
  legacy_id: Maybe<Scalars['String']['output']>;
  modified_by: Maybe<Scalars['String']['output']>;
  modified_date: Maybe<Scalars['String']['output']>;
  new: Maybe<Scalars['Boolean']['output']>;
  path: Scalars['String']['output'];
  post_date: Maybe<Scalars['String']['output']>;
  presenter: Maybe<Scalars['String']['output']>;
  preview_image: Content_WebinarsPreview_Image;
  resource_file: Maybe<Scalars['String']['output']>;
  start_time: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  video: Maybe<Content_WebinarsVideo>;
  video_link: Maybe<Scalars['String']['output']>;
};

export type Content_WebinarsCategories = {
  __typename?: 'Content_WebinarsCategories';
  code: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type Content_WebinarsPreview_Image = {
  __typename?: 'Content_WebinarsPreview_image';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type Content_WebinarsVideo = {
  __typename?: 'Content_WebinarsVideo';
  _id: Maybe<Scalars['MongoID']['output']>;
  caption: Maybe<Scalars['String']['output']>;
  src: Maybe<Scalars['String']['output']>;
  thumbnail: Maybe<Content_WebinarsVideoThumbnail>;
};

export type Content_WebinarsVideoThumbnail = {
  __typename?: 'Content_WebinarsVideoThumbnail';
  _id: Maybe<Scalars['MongoID']['output']>;
  alt: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type CreateManyAdherence_ReviewsInput = {
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyAdherence_ReviewsPayload = {
  __typename?: 'CreateManyAdherence_ReviewsPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records: Maybe<Array<Adherence_Reviews>>;
};

export type CreateManyAdherence_SubmissionsInput = {
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<Adherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyAdherence_SubmissionsPayload = {
  __typename?: 'CreateManyAdherence_SubmissionsPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records: Maybe<Array<Adherence_Submissions>>;
};

export type CreateOneAdherence_ReviewsInput = {
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneAdherence_ReviewsPayload = {
  __typename?: 'CreateOneAdherence_ReviewsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Created document */
  record: Maybe<Adherence_Reviews>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneAdherence_SubmissionsInput = {
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<Adherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneAdherence_SubmissionsPayload = {
  __typename?: 'CreateOneAdherence_SubmissionsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Created document */
  record: Maybe<Adherence_Submissions>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneAssessmentsInput = {
  categories: Array<InputMaybe<Scalars['String']['input']>>;
  code: Scalars['String']['input'];
  date: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
  remote_id: Scalars['String']['input'];
  title: Scalars['String']['input'];
  title_fr: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneAssessmentsPayload = {
  __typename?: 'CreateOneAssessmentsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Created document */
  record: Maybe<Assessments>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNotificationTrackingsInput = {
  notification_id: Scalars['String']['input'];
  username: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneNotificationTrackingsPayload = {
  __typename?: 'CreateOneNotificationTrackingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Created document */
  record: Maybe<NotificationTrackings>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneSterlingModulesInput = {
  code: EnumSterlingModulesCode;
  routes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateOneSterlingModulesPayload = {
  __typename?: 'CreateOneSterlingModulesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Created document */
  record: Maybe<SterlingModules>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUsersInput = {
  coe_role: EnumUsersCoe_Role;
  coe_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment: InputMaybe<Scalars['String']['input']>;
  compliance_role: InputMaybe<EnumUsersCompliance_Role>;
  created: InputMaybe<Scalars['Date']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  last_login: InputMaybe<Scalars['String']['input']>;
  last_name: InputMaybe<Scalars['String']['input']>;
  locked: InputMaybe<Scalars['Boolean']['input']>;
  login_type: InputMaybe<EnumUsersLogin_Type>;
  modified: InputMaybe<Scalars['Date']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  module_permissions: InputMaybe<Array<InputMaybe<EnumUsersModule_Permissions>>>;
  oem_access: InputMaybe<Array<InputMaybe<EnumUsersOem_Access>>>;
  password: InputMaybe<Scalars['String']['input']>;
  preferred_language: InputMaybe<EnumUsersPreferred_Language>;
  refresh_token: InputMaybe<Scalars['String']['input']>;
  reviewer_role: InputMaybe<EnumUsersReviewer_Role>;
  reviewer_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumUsersType>;
  username: Scalars['String']['input'];
};

export type CreateOneUsersPayload = {
  __typename?: 'CreateOneUsersPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Created document */
  record: Maybe<Users>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnecompliance_CasesInput = {
  caseId: InputMaybe<Scalars['String']['input']>;
  caseInformation: Array<InputMaybe<Compliance_CasesCaseInformationInput>>;
  history: Array<InputMaybe<Compliance_CasesHistoryInput>>;
  inProgress: Scalars['Boolean']['input'];
  outcome: Enumcompliance_CasesOutcome;
  outcomeDate: InputMaybe<Scalars['String']['input']>;
  repeatCaseIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reported: Compliance_CasesReportedInput;
  reporter: Compliance_CasesReporterInput;
  status: Enumcompliance_CasesStatus;
  statusPrevious: InputMaybe<Enumcompliance_CasesStatusPrevious>;
  statusTransition: InputMaybe<Compliance_CasesStatusTransitionInput>;
  testCase: Scalars['Boolean']['input'];
};

export type CreateOnecompliance_CasesPayload = {
  __typename?: 'CreateOnecompliance_casesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Created document */
  record: Maybe<Compliance_Cases>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type DateTrackedPost = {
  __typename?: 'DateTrackedPost';
  created_date: Scalars['String']['output'];
  modified_date: Scalars['String']['output'];
  post_date: Maybe<Scalars['String']['output']>;
};

export type DealerCodesAndNames = {
  __typename?: 'DealerCodesAndNames';
  dealerName: Maybe<Scalars['String']['output']>;
  firstDivisionCode: Maybe<Scalars['String']['output']>;
  secondDivisionCode: Maybe<Scalars['String']['output']>;
  unitCode: Scalars['String']['output'];
  vendorCode: Maybe<Scalars['String']['output']>;
};

export type DealerReportPanelData = {
  __typename?: 'DealerReportPanelData';
  dealer: Maybe<DealerReportPanelDataDealerField>;
  question: Maybe<Portal_Context_Progress_ReportQuestionsReviewed>;
};

export type DealerReportPanelDataDealerField = {
  __typename?: 'DealerReportPanelDataDealerField';
  assessmentCode: Maybe<Scalars['String']['output']>;
  dealerName: Maybe<Scalars['String']['output']>;
  firstDivisionCode: Maybe<Scalars['String']['output']>;
  secondDivisionCode: Maybe<Scalars['String']['output']>;
  unitCode: Maybe<Scalars['String']['output']>;
  vendorCode: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type DealerStatusReportType = {
  __typename?: 'DealerStatusReportType';
  completed: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  inreview: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  revise: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  todo: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
};

export type DealerTrackingDetails = {
  __typename?: 'DealerTrackingDetails';
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type DeleteFileResponse = {
  __typename?: 'DeleteFileResponse';
  results: Scalars['Boolean']['output'];
};

export type DocumentUpdateResponse = {
  __typename?: 'DocumentUpdateResponse';
  error: Scalars['Boolean']['output'];
  errorDetails: Array<Maybe<ErrorDetail>>;
};

export type EnumAdherence_CardsLanguage =
  | 'EN'
  | 'FR';

export type EnumAdherence_ContentLanguage =
  | 'EN'
  | 'FR';

export type EnumCategoriesQuestionsLayout =
  | 'range'
  | 'standard';

export type EnumConfigurationsOem =
  | 'DEMO'
  | 'HACC'
  | 'MMSC';

export type EnumConfigurationsType =
  | 'STARTUP';

export type EnumContentLanguage =
  | 'EN'
  | 'FR';

export type EnumContent_Business_InsightsLanguage =
  | 'EN'
  | 'FR';

export type EnumContent_NotificationsLanguage =
  | 'EN'
  | 'FR';

export type EnumContent_Program_UpdatesLanguage =
  | 'EN'
  | 'FR';

export type EnumContent_VendorLanguage =
  | 'EN'
  | 'FR';

export type EnumContent_WebinarsLanguage =
  | 'EN'
  | 'FR';

export type EnumPrivate_RoutesRoles =
  | 'LOCAL'
  | 'REMOTE';

export type EnumReporting_ConfigsType =
  | 'UNIT'
  | 'VENDOR';

export type EnumSterlingModulesCode =
  | 'BASE'
  | 'RETAIL';

export type EnumTrackingOem_Codes =
  | 'DEMO'
  | 'HACC'
  | 'MMSC';

export type EnumUsersCoe_Role =
  | 'ADMIN'
  | 'DEVELOPER'
  | 'MANAGER'
  | 'READ_ONLY'
  | 'STANDARDS_ONLY'
  | 'SUPER_ADMIN'
  | 'UNIT'
  | 'VENDOR';

export type EnumUsersCompliance_Role =
  | 'BLVD'
  | 'COMMITTEE'
  | 'DEALER'
  | 'HYUNDAI'
  | 'ZONE_MANAGER';

export type EnumUsersLogin_Type =
  | 'LOCAL'
  | 'REMOTE';

export type EnumUsersModule_Permissions =
  | 'BASE'
  | 'RETAIL';

export type EnumUsersOem_Access =
  | 'DEMO'
  | 'HACC'
  | 'MMSC';

export type EnumUsersPreferred_Language =
  | 'EN'
  | 'FR';

export type EnumUsersReviewer_Role =
  | 'DEVELOPER'
  | 'NONE'
  | 'REVIEWER'
  | 'REVIEWER_ADMIN'
  | 'REVIEWER_MANAGER';

export type EnumUsersType =
  | 'LOCAL'
  | 'REMOTE';

export type Enumcompliance_CasesCaseInformationCategory =
  | 'ADVERTISING'
  | 'OTHER'
  | 'PMA'
  | 'PRICING';

export type Enumcompliance_CasesCaseInformationOngoing =
  | 'NO'
  | 'UNSURE'
  | 'YES';

export type Enumcompliance_CasesHistoryStatus =
  | 'ASSISTANCE'
  | 'CLOSED'
  | 'ESCALATED'
  | 'IN_REVIEW'
  | 'RETURNED'
  | 'SUBMITTED';

export type Enumcompliance_CasesOutcome =
  | 'ABSOLVED'
  | 'UNDETERMINED'
  | 'VIOLATION';

export type Enumcompliance_CasesStatus =
  | 'ASSISTANCE'
  | 'CLOSED'
  | 'ESCALATED'
  | 'IN_REVIEW'
  | 'RETURNED'
  | 'SUBMITTED';

export type Enumcompliance_CasesStatusPrevious =
  | 'ASSISTANCE'
  | 'CLOSED'
  | 'ESCALATED'
  | 'IN_REVIEW'
  | 'RETURNED'
  | 'SUBMITTED';

export type Enumcompliance_CasesStatusTransitionFrom =
  | 'ASSISTANCE'
  | 'CLOSED'
  | 'ESCALATED'
  | 'IN_REVIEW'
  | 'RETURNED'
  | 'SUBMITTED';

export type Enumcompliance_CasesStatusTransitionTo =
  | 'ASSISTANCE'
  | 'CLOSED'
  | 'ESCALATED'
  | 'IN_REVIEW'
  | 'RETURNED'
  | 'SUBMITTED';

export type Enumlighthouse_AggregateOem =
  | 'FORD'
  | 'HACC'
  | 'KIA'
  | 'MMSC'
  | 'TOYOTA';

export type Enumportal_Context_Progress_ReportQuestionsReviewedAssigned =
  | 'blvd'
  | 'dealer'
  | 'vendor';

export type Enumportal_Context_Progress_ReportQuestionsReviewedPriority =
  | 'CRITICAL'
  | 'EVOLVED'
  | 'FUNDAMENTAL'
  | 'PROGRESSIVE'
  | 'SIGNIFICANT';

export type Enumportal_Context_Progress_ReportQuestionsReviewedStatus =
  | 'completed'
  | 'inreview'
  | 'revise'
  | 'todo';

export type Enumportal_Context_QuestionsDataLayout =
  | 'range'
  | 'standard';

export type Enumportal_Context_QuestionsLanguageCode =
  | 'EN'
  | 'FR';

export type Enumportal_Context_ResponsesAssigned =
  | 'blvd'
  | 'dealer'
  | 'vendor';

export type Enumportal_Context_ResponsesStatus =
  | 'completed'
  | 'inreview'
  | 'revise'
  | 'todo';

export type Enumportal_Context_ResponsesVendorStatus =
  | 'approved'
  | 'preferred';

export type Enumportal_Context_VendorsDataVendorStatus =
  | 'approved'
  | 'preferred';

export type ErrorDetail = {
  __typename?: 'ErrorDetail';
  field: Maybe<Scalars['String']['output']>;
  message_en: Scalars['String']['output'];
  message_fr: Scalars['String']['output'];
};

export type ErrorInterface = {
  /** Generic error message */
  message: Maybe<Scalars['String']['output']>;
};

export type ExecutiveSummary = {
  __typename?: 'ExecutiveSummary';
  category_code: Scalars['String']['output'];
  category_label_EN: Scalars['String']['output'];
  category_label_FR: Scalars['String']['output'];
  category_number: Scalars['Int']['output'];
  question_label_EN: Scalars['String']['output'];
  question_label_FR: Scalars['String']['output'];
  question_name: Scalars['String']['output'];
  question_number: Scalars['Int']['output'];
  response_count: ResponseAnalysis;
  response_percent: ResponseAnalysis;
};

export type FilterBy =
  | 'ASSESSMENT_CODE'
  | 'DISTRICT_CODE'
  | 'ENABLED'
  | 'PREFERRED_VENDOR'
  | 'REGION_CODE'
  | 'REVIEWER_NAME'
  | 'UNIT_CODE'
  | 'UNIT_NAME'
  | 'VENDOR_NAME';

export type FilterCountAdherence_CriteriaInput = {
  AND: InputMaybe<Array<FilterCountAdherence_CriteriaInput>>;
  OR: InputMaybe<Array<FilterCountAdherence_CriteriaInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterCountAdherence_CriteriaOperatorsInput>;
  category: InputMaybe<Scalars['String']['input']>;
  category_order: InputMaybe<Scalars['Float']['input']>;
  correct_response: InputMaybe<Scalars['String']['input']>;
  criteria_image: InputMaybe<Scalars['String']['input']>;
  fail_response: InputMaybe<Scalars['String']['input']>;
  media_channels: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question: InputMaybe<Scalars['String']['input']>;
  question_dependencies: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_key: InputMaybe<Scalars['String']['input']>;
  question_order: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAdherence_CriteriaOperatorsInput = {
  _id: InputMaybe<FilterCountAdherence_Criteria_IdOperatorsInput>;
};

export type FilterCountAdherence_Criteria_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountAdherence_ReviewsInput = {
  AND: InputMaybe<Array<FilterCountAdherence_ReviewsInput>>;
  OR: InputMaybe<Array<FilterCountAdherence_ReviewsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterCountAdherence_ReviewsOperatorsInput>;
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAdherence_ReviewsOperatorsInput = {
  _id: InputMaybe<FilterCountAdherence_Reviews_IdOperatorsInput>;
  requestId: InputMaybe<FilterCountAdherence_ReviewsRequestIdOperatorsInput>;
};

export type FilterCountAdherence_ReviewsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountAdherence_Reviews_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountAdherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountAdherence_SubmissionsCreatedAtOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountAdherence_SubmissionsInput = {
  AND: InputMaybe<Array<FilterCountAdherence_SubmissionsInput>>;
  OR: InputMaybe<Array<FilterCountAdherence_SubmissionsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterCountAdherence_SubmissionsOperatorsInput>;
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<FilterCountAdherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountAdherence_SubmissionsOperatorsInput = {
  _id: InputMaybe<FilterCountAdherence_Submissions_IdOperatorsInput>;
  createdAt: InputMaybe<FilterCountAdherence_SubmissionsCreatedAtOperatorsInput>;
  requestId: InputMaybe<FilterCountAdherence_SubmissionsRequestIdOperatorsInput>;
};

export type FilterCountAdherence_SubmissionsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountAdherence_Submissions_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAdherence_CardsImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAdherence_CardsInput = {
  AND: InputMaybe<Array<FilterFindManyAdherence_CardsInput>>;
  OR: InputMaybe<Array<FilterFindManyAdherence_CardsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyAdherence_CardsOperatorsInput>;
  description: InputMaybe<Scalars['String']['input']>;
  featured: InputMaybe<Scalars['Boolean']['input']>;
  image: InputMaybe<FilterFindManyAdherence_CardsImageInput>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumAdherence_CardsLanguage>;
  link_label: InputMaybe<Scalars['String']['input']>;
  link_url: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Scalars['Float']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAdherence_CardsOperatorsInput = {
  _id: InputMaybe<FilterFindManyAdherence_Cards_IdOperatorsInput>;
  order: InputMaybe<FilterFindManyAdherence_CardsOrderOperatorsInput>;
  title: InputMaybe<FilterFindManyAdherence_CardsTitleOperatorsInput>;
};

export type FilterFindManyAdherence_CardsOrderOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdherence_CardsTitleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAdherence_Cards_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAdherence_ContentContentOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAdherence_ContentInput = {
  AND: InputMaybe<Array<FilterFindManyAdherence_ContentInput>>;
  OR: InputMaybe<Array<FilterFindManyAdherence_ContentInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyAdherence_ContentOperatorsInput>;
  alternatePath: InputMaybe<Scalars['String']['input']>;
  content: InputMaybe<Scalars['String']['input']>;
  itemtype: InputMaybe<Scalars['String']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumAdherence_ContentLanguage>;
  order: InputMaybe<Scalars['Float']['input']>;
  parent: InputMaybe<Scalars['MongoID']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  pathFr: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  titleFr: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAdherence_ContentOperatorsInput = {
  _id: InputMaybe<FilterFindManyAdherence_Content_IdOperatorsInput>;
  content: InputMaybe<FilterFindManyAdherence_ContentContentOperatorsInput>;
  order: InputMaybe<FilterFindManyAdherence_ContentOrderOperatorsInput>;
  title: InputMaybe<FilterFindManyAdherence_ContentTitleOperatorsInput>;
};

export type FilterFindManyAdherence_ContentOrderOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAdherence_ContentTitleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAdherence_Content_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAdherence_CriteriaInput = {
  AND: InputMaybe<Array<FilterFindManyAdherence_CriteriaInput>>;
  OR: InputMaybe<Array<FilterFindManyAdherence_CriteriaInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyAdherence_CriteriaOperatorsInput>;
  category: InputMaybe<Scalars['String']['input']>;
  category_order: InputMaybe<Scalars['Float']['input']>;
  correct_response: InputMaybe<Scalars['String']['input']>;
  criteria_image: InputMaybe<Scalars['String']['input']>;
  fail_response: InputMaybe<Scalars['String']['input']>;
  media_channels: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question: InputMaybe<Scalars['String']['input']>;
  question_dependencies: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_key: InputMaybe<Scalars['String']['input']>;
  question_order: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAdherence_CriteriaOperatorsInput = {
  _id: InputMaybe<FilterFindManyAdherence_Criteria_IdOperatorsInput>;
};

export type FilterFindManyAdherence_Criteria_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAdherence_ReviewsInput = {
  AND: InputMaybe<Array<FilterFindManyAdherence_ReviewsInput>>;
  OR: InputMaybe<Array<FilterFindManyAdherence_ReviewsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyAdherence_ReviewsOperatorsInput>;
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAdherence_ReviewsOperatorsInput = {
  _id: InputMaybe<FilterFindManyAdherence_Reviews_IdOperatorsInput>;
  requestId: InputMaybe<FilterFindManyAdherence_ReviewsRequestIdOperatorsInput>;
};

export type FilterFindManyAdherence_ReviewsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAdherence_Reviews_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAdherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyAdherence_SubmissionsCreatedAtOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyAdherence_SubmissionsInput = {
  AND: InputMaybe<Array<FilterFindManyAdherence_SubmissionsInput>>;
  OR: InputMaybe<Array<FilterFindManyAdherence_SubmissionsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyAdherence_SubmissionsOperatorsInput>;
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<FilterFindManyAdherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAdherence_SubmissionsOperatorsInput = {
  _id: InputMaybe<FilterFindManyAdherence_Submissions_IdOperatorsInput>;
  createdAt: InputMaybe<FilterFindManyAdherence_SubmissionsCreatedAtOperatorsInput>;
  requestId: InputMaybe<FilterFindManyAdherence_SubmissionsRequestIdOperatorsInput>;
};

export type FilterFindManyAdherence_SubmissionsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAdherence_Submissions_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssessment_SummaryAssessment_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAssessment_SummaryCategory_ScoresInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  category_code: InputMaybe<Scalars['String']['input']>;
  category_label: InputMaybe<Scalars['String']['input']>;
  category_label_fr: InputMaybe<Scalars['String']['input']>;
  final_score: InputMaybe<Scalars['Float']['input']>;
  max_score: InputMaybe<Scalars['Float']['input']>;
  total_score: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyAssessment_SummaryInput = {
  AND: InputMaybe<Array<FilterFindManyAssessment_SummaryInput>>;
  OR: InputMaybe<Array<FilterFindManyAssessment_SummaryInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyAssessment_SummaryOperatorsInput>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  assessment_label: InputMaybe<Scalars['String']['input']>;
  assessment_label_fr: InputMaybe<Scalars['String']['input']>;
  category_scores: InputMaybe<Array<InputMaybe<FilterFindManyAssessment_SummaryCategory_ScoresInput>>>;
  date: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  final_score: InputMaybe<Scalars['Float']['input']>;
  max_score: InputMaybe<Scalars['Float']['input']>;
  preferred_vendor: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_name: InputMaybe<Scalars['String']['input']>;
  segment_0_code: InputMaybe<Scalars['String']['input']>;
  segment_0_label: InputMaybe<Scalars['String']['input']>;
  segment_1_code: InputMaybe<Scalars['String']['input']>;
  segment_1_label: InputMaybe<Scalars['String']['input']>;
  total_score: InputMaybe<Scalars['Float']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  unit_name: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
  vendor_name: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssessment_SummaryOperatorsInput = {
  _id: InputMaybe<FilterFindManyAssessment_Summary_IdOperatorsInput>;
  assessment_code: InputMaybe<FilterFindManyAssessment_SummaryAssessment_CodeOperatorsInput>;
  preferred_vendor: InputMaybe<FilterFindManyAssessment_SummaryPreferred_VendorOperatorsInput>;
  total_score: InputMaybe<FilterFindManyAssessment_SummaryTotal_ScoreOperatorsInput>;
  unit_code: InputMaybe<FilterFindManyAssessment_SummaryUnit_CodeOperatorsInput>;
  vendor_name: InputMaybe<FilterFindManyAssessment_SummaryVendor_NameOperatorsInput>;
};

export type FilterFindManyAssessment_SummaryPreferred_VendorOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindManyAssessment_SummaryTotal_ScoreOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyAssessment_SummaryUnit_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAssessment_SummaryVendor_NameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAssessment_Summary_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAssessmentsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAssessmentsDateOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyAssessmentsInput = {
  AND: InputMaybe<Array<FilterFindManyAssessmentsInput>>;
  OR: InputMaybe<Array<FilterFindManyAssessmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyAssessmentsOperatorsInput>;
  categories: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: InputMaybe<Scalars['String']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['String']['input']>;
  remote_id: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_fr: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyAssessmentsOperatorsInput = {
  _id: InputMaybe<FilterFindManyAssessments_IdOperatorsInput>;
  code: InputMaybe<FilterFindManyAssessmentsCodeOperatorsInput>;
  date: InputMaybe<FilterFindManyAssessmentsDateOperatorsInput>;
};

export type FilterFindManyAssessments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCategoriesAssessment_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCategoriesCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyCategoriesInput = {
  AND: InputMaybe<Array<FilterFindManyCategoriesInput>>;
  OR: InputMaybe<Array<FilterFindManyCategoriesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyCategoriesOperatorsInput>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  label_fr: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Scalars['Float']['input']>;
  questions: InputMaybe<Array<InputMaybe<FilterFindManyCategoriesQuestionsInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCategoriesOperatorsInput = {
  _id: InputMaybe<FilterFindManyCategories_IdOperatorsInput>;
  assessment_code: InputMaybe<FilterFindManyCategoriesAssessment_CodeOperatorsInput>;
  code: InputMaybe<FilterFindManyCategoriesCodeOperatorsInput>;
};

export type FilterFindManyCategoriesQuestionsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  improvement_EN: InputMaybe<Scalars['String']['input']>;
  improvement_FR: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  label_french: InputMaybe<Scalars['String']['input']>;
  layout: InputMaybe<EnumCategoriesQuestionsLayout>;
  name: InputMaybe<Scalars['String']['input']>;
  number: InputMaybe<Scalars['Float']['input']>;
  rationale_EN: InputMaybe<Scalars['String']['input']>;
  rationale_FR: InputMaybe<Scalars['String']['input']>;
  required: InputMaybe<Scalars['Boolean']['input']>;
  resources: InputMaybe<Array<InputMaybe<FilterFindManyCategoriesQuestionsResourcesInput>>>;
  resources_french: InputMaybe<Array<InputMaybe<FilterFindManyCategoriesQuestionsResourcesInput>>>;
  video_link_EN: InputMaybe<Scalars['String']['input']>;
  video_link_FR: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyCategoriesQuestionsResourcesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FilterFindManyCategories_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContentAncestorsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  wordpress_id: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyContentContentOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContentContent_SearchOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContentInput = {
  AND: InputMaybe<Array<FilterFindManyContentInput>>;
  OR: InputMaybe<Array<FilterFindManyContentInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyContentOperatorsInput>;
  alternatePath: InputMaybe<Scalars['String']['input']>;
  ancestors: InputMaybe<Array<InputMaybe<FilterFindManyContentAncestorsInput>>>;
  content: InputMaybe<Scalars['String']['input']>;
  content_search: InputMaybe<Scalars['String']['input']>;
  itemtype: InputMaybe<Scalars['String']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContentLanguage>;
  order: InputMaybe<Scalars['Float']['input']>;
  parent: InputMaybe<Scalars['MongoID']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  pathFr: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  titleFr: InputMaybe<Scalars['String']['input']>;
  wordpress_id: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContentOperatorsInput = {
  _id: InputMaybe<FilterFindManyContent_IdOperatorsInput>;
  content: InputMaybe<FilterFindManyContentContentOperatorsInput>;
  content_search: InputMaybe<FilterFindManyContentContent_SearchOperatorsInput>;
  title: InputMaybe<FilterFindManyContentTitleOperatorsInput>;
};

export type FilterFindManyContentTitleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyContent_Business_InsightsCategoriesInput = {
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Business_InsightsHero_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Business_InsightsInput = {
  AND: InputMaybe<Array<FilterFindManyContent_Business_InsightsInput>>;
  OR: InputMaybe<Array<FilterFindManyContent_Business_InsightsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyContent_Business_InsightsOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  body: InputMaybe<Scalars['String']['input']>;
  button_label: InputMaybe<Scalars['String']['input']>;
  button_link: InputMaybe<Scalars['String']['input']>;
  categories: InputMaybe<Array<InputMaybe<FilterFindManyContent_Business_InsightsCategoriesInput>>>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  hero_image: InputMaybe<FilterFindManyContent_Business_InsightsHero_ImageInput>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_Business_InsightsLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  new: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindManyContent_Business_InsightsPreview_ImageInput>;
  title: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContent_Business_InsightsOperatorsInput = {
  _id: InputMaybe<FilterFindManyContent_Business_Insights_IdOperatorsInput>;
};

export type FilterFindManyContent_Business_InsightsPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Business_Insights_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContent_NotificationsCategoriesInput = {
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_NotificationsInput = {
  AND: InputMaybe<Array<FilterFindManyContent_NotificationsInput>>;
  OR: InputMaybe<Array<FilterFindManyContent_NotificationsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyContent_NotificationsOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  button_label: InputMaybe<Scalars['String']['input']>;
  button_link: InputMaybe<Scalars['String']['input']>;
  categories: InputMaybe<Array<InputMaybe<FilterFindManyContent_NotificationsCategoriesInput>>>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_NotificationsLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindManyContent_NotificationsPreview_ImageInput>;
  title: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContent_NotificationsOperatorsInput = {
  _id: InputMaybe<FilterFindManyContent_Notifications_IdOperatorsInput>;
};

export type FilterFindManyContent_NotificationsPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Notifications_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContent_Program_UpdatesHero_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Program_UpdatesInput = {
  AND: InputMaybe<Array<FilterFindManyContent_Program_UpdatesInput>>;
  OR: InputMaybe<Array<FilterFindManyContent_Program_UpdatesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyContent_Program_UpdatesOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  body: InputMaybe<Scalars['String']['input']>;
  button_label: InputMaybe<Scalars['String']['input']>;
  button_link: InputMaybe<Scalars['String']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  hero_image: InputMaybe<FilterFindManyContent_Program_UpdatesHero_ImageInput>;
  important: InputMaybe<Scalars['Boolean']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_Program_UpdatesLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  new: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindManyContent_Program_UpdatesPreview_ImageInput>;
  title: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContent_Program_UpdatesOperatorsInput = {
  _id: InputMaybe<FilterFindManyContent_Program_Updates_IdOperatorsInput>;
};

export type FilterFindManyContent_Program_UpdatesPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Program_Updates_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContent_VendorInput = {
  AND: InputMaybe<Array<FilterFindManyContent_VendorInput>>;
  OR: InputMaybe<Array<FilterFindManyContent_VendorInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyContent_VendorOperatorsInput>;
  cancellation_notice: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  dedicated_support_team: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  emailHACC: InputMaybe<Scalars['String']['input']>;
  emailMMSC: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_VendorLanguage>;
  languages: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Scalars['String']['input']>;
  maximum_price: InputMaybe<Scalars['Float']['input']>;
  minimum_contract: InputMaybe<Scalars['String']['input']>;
  minimum_price: InputMaybe<Scalars['Float']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  number_of_employees: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<FilterFindManyContent_VendorPreferredInput>;
  service_area: InputMaybe<Scalars['String']['input']>;
  services: InputMaybe<Array<InputMaybe<FilterFindManyContent_VendorServicesInput>>>;
  title: InputMaybe<Scalars['String']['input']>;
  value_added_services: InputMaybe<Array<InputMaybe<FilterFindManyContent_VendorValue_Added_ServicesInput>>>;
  website: InputMaybe<Scalars['String']['input']>;
  websiteHACC: InputMaybe<Scalars['String']['input']>;
  websiteMMSC: InputMaybe<Scalars['String']['input']>;
  years_of_operation: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContent_VendorOperatorsInput = {
  _id: InputMaybe<FilterFindManyContent_Vendor_IdOperatorsInput>;
};

export type FilterFindManyContent_VendorPreferredInput = {
  DEMO: InputMaybe<Scalars['Boolean']['input']>;
  HACC: InputMaybe<Scalars['Boolean']['input']>;
  MMSC: InputMaybe<Scalars['Boolean']['input']>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyContent_VendorServicesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_VendorValue_Added_ServicesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Vendor_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContent_WebinarsCategoriesInput = {
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_WebinarsInput = {
  AND: InputMaybe<Array<FilterFindManyContent_WebinarsInput>>;
  OR: InputMaybe<Array<FilterFindManyContent_WebinarsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyContent_WebinarsOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  body: InputMaybe<Scalars['String']['input']>;
  categories: InputMaybe<Array<InputMaybe<FilterFindManyContent_WebinarsCategoriesInput>>>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  duration: InputMaybe<Scalars['Float']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_WebinarsLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  new: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  presenter: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindManyContent_WebinarsPreview_ImageInput>;
  resource_file: InputMaybe<Scalars['String']['input']>;
  start_time: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  video: InputMaybe<FilterFindManyContent_WebinarsVideoInput>;
  video_link: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyContent_WebinarsOperatorsInput = {
  _id: InputMaybe<FilterFindManyContent_Webinars_IdOperatorsInput>;
};

export type FilterFindManyContent_WebinarsPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_WebinarsVideoInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  caption: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
  thumbnail: InputMaybe<FilterFindManyContent_WebinarsVideoThumbnailInput>;
};

export type FilterFindManyContent_WebinarsVideoThumbnailInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyContent_Webinars_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyContent_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyLighthouseCategoriesAccessibilityInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  manualDescription: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type FilterFindManyLighthouseCategoriesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  accessibility: InputMaybe<FilterFindManyLighthouseCategoriesAccessibilityInput>;
  bestPractices: InputMaybe<FilterFindManyLighthouseCategoriesPerformanceInput>;
  performance: InputMaybe<FilterFindManyLighthouseCategoriesPerformanceInput>;
  pwa: InputMaybe<FilterFindManyLighthouseCategoriesAccessibilityInput>;
  seo: InputMaybe<FilterFindManyLighthouseCategoriesAccessibilityInput>;
};

export type FilterFindManyLighthouseCategoriesPerformanceInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  id: Scalars['String']['input'];
  score: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type FilterFindManyLighthouseInput = {
  AND: InputMaybe<Array<FilterFindManyLighthouseInput>>;
  OR: InputMaybe<Array<FilterFindManyLighthouseInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyLighthouseOperatorsInput>;
  categories: InputMaybe<FilterFindManyLighthouseCategoriesInput>;
  dealerCode: InputMaybe<Scalars['String']['input']>;
  requestedUrl: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyLighthouseOperatorsInput = {
  _id: InputMaybe<FilterFindManyLighthouse_IdOperatorsInput>;
};

export type FilterFindManyLighthouse_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrivate_RoutesInput = {
  AND: InputMaybe<Array<FilterFindManyPrivate_RoutesInput>>;
  OR: InputMaybe<Array<FilterFindManyPrivate_RoutesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyPrivate_RoutesOperatorsInput>;
  path: InputMaybe<Scalars['String']['input']>;
  roles: InputMaybe<Array<InputMaybe<EnumPrivate_RoutesRoles>>>;
  usernames: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrivate_RoutesOperatorsInput = {
  _id: InputMaybe<FilterFindManyPrivate_Routes_IdOperatorsInput>;
};

export type FilterFindManyPrivate_Routes_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyReporting_AggregatesInput = {
  AND: InputMaybe<Array<FilterFindManyReporting_AggregatesInput>>;
  OR: InputMaybe<Array<FilterFindManyReporting_AggregatesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyReporting_AggregatesOperatorsInput>;
  avgBounceRate: InputMaybe<Scalars['JSON']['input']>;
  avgSessionPages: InputMaybe<Scalars['JSON']['input']>;
  avgUserSession: InputMaybe<Scalars['JSON']['input']>;
  browserTraffic: InputMaybe<Scalars['JSON']['input']>;
  contactPageVisits: InputMaybe<Scalars['JSON']['input']>;
  count: InputMaybe<Scalars['Float']['input']>;
  deviceTraffic: InputMaybe<Scalars['JSON']['input']>;
  entranceBySourceMedium: InputMaybe<Scalars['JSON']['input']>;
  search_term: InputMaybe<Scalars['String']['input']>;
  timestamp: InputMaybe<Scalars['Date']['input']>;
  uniqueVisits: InputMaybe<Scalars['JSON']['input']>;
  viewportTraffic: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReporting_AggregatesOperatorsInput = {
  _id: InputMaybe<FilterFindManyReporting_Aggregates_IdOperatorsInput>;
  search_term: InputMaybe<FilterFindManyReporting_AggregatesSearch_TermOperatorsInput>;
  timestamp: InputMaybe<FilterFindManyReporting_AggregatesTimestampOperatorsInput>;
};

export type FilterFindManyReporting_AggregatesSearch_TermOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReporting_AggregatesTimestampOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyReporting_Aggregates_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyReporting_ConfigsInput = {
  AND: InputMaybe<Array<FilterFindManyReporting_ConfigsInput>>;
  OR: InputMaybe<Array<FilterFindManyReporting_ConfigsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyReporting_ConfigsOperatorsInput>;
  measurement_id: InputMaybe<Scalars['String']['input']>;
  parent_code: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<Scalars['Boolean']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  tracking_code: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumReporting_ConfigsType>;
  ua_view_id: InputMaybe<Scalars['String']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  vendor_code: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReporting_ConfigsOperatorsInput = {
  _id: InputMaybe<FilterFindManyReporting_Configs_IdOperatorsInput>;
  region: InputMaybe<FilterFindManyReporting_ConfigsRegionOperatorsInput>;
  unit_code: InputMaybe<FilterFindManyReporting_ConfigsUnit_CodeOperatorsInput>;
  vendor_code: InputMaybe<FilterFindManyReporting_ConfigsVendor_CodeOperatorsInput>;
};

export type FilterFindManyReporting_ConfigsRegionOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReporting_ConfigsUnit_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReporting_ConfigsVendor_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReporting_Configs_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyReviewsAnswersInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  answer: InputMaybe<Scalars['String']['input']>;
  comments: InputMaybe<Scalars['String']['input']>;
  comments_fr: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  screenshots: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyReviewsAssessment_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReviewsInput = {
  AND: InputMaybe<Array<FilterFindManyReviewsInput>>;
  OR: InputMaybe<Array<FilterFindManyReviewsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyReviewsOperatorsInput>;
  answers: InputMaybe<Array<InputMaybe<FilterFindManyReviewsAnswersInput>>>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  category_code: InputMaybe<Scalars['String']['input']>;
  category_label: InputMaybe<Scalars['String']['input']>;
  category_label_fr: InputMaybe<Scalars['String']['input']>;
  period_label: InputMaybe<Scalars['String']['input']>;
  period_label_fr: InputMaybe<Scalars['String']['input']>;
  segmentation: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  unit_name: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyReviewsOperatorsInput = {
  _id: InputMaybe<FilterFindManyReviews_IdOperatorsInput>;
  assessment_code: InputMaybe<FilterFindManyReviewsAssessment_CodeOperatorsInput>;
  unit_code: InputMaybe<FilterFindManyReviewsUnit_CodeOperatorsInput>;
};

export type FilterFindManyReviewsUnit_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyReviews_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManySegmentsInput = {
  AND: InputMaybe<Array<FilterFindManySegmentsInput>>;
  OR: InputMaybe<Array<FilterFindManySegmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManySegmentsOperatorsInput>;
  hierarchy: InputMaybe<Scalars['Float']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  parent: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManySegmentsNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManySegmentsOperatorsInput = {
  _id: InputMaybe<FilterFindManySegments_IdOperatorsInput>;
  name: InputMaybe<FilterFindManySegmentsNameOperatorsInput>;
  value: InputMaybe<FilterFindManySegmentsValueOperatorsInput>;
};

export type FilterFindManySegmentsValueOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManySegments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTrackingInput = {
  AND: InputMaybe<Array<FilterFindManyTrackingInput>>;
  OR: InputMaybe<Array<FilterFindManyTrackingInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyTrackingOperatorsInput>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  event_date: InputMaybe<Scalars['Date']['input']>;
  event_type: InputMaybe<Scalars['String']['input']>;
  object_id: InputMaybe<Scalars['String']['input']>;
  object_type: InputMaybe<Scalars['String']['input']>;
  oem_codes: InputMaybe<Array<InputMaybe<EnumTrackingOem_Codes>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTrackingOperatorsInput = {
  _id: InputMaybe<FilterFindManyTracking_IdOperatorsInput>;
};

export type FilterFindManyTracking_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUnitsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUnitsInput = {
  AND: InputMaybe<Array<FilterFindManyUnitsInput>>;
  OR: InputMaybe<Array<FilterFindManyUnitsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyUnitsOperatorsInput>;
  address: InputMaybe<Scalars['String']['input']>;
  city: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  postal_code: InputMaybe<Scalars['String']['input']>;
  province: InputMaybe<Scalars['String']['input']>;
  segment_0: InputMaybe<Scalars['String']['input']>;
  segment_1: InputMaybe<Scalars['String']['input']>;
  vendor_name: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyUnitsNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUnitsOperatorsInput = {
  _id: InputMaybe<FilterFindManyUnits_IdOperatorsInput>;
  code: InputMaybe<FilterFindManyUnitsCodeOperatorsInput>;
  name: InputMaybe<FilterFindManyUnitsNameOperatorsInput>;
};

export type FilterFindManyUnits_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUsersCoe_RoleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumUsersCoe_Role>;
  gte: InputMaybe<EnumUsersCoe_Role>;
  in: InputMaybe<Array<InputMaybe<EnumUsersCoe_Role>>>;
  lt: InputMaybe<EnumUsersCoe_Role>;
  lte: InputMaybe<EnumUsersCoe_Role>;
  ne: InputMaybe<EnumUsersCoe_Role>;
  nin: InputMaybe<Array<InputMaybe<EnumUsersCoe_Role>>>;
};

export type FilterFindManyUsersCompliance_RoleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumUsersCompliance_Role>;
  gte: InputMaybe<EnumUsersCompliance_Role>;
  in: InputMaybe<Array<InputMaybe<EnumUsersCompliance_Role>>>;
  lt: InputMaybe<EnumUsersCompliance_Role>;
  lte: InputMaybe<EnumUsersCompliance_Role>;
  ne: InputMaybe<EnumUsersCompliance_Role>;
  nin: InputMaybe<Array<InputMaybe<EnumUsersCompliance_Role>>>;
};

export type FilterFindManyUsersInput = {
  AND: InputMaybe<Array<FilterFindManyUsersInput>>;
  OR: InputMaybe<Array<FilterFindManyUsersInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyUsersOperatorsInput>;
  coe_role: InputMaybe<EnumUsersCoe_Role>;
  coe_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment: InputMaybe<Scalars['String']['input']>;
  compliance_role: InputMaybe<EnumUsersCompliance_Role>;
  created: InputMaybe<Scalars['Date']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  last_login: InputMaybe<Scalars['String']['input']>;
  last_name: InputMaybe<Scalars['String']['input']>;
  locked: InputMaybe<Scalars['Boolean']['input']>;
  login_type: InputMaybe<EnumUsersLogin_Type>;
  modified: InputMaybe<Scalars['Date']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  module_permissions: InputMaybe<Array<InputMaybe<EnumUsersModule_Permissions>>>;
  oem_access: InputMaybe<Array<InputMaybe<EnumUsersOem_Access>>>;
  password: InputMaybe<Scalars['String']['input']>;
  preferred_language: InputMaybe<EnumUsersPreferred_Language>;
  refresh_token: InputMaybe<Scalars['String']['input']>;
  reviewer_role: InputMaybe<EnumUsersReviewer_Role>;
  reviewer_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumUsersType>;
  username: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUsersOperatorsInput = {
  _id: InputMaybe<FilterFindManyUsers_IdOperatorsInput>;
  coe_role: InputMaybe<FilterFindManyUsersCoe_RoleOperatorsInput>;
  compliance_role: InputMaybe<FilterFindManyUsersCompliance_RoleOperatorsInput>;
  username: InputMaybe<FilterFindManyUsersUsernameOperatorsInput>;
};

export type FilterFindManyUsersUsernameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUsers_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorsInput = {
  AND: InputMaybe<Array<FilterFindManyVendorsInput>>;
  OR: InputMaybe<Array<FilterFindManyVendorsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyVendorsOperatorsInput>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_name: InputMaybe<Scalars['String']['input']>;
  segment_0: InputMaybe<Scalars['String']['input']>;
  segment_1: InputMaybe<Scalars['String']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  unit_name: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
  vendor_name: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVendorsOperatorsInput = {
  _id: InputMaybe<FilterFindManyVendors_IdOperatorsInput>;
  vendor_name: InputMaybe<FilterFindManyVendorsVendor_NameOperatorsInput>;
};

export type FilterFindManyVendorsVendor_NameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyVendors_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManylighthouse_AggregateInput = {
  AND: InputMaybe<Array<FilterFindManylighthouse_AggregateInput>>;
  OR: InputMaybe<Array<FilterFindManylighthouse_AggregateInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManylighthouse_AggregateOperatorsInput>;
  categories: InputMaybe<FilterFindManyLighthouseCategoriesInput>;
  dealerCode: InputMaybe<Scalars['String']['input']>;
  oem: InputMaybe<Enumlighthouse_AggregateOem>;
  requestedUrl: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManylighthouse_AggregateOperatorsInput = {
  _id: InputMaybe<FilterFindManylighthouse_Aggregate_IdOperatorsInput>;
};

export type FilterFindManylighthouse_Aggregate_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_AssessmentsAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_AssessmentsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_AssessmentsCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_AssessmentsDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<FilterFindManyportal_Context_AssessmentsDataLabelInput>;
};

export type FilterFindManyportal_Context_AssessmentsDataLabelInput = {
  EN: InputMaybe<Scalars['String']['input']>;
  FR: InputMaybe<Scalars['String']['input']>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyportal_Context_AssessmentsInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_AssessmentsInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_AssessmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_AssessmentsOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_AssessmentsCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_AssessmentsDataInput>;
  order: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_AssessmentsOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Assessments_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_AssessmentsAssessmentCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_AssessmentsCodeOperatorsInput>;
  order: InputMaybe<FilterFindManyportal_Context_AssessmentsOrderOperatorsInput>;
};

export type FilterFindManyportal_Context_AssessmentsOrderOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyportal_Context_Assessments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_CategoriesAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_CategoriesCategoryCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_CategoriesCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_CategoriesCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_CategoriesDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  label: InputMaybe<FilterFindManyportal_Context_AssessmentsDataLabelInput>;
};

export type FilterFindManyportal_Context_CategoriesInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_CategoriesInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_CategoriesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_CategoriesOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  categoryCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_CategoriesCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_CategoriesDataInput>;
  order: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_CategoriesOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Categories_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_CategoriesAssessmentCodeOperatorsInput>;
  categoryCode: InputMaybe<FilterFindManyportal_Context_CategoriesCategoryCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_CategoriesCodeOperatorsInput>;
  order: InputMaybe<FilterFindManyportal_Context_CategoriesOrderOperatorsInput>;
};

export type FilterFindManyportal_Context_CategoriesOrderOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyportal_Context_Categories_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_Divisions_FirstAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Divisions_FirstCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Divisions_FirstCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_Divisions_FirstDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_Divisions_FirstFirstDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Divisions_FirstInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_Divisions_FirstInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_Divisions_FirstInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_Divisions_FirstOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_Divisions_FirstCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_Divisions_FirstDataInput>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_Divisions_FirstOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Divisions_First_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_Divisions_FirstAssessmentCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_Divisions_FirstCodeOperatorsInput>;
  firstDivisionCode: InputMaybe<FilterFindManyportal_Context_Divisions_FirstFirstDivisionCodeOperatorsInput>;
};

export type FilterFindManyportal_Context_Divisions_First_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_Divisions_SecondAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Divisions_SecondCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Divisions_SecondCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_Divisions_SecondDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_Divisions_SecondFirstDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Divisions_SecondInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_Divisions_SecondInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_Divisions_SecondInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_Divisions_SecondOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_Divisions_SecondCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_Divisions_SecondDataInput>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
  secondDivisionCode: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_Divisions_SecondOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Divisions_Second_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_Divisions_SecondAssessmentCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_Divisions_SecondCodeOperatorsInput>;
  firstDivisionCode: InputMaybe<FilterFindManyportal_Context_Divisions_SecondFirstDivisionCodeOperatorsInput>;
  secondDivisionCode: InputMaybe<FilterFindManyportal_Context_Divisions_SecondSecondDivisionCodeOperatorsInput>;
};

export type FilterFindManyportal_Context_Divisions_SecondSecondDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Divisions_Second_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_Progress_ReportAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportCategoryScoresInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  category: InputMaybe<Scalars['String']['input']>;
  score: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportDealerNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportFirstDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_Progress_ReportInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_Progress_ReportInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_Progress_ReportOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  assessmentRank: InputMaybe<Scalars['Float']['input']>;
  categoryScores: InputMaybe<Array<InputMaybe<FilterFindManyportal_Context_Progress_ReportCategoryScoresInput>>>;
  dealerName: InputMaybe<Scalars['String']['input']>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
  pointsEarned: InputMaybe<Scalars['Float']['input']>;
  pointsMissed: InputMaybe<Scalars['Float']['input']>;
  pointsPossible: InputMaybe<Scalars['Float']['input']>;
  questionsReviewed: InputMaybe<Array<InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedInput>>>;
  secondDivisionCode: InputMaybe<Scalars['String']['input']>;
  totalDealers: InputMaybe<Scalars['Float']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
  vendorName: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_Progress_ReportOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Progress_Report_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_Progress_ReportAssessmentCodeOperatorsInput>;
  dealerName: InputMaybe<FilterFindManyportal_Context_Progress_ReportDealerNameOperatorsInput>;
  firstDivisionCode: InputMaybe<FilterFindManyportal_Context_Progress_ReportFirstDivisionCodeOperatorsInput>;
  secondDivisionCode: InputMaybe<FilterFindManyportal_Context_Progress_ReportSecondDivisionCodeOperatorsInput>;
  unitCode: InputMaybe<FilterFindManyportal_Context_Progress_ReportUnitCodeOperatorsInput>;
  vendorCode: InputMaybe<FilterFindManyportal_Context_Progress_ReportVendorCodeOperatorsInput>;
  vendorName: InputMaybe<FilterFindManyportal_Context_Progress_ReportVendorNameOperatorsInput>;
};

export type FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput = {
  EN: InputMaybe<Scalars['String']['input']>;
  FR: InputMaybe<Scalars['String']['input']>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportQuestionsReviewedInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  answer: InputMaybe<Scalars['String']['input']>;
  answerValue: InputMaybe<Scalars['Float']['input']>;
  assigned: InputMaybe<Enumportal_Context_Progress_ReportQuestionsReviewedAssigned>;
  categoryCode: InputMaybe<Scalars['String']['input']>;
  categoryLabel: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  comments: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  dealerName: InputMaybe<Scalars['String']['input']>;
  improvement: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  isRequired: InputMaybe<Scalars['Boolean']['input']>;
  priority: InputMaybe<Enumportal_Context_Progress_ReportQuestionsReviewedPriority>;
  questionCode: InputMaybe<Scalars['String']['input']>;
  questionLabel: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  questionRationale: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  resolveImpact: InputMaybe<Scalars['Float']['input']>;
  score: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedScoreInput>;
  screenshots: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: InputMaybe<Enumportal_Context_Progress_ReportQuestionsReviewedStatus>;
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
  vendorName: InputMaybe<Scalars['String']['input']>;
  videoLink: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  weight: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportQuestionsReviewedScoreInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  earned: InputMaybe<Scalars['Float']['input']>;
  max: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportSecondDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportUnitCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportVendorCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Progress_ReportVendorNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Progress_Report_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_QuestionsAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_QuestionsCategoryCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_QuestionsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_QuestionsCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_QuestionsDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  isRequired: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  layout: InputMaybe<Enumportal_Context_QuestionsDataLayout>;
  rationale: InputMaybe<Scalars['String']['input']>;
  resources: InputMaybe<Array<InputMaybe<FilterFindManyportal_Context_QuestionsDataResourcesInput>>>;
  statusFlag: InputMaybe<Scalars['String']['input']>;
  weight: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyportal_Context_QuestionsDataResourcesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_QuestionsInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_QuestionsInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_QuestionsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_QuestionsOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  categoryCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_QuestionsCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_QuestionsDataInput>;
  languageCode: InputMaybe<Enumportal_Context_QuestionsLanguageCode>;
  order: InputMaybe<Scalars['Float']['input']>;
  questionCode: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_QuestionsOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Questions_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_QuestionsAssessmentCodeOperatorsInput>;
  categoryCode: InputMaybe<FilterFindManyportal_Context_QuestionsCategoryCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_QuestionsCodeOperatorsInput>;
  order: InputMaybe<FilterFindManyportal_Context_QuestionsOrderOperatorsInput>;
  questionCode: InputMaybe<FilterFindManyportal_Context_QuestionsQuestionCodeOperatorsInput>;
};

export type FilterFindManyportal_Context_QuestionsOrderOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyportal_Context_QuestionsQuestionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Questions_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_ResponsesAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesCategoryCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  answer: InputMaybe<Scalars['String']['input']>;
  comment: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  score: InputMaybe<FilterFindManyportal_Context_Progress_ReportQuestionsReviewedScoreInput>;
  screenshots: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FilterFindManyportal_Context_ResponsesFirstDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_ResponsesInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_ResponsesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_ResponsesOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  assigned: InputMaybe<Enumportal_Context_ResponsesAssigned>;
  categoryCode: InputMaybe<Scalars['String']['input']>;
  data: InputMaybe<FilterFindManyportal_Context_ResponsesDataInput>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
  questionCode: InputMaybe<Scalars['String']['input']>;
  secondDivisionCode: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Enumportal_Context_ResponsesStatus>;
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
  vendorStatus: InputMaybe<Enumportal_Context_ResponsesVendorStatus>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_ResponsesOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Responses_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_ResponsesAssessmentCodeOperatorsInput>;
  categoryCode: InputMaybe<FilterFindManyportal_Context_ResponsesCategoryCodeOperatorsInput>;
  firstDivisionCode: InputMaybe<FilterFindManyportal_Context_ResponsesFirstDivisionCodeOperatorsInput>;
  questionCode: InputMaybe<FilterFindManyportal_Context_ResponsesQuestionCodeOperatorsInput>;
  secondDivisionCode: InputMaybe<FilterFindManyportal_Context_ResponsesSecondDivisionCodeOperatorsInput>;
  tags: InputMaybe<FilterFindManyportal_Context_ResponsesTagsOperatorsInput>;
  unitCode: InputMaybe<FilterFindManyportal_Context_ResponsesUnitCodeOperatorsInput>;
  vendorCode: InputMaybe<FilterFindManyportal_Context_ResponsesVendorCodeOperatorsInput>;
  vendorStatus: InputMaybe<FilterFindManyportal_Context_ResponsesVendorStatusOperatorsInput>;
};

export type FilterFindManyportal_Context_ResponsesQuestionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesSecondDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesTagsOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesUnitCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesVendorCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_ResponsesVendorStatusOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Enumportal_Context_ResponsesVendorStatus>;
  gte: InputMaybe<Enumportal_Context_ResponsesVendorStatus>;
  in: InputMaybe<Array<InputMaybe<Enumportal_Context_ResponsesVendorStatus>>>;
  lt: InputMaybe<Enumportal_Context_ResponsesVendorStatus>;
  lte: InputMaybe<Enumportal_Context_ResponsesVendorStatus>;
  ne: InputMaybe<Enumportal_Context_ResponsesVendorStatus>;
  nin: InputMaybe<Array<InputMaybe<Enumportal_Context_ResponsesVendorStatus>>>;
};

export type FilterFindManyportal_Context_Responses_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_TagsAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_TagsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_TagsCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_TagsDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  label: InputMaybe<FilterFindManyportal_Context_AssessmentsDataLabelInput>;
};

export type FilterFindManyportal_Context_TagsInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_TagsInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_TagsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_TagsOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_TagsCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_TagsDataInput>;
  tagCode: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_TagsOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Tags_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_TagsAssessmentCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_TagsCodeOperatorsInput>;
  tagCode: InputMaybe<FilterFindManyportal_Context_TagsTagCodeOperatorsInput>;
};

export type FilterFindManyportal_Context_TagsTagCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Tags_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_UnitsAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_UnitsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_UnitsCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_UnitsDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  reviewer: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_UnitsFirstDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_UnitsInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_UnitsInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_UnitsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_UnitsOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_UnitsCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_UnitsDataInput>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
  secondDivisionCode: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_UnitsOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Units_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_UnitsAssessmentCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_UnitsCodeOperatorsInput>;
  firstDivisionCode: InputMaybe<FilterFindManyportal_Context_UnitsFirstDivisionCodeOperatorsInput>;
  secondDivisionCode: InputMaybe<FilterFindManyportal_Context_UnitsSecondDivisionCodeOperatorsInput>;
  unitCode: InputMaybe<FilterFindManyportal_Context_UnitsUnitCodeOperatorsInput>;
  vendorCode: InputMaybe<FilterFindManyportal_Context_UnitsVendorCodeOperatorsInput>;
};

export type FilterFindManyportal_Context_UnitsSecondDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_UnitsUnitCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_UnitsVendorCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Units_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyportal_Context_VendorsAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_VendorsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_VendorsCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyportal_Context_VendorsDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  vendorStatus: InputMaybe<Enumportal_Context_VendorsDataVendorStatus>;
};

export type FilterFindManyportal_Context_VendorsInput = {
  AND: InputMaybe<Array<FilterFindManyportal_Context_VendorsInput>>;
  OR: InputMaybe<Array<FilterFindManyportal_Context_VendorsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindManyportal_Context_VendorsOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindManyportal_Context_VendorsCompInput>;
  data: InputMaybe<FilterFindManyportal_Context_VendorsDataInput>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyportal_Context_VendorsOperatorsInput = {
  _id: InputMaybe<FilterFindManyportal_Context_Vendors_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindManyportal_Context_VendorsAssessmentCodeOperatorsInput>;
  code: InputMaybe<FilterFindManyportal_Context_VendorsCodeOperatorsInput>;
  vendorCode: InputMaybe<FilterFindManyportal_Context_VendorsVendorCodeOperatorsInput>;
};

export type FilterFindManyportal_Context_VendorsVendorCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyportal_Context_Vendors_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAdherence_CardsImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneAdherence_CardsInput = {
  AND: InputMaybe<Array<FilterFindOneAdherence_CardsInput>>;
  OR: InputMaybe<Array<FilterFindOneAdherence_CardsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneAdherence_CardsOperatorsInput>;
  description: InputMaybe<Scalars['String']['input']>;
  featured: InputMaybe<Scalars['Boolean']['input']>;
  image: InputMaybe<FilterFindOneAdherence_CardsImageInput>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumAdherence_CardsLanguage>;
  link_label: InputMaybe<Scalars['String']['input']>;
  link_url: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Scalars['Float']['input']>;
  source: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAdherence_CardsOperatorsInput = {
  _id: InputMaybe<FilterFindOneAdherence_Cards_IdOperatorsInput>;
  order: InputMaybe<FilterFindOneAdherence_CardsOrderOperatorsInput>;
  title: InputMaybe<FilterFindOneAdherence_CardsTitleOperatorsInput>;
};

export type FilterFindOneAdherence_CardsOrderOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOneAdherence_CardsTitleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAdherence_Cards_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAdherence_CriteriaInput = {
  AND: InputMaybe<Array<FilterFindOneAdherence_CriteriaInput>>;
  OR: InputMaybe<Array<FilterFindOneAdherence_CriteriaInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneAdherence_CriteriaOperatorsInput>;
  category: InputMaybe<Scalars['String']['input']>;
  category_order: InputMaybe<Scalars['Float']['input']>;
  correct_response: InputMaybe<Scalars['String']['input']>;
  criteria_image: InputMaybe<Scalars['String']['input']>;
  fail_response: InputMaybe<Scalars['String']['input']>;
  media_channels: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  periods: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question: InputMaybe<Scalars['String']['input']>;
  question_dependencies: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  question_key: InputMaybe<Scalars['String']['input']>;
  question_order: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAdherence_CriteriaOperatorsInput = {
  _id: InputMaybe<FilterFindOneAdherence_Criteria_IdOperatorsInput>;
};

export type FilterFindOneAdherence_Criteria_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAdherence_ReviewsInput = {
  AND: InputMaybe<Array<FilterFindOneAdherence_ReviewsInput>>;
  OR: InputMaybe<Array<FilterFindOneAdherence_ReviewsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneAdherence_ReviewsOperatorsInput>;
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAdherence_ReviewsOperatorsInput = {
  _id: InputMaybe<FilterFindOneAdherence_Reviews_IdOperatorsInput>;
  requestId: InputMaybe<FilterFindOneAdherence_ReviewsRequestIdOperatorsInput>;
};

export type FilterFindOneAdherence_ReviewsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAdherence_Reviews_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAdherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneAdherence_SubmissionsCreatedAtOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneAdherence_SubmissionsInput = {
  AND: InputMaybe<Array<FilterFindOneAdherence_SubmissionsInput>>;
  OR: InputMaybe<Array<FilterFindOneAdherence_SubmissionsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneAdherence_SubmissionsOperatorsInput>;
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<FilterFindOneAdherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAdherence_SubmissionsOperatorsInput = {
  _id: InputMaybe<FilterFindOneAdherence_Submissions_IdOperatorsInput>;
  createdAt: InputMaybe<FilterFindOneAdherence_SubmissionsCreatedAtOperatorsInput>;
  requestId: InputMaybe<FilterFindOneAdherence_SubmissionsRequestIdOperatorsInput>;
};

export type FilterFindOneAdherence_SubmissionsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAdherence_Submissions_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAssessment_SummaryAssessment_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAssessment_SummaryCategory_ScoresInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  category_code: InputMaybe<Scalars['String']['input']>;
  category_label: InputMaybe<Scalars['String']['input']>;
  category_label_fr: InputMaybe<Scalars['String']['input']>;
  final_score: InputMaybe<Scalars['Float']['input']>;
  max_score: InputMaybe<Scalars['Float']['input']>;
  total_score: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneAssessment_SummaryInput = {
  AND: InputMaybe<Array<FilterFindOneAssessment_SummaryInput>>;
  OR: InputMaybe<Array<FilterFindOneAssessment_SummaryInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneAssessment_SummaryOperatorsInput>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  assessment_label: InputMaybe<Scalars['String']['input']>;
  assessment_label_fr: InputMaybe<Scalars['String']['input']>;
  category_scores: InputMaybe<Array<InputMaybe<FilterFindOneAssessment_SummaryCategory_ScoresInput>>>;
  date: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  final_score: InputMaybe<Scalars['Float']['input']>;
  max_score: InputMaybe<Scalars['Float']['input']>;
  preferred_vendor: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_name: InputMaybe<Scalars['String']['input']>;
  segment_0_code: InputMaybe<Scalars['String']['input']>;
  segment_0_label: InputMaybe<Scalars['String']['input']>;
  segment_1_code: InputMaybe<Scalars['String']['input']>;
  segment_1_label: InputMaybe<Scalars['String']['input']>;
  total_score: InputMaybe<Scalars['Float']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  unit_name: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
  vendor_name: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAssessment_SummaryOperatorsInput = {
  _id: InputMaybe<FilterFindOneAssessment_Summary_IdOperatorsInput>;
  assessment_code: InputMaybe<FilterFindOneAssessment_SummaryAssessment_CodeOperatorsInput>;
  preferred_vendor: InputMaybe<FilterFindOneAssessment_SummaryPreferred_VendorOperatorsInput>;
  total_score: InputMaybe<FilterFindOneAssessment_SummaryTotal_ScoreOperatorsInput>;
  unit_code: InputMaybe<FilterFindOneAssessment_SummaryUnit_CodeOperatorsInput>;
  vendor_name: InputMaybe<FilterFindOneAssessment_SummaryVendor_NameOperatorsInput>;
};

export type FilterFindOneAssessment_SummaryPreferred_VendorOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type FilterFindOneAssessment_SummaryTotal_ScoreOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOneAssessment_SummaryUnit_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAssessment_SummaryVendor_NameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAssessment_Summary_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAssessmentsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAssessmentsDateOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneAssessmentsInput = {
  AND: InputMaybe<Array<FilterFindOneAssessmentsInput>>;
  OR: InputMaybe<Array<FilterFindOneAssessmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneAssessmentsOperatorsInput>;
  categories: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: InputMaybe<Scalars['String']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['String']['input']>;
  remote_id: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_fr: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneAssessmentsOperatorsInput = {
  _id: InputMaybe<FilterFindOneAssessments_IdOperatorsInput>;
  code: InputMaybe<FilterFindOneAssessmentsCodeOperatorsInput>;
  date: InputMaybe<FilterFindOneAssessmentsDateOperatorsInput>;
};

export type FilterFindOneAssessments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneConfigurationsInput = {
  AND: InputMaybe<Array<FilterFindOneConfigurationsInput>>;
  OR: InputMaybe<Array<FilterFindOneConfigurationsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneConfigurationsOperatorsInput>;
  district_label_en: InputMaybe<Scalars['String']['input']>;
  district_label_fr: InputMaybe<Scalars['String']['input']>;
  maintenance_message_en: InputMaybe<Scalars['String']['input']>;
  maintenance_message_fr: InputMaybe<Scalars['String']['input']>;
  oem: InputMaybe<EnumConfigurationsOem>;
  region_label_en: InputMaybe<Scalars['String']['input']>;
  region_label_fr: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumConfigurationsType>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneConfigurationsOperatorsInput = {
  _id: InputMaybe<FilterFindOneConfigurations_IdOperatorsInput>;
  type: InputMaybe<FilterFindOneConfigurationsTypeOperatorsInput>;
};

export type FilterFindOneConfigurationsTypeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumConfigurationsType>;
  gte: InputMaybe<EnumConfigurationsType>;
  in: InputMaybe<Array<InputMaybe<EnumConfigurationsType>>>;
  lt: InputMaybe<EnumConfigurationsType>;
  lte: InputMaybe<EnumConfigurationsType>;
  ne: InputMaybe<EnumConfigurationsType>;
  nin: InputMaybe<Array<InputMaybe<EnumConfigurationsType>>>;
};

export type FilterFindOneConfigurations_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneContent_Business_InsightsCategoriesInput = {
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Business_InsightsHero_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Business_InsightsInput = {
  AND: InputMaybe<Array<FilterFindOneContent_Business_InsightsInput>>;
  OR: InputMaybe<Array<FilterFindOneContent_Business_InsightsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneContent_Business_InsightsOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  body: InputMaybe<Scalars['String']['input']>;
  button_label: InputMaybe<Scalars['String']['input']>;
  button_link: InputMaybe<Scalars['String']['input']>;
  categories: InputMaybe<Array<InputMaybe<FilterFindOneContent_Business_InsightsCategoriesInput>>>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  hero_image: InputMaybe<FilterFindOneContent_Business_InsightsHero_ImageInput>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_Business_InsightsLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  new: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindOneContent_Business_InsightsPreview_ImageInput>;
  title: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneContent_Business_InsightsOperatorsInput = {
  _id: InputMaybe<FilterFindOneContent_Business_Insights_IdOperatorsInput>;
};

export type FilterFindOneContent_Business_InsightsPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Business_Insights_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneContent_NotificationsCategoriesInput = {
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_NotificationsInput = {
  AND: InputMaybe<Array<FilterFindOneContent_NotificationsInput>>;
  OR: InputMaybe<Array<FilterFindOneContent_NotificationsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneContent_NotificationsOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  button_label: InputMaybe<Scalars['String']['input']>;
  button_link: InputMaybe<Scalars['String']['input']>;
  categories: InputMaybe<Array<InputMaybe<FilterFindOneContent_NotificationsCategoriesInput>>>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_NotificationsLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindOneContent_NotificationsPreview_ImageInput>;
  title: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneContent_NotificationsOperatorsInput = {
  _id: InputMaybe<FilterFindOneContent_Notifications_IdOperatorsInput>;
};

export type FilterFindOneContent_NotificationsPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Notifications_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneContent_Program_UpdatesHero_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Program_UpdatesInput = {
  AND: InputMaybe<Array<FilterFindOneContent_Program_UpdatesInput>>;
  OR: InputMaybe<Array<FilterFindOneContent_Program_UpdatesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneContent_Program_UpdatesOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  body: InputMaybe<Scalars['String']['input']>;
  button_label: InputMaybe<Scalars['String']['input']>;
  button_link: InputMaybe<Scalars['String']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  hero_image: InputMaybe<FilterFindOneContent_Program_UpdatesHero_ImageInput>;
  important: InputMaybe<Scalars['Boolean']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_Program_UpdatesLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  new: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindOneContent_Program_UpdatesPreview_ImageInput>;
  title: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneContent_Program_UpdatesOperatorsInput = {
  _id: InputMaybe<FilterFindOneContent_Program_Updates_IdOperatorsInput>;
};

export type FilterFindOneContent_Program_UpdatesPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Program_Updates_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneContent_VendorInput = {
  AND: InputMaybe<Array<FilterFindOneContent_VendorInput>>;
  OR: InputMaybe<Array<FilterFindOneContent_VendorInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneContent_VendorOperatorsInput>;
  cancellation_notice: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  dedicated_support_team: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  emailHACC: InputMaybe<Scalars['String']['input']>;
  emailMMSC: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_VendorLanguage>;
  languages: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Scalars['String']['input']>;
  maximum_price: InputMaybe<Scalars['Float']['input']>;
  minimum_contract: InputMaybe<Scalars['String']['input']>;
  minimum_price: InputMaybe<Scalars['Float']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  number_of_employees: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<FilterFindOneContent_VendorPreferredInput>;
  service_area: InputMaybe<Scalars['String']['input']>;
  services: InputMaybe<Array<InputMaybe<FilterFindOneContent_VendorServicesInput>>>;
  title: InputMaybe<Scalars['String']['input']>;
  value_added_services: InputMaybe<Array<InputMaybe<FilterFindOneContent_VendorValue_Added_ServicesInput>>>;
  website: InputMaybe<Scalars['String']['input']>;
  websiteHACC: InputMaybe<Scalars['String']['input']>;
  websiteMMSC: InputMaybe<Scalars['String']['input']>;
  years_of_operation: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneContent_VendorOperatorsInput = {
  _id: InputMaybe<FilterFindOneContent_Vendor_IdOperatorsInput>;
};

export type FilterFindOneContent_VendorPreferredInput = {
  DEMO: InputMaybe<Scalars['Boolean']['input']>;
  HACC: InputMaybe<Scalars['Boolean']['input']>;
  MMSC: InputMaybe<Scalars['Boolean']['input']>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneContent_VendorServicesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_VendorValue_Added_ServicesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Vendor_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneContent_WebinarsCategoriesInput = {
  code: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_WebinarsInput = {
  AND: InputMaybe<Array<FilterFindOneContent_WebinarsInput>>;
  OR: InputMaybe<Array<FilterFindOneContent_WebinarsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneContent_WebinarsOperatorsInput>;
  alternate_path: InputMaybe<Scalars['String']['input']>;
  body: InputMaybe<Scalars['String']['input']>;
  categories: InputMaybe<Array<InputMaybe<FilterFindOneContent_WebinarsCategoriesInput>>>;
  created_by: InputMaybe<Scalars['String']['input']>;
  created_date: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  duration: InputMaybe<Scalars['Float']['input']>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  key: InputMaybe<Scalars['String']['input']>;
  language: InputMaybe<EnumContent_WebinarsLanguage>;
  legacy_id: InputMaybe<Scalars['String']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  modified_date: InputMaybe<Scalars['String']['input']>;
  new: InputMaybe<Scalars['Boolean']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  post_date: InputMaybe<Scalars['String']['input']>;
  presenter: InputMaybe<Scalars['String']['input']>;
  preview_image: InputMaybe<FilterFindOneContent_WebinarsPreview_ImageInput>;
  resource_file: InputMaybe<Scalars['String']['input']>;
  start_time: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  video: InputMaybe<FilterFindOneContent_WebinarsVideoInput>;
  video_link: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneContent_WebinarsOperatorsInput = {
  _id: InputMaybe<FilterFindOneContent_Webinars_IdOperatorsInput>;
};

export type FilterFindOneContent_WebinarsPreview_ImageInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_WebinarsVideoInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  caption: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
  thumbnail: InputMaybe<FilterFindOneContent_WebinarsVideoThumbnailInput>;
};

export type FilterFindOneContent_WebinarsVideoThumbnailInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  alt: InputMaybe<Scalars['String']['input']>;
  src: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneContent_Webinars_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneLighthouseCategoriesAccessibilityInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  manualDescription: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type FilterFindOneLighthouseCategoriesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  accessibility: InputMaybe<FilterFindOneLighthouseCategoriesAccessibilityInput>;
  bestPractices: InputMaybe<FilterFindOneLighthouseCategoriesPerformanceInput>;
  performance: InputMaybe<FilterFindOneLighthouseCategoriesPerformanceInput>;
  pwa: InputMaybe<FilterFindOneLighthouseCategoriesAccessibilityInput>;
  seo: InputMaybe<FilterFindOneLighthouseCategoriesAccessibilityInput>;
};

export type FilterFindOneLighthouseCategoriesPerformanceInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  id: Scalars['String']['input'];
  score: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type FilterFindOneLighthouseInput = {
  AND: InputMaybe<Array<FilterFindOneLighthouseInput>>;
  OR: InputMaybe<Array<FilterFindOneLighthouseInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneLighthouseOperatorsInput>;
  categories: InputMaybe<FilterFindOneLighthouseCategoriesInput>;
  dealerCode: InputMaybe<Scalars['String']['input']>;
  requestedUrl: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneLighthouseOperatorsInput = {
  _id: InputMaybe<FilterFindOneLighthouse_IdOperatorsInput>;
};

export type FilterFindOneLighthouse_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrivate_RoutesInput = {
  AND: InputMaybe<Array<FilterFindOnePrivate_RoutesInput>>;
  OR: InputMaybe<Array<FilterFindOnePrivate_RoutesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOnePrivate_RoutesOperatorsInput>;
  path: InputMaybe<Scalars['String']['input']>;
  roles: InputMaybe<Array<InputMaybe<EnumPrivate_RoutesRoles>>>;
  usernames: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrivate_RoutesOperatorsInput = {
  _id: InputMaybe<FilterFindOnePrivate_Routes_IdOperatorsInput>;
};

export type FilterFindOnePrivate_Routes_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneReporting_AggregatesInput = {
  AND: InputMaybe<Array<FilterFindOneReporting_AggregatesInput>>;
  OR: InputMaybe<Array<FilterFindOneReporting_AggregatesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneReporting_AggregatesOperatorsInput>;
  avgBounceRate: InputMaybe<Scalars['JSON']['input']>;
  avgSessionPages: InputMaybe<Scalars['JSON']['input']>;
  avgUserSession: InputMaybe<Scalars['JSON']['input']>;
  browserTraffic: InputMaybe<Scalars['JSON']['input']>;
  contactPageVisits: InputMaybe<Scalars['JSON']['input']>;
  count: InputMaybe<Scalars['Float']['input']>;
  deviceTraffic: InputMaybe<Scalars['JSON']['input']>;
  entranceBySourceMedium: InputMaybe<Scalars['JSON']['input']>;
  search_term: InputMaybe<Scalars['String']['input']>;
  timestamp: InputMaybe<Scalars['Date']['input']>;
  uniqueVisits: InputMaybe<Scalars['JSON']['input']>;
  viewportTraffic: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneReporting_AggregatesOperatorsInput = {
  _id: InputMaybe<FilterFindOneReporting_Aggregates_IdOperatorsInput>;
  search_term: InputMaybe<FilterFindOneReporting_AggregatesSearch_TermOperatorsInput>;
  timestamp: InputMaybe<FilterFindOneReporting_AggregatesTimestampOperatorsInput>;
};

export type FilterFindOneReporting_AggregatesSearch_TermOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneReporting_AggregatesTimestampOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneReporting_Aggregates_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneReporting_ConfigsInput = {
  AND: InputMaybe<Array<FilterFindOneReporting_ConfigsInput>>;
  OR: InputMaybe<Array<FilterFindOneReporting_ConfigsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneReporting_ConfigsOperatorsInput>;
  measurement_id: InputMaybe<Scalars['String']['input']>;
  parent_code: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<Scalars['Boolean']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  tracking_code: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumReporting_ConfigsType>;
  ua_view_id: InputMaybe<Scalars['String']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  vendor_code: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneReporting_ConfigsOperatorsInput = {
  _id: InputMaybe<FilterFindOneReporting_Configs_IdOperatorsInput>;
  region: InputMaybe<FilterFindOneReporting_ConfigsRegionOperatorsInput>;
  unit_code: InputMaybe<FilterFindOneReporting_ConfigsUnit_CodeOperatorsInput>;
  vendor_code: InputMaybe<FilterFindOneReporting_ConfigsVendor_CodeOperatorsInput>;
};

export type FilterFindOneReporting_ConfigsRegionOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneReporting_ConfigsUnit_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneReporting_ConfigsVendor_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneReporting_Configs_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSegmentsInput = {
  AND: InputMaybe<Array<FilterFindOneSegmentsInput>>;
  OR: InputMaybe<Array<FilterFindOneSegmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneSegmentsOperatorsInput>;
  hierarchy: InputMaybe<Scalars['Float']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  parent: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
  value: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneSegmentsNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSegmentsOperatorsInput = {
  _id: InputMaybe<FilterFindOneSegments_IdOperatorsInput>;
  name: InputMaybe<FilterFindOneSegmentsNameOperatorsInput>;
  value: InputMaybe<FilterFindOneSegmentsValueOperatorsInput>;
};

export type FilterFindOneSegmentsValueOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneSegments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneSterlingModulesCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumSterlingModulesCode>;
  gte: InputMaybe<EnumSterlingModulesCode>;
  in: InputMaybe<Array<InputMaybe<EnumSterlingModulesCode>>>;
  lt: InputMaybe<EnumSterlingModulesCode>;
  lte: InputMaybe<EnumSterlingModulesCode>;
  ne: InputMaybe<EnumSterlingModulesCode>;
  nin: InputMaybe<Array<InputMaybe<EnumSterlingModulesCode>>>;
};

export type FilterFindOneSterlingModulesInput = {
  AND: InputMaybe<Array<FilterFindOneSterlingModulesInput>>;
  OR: InputMaybe<Array<FilterFindOneSterlingModulesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneSterlingModulesOperatorsInput>;
  code: InputMaybe<EnumSterlingModulesCode>;
  routes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneSterlingModulesOperatorsInput = {
  _id: InputMaybe<FilterFindOneSterlingModules_IdOperatorsInput>;
  code: InputMaybe<FilterFindOneSterlingModulesCodeOperatorsInput>;
};

export type FilterFindOneSterlingModules_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTrackingInput = {
  AND: InputMaybe<Array<FilterFindOneTrackingInput>>;
  OR: InputMaybe<Array<FilterFindOneTrackingInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneTrackingOperatorsInput>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  event_date: InputMaybe<Scalars['Date']['input']>;
  event_type: InputMaybe<Scalars['String']['input']>;
  object_id: InputMaybe<Scalars['String']['input']>;
  object_type: InputMaybe<Scalars['String']['input']>;
  oem_codes: InputMaybe<Array<InputMaybe<EnumTrackingOem_Codes>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTrackingOperatorsInput = {
  _id: InputMaybe<FilterFindOneTracking_IdOperatorsInput>;
};

export type FilterFindOneTracking_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUnitsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUnitsInput = {
  AND: InputMaybe<Array<FilterFindOneUnitsInput>>;
  OR: InputMaybe<Array<FilterFindOneUnitsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneUnitsOperatorsInput>;
  address: InputMaybe<Scalars['String']['input']>;
  city: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  postal_code: InputMaybe<Scalars['String']['input']>;
  province: InputMaybe<Scalars['String']['input']>;
  segment_0: InputMaybe<Scalars['String']['input']>;
  segment_1: InputMaybe<Scalars['String']['input']>;
  vendor_name: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneUnitsNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUnitsOperatorsInput = {
  _id: InputMaybe<FilterFindOneUnits_IdOperatorsInput>;
  code: InputMaybe<FilterFindOneUnitsCodeOperatorsInput>;
  name: InputMaybe<FilterFindOneUnitsNameOperatorsInput>;
};

export type FilterFindOneUnits_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUsersCoe_RoleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumUsersCoe_Role>;
  gte: InputMaybe<EnumUsersCoe_Role>;
  in: InputMaybe<Array<InputMaybe<EnumUsersCoe_Role>>>;
  lt: InputMaybe<EnumUsersCoe_Role>;
  lte: InputMaybe<EnumUsersCoe_Role>;
  ne: InputMaybe<EnumUsersCoe_Role>;
  nin: InputMaybe<Array<InputMaybe<EnumUsersCoe_Role>>>;
};

export type FilterFindOneUsersCompliance_RoleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumUsersCompliance_Role>;
  gte: InputMaybe<EnumUsersCompliance_Role>;
  in: InputMaybe<Array<InputMaybe<EnumUsersCompliance_Role>>>;
  lt: InputMaybe<EnumUsersCompliance_Role>;
  lte: InputMaybe<EnumUsersCompliance_Role>;
  ne: InputMaybe<EnumUsersCompliance_Role>;
  nin: InputMaybe<Array<InputMaybe<EnumUsersCompliance_Role>>>;
};

export type FilterFindOneUsersInput = {
  AND: InputMaybe<Array<FilterFindOneUsersInput>>;
  OR: InputMaybe<Array<FilterFindOneUsersInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneUsersOperatorsInput>;
  coe_role: InputMaybe<EnumUsersCoe_Role>;
  coe_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment: InputMaybe<Scalars['String']['input']>;
  compliance_role: InputMaybe<EnumUsersCompliance_Role>;
  created: InputMaybe<Scalars['Date']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  last_login: InputMaybe<Scalars['String']['input']>;
  last_name: InputMaybe<Scalars['String']['input']>;
  locked: InputMaybe<Scalars['Boolean']['input']>;
  login_type: InputMaybe<EnumUsersLogin_Type>;
  modified: InputMaybe<Scalars['Date']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  module_permissions: InputMaybe<Array<InputMaybe<EnumUsersModule_Permissions>>>;
  oem_access: InputMaybe<Array<InputMaybe<EnumUsersOem_Access>>>;
  password: InputMaybe<Scalars['String']['input']>;
  preferred_language: InputMaybe<EnumUsersPreferred_Language>;
  refresh_token: InputMaybe<Scalars['String']['input']>;
  reviewer_role: InputMaybe<EnumUsersReviewer_Role>;
  reviewer_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumUsersType>;
  username: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUsersOperatorsInput = {
  _id: InputMaybe<FilterFindOneUsers_IdOperatorsInput>;
  coe_role: InputMaybe<FilterFindOneUsersCoe_RoleOperatorsInput>;
  compliance_role: InputMaybe<FilterFindOneUsersCompliance_RoleOperatorsInput>;
  username: InputMaybe<FilterFindOneUsersUsernameOperatorsInput>;
};

export type FilterFindOneUsersUsernameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUsers_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorsInput = {
  AND: InputMaybe<Array<FilterFindOneVendorsInput>>;
  OR: InputMaybe<Array<FilterFindOneVendorsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneVendorsOperatorsInput>;
  assessment_code: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<Scalars['Boolean']['input']>;
  reviewer_name: InputMaybe<Scalars['String']['input']>;
  segment_0: InputMaybe<Scalars['String']['input']>;
  segment_1: InputMaybe<Scalars['String']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  unit_name: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
  vendor_name: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVendorsOperatorsInput = {
  _id: InputMaybe<FilterFindOneVendors_IdOperatorsInput>;
  vendor_name: InputMaybe<FilterFindOneVendorsVendor_NameOperatorsInput>;
};

export type FilterFindOneVendorsVendor_NameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneVendors_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnelighthouse_AggregateInput = {
  AND: InputMaybe<Array<FilterFindOnelighthouse_AggregateInput>>;
  OR: InputMaybe<Array<FilterFindOnelighthouse_AggregateInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOnelighthouse_AggregateOperatorsInput>;
  categories: InputMaybe<FilterFindOneLighthouseCategoriesInput>;
  dealerCode: InputMaybe<Scalars['String']['input']>;
  oem: InputMaybe<Enumlighthouse_AggregateOem>;
  requestedUrl: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnelighthouse_AggregateOperatorsInput = {
  _id: InputMaybe<FilterFindOnelighthouse_Aggregate_IdOperatorsInput>;
};

export type FilterFindOnelighthouse_Aggregate_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneportal_Context_Assessment_LabelsAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Assessment_LabelsCategoriesInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  categoryCode: InputMaybe<Scalars['String']['input']>;
  categoryLabel: InputMaybe<FilterFindOneportal_Context_AssessmentsDataLabelInput>;
};

export type FilterFindOneportal_Context_Assessment_LabelsInput = {
  AND: InputMaybe<Array<FilterFindOneportal_Context_Assessment_LabelsInput>>;
  OR: InputMaybe<Array<FilterFindOneportal_Context_Assessment_LabelsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneportal_Context_Assessment_LabelsOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  assessmentLabel: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  categories: InputMaybe<Array<InputMaybe<FilterFindOneportal_Context_Assessment_LabelsCategoriesInput>>>;
  questions: InputMaybe<Array<InputMaybe<FilterFindOneportal_Context_Assessment_LabelsQuestionsInput>>>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneportal_Context_Assessment_LabelsOperatorsInput = {
  _id: InputMaybe<FilterFindOneportal_Context_Assessment_Labels_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindOneportal_Context_Assessment_LabelsAssessmentCodeOperatorsInput>;
};

export type FilterFindOneportal_Context_Assessment_LabelsQuestionsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  categoryLabel: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  improvement: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  questionCode: InputMaybe<Scalars['String']['input']>;
  questionLabel: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  questionRationale: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  resource: InputMaybe<FilterFindOneportal_Context_Assessment_LabelsQuestionsResourceInput>;
  videoLink: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
};

export type FilterFindOneportal_Context_Assessment_LabelsQuestionsResourceEnInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FilterFindOneportal_Context_Assessment_LabelsQuestionsResourceInput = {
  EN: InputMaybe<Array<InputMaybe<FilterFindOneportal_Context_Assessment_LabelsQuestionsResourceEnInput>>>;
  FR: InputMaybe<Array<InputMaybe<FilterFindOneportal_Context_Assessment_LabelsQuestionsResourceEnInput>>>;
};

export type FilterFindOneportal_Context_Assessment_Labels_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneportal_Context_AssessmentsAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_AssessmentsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_AssessmentsCompInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneportal_Context_AssessmentsDataInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
  label: InputMaybe<FilterFindOneportal_Context_AssessmentsDataLabelInput>;
};

export type FilterFindOneportal_Context_AssessmentsDataLabelInput = {
  EN: InputMaybe<Scalars['String']['input']>;
  FR: InputMaybe<Scalars['String']['input']>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneportal_Context_AssessmentsInput = {
  AND: InputMaybe<Array<FilterFindOneportal_Context_AssessmentsInput>>;
  OR: InputMaybe<Array<FilterFindOneportal_Context_AssessmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneportal_Context_AssessmentsOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  code: InputMaybe<Scalars['String']['input']>;
  comp: InputMaybe<FilterFindOneportal_Context_AssessmentsCompInput>;
  data: InputMaybe<FilterFindOneportal_Context_AssessmentsDataInput>;
  order: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneportal_Context_AssessmentsOperatorsInput = {
  _id: InputMaybe<FilterFindOneportal_Context_Assessments_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindOneportal_Context_AssessmentsAssessmentCodeOperatorsInput>;
  code: InputMaybe<FilterFindOneportal_Context_AssessmentsCodeOperatorsInput>;
  order: InputMaybe<FilterFindOneportal_Context_AssessmentsOrderOperatorsInput>;
};

export type FilterFindOneportal_Context_AssessmentsOrderOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOneportal_Context_Assessments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneportal_Context_Progress_Category_AverageAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_Category_AverageCategoryScoresInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  category: InputMaybe<Scalars['String']['input']>;
  scoreAverage: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneportal_Context_Progress_Category_AverageInput = {
  AND: InputMaybe<Array<FilterFindOneportal_Context_Progress_Category_AverageInput>>;
  OR: InputMaybe<Array<FilterFindOneportal_Context_Progress_Category_AverageInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneportal_Context_Progress_Category_AverageOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  categoryScores: InputMaybe<Array<InputMaybe<FilterFindOneportal_Context_Progress_Category_AverageCategoryScoresInput>>>;
  dealerAssessmentAverage: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneportal_Context_Progress_Category_AverageOperatorsInput = {
  _id: InputMaybe<FilterFindOneportal_Context_Progress_Category_Average_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindOneportal_Context_Progress_Category_AverageAssessmentCodeOperatorsInput>;
};

export type FilterFindOneportal_Context_Progress_Category_Average_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneportal_Context_Progress_ReportAssessmentCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportCategoryScoresInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  category: InputMaybe<Scalars['String']['input']>;
  score: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportDealerNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportFirstDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportInput = {
  AND: InputMaybe<Array<FilterFindOneportal_Context_Progress_ReportInput>>;
  OR: InputMaybe<Array<FilterFindOneportal_Context_Progress_ReportInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterFindOneportal_Context_Progress_ReportOperatorsInput>;
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  assessmentRank: InputMaybe<Scalars['Float']['input']>;
  categoryScores: InputMaybe<Array<InputMaybe<FilterFindOneportal_Context_Progress_ReportCategoryScoresInput>>>;
  dealerName: InputMaybe<Scalars['String']['input']>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
  pointsEarned: InputMaybe<Scalars['Float']['input']>;
  pointsMissed: InputMaybe<Scalars['Float']['input']>;
  pointsPossible: InputMaybe<Scalars['Float']['input']>;
  questionsReviewed: InputMaybe<Array<InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedInput>>>;
  secondDivisionCode: InputMaybe<Scalars['String']['input']>;
  totalDealers: InputMaybe<Scalars['Float']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
  vendorName: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneportal_Context_Progress_ReportOperatorsInput = {
  _id: InputMaybe<FilterFindOneportal_Context_Progress_Report_IdOperatorsInput>;
  assessmentCode: InputMaybe<FilterFindOneportal_Context_Progress_ReportAssessmentCodeOperatorsInput>;
  dealerName: InputMaybe<FilterFindOneportal_Context_Progress_ReportDealerNameOperatorsInput>;
  firstDivisionCode: InputMaybe<FilterFindOneportal_Context_Progress_ReportFirstDivisionCodeOperatorsInput>;
  secondDivisionCode: InputMaybe<FilterFindOneportal_Context_Progress_ReportSecondDivisionCodeOperatorsInput>;
  unitCode: InputMaybe<FilterFindOneportal_Context_Progress_ReportUnitCodeOperatorsInput>;
  vendorCode: InputMaybe<FilterFindOneportal_Context_Progress_ReportVendorCodeOperatorsInput>;
  vendorName: InputMaybe<FilterFindOneportal_Context_Progress_ReportVendorNameOperatorsInput>;
};

export type FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput = {
  EN: InputMaybe<Scalars['String']['input']>;
  FR: InputMaybe<Scalars['String']['input']>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportQuestionsReviewedInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  answer: InputMaybe<Scalars['String']['input']>;
  answerValue: InputMaybe<Scalars['Float']['input']>;
  assigned: InputMaybe<Enumportal_Context_Progress_ReportQuestionsReviewedAssigned>;
  categoryCode: InputMaybe<Scalars['String']['input']>;
  categoryLabel: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  comments: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  dealerName: InputMaybe<Scalars['String']['input']>;
  improvement: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  isRequired: InputMaybe<Scalars['Boolean']['input']>;
  priority: InputMaybe<Enumportal_Context_Progress_ReportQuestionsReviewedPriority>;
  questionCode: InputMaybe<Scalars['String']['input']>;
  questionLabel: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  questionRationale: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  resolveImpact: InputMaybe<Scalars['Float']['input']>;
  score: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedScoreInput>;
  screenshots: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: InputMaybe<Enumportal_Context_Progress_ReportQuestionsReviewedStatus>;
  tags: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
  vendorName: InputMaybe<Scalars['String']['input']>;
  videoLink: InputMaybe<FilterFindOneportal_Context_Progress_ReportQuestionsReviewedCommentsInput>;
  weight: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportQuestionsReviewedScoreInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  earned: InputMaybe<Scalars['Float']['input']>;
  max: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportSecondDivisionCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportUnitCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportVendorCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_ReportVendorNameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneportal_Context_Progress_Report_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveOneAdherence_ReviewsInput = {
  AND: InputMaybe<Array<FilterRemoveOneAdherence_ReviewsInput>>;
  OR: InputMaybe<Array<FilterRemoveOneAdherence_ReviewsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterRemoveOneAdherence_ReviewsOperatorsInput>;
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveOneAdherence_ReviewsOperatorsInput = {
  _id: InputMaybe<FilterRemoveOneAdherence_Reviews_IdOperatorsInput>;
  requestId: InputMaybe<FilterRemoveOneAdherence_ReviewsRequestIdOperatorsInput>;
};

export type FilterRemoveOneAdherence_ReviewsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveOneAdherence_Reviews_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterRemoveOneAssessmentsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveOneAssessmentsDateOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterRemoveOneAssessmentsInput = {
  AND: InputMaybe<Array<FilterRemoveOneAssessmentsInput>>;
  OR: InputMaybe<Array<FilterRemoveOneAssessmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterRemoveOneAssessmentsOperatorsInput>;
  categories: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: InputMaybe<Scalars['String']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['String']['input']>;
  remote_id: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_fr: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterRemoveOneAssessmentsOperatorsInput = {
  _id: InputMaybe<FilterRemoveOneAssessments_IdOperatorsInput>;
  code: InputMaybe<FilterRemoveOneAssessmentsCodeOperatorsInput>;
  date: InputMaybe<FilterRemoveOneAssessmentsDateOperatorsInput>;
};

export type FilterRemoveOneAssessments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyAdherence_ReviewsInput = {
  AND: InputMaybe<Array<FilterUpdateManyAdherence_ReviewsInput>>;
  OR: InputMaybe<Array<FilterUpdateManyAdherence_ReviewsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateManyAdherence_ReviewsOperatorsInput>;
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyAdherence_ReviewsOperatorsInput = {
  _id: InputMaybe<FilterUpdateManyAdherence_Reviews_IdOperatorsInput>;
  requestId: InputMaybe<FilterUpdateManyAdherence_ReviewsRequestIdOperatorsInput>;
};

export type FilterUpdateManyAdherence_ReviewsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyAdherence_Reviews_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyAdherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyAdherence_SubmissionsCreatedAtOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyAdherence_SubmissionsInput = {
  AND: InputMaybe<Array<FilterUpdateManyAdherence_SubmissionsInput>>;
  OR: InputMaybe<Array<FilterUpdateManyAdherence_SubmissionsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateManyAdherence_SubmissionsOperatorsInput>;
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<FilterUpdateManyAdherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyAdherence_SubmissionsOperatorsInput = {
  _id: InputMaybe<FilterUpdateManyAdherence_Submissions_IdOperatorsInput>;
  createdAt: InputMaybe<FilterUpdateManyAdherence_SubmissionsCreatedAtOperatorsInput>;
  requestId: InputMaybe<FilterUpdateManyAdherence_SubmissionsRequestIdOperatorsInput>;
};

export type FilterUpdateManyAdherence_SubmissionsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyAdherence_Submissions_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneAdherence_ReviewsInput = {
  AND: InputMaybe<Array<FilterUpdateOneAdherence_ReviewsInput>>;
  OR: InputMaybe<Array<FilterUpdateOneAdherence_ReviewsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateOneAdherence_ReviewsOperatorsInput>;
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneAdherence_ReviewsOperatorsInput = {
  _id: InputMaybe<FilterUpdateOneAdherence_Reviews_IdOperatorsInput>;
  requestId: InputMaybe<FilterUpdateOneAdherence_ReviewsRequestIdOperatorsInput>;
};

export type FilterUpdateOneAdherence_ReviewsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneAdherence_Reviews_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneAdherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneAdherence_SubmissionsCreatedAtOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneAdherence_SubmissionsInput = {
  AND: InputMaybe<Array<FilterUpdateOneAdherence_SubmissionsInput>>;
  OR: InputMaybe<Array<FilterUpdateOneAdherence_SubmissionsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateOneAdherence_SubmissionsOperatorsInput>;
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<FilterUpdateOneAdherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneAdherence_SubmissionsOperatorsInput = {
  _id: InputMaybe<FilterUpdateOneAdherence_Submissions_IdOperatorsInput>;
  createdAt: InputMaybe<FilterUpdateOneAdherence_SubmissionsCreatedAtOperatorsInput>;
  requestId: InputMaybe<FilterUpdateOneAdherence_SubmissionsRequestIdOperatorsInput>;
};

export type FilterUpdateOneAdherence_SubmissionsRequestIdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneAdherence_Submissions_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneAssessmentsCodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneAssessmentsDateOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneAssessmentsInput = {
  AND: InputMaybe<Array<FilterUpdateOneAssessmentsInput>>;
  OR: InputMaybe<Array<FilterUpdateOneAssessmentsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateOneAssessmentsOperatorsInput>;
  categories: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: InputMaybe<Scalars['String']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['String']['input']>;
  remote_id: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_fr: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneAssessmentsOperatorsInput = {
  _id: InputMaybe<FilterUpdateOneAssessments_IdOperatorsInput>;
  code: InputMaybe<FilterUpdateOneAssessmentsCodeOperatorsInput>;
  date: InputMaybe<FilterUpdateOneAssessmentsDateOperatorsInput>;
};

export type FilterUpdateOneAssessments_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneReporting_AggregatesInput = {
  AND: InputMaybe<Array<FilterUpdateOneReporting_AggregatesInput>>;
  OR: InputMaybe<Array<FilterUpdateOneReporting_AggregatesInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateOneReporting_AggregatesOperatorsInput>;
  avgBounceRate: InputMaybe<Scalars['JSON']['input']>;
  avgSessionPages: InputMaybe<Scalars['JSON']['input']>;
  avgUserSession: InputMaybe<Scalars['JSON']['input']>;
  browserTraffic: InputMaybe<Scalars['JSON']['input']>;
  contactPageVisits: InputMaybe<Scalars['JSON']['input']>;
  count: InputMaybe<Scalars['Float']['input']>;
  deviceTraffic: InputMaybe<Scalars['JSON']['input']>;
  entranceBySourceMedium: InputMaybe<Scalars['JSON']['input']>;
  search_term: InputMaybe<Scalars['String']['input']>;
  timestamp: InputMaybe<Scalars['Date']['input']>;
  uniqueVisits: InputMaybe<Scalars['JSON']['input']>;
  viewportTraffic: InputMaybe<Scalars['JSON']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneReporting_AggregatesOperatorsInput = {
  _id: InputMaybe<FilterUpdateOneReporting_Aggregates_IdOperatorsInput>;
  search_term: InputMaybe<FilterUpdateOneReporting_AggregatesSearch_TermOperatorsInput>;
  timestamp: InputMaybe<FilterUpdateOneReporting_AggregatesTimestampOperatorsInput>;
};

export type FilterUpdateOneReporting_AggregatesSearch_TermOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneReporting_AggregatesTimestampOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Date']['input']>;
  gte: InputMaybe<Scalars['Date']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt: InputMaybe<Scalars['Date']['input']>;
  lte: InputMaybe<Scalars['Date']['input']>;
  ne: InputMaybe<Scalars['Date']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneReporting_Aggregates_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneReporting_ConfigsInput = {
  AND: InputMaybe<Array<FilterUpdateOneReporting_ConfigsInput>>;
  OR: InputMaybe<Array<FilterUpdateOneReporting_ConfigsInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateOneReporting_ConfigsOperatorsInput>;
  measurement_id: InputMaybe<Scalars['String']['input']>;
  parent_code: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<Scalars['Boolean']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  tracking_code: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumReporting_ConfigsType>;
  ua_view_id: InputMaybe<Scalars['String']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  vendor_code: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneReporting_ConfigsOperatorsInput = {
  _id: InputMaybe<FilterUpdateOneReporting_Configs_IdOperatorsInput>;
  region: InputMaybe<FilterUpdateOneReporting_ConfigsRegionOperatorsInput>;
  unit_code: InputMaybe<FilterUpdateOneReporting_ConfigsUnit_CodeOperatorsInput>;
  vendor_code: InputMaybe<FilterUpdateOneReporting_ConfigsVendor_CodeOperatorsInput>;
};

export type FilterUpdateOneReporting_ConfigsRegionOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneReporting_ConfigsUnit_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneReporting_ConfigsVendor_CodeOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneReporting_Configs_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneUsersCoe_RoleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumUsersCoe_Role>;
  gte: InputMaybe<EnumUsersCoe_Role>;
  in: InputMaybe<Array<InputMaybe<EnumUsersCoe_Role>>>;
  lt: InputMaybe<EnumUsersCoe_Role>;
  lte: InputMaybe<EnumUsersCoe_Role>;
  ne: InputMaybe<EnumUsersCoe_Role>;
  nin: InputMaybe<Array<InputMaybe<EnumUsersCoe_Role>>>;
};

export type FilterUpdateOneUsersCompliance_RoleOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<EnumUsersCompliance_Role>;
  gte: InputMaybe<EnumUsersCompliance_Role>;
  in: InputMaybe<Array<InputMaybe<EnumUsersCompliance_Role>>>;
  lt: InputMaybe<EnumUsersCompliance_Role>;
  lte: InputMaybe<EnumUsersCompliance_Role>;
  ne: InputMaybe<EnumUsersCompliance_Role>;
  nin: InputMaybe<Array<InputMaybe<EnumUsersCompliance_Role>>>;
};

export type FilterUpdateOneUsersInput = {
  AND: InputMaybe<Array<FilterUpdateOneUsersInput>>;
  OR: InputMaybe<Array<FilterUpdateOneUsersInput>>;
  _id: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators: InputMaybe<FilterUpdateOneUsersOperatorsInput>;
  coe_role: InputMaybe<EnumUsersCoe_Role>;
  coe_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment: InputMaybe<Scalars['String']['input']>;
  compliance_role: InputMaybe<EnumUsersCompliance_Role>;
  created: InputMaybe<Scalars['Date']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  last_login: InputMaybe<Scalars['String']['input']>;
  last_name: InputMaybe<Scalars['String']['input']>;
  locked: InputMaybe<Scalars['Boolean']['input']>;
  login_type: InputMaybe<EnumUsersLogin_Type>;
  modified: InputMaybe<Scalars['Date']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  module_permissions: InputMaybe<Array<InputMaybe<EnumUsersModule_Permissions>>>;
  oem_access: InputMaybe<Array<InputMaybe<EnumUsersOem_Access>>>;
  password: InputMaybe<Scalars['String']['input']>;
  preferred_language: InputMaybe<EnumUsersPreferred_Language>;
  refresh_token: InputMaybe<Scalars['String']['input']>;
  reviewer_role: InputMaybe<EnumUsersReviewer_Role>;
  reviewer_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumUsersType>;
  username: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneUsersOperatorsInput = {
  _id: InputMaybe<FilterUpdateOneUsers_IdOperatorsInput>;
  coe_role: InputMaybe<FilterUpdateOneUsersCoe_RoleOperatorsInput>;
  compliance_role: InputMaybe<FilterUpdateOneUsersCompliance_RoleOperatorsInput>;
  username: InputMaybe<FilterUpdateOneUsersUsernameOperatorsInput>;
};

export type FilterUpdateOneUsersUsernameOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUsers_IdOperatorsInput = {
  exists: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['MongoID']['input']>;
  gte: InputMaybe<Scalars['MongoID']['input']>;
  in: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt: InputMaybe<Scalars['MongoID']['input']>;
  lte: InputMaybe<Scalars['MongoID']['input']>;
  ne: InputMaybe<Scalars['MongoID']['input']>;
  nin: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type GoogleTrend = {
  __typename?: 'GoogleTrend';
  averageInterest: Maybe<Scalars['Int']['output']>;
  noData: Scalars['Boolean']['output'];
  trendData: Maybe<Array<Maybe<GoogleTrendSegment>>>;
};

export type GoogleTrendSegment = {
  __typename?: 'GoogleTrendSegment';
  interest: Maybe<Scalars['Int']['output']>;
  time: Maybe<Scalars['String']['output']>;
};

export type GroupBy =
  | 'ASSESSMENT_CODE'
  | 'DISTRICT_CODE'
  | 'REGION_CODE'
  | 'REVIEWER_NAME'
  | 'UNIT_CODE'
  | 'VENDOR_NAME';

export type GroupByEnum =
  | 'CATEGORY_CODE'
  | 'PRIORITY'
  | 'STATUS';

export type InsertPrivateRouteDocument = {
  path: Scalars['String']['input'];
  roles: Array<InputMaybe<Scalars['String']['input']>>;
  usernames: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InsertVendorDocument = {
  code: Scalars['String']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  url: InputMaybe<Scalars['String']['input']>;
};

export type LanguageCode =
  | 'EN'
  | 'FR';

export type Lighthouse = {
  __typename?: 'Lighthouse';
  _id: Scalars['MongoID']['output'];
  categories: LighthouseCategories;
  dealerCode: Scalars['String']['output'];
  requestedUrl: Scalars['String']['output'];
};

export type LighthouseCategories = {
  __typename?: 'LighthouseCategories';
  _id: Maybe<Scalars['MongoID']['output']>;
  accessibility: Maybe<LighthouseCategoriesAccessibility>;
  bestPractices: Maybe<LighthouseCategoriesPerformance>;
  performance: Maybe<LighthouseCategoriesPerformance>;
  pwa: Maybe<LighthouseCategoriesAccessibility>;
  seo: Maybe<LighthouseCategoriesAccessibility>;
};

export type LighthouseCategoriesAccessibility = {
  __typename?: 'LighthouseCategoriesAccessibility';
  _id: Maybe<Scalars['MongoID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manualDescription: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type LighthouseCategoriesPerformance = {
  __typename?: 'LighthouseCategoriesPerformance';
  _id: Maybe<Scalars['MongoID']['output']>;
  id: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type LighthouseCategoryAggregate = {
  __typename?: 'LighthouseCategoryAggregate';
  accessibility: Maybe<LighthouseCategoryAggregateScore>;
  bestPractices: Maybe<LighthouseCategoryAggregateScore>;
  oem: Maybe<Scalars['String']['output']>;
  performance: Maybe<LighthouseCategoryAggregateScore>;
  seo: Maybe<LighthouseCategoryAggregateScore>;
};

export type LighthouseCategoryAggregateScore = {
  __typename?: 'LighthouseCategoryAggregateScore';
  avg: Maybe<Scalars['Float']['output']>;
  max: Maybe<Scalars['Float']['output']>;
};

export type LighthouseScore = {
  __typename?: 'LighthouseScore';
  accessibility: Maybe<Scalars['Int']['output']>;
  answer: Maybe<Scalars['String']['output']>;
  performance: Maybe<Scalars['Int']['output']>;
  seo: Maybe<Scalars['Int']['output']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  error: Scalars['String']['output'];
  language: Maybe<Scalars['String']['output']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type ManagementHomeSummaryCategoryType = {
  __typename?: 'ManagementHomeSummaryCategoryType';
  averageScore: Scalars['Float']['output'];
  category: Scalars['String']['output'];
  scoreChange: Scalars['Float']['output'];
};

export type ManagementHomeSummaryType = {
  __typename?: 'ManagementHomeSummaryType';
  averageScore: Scalars['Float']['output'];
  averageScoreChange: Scalars['Float']['output'];
  bestCategory: ManagementHomeSummaryCategoryType;
  worstCategory: ManagementHomeSummaryCategoryType;
};

export type ManagementRankType = {
  __typename?: 'ManagementRankType';
  assessmentManagerRank: Scalars['Int']['output'];
  dealerName: Scalars['String']['output'];
  previousScore: Maybe<Scalars['Int']['output']>;
  roundedScore: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  tapEligible: Scalars['Boolean']['output'];
};

export type ManagementReportQuestionType = {
  __typename?: 'ManagementReportQuestionType';
  _id: Scalars['String']['output'];
  assignedProblemInstances: Maybe<Scalars['Int']['output']>;
  assignedProblemQuestions: Maybe<Array<Maybe<ProblemQuestionType>>>;
  categoryCode: Scalars['String']['output'];
  completionPercentage: Scalars['Float']['output'];
  instances: Scalars['Int']['output'];
  pointDeficit: Scalars['Int']['output'];
  priority: Scalars['String']['output'];
  problemInstances: Scalars['Int']['output'];
  problemQuestions: Maybe<Array<Maybe<ProblemQuestionType>>>;
  questionCode: Scalars['String']['output'];
  resolveImpact: Maybe<Scalars['Float']['output']>;
  totalMaxPoints: Maybe<Scalars['Int']['output']>;
};

export type ManagementReportType = {
  __typename?: 'ManagementReportType';
  CRITICAL: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
  EVOLVED: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
  FUNDAMENTAL: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
  PROGRESSIVE: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
  SIGNIFICANT: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
};

export type ManagementStatusReportType = {
  __typename?: 'ManagementStatusReportType';
  completed: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
  inreview: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
  revise: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
  todo: Maybe<Array<Maybe<ManagementReportQuestionType>>>;
};

export type MediaChannelStats = {
  __typename?: 'MediaChannelStats';
  failed: Maybe<Scalars['Int']['output']>;
  mediaChannel: Maybe<Scalars['String']['output']>;
  reviewsCount: Maybe<Scalars['Int']['output']>;
};

export type Meta = {
  __typename?: 'Meta';
  documents: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  DEBUG_markAllReviewsAsRequested: Maybe<Scalars['Boolean']['output']>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  SterlingModuleCreateOne: Maybe<CreateOneSterlingModulesPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  adherenceReviewCreateMany: Maybe<CreateManyAdherence_ReviewsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  adherenceReviewCreateOne: Maybe<CreateOneAdherence_ReviewsPayload>;
  /** Remove one document: 1) Remove with hooks via findOneAndRemove. 2) Return removed document. */
  adherenceReviewRemoveOne: Maybe<RemoveOneAdherence_ReviewsPayload>;
  adherenceReviewSendApproval: Maybe<Scalars['String']['output']>;
  adherenceReviewSendDenial: Maybe<Scalars['String']['output']>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  adherenceReviewUpdateMany: Maybe<UpdateManyAdherence_ReviewsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  adherenceReviewUpdateOne: Maybe<UpdateOneAdherence_ReviewsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  adherenceSubmissionCreateMany: Maybe<CreateManyAdherence_SubmissionsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  adherenceSubmissionCreateOne: Maybe<CreateOneAdherence_SubmissionsPayload>;
  adherenceSubmissionMarkComplete: Maybe<Scalars['Boolean']['output']>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  adherenceSubmissionUpdateMany: Maybe<UpdateManyAdherence_SubmissionsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  adherenceSubmissionUpdateOne: Maybe<UpdateOneAdherence_SubmissionsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  assessmentCreateOne: Maybe<CreateOneAssessmentsPayload>;
  /** Remove one document: 1) Remove with hooks via findOneAndRemove. 2) Return removed document. */
  assessmentRemoveOne: Maybe<RemoveOneAssessmentsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  assessmentUpdateOne: Maybe<UpdateOneAssessmentsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  complianceCaseCreateOne: Maybe<CreateOnecompliance_CasesPayload>;
  complianceCaseUpdateCaseInformation: Maybe<Scalars['String']['output']>;
  complianceCaseUpdateInProgress: Scalars['Boolean']['output'];
  complianceCaseUpdateStatus: Scalars['Boolean']['output'];
  markAllAsRead: Maybe<Scalars['Boolean']['output']>;
  markAllAsUnread: Maybe<Scalars['Boolean']['output']>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  notificationTrackingCreateOne: Maybe<CreateOneNotificationTrackingsPayload>;
  preferred_language: Maybe<Scalars['Boolean']['output']>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  reportingAggregateUpdateById: Maybe<UpdateByIdReporting_AggregatesPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  reportingAggregateUpdateOne: Maybe<UpdateOneReporting_AggregatesPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  reportingConfigUpdateById: Maybe<UpdateByIdReporting_ConfigsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  reportingConfigUpdateOne: Maybe<UpdateOneReporting_ConfigsPayload>;
  route_permission: Maybe<Scalars['Boolean']['output']>;
  updateCheckpointState: Maybe<Scalars['Boolean']['output']>;
  updateContentTags: Maybe<Content>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  userCreateOne: Maybe<CreateOneUsersPayload>;
  userUpdateLanguage: Maybe<EnumUsersPreferred_Language>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdateOne: Maybe<UpdateOneUsersPayload>;
};


export type MutationSterlingModuleCreateOneArgs = {
  record: CreateOneSterlingModulesInput;
};


export type MutationAdherenceReviewCreateManyArgs = {
  records: Array<CreateManyAdherence_ReviewsInput>;
};


export type MutationAdherenceReviewCreateOneArgs = {
  record: CreateOneAdherence_ReviewsInput;
};


export type MutationAdherenceReviewRemoveOneArgs = {
  filter: InputMaybe<FilterRemoveOneAdherence_ReviewsInput>;
  sort: InputMaybe<SortRemoveOneAdherence_ReviewsInput>;
};


export type MutationAdherenceReviewSendApprovalArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationAdherenceReviewSendDenialArgs = {
  failedQuestionKeys: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestId: Scalars['String']['input'];
};


export type MutationAdherenceReviewUpdateManyArgs = {
  filter: InputMaybe<FilterUpdateManyAdherence_ReviewsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyAdherence_ReviewsInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateManyAdherence_ReviewsInput>;
};


export type MutationAdherenceReviewUpdateOneArgs = {
  filter: InputMaybe<FilterUpdateOneAdherence_ReviewsInput>;
  record: UpdateOneAdherence_ReviewsInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateOneAdherence_ReviewsInput>;
};


export type MutationAdherenceSubmissionCreateManyArgs = {
  records: Array<CreateManyAdherence_SubmissionsInput>;
};


export type MutationAdherenceSubmissionCreateOneArgs = {
  record: CreateOneAdherence_SubmissionsInput;
};


export type MutationAdherenceSubmissionMarkCompleteArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationAdherenceSubmissionUpdateManyArgs = {
  filter: InputMaybe<FilterUpdateManyAdherence_SubmissionsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyAdherence_SubmissionsInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateManyAdherence_SubmissionsInput>;
};


export type MutationAdherenceSubmissionUpdateOneArgs = {
  filter: InputMaybe<FilterUpdateOneAdherence_SubmissionsInput>;
  record: UpdateOneAdherence_SubmissionsInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateOneAdherence_SubmissionsInput>;
};


export type MutationAssessmentCreateOneArgs = {
  record: CreateOneAssessmentsInput;
};


export type MutationAssessmentRemoveOneArgs = {
  filter: InputMaybe<FilterRemoveOneAssessmentsInput>;
  sort: InputMaybe<SortRemoveOneAssessmentsInput>;
};


export type MutationAssessmentUpdateOneArgs = {
  filter: InputMaybe<FilterUpdateOneAssessmentsInput>;
  record: UpdateOneAssessmentsInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateOneAssessmentsInput>;
};


export type MutationComplianceCaseCreateOneArgs = {
  record: CreateOnecompliance_CasesInput;
};


export type MutationComplianceCaseUpdateCaseInformationArgs = {
  caseId: Scalars['String']['input'];
  category: Enumcompliance_CasesCaseInformationCategory;
  categoryOther: Scalars['String']['input'];
  evidence: Array<InputMaybe<Compliance_CasesCaseInformationEvidenceInput>>;
  infractionDate: Scalars['String']['input'];
  infractionLocation: InputMaybe<Scalars['String']['input']>;
  ongoing: Enumcompliance_CasesCaseInformationOngoing;
  summary: Scalars['String']['input'];
};


export type MutationComplianceCaseUpdateInProgressArgs = {
  caseId: Scalars['String']['input'];
  inProgress: Scalars['Boolean']['input'];
};


export type MutationComplianceCaseUpdateStatusArgs = {
  caseId: Scalars['String']['input'];
  dealerNotes: InputMaybe<Scalars['String']['input']>;
  internalNotes: InputMaybe<Scalars['String']['input']>;
  internalNotesName: InputMaybe<Scalars['String']['input']>;
  outcome: Enumcompliance_CasesOutcome;
  status: Enumcompliance_CasesStatus;
};


export type MutationMarkAllAsReadArgs = {
  ids: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationNotificationTrackingCreateOneArgs = {
  record: CreateOneNotificationTrackingsInput;
};


export type MutationPreferred_LanguageArgs = {
  language: LanguageCode;
};


export type MutationReportingAggregateUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdReporting_AggregatesInput;
};


export type MutationReportingAggregateUpdateOneArgs = {
  filter: InputMaybe<FilterUpdateOneReporting_AggregatesInput>;
  record: UpdateOneReporting_AggregatesInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateOneReporting_AggregatesInput>;
};


export type MutationReportingConfigUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdReporting_ConfigsInput;
};


export type MutationReportingConfigUpdateOneArgs = {
  filter: InputMaybe<FilterUpdateOneReporting_ConfigsInput>;
  record: UpdateOneReporting_ConfigsInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateOneReporting_ConfigsInput>;
};


export type MutationRoute_PermissionArgs = {
  path: Scalars['String']['input'];
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdateCheckpointStateArgs = {
  assigned: InputMaybe<Scalars['String']['input']>;
  questionCodes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status: InputMaybe<Scalars['String']['input']>;
  unitCodes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateContentTagsArgs = {
  tags: Array<InputMaybe<Scalars['String']['input']>>;
  wordpress_id: Scalars['Int']['input'];
};


export type MutationUserCreateOneArgs = {
  record: CreateOneUsersInput;
};


export type MutationUserUpdateLanguageArgs = {
  language: LanguageCode;
};


export type MutationUserUpdateOneArgs = {
  filter: InputMaybe<FilterUpdateOneUsersInput>;
  record: UpdateOneUsersInput;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortUpdateOneUsersInput>;
};

export type NotificationTrackings = {
  __typename?: 'NotificationTrackings';
  _id: Scalars['MongoID']['output'];
  notification_id: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type OemCode =
  | 'DEMO'
  | 'HACC'
  | 'MMSC';

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage: Maybe<Scalars['Boolean']['output']>;
  itemCount: Maybe<Scalars['Int']['output']>;
  pageCount: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type PreferredVendorComparisonDocument = {
  __typename?: 'PreferredVendorComparisonDocument';
  nonPreferredAvgScore: Scalars['Float']['output'];
  nonPreferredMarketShare: Scalars['Float']['output'];
  preferredAvgScore: Scalars['Float']['output'];
  preferredMarketShare: Scalars['Float']['output'];
};

export type PrivateRouteDocument = {
  __typename?: 'PrivateRouteDocument';
  _id: Scalars['String']['output'];
  path: Scalars['String']['output'];
  roles: Array<Maybe<Scalars['String']['output']>>;
  usernames: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Private_Routes = {
  __typename?: 'Private_Routes';
  _id: Scalars['MongoID']['output'];
  path: Scalars['String']['output'];
  roles: Array<Maybe<EnumPrivate_RoutesRoles>>;
  usernames: Maybe<Scalars['String']['output']>;
};

export type ProblemQuestionType = {
  __typename?: 'ProblemQuestionType';
  answerValue: Scalars['Int']['output'];
  assigned: Maybe<Scalars['String']['output']>;
  categoryCode: Scalars['String']['output'];
  dealerName: Maybe<Scalars['String']['output']>;
  score: Maybe<ReportScore>;
  status: Maybe<Scalars['String']['output']>;
  unitCode: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type ProgressHomeFilterOptionsType = {
  __typename?: 'ProgressHomeFilterOptionsType';
  dealers: Maybe<Array<Maybe<DealerCodesAndNames>>>;
  divisions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendor: Maybe<Array<Maybe<VendorCodesAndNames>>>;
};

export type ProgressQuestionsByPriority = {
  __typename?: 'ProgressQuestionsByPriority';
  CRITICAL: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  EVOLVED: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  FUNDAMENTAL: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  PROGRESSIVE: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  SIGNIFICANT: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
};

export type Query = {
  __typename?: 'Query';
  adherenceCardsMany: Array<Adherence_Cards>;
  adherenceCardsOne: Maybe<Adherence_Cards>;
  adherenceContentMany: Array<Adherence_Content>;
  adherenceContentOne: Maybe<Adherence_Content>;
  adherenceContentSearch: Maybe<Array<Maybe<Adherence_Content>>>;
  adherenceCriteriaCount: Maybe<Scalars['Int']['output']>;
  adherenceCriteriaMany: Array<Adherence_Criteria>;
  adherenceCriteriaOne: Maybe<Adherence_Criteria>;
  adherenceMediaChannelPassrateByCampaign: Maybe<AdherenceCampaignResults>;
  adherenceReviewCount: Maybe<Scalars['Int']['output']>;
  adherenceReviewFindMany: Array<Adherence_Reviews>;
  adherenceReviewFindOne: Maybe<Adherence_Reviews>;
  adherenceReviewSummaryDashboard: Maybe<Array<Maybe<AdherenceReviewDealerSummary>>>;
  adherenceSubmissionCount: Maybe<Scalars['Int']['output']>;
  adherenceSubmissionMany: Array<Adherence_Submissions>;
  adherenceSubmissionOne: Maybe<Adherence_Submissions>;
  adherenceSubmissionPagination: Maybe<Adherence_SubmissionsPagination>;
  adherence_content: Maybe<ContentOld>;
  assessmentEndDate: Scalars['String']['output'];
  assessmentMany: Array<Assessments>;
  assessmentOne: Maybe<Assessments>;
  assessmentStartDate: Scalars['String']['output'];
  assessmentSummariesGroup: AssessmentSummaryGroupPreQuery;
  assessmentSummaryMany: Array<Assessment_Summary>;
  assessmentSummaryManyGroup: Maybe<AssessmentSummaryGroupPreQuery>;
  assessmentSummaryOne: Maybe<Assessment_Summary>;
  assessmentSummaryTopByVendor: Maybe<TopByVendor>;
  assessments: Maybe<Array<Maybe<AssessmentDetails>>>;
  autocompleteSearch: Maybe<Array<Maybe<SearchResult>>>;
  categoriesMany: Array<Categories>;
  complianceCasesMany: Array<Compliance_Cases>;
  configurationOne: Maybe<Configurations>;
  content: Maybe<ContentOld>;
  contentBusinessInsightMany: Array<Content_Business_Insights>;
  contentBusinessInsightOne: Maybe<Content_Business_Insights>;
  contentMany: Array<Content>;
  contentNotificationMany: Array<Content_Notifications>;
  contentNotificationOne: Maybe<Content_Notifications>;
  contentOne: Maybe<Content>;
  contentProgramUpdateMany: Array<Content_Program_Updates>;
  contentProgramUpdateOne: Maybe<Content_Program_Updates>;
  contentSearch: Maybe<Array<Maybe<SearchResult>>>;
  contentVendorMany: Array<Content_Vendor>;
  contentVendorOne: Maybe<Content_Vendor>;
  contentWebinarMany: Array<Content_Webinars>;
  contentWebinarOne: Maybe<Content_Webinars>;
  contextQuestionsByPriority: Maybe<QuestionsByWeightGroup>;
  executive_summary: Maybe<Array<Maybe<ExecutiveSummary>>>;
  generateSearchKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  google_trends: Maybe<GoogleTrend>;
  lighthouseAggregateByOem: Maybe<Array<Maybe<LighthouseCategoryAggregate>>>;
  lighthouseAggregateMany: Array<Lighthouse_Aggregate>;
  lighthouseAggregateOne: Maybe<Lighthouse_Aggregate>;
  lighthouseMany: Array<Lighthouse>;
  lighthouseOne: Maybe<Lighthouse>;
  lighthouse_question_analysis: Maybe<Array<Maybe<QuestionScoreByLighthouseCategory>>>;
  login: Maybe<LoginResponse>;
  logout: Maybe<LogoutResponse>;
  oem_independent_private_route: PrivateRouteDocument;
  oem_independent_private_routes: Array<Maybe<PrivateRouteDocument>>;
  permittedRoutes: Array<Scalars['String']['output']>;
  platform_master_vendor: Maybe<VendorDocument>;
  platform_master_vendors: Maybe<Array<Maybe<VendorDocument>>>;
  portalContextAssessmentLabelOne: Maybe<Portal_Context_Assessment_Labels>;
  portalContextAssessmentsMany: Array<Portal_Context_Assessments>;
  portalContextAssessmentsOne: Maybe<Portal_Context_Assessments>;
  portalContextCategoriesMany: Array<Portal_Context_Categories>;
  portalContextFirstDivisionsMany: Array<Portal_Context_Divisions_First>;
  portalContextManagementDealerFilters: Maybe<ProgressHomeFilterOptionsType>;
  portalContextManagementDealerRanks: Maybe<Array<Maybe<ManagementRankType>>>;
  portalContextManagementDivisionDisplay: Maybe<Scalars['String']['output']>;
  portalContextManagementProgressHome: Maybe<ManagementReportType>;
  portalContextManagementProgressHomeSummary: Maybe<ManagementHomeSummaryType>;
  portalContextManagementProgressStatusReport: Maybe<ManagementStatusReportType>;
  portalContextOemDealerFilters: Maybe<ProgressHomeFilterOptionsType>;
  portalContextOemDealerRanks: Maybe<Array<Maybe<ManagementRankType>>>;
  portalContextOemProgressHome: Maybe<ManagementReportType>;
  portalContextOemProgressHomeSummary: Maybe<ManagementHomeSummaryType>;
  portalContextOemProgressStatusReport: Maybe<ManagementStatusReportType>;
  portalContextProgressCategoryOne: Maybe<Portal_Context_Progress_Category_Average>;
  portalContextProgressReportByPriority: Maybe<ProgressQuestionsByPriority>;
  portalContextProgressReportByStatus: Maybe<DealerStatusReportType>;
  portalContextProgressReportIsMultiDealer: Scalars['Boolean']['output'];
  portalContextProgressReportMany: Array<Portal_Context_Progress_Report>;
  portalContextProgressReportOne: Maybe<Portal_Context_Progress_Report>;
  portalContextProgressReportPreviousOne: Maybe<Portal_Context_Progress_Report>;
  portalContextProgressReportQuestionById: Maybe<DealerReportPanelData>;
  portalContextQuestionsMany: Array<Portal_Context_Questions>;
  portalContextResponsesMany: Array<Portal_Context_Responses>;
  portalContextSecondDivisionsMany: Array<Portal_Context_Divisions_Second>;
  portalContextTagsMany: Array<Portal_Context_Tags>;
  portalContextUnitsMany: Array<Portal_Context_Units>;
  portalContextVendorDealerFilters: Maybe<ProgressHomeFilterOptionsType>;
  portalContextVendorDealerRanks: Maybe<Array<Maybe<ManagementRankType>>>;
  portalContextVendorNameFromToken: Maybe<Scalars['String']['output']>;
  portalContextVendorProgressHome: Maybe<ManagementReportType>;
  portalContextVendorProgressHomeRevisions: Maybe<Array<Maybe<VendorProgressHomeRevision>>>;
  portalContextVendorProgressHomeSummary: Maybe<ManagementHomeSummaryType>;
  portalContextVendorProgressStatusReport: Maybe<ManagementStatusReportType>;
  portalContextVendorsMany: Array<Portal_Context_Vendors>;
  preferredVendorComparison: Maybe<PreferredVendorComparisonDocument>;
  privateRouteMany: Array<Private_Routes>;
  privateRouteOne: Maybe<Private_Routes>;
  reportingAggregateGetOrCreate: Maybe<Array<Maybe<Reporting_Aggregates>>>;
  reportingAggregateGetVendor: Maybe<Array<Maybe<Reporting_Aggregates>>>;
  reportingAggregateMany: Array<Reporting_Aggregates>;
  reportingAggregateOne: Maybe<Reporting_Aggregates>;
  reportingConfigMany: Array<Reporting_Configs>;
  reportingConfigOne: Maybe<Reporting_Configs>;
  reportingConfigUnitTracking: Maybe<Reporting_Configs>;
  reportingConfigVendorProp: Maybe<Reporting_Configs>;
  reportingConfigVendorSites: Maybe<Array<Maybe<Reporting_Configs>>>;
  reportingConfigViewIds: Maybe<WebProperties>;
  responsesQuestionsByPoints: Maybe<Array<Maybe<Portal_Context_Responses>>>;
  reviewsMany: Array<Reviews>;
  routePermission: Maybe<Scalars['Boolean']['output']>;
  routes: Array<Maybe<PrivateRouteDocument>>;
  scores: Maybe<ScoreAggregatePackage>;
  searchContentPages: Maybe<Array<Maybe<Content>>>;
  seenNotifications: Maybe<Array<Maybe<NotificationTrackings>>>;
  segmentsMany: Array<Segments>;
  segmentsManyByRole: Maybe<Array<Maybe<Segments>>>;
  segmentsOne: Maybe<Segments>;
  sterlingModuleOne: Maybe<SterlingModules>;
  tagSearch: Maybe<Array<Maybe<SearchResult>>>;
  tagSuggestionSearch: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  top_level_adherence_contents: Maybe<Array<Maybe<ContentOld>>>;
  top_level_contents: Maybe<Array<Maybe<ContentOld>>>;
  trackingMany: Array<Tracking>;
  trackingOne: Maybe<Tracking>;
  unitCodeByUser: Maybe<Scalars['String']['output']>;
  unitNameByUser: Scalars['String']['output'];
  unitsMany: Array<Units>;
  unitsManyByReporting: Maybe<Array<Maybe<Units>>>;
  unitsManyByRole: Maybe<Array<Maybe<Units>>>;
  unitsOne: Maybe<Units>;
  userMany: Array<Users>;
  userOne: Maybe<Users>;
  vendors: Maybe<Array<Maybe<Vendor>>>;
  vendorsMany: Array<Vendors>;
  vendorsOne: Maybe<Vendors>;
};


export type QueryAdherenceCardsManyArgs = {
  filter: InputMaybe<FilterFindManyAdherence_CardsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAdherence_CardsInput>;
};


export type QueryAdherenceCardsOneArgs = {
  filter: InputMaybe<FilterFindOneAdherence_CardsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneAdherence_CardsInput>;
};


export type QueryAdherenceContentManyArgs = {
  filter: InputMaybe<FilterFindManyAdherence_ContentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAdherence_ContentInput>;
};


export type QueryAdherenceContentOneArgs = {
  language: InputMaybe<Scalars['String']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdherenceContentSearchArgs = {
  language: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdherenceCriteriaCountArgs = {
  filter: InputMaybe<FilterCountAdherence_CriteriaInput>;
};


export type QueryAdherenceCriteriaManyArgs = {
  filter: InputMaybe<FilterFindManyAdherence_CriteriaInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAdherence_CriteriaInput>;
};


export type QueryAdherenceCriteriaOneArgs = {
  filter: InputMaybe<FilterFindOneAdherence_CriteriaInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneAdherence_CriteriaInput>;
};


export type QueryAdherenceMediaChannelPassrateByCampaignArgs = {
  campaign: InputMaybe<Scalars['String']['input']>;
  previousCampaign: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdherenceReviewCountArgs = {
  filter: InputMaybe<FilterCountAdherence_ReviewsInput>;
};


export type QueryAdherenceReviewFindManyArgs = {
  filter: InputMaybe<FilterFindManyAdherence_ReviewsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAdherence_ReviewsInput>;
};


export type QueryAdherenceReviewFindOneArgs = {
  filter: InputMaybe<FilterFindOneAdherence_ReviewsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneAdherence_ReviewsInput>;
};


export type QueryAdherenceSubmissionCountArgs = {
  filter: InputMaybe<FilterCountAdherence_SubmissionsInput>;
};


export type QueryAdherenceSubmissionManyArgs = {
  filter: InputMaybe<FilterFindManyAdherence_SubmissionsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAdherence_SubmissionsInput>;
};


export type QueryAdherenceSubmissionOneArgs = {
  filter: InputMaybe<FilterFindOneAdherence_SubmissionsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneAdherence_SubmissionsInput>;
};


export type QueryAdherenceSubmissionPaginationArgs = {
  filter: InputMaybe<FilterFindManyAdherence_SubmissionsInput>;
  page: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAdherence_SubmissionsInput>;
};


export type QueryAdherence_ContentArgs = {
  language: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type QueryAssessmentEndDateArgs = {
  assessmentCode: Scalars['String']['input'];
};


export type QueryAssessmentManyArgs = {
  filter: InputMaybe<FilterFindManyAssessmentsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAssessmentsInput>;
};


export type QueryAssessmentOneArgs = {
  filter: InputMaybe<FilterFindOneAssessmentsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneAssessmentsInput>;
};


export type QueryAssessmentStartDateArgs = {
  assessmentCode: Scalars['String']['input'];
};


export type QueryAssessmentSummariesGroupArgs = {
  assessmentCode: Scalars['String']['input'];
  categorySort: InputMaybe<Scalars['String']['input']>;
  filterBool: InputMaybe<Scalars['Boolean']['input']>;
  filterBoolTwo: InputMaybe<Scalars['Boolean']['input']>;
  filterBy: InputMaybe<FilterBy>;
  filterByTwo: InputMaybe<FilterBy>;
  filterRole: InputMaybe<Scalars['Boolean']['input']>;
  filterText: InputMaybe<Scalars['String']['input']>;
  filterTextTwo: InputMaybe<Scalars['String']['input']>;
  groupBy: GroupBy;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryAssessmentSummaryManyArgs = {
  filter: InputMaybe<FilterFindManyAssessment_SummaryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyAssessment_SummaryInput>;
};


export type QueryAssessmentSummaryManyGroupArgs = {
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  categorySort: InputMaybe<Scalars['String']['input']>;
  filterBool: InputMaybe<Scalars['Boolean']['input']>;
  filterBoolTwo: InputMaybe<Scalars['Boolean']['input']>;
  filterBy: InputMaybe<Scalars['String']['input']>;
  filterByTwo: InputMaybe<Scalars['String']['input']>;
  filterRole: InputMaybe<Scalars['Boolean']['input']>;
  filterText: InputMaybe<Scalars['String']['input']>;
  filterTextTwo: InputMaybe<Scalars['String']['input']>;
  groupBy: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssessmentSummaryOneArgs = {
  filter: InputMaybe<FilterFindOneAssessment_SummaryInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneAssessment_SummaryInput>;
};


export type QueryAssessmentSummaryTopByVendorArgs = {
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  vendorName: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutocompleteSearchArgs = {
  language: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoriesManyArgs = {
  filter: InputMaybe<FilterFindManyCategoriesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyCategoriesInput>;
};


export type QueryComplianceCasesManyArgs = {
  adminView: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManycompliance_CasesInput>;
};


export type QueryConfigurationOneArgs = {
  filter: InputMaybe<FilterFindOneConfigurationsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneConfigurationsInput>;
};


export type QueryContentArgs = {
  language: Scalars['String']['input'];
  path: Scalars['String']['input'];
};


export type QueryContentBusinessInsightManyArgs = {
  filter: InputMaybe<FilterFindManyContent_Business_InsightsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyContent_Business_InsightsInput>;
};


export type QueryContentBusinessInsightOneArgs = {
  filter: InputMaybe<FilterFindOneContent_Business_InsightsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneContent_Business_InsightsInput>;
};


export type QueryContentManyArgs = {
  filter: InputMaybe<FilterFindManyContentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyContentInput>;
};


export type QueryContentNotificationManyArgs = {
  filter: InputMaybe<FilterFindManyContent_NotificationsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyContent_NotificationsInput>;
};


export type QueryContentNotificationOneArgs = {
  filter: InputMaybe<FilterFindOneContent_NotificationsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneContent_NotificationsInput>;
};


export type QueryContentOneArgs = {
  language: InputMaybe<Scalars['String']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentProgramUpdateManyArgs = {
  filter: InputMaybe<FilterFindManyContent_Program_UpdatesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyContent_Program_UpdatesInput>;
};


export type QueryContentProgramUpdateOneArgs = {
  filter: InputMaybe<FilterFindOneContent_Program_UpdatesInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneContent_Program_UpdatesInput>;
};


export type QueryContentSearchArgs = {
  language: InputMaybe<Scalars['String']['input']>;
  noLimit: InputMaybe<Scalars['Boolean']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentVendorManyArgs = {
  filter: InputMaybe<FilterFindManyContent_VendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyContent_VendorInput>;
};


export type QueryContentVendorOneArgs = {
  filter: InputMaybe<FilterFindOneContent_VendorInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneContent_VendorInput>;
};


export type QueryContentWebinarManyArgs = {
  filter: InputMaybe<FilterFindManyContent_WebinarsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyContent_WebinarsInput>;
};


export type QueryContentWebinarOneArgs = {
  filter: InputMaybe<FilterFindOneContent_WebinarsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneContent_WebinarsInput>;
};


export type QueryContextQuestionsByPriorityArgs = {
  assessmentCode: Scalars['String']['input'];
  languageCode: LanguageCode;
};


export type QueryExecutive_SummaryArgs = {
  assessmentCode: Scalars['String']['input'];
};


export type QueryGenerateSearchKeywordsArgs = {
  language: LanguageCode;
  text: Scalars['String']['input'];
};


export type QueryGoogle_TrendsArgs = {
  dealerName: Scalars['String']['input'];
};


export type QueryLighthouseAggregateManyArgs = {
  filter: InputMaybe<FilterFindManylighthouse_AggregateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManylighthouse_AggregateInput>;
};


export type QueryLighthouseAggregateOneArgs = {
  filter: InputMaybe<FilterFindOnelighthouse_AggregateInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOnelighthouse_AggregateInput>;
};


export type QueryLighthouseManyArgs = {
  filter: InputMaybe<FilterFindManyLighthouseInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyLighthouseInput>;
};


export type QueryLighthouseOneArgs = {
  filter: InputMaybe<FilterFindOneLighthouseInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneLighthouseInput>;
};


export type QueryLighthouse_Question_AnalysisArgs = {
  assessmentCode: Scalars['String']['input'];
};


export type QueryLoginArgs = {
  isPresentation: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QueryOem_Independent_Private_RouteArgs = {
  path: Scalars['String']['input'];
};


export type QueryPlatform_Master_VendorArgs = {
  code: Scalars['String']['input'];
};


export type QueryPortalContextAssessmentLabelOneArgs = {
  filter: InputMaybe<FilterFindOneportal_Context_Assessment_LabelsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneportal_Context_Assessment_LabelsInput>;
};


export type QueryPortalContextAssessmentsManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_AssessmentsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_AssessmentsInput>;
};


export type QueryPortalContextAssessmentsOneArgs = {
  filter: InputMaybe<FilterFindOneportal_Context_AssessmentsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneportal_Context_AssessmentsInput>;
};


export type QueryPortalContextCategoriesManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_CategoriesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_CategoriesInput>;
};


export type QueryPortalContextFirstDivisionsManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_Divisions_FirstInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_Divisions_FirstInput>;
};


export type QueryPortalContextManagementDealerFiltersArgs = {
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextManagementProgressHomeArgs = {
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextManagementProgressHomeSummaryArgs = {
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextManagementProgressStatusReportArgs = {
  groupBy: InputMaybe<GroupByEnum>;
  unitCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextOemDealerFiltersArgs = {
  division: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextOemProgressHomeArgs = {
  division: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextOemProgressHomeSummaryArgs = {
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextOemProgressStatusReportArgs = {
  division: InputMaybe<Scalars['String']['input']>;
  groupBy: InputMaybe<GroupByEnum>;
  status: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextProgressCategoryOneArgs = {
  filter: InputMaybe<FilterFindOneportal_Context_Progress_Category_AverageInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneportal_Context_Progress_Category_AverageInput>;
};


export type QueryPortalContextProgressReportManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_Progress_ReportInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_Progress_ReportInput>;
};


export type QueryPortalContextProgressReportOneArgs = {
  filter: InputMaybe<FilterFindOneportal_Context_Progress_ReportInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneportal_Context_Progress_ReportInput>;
};


export type QueryPortalContextProgressReportPreviousOneArgs = {
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  unitCode: Scalars['String']['input'];
};


export type QueryPortalContextProgressReportQuestionByIdArgs = {
  questionCode: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextQuestionsManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_QuestionsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_QuestionsInput>;
};


export type QueryPortalContextResponsesManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_ResponsesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_ResponsesInput>;
};


export type QueryPortalContextSecondDivisionsManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_Divisions_SecondInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_Divisions_SecondInput>;
};


export type QueryPortalContextTagsManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_TagsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_TagsInput>;
};


export type QueryPortalContextUnitsManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_UnitsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_UnitsInput>;
};


export type QueryPortalContextVendorProgressHomeArgs = {
  unitCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextVendorProgressHomeRevisionsArgs = {
  assessmentCode: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextVendorProgressHomeSummaryArgs = {
  unitCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextVendorProgressStatusReportArgs = {
  assigneeOnly: InputMaybe<Scalars['Boolean']['input']>;
  groupBy: InputMaybe<GroupByEnum>;
  unitCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortalContextVendorsManyArgs = {
  filter: InputMaybe<FilterFindManyportal_Context_VendorsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyportal_Context_VendorsInput>;
};


export type QueryPreferredVendorComparisonArgs = {
  assessmentCode: Scalars['String']['input'];
};


export type QueryPrivateRouteManyArgs = {
  filter: InputMaybe<FilterFindManyPrivate_RoutesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyPrivate_RoutesInput>;
};


export type QueryPrivateRouteOneArgs = {
  filter: InputMaybe<FilterFindOnePrivate_RoutesInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOnePrivate_RoutesInput>;
};


export type QueryReportingAggregateGetOrCreateArgs = {
  search_term: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportingAggregateManyArgs = {
  filter: InputMaybe<FilterFindManyReporting_AggregatesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyReporting_AggregatesInput>;
};


export type QueryReportingAggregateOneArgs = {
  filter: InputMaybe<FilterFindOneReporting_AggregatesInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneReporting_AggregatesInput>;
};


export type QueryReportingConfigManyArgs = {
  filter: InputMaybe<FilterFindManyReporting_ConfigsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyReporting_ConfigsInput>;
};


export type QueryReportingConfigOneArgs = {
  filter: InputMaybe<FilterFindOneReporting_ConfigsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneReporting_ConfigsInput>;
};


export type QueryReportingConfigUnitTrackingArgs = {
  create: InputMaybe<Scalars['Boolean']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportingConfigViewIdsArgs = {
  update: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryResponsesQuestionsByPointsArgs = {
  assessmentCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryReviewsManyArgs = {
  filter: InputMaybe<FilterFindManyReviewsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyReviewsInput>;
};


export type QueryRoutePermissionArgs = {
  path: Scalars['String']['input'];
};


export type QueryScoresArgs = {
  aggregateOn: SterlingKey;
  cacheKey: InputMaybe<Scalars['String']['input']>;
  filter: ScoreFilter;
};


export type QuerySegmentsManyArgs = {
  filter: InputMaybe<FilterFindManySegmentsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManySegmentsInput>;
};


export type QuerySegmentsManyByRoleArgs = {
  assessmentCode: InputMaybe<Scalars['String']['input']>;
};


export type QuerySegmentsOneArgs = {
  filter: InputMaybe<FilterFindOneSegmentsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneSegmentsInput>;
};


export type QuerySterlingModuleOneArgs = {
  filter: InputMaybe<FilterFindOneSterlingModulesInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneSterlingModulesInput>;
};


export type QueryTagSearchArgs = {
  language: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagSuggestionSearchArgs = {
  language: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryTop_Level_Adherence_ContentsArgs = {
  itemType: InputMaybe<Scalars['String']['input']>;
  language: LanguageCode;
};


export type QueryTop_Level_ContentsArgs = {
  itemType: InputMaybe<Scalars['String']['input']>;
  language: LanguageCode;
};


export type QueryTrackingManyArgs = {
  filter: InputMaybe<FilterFindManyTrackingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyTrackingInput>;
};


export type QueryTrackingOneArgs = {
  filter: InputMaybe<FilterFindOneTrackingInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneTrackingInput>;
};


export type QueryUnitsManyArgs = {
  filter: InputMaybe<FilterFindManyUnitsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyUnitsInput>;
};


export type QueryUnitsManyByRoleArgs = {
  unitCode: InputMaybe<Scalars['String']['input']>;
};


export type QueryUnitsOneArgs = {
  filter: InputMaybe<FilterFindOneUnitsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneUnitsInput>;
};


export type QueryUserManyArgs = {
  filter: InputMaybe<FilterFindManyUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyUsersInput>;
};


export type QueryUserOneArgs = {
  filter: InputMaybe<FilterFindOneUsersInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneUsersInput>;
};


export type QueryVendorsArgs = {
  assessmentCode: Scalars['String']['input'];
};


export type QueryVendorsManyArgs = {
  filter: InputMaybe<FilterFindManyVendorsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindManyVendorsInput>;
};


export type QueryVendorsOneArgs = {
  filter: InputMaybe<FilterFindOneVendorsInput>;
  skip: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<SortFindOneVendorsInput>;
};

export type Question = {
  __typename?: 'Question';
  label: Maybe<Scalars['String']['output']>;
  label_french: Maybe<Scalars['String']['output']>;
  layout: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  rationale_EN: Maybe<Scalars['String']['output']>;
  rationale_FR: Maybe<Scalars['String']['output']>;
  required: Maybe<Scalars['Boolean']['output']>;
  resources: Maybe<Array<Maybe<Resource>>>;
  resources_french: Maybe<Array<Maybe<Resource>>>;
};

export type QuestionScoreByLighthouseCategory = {
  __typename?: 'QuestionScoreByLighthouseCategory';
  category_code: Scalars['String']['output'];
  question_name: Scalars['String']['output'];
  scores: Maybe<Array<Maybe<LighthouseScore>>>;
};

export type QuestionsByWeightGroup = {
  __typename?: 'QuestionsByWeightGroup';
  critical: Maybe<Array<Maybe<Portal_Context_Questions>>>;
  evolved: Maybe<Array<Maybe<Portal_Context_Questions>>>;
  fundamental: Maybe<Array<Maybe<Portal_Context_Questions>>>;
  progressive: Maybe<Array<Maybe<Portal_Context_Questions>>>;
  significant: Maybe<Array<Maybe<Portal_Context_Questions>>>;
};

export type RankCount = {
  __typename?: 'RankCount';
  score_59_and_below: Scalars['Int']['output'];
  score_60_to_69: Scalars['Int']['output'];
  score_70_to_79: Scalars['Int']['output'];
  score_80_to_89: Scalars['Int']['output'];
  score_90_and_above: Scalars['Int']['output'];
};

export type RemoveOneAdherence_ReviewsPayload = {
  __typename?: 'RemoveOneAdherence_ReviewsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Removed document */
  record: Maybe<Adherence_Reviews>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type RemoveOneAssessmentsPayload = {
  __typename?: 'RemoveOneAssessmentsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Removed document */
  record: Maybe<Assessments>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type ReportScore = {
  __typename?: 'ReportScore';
  earned: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
};

export type Reporting_Aggregates = {
  __typename?: 'Reporting_Aggregates';
  _id: Scalars['MongoID']['output'];
  avgBounceRate: Maybe<Scalars['JSON']['output']>;
  avgSessionPages: Maybe<Scalars['JSON']['output']>;
  avgUserSession: Maybe<Scalars['JSON']['output']>;
  browserTraffic: Maybe<Scalars['JSON']['output']>;
  contactPageVisits: Maybe<Scalars['JSON']['output']>;
  count: Maybe<Scalars['Float']['output']>;
  deviceTraffic: Maybe<Scalars['JSON']['output']>;
  entranceBySourceMedium: Maybe<Scalars['JSON']['output']>;
  search_term: Maybe<Scalars['String']['output']>;
  timestamp: Maybe<Scalars['Date']['output']>;
  uniqueVisits: Maybe<Scalars['JSON']['output']>;
  viewportTraffic: Maybe<Scalars['JSON']['output']>;
};

export type Reporting_Configs = {
  __typename?: 'Reporting_Configs';
  _id: Scalars['MongoID']['output'];
  measurement_id: Maybe<Scalars['String']['output']>;
  parent_code: Maybe<Scalars['String']['output']>;
  preferred: Scalars['Boolean']['output'];
  region: Maybe<Scalars['String']['output']>;
  reports: Maybe<Scalars['JSON']['output']>;
  tracking_code: Maybe<Scalars['String']['output']>;
  type: EnumReporting_ConfigsType;
  ua_view_id: Maybe<Scalars['String']['output']>;
  unit: Maybe<DealerTrackingDetails>;
  unit_code: Maybe<Scalars['String']['output']>;
  vendor_code: Scalars['String']['output'];
};

export type Resource = {
  __typename?: 'Resource';
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type ResponseAnalysis = {
  __typename?: 'ResponseAnalysis';
  no: Scalars['Float']['output'];
  somewhat: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  yes: Scalars['Float']['output'];
};

export type Review = {
  __typename?: 'Review';
  answers: Maybe<Array<Answer>>;
  assessment_code: Maybe<Scalars['String']['output']>;
  category_code: Maybe<Scalars['String']['output']>;
  category_label: Maybe<Scalars['String']['output']>;
  category_label_fr: Maybe<Scalars['String']['output']>;
  period: Maybe<Scalars['String']['output']>;
  period_label: Maybe<Scalars['String']['output']>;
  unit_code: Maybe<Scalars['String']['output']>;
  unit_name: Maybe<Scalars['String']['output']>;
};

export type ReviewPassStats = {
  __typename?: 'ReviewPassStats';
  bestMediaChannel: Maybe<Scalars['String']['output']>;
  failed: Maybe<Scalars['Int']['output']>;
  passed: Maybe<Scalars['Int']['output']>;
  topMediaChannel: Maybe<Scalars['String']['output']>;
};

export type ReviewerRole =
  | 'DEVELOPER'
  | 'NONE'
  | 'REVIEWER'
  | 'REVIEWER_ADMIN'
  | 'REVIEWER_MANAGER';

export type Reviews = {
  __typename?: 'Reviews';
  _id: Scalars['MongoID']['output'];
  answers: Array<Maybe<ReviewsAnswers>>;
  assessment_code: Scalars['String']['output'];
  category_code: Scalars['String']['output'];
  category_label: Maybe<Scalars['String']['output']>;
  category_label_fr: Maybe<Scalars['String']['output']>;
  period_label: Maybe<Scalars['String']['output']>;
  period_label_fr: Maybe<Scalars['String']['output']>;
  segmentation: Array<Maybe<Scalars['String']['output']>>;
  unit_code: Scalars['String']['output'];
  unit_name: Scalars['String']['output'];
};

export type ReviewsAnswers = {
  __typename?: 'ReviewsAnswers';
  _id: Maybe<Scalars['MongoID']['output']>;
  answer: Scalars['String']['output'];
  comments: Maybe<Scalars['String']['output']>;
  comments_fr: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  screenshots: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message: Maybe<Scalars['String']['output']>;
};

export type ScoreAggregate = {
  __typename?: 'ScoreAggregate';
  categories: CategoryScoreAggregatePackage;
  code: Scalars['String']['output'];
  finalScore: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  responses: ScoreAggregateResponses;
  unitCount: Scalars['Int']['output'];
};

export type ScoreAggregatePackage = {
  __typename?: 'ScoreAggregatePackage';
  results: Array<ScoreAggregate>;
  summary: ScoreAggregateSummary;
};

export type ScoreAggregateRange = {
  __typename?: 'ScoreAggregateRange';
  count59AndBelow: Scalars['Int']['output'];
  count60To69: Scalars['Int']['output'];
  count70To79: Scalars['Int']['output'];
  count80To89: Scalars['Int']['output'];
  count90AndAbove: Scalars['Int']['output'];
};

export type ScoreAggregateResponses = {
  __typename?: 'ScoreAggregateResponses';
  no: Scalars['Int']['output'];
  somewhat: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  yes: Scalars['Int']['output'];
};

export type ScoreAggregateSummary = {
  __typename?: 'ScoreAggregateSummary';
  finalScore: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  range: ScoreAggregateRange;
  ranked: Array<Scalars['String']['output']>;
  unitCount: Scalars['Int']['output'];
};

export type ScoreFilter = {
  assessmentCode: Scalars['String']['input'];
  categoryCode: InputMaybe<Scalars['String']['input']>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
  questionCode: InputMaybe<Scalars['String']['input']>;
  secondDivisionCode: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  _id: Maybe<Scalars['MongoID']['output']>;
  ancestors: Maybe<Array<Maybe<ContentAncestor>>>;
  content: Maybe<Scalars['String']['output']>;
  content_search: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  search_score: Maybe<Scalars['Float']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Maybe<Scalars['String']['output']>;
};

export type Segments = {
  __typename?: 'Segments';
  _id: Scalars['MongoID']['output'];
  hierarchy: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SortBy =
  | 'CATEGORY_SCORE'
  | 'DATE'
  | 'DISTRICT_CODE'
  | 'FINAL_SCORE'
  | 'GROUP_ID'
  | 'PERCENT_IN_GROUP'
  | 'PREFERRED_VENDOR'
  | 'REGION_CODE'
  | 'REVIEWER_NAME'
  | 'UNITS_IN_GROUP'
  | 'UNIT_NAME'
  | 'VENDOR_NAME';

export type SortFindManyAdherence_CardsInput =
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyAdherence_ContentInput =
  | 'CONTENT_ASC'
  | 'CONTENT_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyAdherence_CriteriaInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyAdherence_ReviewsInput =
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyAdherence_SubmissionsInput =
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyAssessment_SummaryInput =
  | 'ASSESSMENT_CODE_ASC'
  | 'ASSESSMENT_CODE_DESC'
  | 'PREFERRED_VENDOR_ASC'
  | 'PREFERRED_VENDOR_DESC'
  | 'TOTAL_SCORE_ASC'
  | 'TOTAL_SCORE_DESC'
  | 'UNIT_CODE_ASC'
  | 'UNIT_CODE_DESC'
  | 'VENDOR_NAME_ASC'
  | 'VENDOR_NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyAssessmentsInput =
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyCategoriesInput =
  | 'ASSESSMENT_CODE_ASC'
  | 'ASSESSMENT_CODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyContentInput =
  | 'CONTENT_ASC'
  | 'CONTENT_DESC'
  | 'CONTENT_SEARCH_ASC'
  | 'CONTENT_SEARCH_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyContent_Business_InsightsInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyContent_NotificationsInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyContent_Program_UpdatesInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyContent_VendorInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyContent_WebinarsInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyLighthouseInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyPrivate_RoutesInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyReporting_AggregatesInput =
  | 'SEARCH_TERM_ASC'
  | 'SEARCH_TERM_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyReporting_ConfigsInput =
  | 'REGION_ASC'
  | 'REGION_DESC'
  | 'UNIT_CODE_ASC'
  | 'UNIT_CODE_DESC'
  | 'VENDOR_CODE_ASC'
  | 'VENDOR_CODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyReviewsInput =
  | 'ASSESSMENT_CODE_ASC'
  | 'ASSESSMENT_CODE_DESC'
  | 'UNIT_CODE_ASC'
  | 'UNIT_CODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManySegmentsInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'VALUE_ASC'
  | 'VALUE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyTrackingInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyUnitsInput =
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyUsersInput =
  | 'COE_ROLE_ASC'
  | 'COE_ROLE_DESC'
  | 'COMPLIANCE_ROLE_ASC'
  | 'COMPLIANCE_ROLE_DESC'
  | 'USERNAME_ASC'
  | 'USERNAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyVendorsInput =
  | 'VENDOR_NAME_ASC'
  | 'VENDOR_NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManycompliance_CasesInput =
  | 'CASEID_ASC'
  | 'CASEID_DESC'
  | 'OUTCOMEDATE_ASC'
  | 'OUTCOMEDATE_DESC'
  | 'REPEATCASEIDS_ASC'
  | 'REPEATCASEIDS_DESC'
  | 'REPORTER_ASC'
  | 'REPORTER_DESC'
  | 'STATUS_ASC'
  | 'STATUS_DESC'
  | 'TESTCASE_ASC'
  | 'TESTCASE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManylighthouse_AggregateInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_AssessmentsInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_CategoriesInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_DESC'
  | 'ASSESSMENTCODE__ORDER_ASC'
  | 'ASSESSMENTCODE__ORDER_DESC'
  | 'CATEGORYCODE_ASC'
  | 'CATEGORYCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_Divisions_FirstInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'FIRSTDIVISIONCODE_ASC'
  | 'FIRSTDIVISIONCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_Divisions_SecondInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_DESC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE__SECONDDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE__SECONDDIVISIONCODE_DESC'
  | 'ASSESSMENTCODE__SECONDDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__SECONDDIVISIONCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'FIRSTDIVISIONCODE_ASC'
  | 'FIRSTDIVISIONCODE_DESC'
  | 'SECONDDIVISIONCODE_ASC'
  | 'SECONDDIVISIONCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_Progress_ReportInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_DESC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_DESC'
  | 'ASSESSMENTCODE__SECONDDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__SECONDDIVISIONCODE_DESC'
  | 'DEALERNAME_ASC'
  | 'DEALERNAME_DESC'
  | 'FIRSTDIVISIONCODE_ASC'
  | 'FIRSTDIVISIONCODE_DESC'
  | 'SECONDDIVISIONCODE_ASC'
  | 'SECONDDIVISIONCODE_DESC'
  | 'UNITCODE_ASC'
  | 'UNITCODE_DESC'
  | 'VENDORCODE_ASC'
  | 'VENDORCODE_DESC'
  | 'VENDORNAME_ASC'
  | 'VENDORNAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_QuestionsInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_DESC'
  | 'CATEGORYCODE_ASC'
  | 'CATEGORYCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'QUESTIONCODE_ASC'
  | 'QUESTIONCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_ResponsesInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'CATEGORYCODE_ASC'
  | 'CATEGORYCODE_DESC'
  | 'FIRSTDIVISIONCODE_ASC'
  | 'FIRSTDIVISIONCODE_DESC'
  | 'QUESTIONCODE_ASC'
  | 'QUESTIONCODE_DESC'
  | 'SECONDDIVISIONCODE_ASC'
  | 'SECONDDIVISIONCODE_DESC'
  | 'TAGS_ASC'
  | 'TAGS_DESC'
  | 'UNITCODE_ASC'
  | 'UNITCODE_DESC'
  | 'UNITCODE__ASSESSMENTCODE_ASC'
  | 'UNITCODE__ASSESSMENTCODE_DESC'
  | 'UNITCODE__ASSESSMENTCODE__CATEGORYCODE_ASC'
  | 'UNITCODE__ASSESSMENTCODE__CATEGORYCODE_DESC'
  | 'UNITCODE__ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_ASC'
  | 'UNITCODE__ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_DESC'
  | 'VENDORCODE_ASC'
  | 'VENDORCODE_DESC'
  | 'VENDORSTATUS_ASC'
  | 'VENDORSTATUS_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_TagsInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__TAGCODE_ASC'
  | 'ASSESSMENTCODE__TAGCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'TAGCODE_ASC'
  | 'TAGCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_UnitsInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__UNITCODE_ASC'
  | 'ASSESSMENTCODE__UNITCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'FIRSTDIVISIONCODE_ASC'
  | 'FIRSTDIVISIONCODE_DESC'
  | 'SECONDDIVISIONCODE_ASC'
  | 'SECONDDIVISIONCODE_DESC'
  | 'UNITCODE_ASC'
  | 'UNITCODE_DESC'
  | 'VENDORCODE_ASC'
  | 'VENDORCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindManyportal_Context_VendorsInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__VENDORCODE_ASC'
  | 'ASSESSMENTCODE__VENDORCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'VENDORCODE_ASC'
  | 'VENDORCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneAdherence_CardsInput =
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneAdherence_CriteriaInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneAdherence_ReviewsInput =
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneAdherence_SubmissionsInput =
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneAssessment_SummaryInput =
  | 'ASSESSMENT_CODE_ASC'
  | 'ASSESSMENT_CODE_DESC'
  | 'PREFERRED_VENDOR_ASC'
  | 'PREFERRED_VENDOR_DESC'
  | 'TOTAL_SCORE_ASC'
  | 'TOTAL_SCORE_DESC'
  | 'UNIT_CODE_ASC'
  | 'UNIT_CODE_DESC'
  | 'VENDOR_NAME_ASC'
  | 'VENDOR_NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneAssessmentsInput =
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneConfigurationsInput =
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneContent_Business_InsightsInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneContent_NotificationsInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneContent_Program_UpdatesInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneContent_VendorInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneContent_WebinarsInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneLighthouseInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOnePrivate_RoutesInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneReporting_AggregatesInput =
  | 'SEARCH_TERM_ASC'
  | 'SEARCH_TERM_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneReporting_ConfigsInput =
  | 'REGION_ASC'
  | 'REGION_DESC'
  | 'UNIT_CODE_ASC'
  | 'UNIT_CODE_DESC'
  | 'VENDOR_CODE_ASC'
  | 'VENDOR_CODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneSegmentsInput =
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'VALUE_ASC'
  | 'VALUE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneSterlingModulesInput =
  | 'CODE_ASC'
  | 'CODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneTrackingInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneUnitsInput =
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneUsersInput =
  | 'COE_ROLE_ASC'
  | 'COE_ROLE_DESC'
  | 'COMPLIANCE_ROLE_ASC'
  | 'COMPLIANCE_ROLE_DESC'
  | 'USERNAME_ASC'
  | 'USERNAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneVendorsInput =
  | 'VENDOR_NAME_ASC'
  | 'VENDOR_NAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOnelighthouse_AggregateInput =
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneportal_Context_Assessment_LabelsInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneportal_Context_AssessmentsInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'ORDER_ASC'
  | 'ORDER_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneportal_Context_Progress_Category_AverageInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortFindOneportal_Context_Progress_ReportInput =
  | 'ASSESSMENTCODE_ASC'
  | 'ASSESSMENTCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE__ORDER_DESC'
  | 'ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_ASC'
  | 'ASSESSMENTCODE__CATEGORYCODE__QUESTIONCODE_DESC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__FIRSTDIVISIONCODE_DESC'
  | 'ASSESSMENTCODE__SECONDDIVISIONCODE_ASC'
  | 'ASSESSMENTCODE__SECONDDIVISIONCODE_DESC'
  | 'DEALERNAME_ASC'
  | 'DEALERNAME_DESC'
  | 'FIRSTDIVISIONCODE_ASC'
  | 'FIRSTDIVISIONCODE_DESC'
  | 'SECONDDIVISIONCODE_ASC'
  | 'SECONDDIVISIONCODE_DESC'
  | 'UNITCODE_ASC'
  | 'UNITCODE_DESC'
  | 'VENDORCODE_ASC'
  | 'VENDORCODE_DESC'
  | 'VENDORNAME_ASC'
  | 'VENDORNAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortOrder =
  | 'ASC'
  | 'DESC';

export type SortRemoveOneAdherence_ReviewsInput =
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortRemoveOneAssessmentsInput =
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateManyAdherence_ReviewsInput =
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateManyAdherence_SubmissionsInput =
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateOneAdherence_ReviewsInput =
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateOneAdherence_SubmissionsInput =
  | 'CREATEDAT_ASC'
  | 'CREATEDAT_DESC'
  | 'REQUESTID_ASC'
  | 'REQUESTID_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateOneAssessmentsInput =
  | 'CODE_ASC'
  | 'CODE_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateOneReporting_AggregatesInput =
  | 'SEARCH_TERM_ASC'
  | 'SEARCH_TERM_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateOneReporting_ConfigsInput =
  | 'REGION_ASC'
  | 'REGION_DESC'
  | 'UNIT_CODE_ASC'
  | 'UNIT_CODE_DESC'
  | 'VENDOR_CODE_ASC'
  | 'VENDOR_CODE_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SortUpdateOneUsersInput =
  | 'COE_ROLE_ASC'
  | 'COE_ROLE_DESC'
  | 'COMPLIANCE_ROLE_ASC'
  | 'COMPLIANCE_ROLE_DESC'
  | 'USERNAME_ASC'
  | 'USERNAME_DESC'
  | '_ID_ASC'
  | '_ID_DESC';

export type SterlingKey =
  | 'assessment'
  | 'category'
  | 'firstDivision'
  | 'question'
  | 'secondDivision'
  | 'tag'
  | 'unit'
  | 'vendor'
  | 'vendorStatus';

export type SterlingModules = {
  __typename?: 'SterlingModules';
  _id: Scalars['MongoID']['output'];
  code: EnumSterlingModulesCode;
  routes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TopByVendor = {
  __typename?: 'TopByVendor';
  final_score: Maybe<Scalars['Int']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  _id: Scalars['MongoID']['output'];
  assessment_code: Maybe<Scalars['String']['output']>;
  event_date: Scalars['Date']['output'];
  event_type: Scalars['String']['output'];
  object_id: Scalars['String']['output'];
  object_type: Scalars['String']['output'];
  oem_codes: Maybe<Array<Maybe<EnumTrackingOem_Codes>>>;
};

export type Units = {
  __typename?: 'Units';
  _id: Scalars['MongoID']['output'];
  address: Scalars['String']['output'];
  assessment_login: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  last_login: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  postal_code: Scalars['String']['output'];
  province: Scalars['String']['output'];
  segment_0: Scalars['String']['output'];
  segment_1: Scalars['String']['output'];
  vendor: Maybe<Vendors>;
  vendor_name: Scalars['String']['output'];
};


export type UnitsAssessment_LoginArgs = {
  assessmentCode: Scalars['String']['input'];
};


export type UnitsVendorArgs = {
  assessmentCode: Scalars['String']['input'];
};

export type UpdateByIdReporting_AggregatesInput = {
  avgBounceRate: InputMaybe<Scalars['JSON']['input']>;
  avgSessionPages: InputMaybe<Scalars['JSON']['input']>;
  avgUserSession: InputMaybe<Scalars['JSON']['input']>;
  browserTraffic: InputMaybe<Scalars['JSON']['input']>;
  contactPageVisits: InputMaybe<Scalars['JSON']['input']>;
  count: InputMaybe<Scalars['Float']['input']>;
  deviceTraffic: InputMaybe<Scalars['JSON']['input']>;
  entranceBySourceMedium: InputMaybe<Scalars['JSON']['input']>;
  search_term: InputMaybe<Scalars['String']['input']>;
  timestamp: InputMaybe<Scalars['Date']['input']>;
  uniqueVisits: InputMaybe<Scalars['JSON']['input']>;
  viewportTraffic: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdReporting_AggregatesPayload = {
  __typename?: 'UpdateByIdReporting_AggregatesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Reporting_Aggregates>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdReporting_ConfigsInput = {
  measurement_id: InputMaybe<Scalars['String']['input']>;
  parent_code: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<Scalars['Boolean']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  tracking_code: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumReporting_ConfigsType>;
  ua_view_id: InputMaybe<Scalars['String']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  vendor_code: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdReporting_ConfigsPayload = {
  __typename?: 'UpdateByIdReporting_ConfigsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Reporting_Configs>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateManyAdherence_ReviewsInput = {
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyAdherence_ReviewsPayload = {
  __typename?: 'UpdateManyAdherence_ReviewsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyAdherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyAdherence_SubmissionsInput = {
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<UpdateManyAdherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyAdherence_SubmissionsPayload = {
  __typename?: 'UpdateManyAdherence_SubmissionsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected: Maybe<Scalars['Int']['output']>;
};

export type UpdateOneAdherence_ReviewsInput = {
  answerState: InputMaybe<Scalars['JSON']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  dealershipId: InputMaybe<Scalars['String']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  mediaFilename: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  submittedDate: InputMaybe<Scalars['Date']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
  vendor: InputMaybe<Scalars['String']['input']>;
  zone: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneAdherence_ReviewsPayload = {
  __typename?: 'UpdateOneAdherence_ReviewsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Adherence_Reviews>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneAdherence_SubmissionsAttachmentsInput = {
  _id: InputMaybe<Scalars['MongoID']['input']>;
  filename: InputMaybe<Scalars['String']['input']>;
  filesize: InputMaybe<Scalars['Float']['input']>;
  id: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneAdherence_SubmissionsInput = {
  accepted: InputMaybe<Scalars['String']['input']>;
  activity: InputMaybe<Scalars['String']['input']>;
  attachments: InputMaybe<Array<InputMaybe<UpdateOneAdherence_SubmissionsAttachmentsInput>>>;
  audience: InputMaybe<Scalars['String']['input']>;
  campaign: InputMaybe<Scalars['String']['input']>;
  carModel: InputMaybe<Scalars['String']['input']>;
  claimMonth: InputMaybe<Scalars['String']['input']>;
  createdAt: InputMaybe<Scalars['Date']['input']>;
  currency: InputMaybe<Scalars['String']['input']>;
  dealerContribution: InputMaybe<Scalars['Float']['input']>;
  dealershipId: InputMaybe<Scalars['Float']['input']>;
  dealershipName: InputMaybe<Scalars['String']['input']>;
  districts: InputMaybe<Scalars['String']['input']>;
  documentNumber: InputMaybe<Scalars['String']['input']>;
  feedback: InputMaybe<Scalars['String']['input']>;
  history: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  invoiceNumber: InputMaybe<Scalars['String']['input']>;
  lastUpdated: InputMaybe<Scalars['Date']['input']>;
  mediaChannel: InputMaybe<Scalars['String']['input']>;
  paymentDate: InputMaybe<Scalars['String']['input']>;
  paymentDateYearMonth: InputMaybe<Scalars['String']['input']>;
  period: InputMaybe<Scalars['String']['input']>;
  program: InputMaybe<Scalars['String']['input']>;
  qtAdjBudget: InputMaybe<Scalars['Float']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  requestId: InputMaybe<Scalars['String']['input']>;
  requestedPerDealership: InputMaybe<Scalars['Float']['input']>;
  reviewed: InputMaybe<Scalars['Boolean']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  totalCost: InputMaybe<Scalars['Float']['input']>;
  updatedAt: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneAdherence_SubmissionsPayload = {
  __typename?: 'UpdateOneAdherence_SubmissionsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Adherence_Submissions>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneAssessmentsInput = {
  categories: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: InputMaybe<Scalars['String']['input']>;
  date: InputMaybe<Scalars['String']['input']>;
  end_date: InputMaybe<Scalars['String']['input']>;
  remote_id: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_fr: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneAssessmentsPayload = {
  __typename?: 'UpdateOneAssessmentsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Assessments>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneReporting_AggregatesInput = {
  avgBounceRate: InputMaybe<Scalars['JSON']['input']>;
  avgSessionPages: InputMaybe<Scalars['JSON']['input']>;
  avgUserSession: InputMaybe<Scalars['JSON']['input']>;
  browserTraffic: InputMaybe<Scalars['JSON']['input']>;
  contactPageVisits: InputMaybe<Scalars['JSON']['input']>;
  count: InputMaybe<Scalars['Float']['input']>;
  deviceTraffic: InputMaybe<Scalars['JSON']['input']>;
  entranceBySourceMedium: InputMaybe<Scalars['JSON']['input']>;
  search_term: InputMaybe<Scalars['String']['input']>;
  timestamp: InputMaybe<Scalars['Date']['input']>;
  uniqueVisits: InputMaybe<Scalars['JSON']['input']>;
  viewportTraffic: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneReporting_AggregatesPayload = {
  __typename?: 'UpdateOneReporting_AggregatesPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Reporting_Aggregates>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneReporting_ConfigsInput = {
  measurement_id: InputMaybe<Scalars['String']['input']>;
  parent_code: InputMaybe<Scalars['String']['input']>;
  preferred: InputMaybe<Scalars['Boolean']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  tracking_code: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumReporting_ConfigsType>;
  ua_view_id: InputMaybe<Scalars['String']['input']>;
  unit_code: InputMaybe<Scalars['String']['input']>;
  vendor_code: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneReporting_ConfigsPayload = {
  __typename?: 'UpdateOneReporting_ConfigsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Reporting_Configs>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneUsersInput = {
  coe_role: InputMaybe<EnumUsersCoe_Role>;
  coe_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment: InputMaybe<Scalars['String']['input']>;
  compliance_role: InputMaybe<EnumUsersCompliance_Role>;
  created: InputMaybe<Scalars['Date']['input']>;
  created_by: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  first_name: InputMaybe<Scalars['String']['input']>;
  last_login: InputMaybe<Scalars['String']['input']>;
  last_name: InputMaybe<Scalars['String']['input']>;
  locked: InputMaybe<Scalars['Boolean']['input']>;
  login_type: InputMaybe<EnumUsersLogin_Type>;
  modified: InputMaybe<Scalars['Date']['input']>;
  modified_by: InputMaybe<Scalars['String']['input']>;
  module_permissions: InputMaybe<Array<InputMaybe<EnumUsersModule_Permissions>>>;
  oem_access: InputMaybe<Array<InputMaybe<EnumUsersOem_Access>>>;
  password: InputMaybe<Scalars['String']['input']>;
  preferred_language: InputMaybe<EnumUsersPreferred_Language>;
  refresh_token: InputMaybe<Scalars['String']['input']>;
  reviewer_role: InputMaybe<EnumUsersReviewer_Role>;
  reviewer_role_permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<EnumUsersType>;
  username: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneUsersPayload = {
  __typename?: 'UpdateOneUsersPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error: Maybe<ErrorInterface>;
  /** Updated document */
  record: Maybe<Users>;
  /** Document ID */
  recordId: Maybe<Scalars['MongoID']['output']>;
};

export type UploadedFileResponse = {
  __typename?: 'UploadedFileResponse';
  encoding: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UserType =
  | 'LOCAL'
  | 'REMOTE';

export type Users = {
  __typename?: 'Users';
  _id: Scalars['MongoID']['output'];
  coe_role: EnumUsersCoe_Role;
  coe_role_permissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  comment: Maybe<Scalars['String']['output']>;
  compliance_role: Maybe<EnumUsersCompliance_Role>;
  created: Maybe<Scalars['Date']['output']>;
  created_by: Maybe<Scalars['String']['output']>;
  /** List of valid domains for the user. */
  domains: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email: Maybe<Scalars['String']['output']>;
  first_name: Maybe<Scalars['String']['output']>;
  last_login: Maybe<Scalars['String']['output']>;
  last_name: Maybe<Scalars['String']['output']>;
  locked: Maybe<Scalars['Boolean']['output']>;
  login_type: Maybe<EnumUsersLogin_Type>;
  modified: Maybe<Scalars['Date']['output']>;
  modified_by: Maybe<Scalars['String']['output']>;
  module_permissions: Maybe<Array<Maybe<EnumUsersModule_Permissions>>>;
  oem_access: Maybe<Array<Maybe<EnumUsersOem_Access>>>;
  password: Maybe<Scalars['String']['output']>;
  preferred_language: Maybe<EnumUsersPreferred_Language>;
  refresh_token: Maybe<Scalars['String']['output']>;
  reviewer_role: Maybe<EnumUsersReviewer_Role>;
  reviewer_role_permissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Maybe<Scalars['String']['output']>;
  type: EnumUsersType;
  username: Scalars['String']['output'];
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value: Maybe<Scalars['JSON']['output']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  assessment_code: Scalars['String']['output'];
  market_capture: Scalars['Float']['output'];
  num_units: Scalars['Int']['output'];
  unit_codes: Array<Scalars['String']['output']>;
  vendor_name: Scalars['String']['output'];
};

export type VendorCodesAndNames = {
  __typename?: 'VendorCodesAndNames';
  vendorCode: Scalars['String']['output'];
  vendorName: Maybe<Scalars['String']['output']>;
};

export type VendorDocument = {
  __typename?: 'VendorDocument';
  _id: Scalars['String']['output'];
  code: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type VendorProgressHomeRevision = {
  __typename?: 'VendorProgressHomeRevision';
  answerValue: Maybe<Scalars['Int']['output']>;
  assigned: Maybe<Scalars['String']['output']>;
  categoryCode: Maybe<Scalars['String']['output']>;
  dealerName: Maybe<Scalars['String']['output']>;
  priority: Maybe<Scalars['String']['output']>;
  questionCode: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  unitCode: Maybe<Scalars['String']['output']>;
  vendorCode: Maybe<Scalars['String']['output']>;
  vendorName: Maybe<Scalars['String']['output']>;
};

export type Vendors = {
  __typename?: 'Vendors';
  _id: Scalars['MongoID']['output'];
  assessment_code: Scalars['String']['output'];
  displayName: Maybe<Scalars['String']['output']>;
  preferred: Scalars['Boolean']['output'];
  reviewer_name: Scalars['String']['output'];
  segment_0: Scalars['String']['output'];
  segment_1: Scalars['String']['output'];
  unit_code: Scalars['String']['output'];
  unit_name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  vendor_name: Scalars['String']['output'];
};

export type WebProperties = {
  __typename?: 'WebProperties';
  views: Array<Maybe<WebProperty>>;
};

export type WebProperty = {
  __typename?: 'WebProperty';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  unit_code: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  vendor_name: Maybe<Scalars['String']['output']>;
};

export type Compliance_Cases = {
  __typename?: 'compliance_cases';
  _id: Scalars['MongoID']['output'];
  caseId: Scalars['String']['output'];
  caseInformation: Array<Maybe<Compliance_CasesCaseInformation>>;
  history: Array<Maybe<Compliance_CasesHistory>>;
  inProgress: Scalars['Boolean']['output'];
  outcome: Enumcompliance_CasesOutcome;
  outcomeDate: Maybe<Scalars['String']['output']>;
  repeatCaseIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reported: Compliance_CasesReported;
  reporter: Compliance_CasesReporter;
  status: Enumcompliance_CasesStatus;
  statusPrevious: Maybe<Enumcompliance_CasesStatusPrevious>;
  statusTransition: Maybe<Compliance_CasesStatusTransition>;
  testCase: Scalars['Boolean']['output'];
};

export type Compliance_CasesCaseInformation = {
  __typename?: 'compliance_casesCaseInformation';
  category: Enumcompliance_CasesCaseInformationCategory;
  categoryOther: Maybe<Scalars['String']['output']>;
  evidence: Array<Maybe<Compliance_CasesCaseInformationEvidence>>;
  infractionDate: Scalars['String']['output'];
  infractionLocation: Maybe<Scalars['String']['output']>;
  modifiedDate: Scalars['String']['output'];
  ongoing: Enumcompliance_CasesCaseInformationOngoing;
  revision: Scalars['Float']['output'];
  summary: Scalars['String']['output'];
};

export type Compliance_CasesCaseInformationEvidence = {
  __typename?: 'compliance_casesCaseInformationEvidence';
  filename: Scalars['String']['output'];
  mimetype: Scalars['String']['output'];
};

export type Compliance_CasesCaseInformationEvidenceInput = {
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
};

export type Compliance_CasesCaseInformationInput = {
  category: Enumcompliance_CasesCaseInformationCategory;
  categoryOther: InputMaybe<Scalars['String']['input']>;
  evidence: Array<InputMaybe<Compliance_CasesCaseInformationEvidenceInput>>;
  infractionDate: Scalars['String']['input'];
  infractionLocation: InputMaybe<Scalars['String']['input']>;
  modifiedDate: Scalars['String']['input'];
  ongoing: Enumcompliance_CasesCaseInformationOngoing;
  revision: Scalars['Float']['input'];
  summary: Scalars['String']['input'];
};

export type Compliance_CasesHistory = {
  __typename?: 'compliance_casesHistory';
  dealerNotes: Maybe<Scalars['String']['output']>;
  internalNotes: Maybe<Scalars['String']['output']>;
  internalNotesName: Maybe<Scalars['String']['output']>;
  modifiedDate: Scalars['String']['output'];
  status: Enumcompliance_CasesHistoryStatus;
};

export type Compliance_CasesHistoryInput = {
  dealerNotes: InputMaybe<Scalars['String']['input']>;
  internalNotes: InputMaybe<Scalars['String']['input']>;
  internalNotesName: InputMaybe<Scalars['String']['input']>;
  modifiedDate: Scalars['String']['input'];
  status: Enumcompliance_CasesHistoryStatus;
};

export type Compliance_CasesReported = {
  __typename?: 'compliance_casesReported';
  dealerCode: Scalars['String']['output'];
  dealerName: Scalars['String']['output'];
};

export type Compliance_CasesReportedInput = {
  dealerCode: Scalars['String']['input'];
  dealerName: Scalars['String']['input'];
};

export type Compliance_CasesReporter = {
  __typename?: 'compliance_casesReporter';
  dealerCode: Scalars['String']['output'];
  dealerName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Compliance_CasesReporterInput = {
  dealerCode: Scalars['String']['input'];
  dealerName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Compliance_CasesStatusTransition = {
  __typename?: 'compliance_casesStatusTransition';
  from: Enumcompliance_CasesStatusTransitionFrom;
  to: Enumcompliance_CasesStatusTransitionTo;
};

export type Compliance_CasesStatusTransitionInput = {
  from: Enumcompliance_CasesStatusTransitionFrom;
  to: Enumcompliance_CasesStatusTransitionTo;
};

export type Lighthouse_Aggregate = {
  __typename?: 'lighthouse_aggregate';
  _id: Scalars['MongoID']['output'];
  categories: LighthouseCategories;
  dealerCode: Scalars['String']['output'];
  oem: Enumlighthouse_AggregateOem;
  requestedUrl: Scalars['String']['output'];
};

export type Portal_Context_Assessment_Labels = {
  __typename?: 'portal_context_assessment_labels';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  assessmentLabel: Portal_Context_Progress_ReportQuestionsReviewedComments;
  categories: Maybe<Array<Maybe<Portal_Context_Assessment_LabelsCategories>>>;
  questions: Maybe<Array<Maybe<Portal_Context_Assessment_LabelsQuestions>>>;
};

export type Portal_Context_Assessment_LabelsCategories = {
  __typename?: 'portal_context_assessment_labelsCategories';
  _id: Maybe<Scalars['MongoID']['output']>;
  categoryCode: Scalars['String']['output'];
  categoryLabel: Portal_Context_AssessmentsDataLabel;
};

export type Portal_Context_Assessment_LabelsQuestions = {
  __typename?: 'portal_context_assessment_labelsQuestions';
  _id: Maybe<Scalars['MongoID']['output']>;
  categoryLabel: Portal_Context_Progress_ReportQuestionsReviewedComments;
  improvement: Portal_Context_Progress_ReportQuestionsReviewedComments;
  questionCode: Scalars['String']['output'];
  questionLabel: Portal_Context_Progress_ReportQuestionsReviewedComments;
  questionRationale: Portal_Context_Progress_ReportQuestionsReviewedComments;
  resource: Maybe<Portal_Context_Assessment_LabelsQuestionsResource>;
  videoLink: Portal_Context_Progress_ReportQuestionsReviewedComments;
};

export type Portal_Context_Assessment_LabelsQuestionsResource = {
  __typename?: 'portal_context_assessment_labelsQuestionsResource';
  EN: Maybe<Array<Maybe<Portal_Context_Assessment_LabelsQuestionsResourceEn>>>;
  FR: Maybe<Array<Maybe<Portal_Context_Assessment_LabelsQuestionsResourceEn>>>;
};

export type Portal_Context_Assessment_LabelsQuestionsResourceEn = {
  __typename?: 'portal_context_assessment_labelsQuestionsResourceEN';
  _id: Maybe<Scalars['MongoID']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Portal_Context_Assessments = {
  __typename?: 'portal_context_assessments';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  comp: Portal_Context_AssessmentsComp;
  data: Portal_Context_AssessmentsData;
  order: Scalars['Float']['output'];
};

export type Portal_Context_AssessmentsComp = {
  __typename?: 'portal_context_assessmentsComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_AssessmentsData = {
  __typename?: 'portal_context_assessmentsData';
  _id: Maybe<Scalars['MongoID']['output']>;
  active: Scalars['Boolean']['output'];
  date: Scalars['String']['output'];
  label: Portal_Context_AssessmentsDataLabel;
};

export type Portal_Context_AssessmentsDataLabel = {
  __typename?: 'portal_context_assessmentsDataLabel';
  EN: Scalars['String']['output'];
  FR: Scalars['String']['output'];
  _id: Maybe<Scalars['MongoID']['output']>;
};

export type Portal_Context_Categories = {
  __typename?: 'portal_context_categories';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  comp: Portal_Context_CategoriesComp;
  data: Portal_Context_CategoriesData;
  order: Scalars['Float']['output'];
};

export type Portal_Context_CategoriesComp = {
  __typename?: 'portal_context_categoriesComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_CategoriesData = {
  __typename?: 'portal_context_categoriesData';
  _id: Maybe<Scalars['MongoID']['output']>;
  label: Portal_Context_AssessmentsDataLabel;
};

export type Portal_Context_Divisions_First = {
  __typename?: 'portal_context_divisions_first';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  comp: Portal_Context_Divisions_FirstComp;
  data: Portal_Context_Divisions_FirstData;
  firstDivisionCode: Scalars['String']['output'];
};

export type Portal_Context_Divisions_FirstComp = {
  __typename?: 'portal_context_divisions_firstComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_Divisions_FirstData = {
  __typename?: 'portal_context_divisions_firstData';
  _id: Maybe<Scalars['MongoID']['output']>;
  label: Scalars['String']['output'];
};

export type Portal_Context_Divisions_Second = {
  __typename?: 'portal_context_divisions_second';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  comp: Portal_Context_Divisions_SecondComp;
  data: Portal_Context_Divisions_SecondData;
  firstDivisionCode: Scalars['String']['output'];
  secondDivisionCode: Scalars['String']['output'];
};

export type Portal_Context_Divisions_SecondComp = {
  __typename?: 'portal_context_divisions_secondComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_Divisions_SecondData = {
  __typename?: 'portal_context_divisions_secondData';
  _id: Maybe<Scalars['MongoID']['output']>;
  label: Scalars['String']['output'];
};

export type Portal_Context_Progress_Category_Average = {
  __typename?: 'portal_context_progress_category_average';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  categoryScores: Maybe<Array<Maybe<Portal_Context_Progress_Category_AverageCategoryScores>>>;
  dealerAssessmentAverage: Scalars['Float']['output'];
};

export type Portal_Context_Progress_Category_AverageCategoryScores = {
  __typename?: 'portal_context_progress_category_averageCategoryScores';
  _id: Maybe<Scalars['MongoID']['output']>;
  category: Scalars['String']['output'];
  scoreAverage: Scalars['Float']['output'];
};

export type Portal_Context_Progress_Report = {
  __typename?: 'portal_context_progress_report';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  assessmentRank: Scalars['Float']['output'];
  categoryScores: Maybe<Array<Maybe<Portal_Context_Progress_ReportCategoryScores>>>;
  dealerName: Scalars['String']['output'];
  firstDivisionCode: Scalars['String']['output'];
  pointsEarned: Scalars['Float']['output'];
  pointsMissed: Scalars['Float']['output'];
  pointsPossible: Scalars['Float']['output'];
  previousAssessmentRank: Maybe<Scalars['Int']['output']>;
  questionsReviewed: Maybe<Array<Maybe<Portal_Context_Progress_ReportQuestionsReviewed>>>;
  secondDivisionCode: Scalars['String']['output'];
  totalDealers: Scalars['Float']['output'];
  unitCode: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
};

export type Portal_Context_Progress_ReportCategoryScores = {
  __typename?: 'portal_context_progress_reportCategoryScores';
  _id: Maybe<Scalars['MongoID']['output']>;
  category: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type Portal_Context_Progress_ReportQuestionsReviewed = {
  __typename?: 'portal_context_progress_reportQuestionsReviewed';
  _id: Maybe<Scalars['MongoID']['output']>;
  answer: Scalars['String']['output'];
  answerValue: Scalars['Float']['output'];
  assigned: Maybe<Enumportal_Context_Progress_ReportQuestionsReviewedAssigned>;
  categoryCode: Scalars['String']['output'];
  categoryLabel: Portal_Context_Progress_ReportQuestionsReviewedComments;
  comments: Portal_Context_Progress_ReportQuestionsReviewedComments;
  dealerName: Scalars['String']['output'];
  improvement: Portal_Context_Progress_ReportQuestionsReviewedComments;
  isRequired: Scalars['Boolean']['output'];
  priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority;
  questionCode: Scalars['String']['output'];
  questionLabel: Portal_Context_Progress_ReportQuestionsReviewedComments;
  questionRationale: Portal_Context_Progress_ReportQuestionsReviewedComments;
  resolveImpact: Maybe<Scalars['Float']['output']>;
  score: Portal_Context_Progress_ReportQuestionsReviewedScore;
  screenshots: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: Maybe<Enumportal_Context_Progress_ReportQuestionsReviewedStatus>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  vendorCode: Scalars['String']['output'];
  vendorName: Scalars['String']['output'];
  videoLink: Portal_Context_Progress_ReportQuestionsReviewedComments;
  weight: Scalars['Float']['output'];
};

export type Portal_Context_Progress_ReportQuestionsReviewedComments = {
  __typename?: 'portal_context_progress_reportQuestionsReviewedComments';
  EN: Maybe<Scalars['String']['output']>;
  FR: Maybe<Scalars['String']['output']>;
  _id: Maybe<Scalars['MongoID']['output']>;
};

export type Portal_Context_Progress_ReportQuestionsReviewedScore = {
  __typename?: 'portal_context_progress_reportQuestionsReviewedScore';
  _id: Maybe<Scalars['MongoID']['output']>;
  earned: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
};

export type Portal_Context_Questions = {
  __typename?: 'portal_context_questions';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  categoryLabel: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  comp: Portal_Context_QuestionsComp;
  data: Portal_Context_QuestionsData;
  languageCode: Enumportal_Context_QuestionsLanguageCode;
  order: Scalars['Float']['output'];
  questionCode: Scalars['String']['output'];
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Portal_Context_QuestionsComp = {
  __typename?: 'portal_context_questionsComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_QuestionsData = {
  __typename?: 'portal_context_questionsData';
  _id: Maybe<Scalars['MongoID']['output']>;
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  layout: Enumportal_Context_QuestionsDataLayout;
  rationale: Scalars['String']['output'];
  resources: Array<Maybe<Portal_Context_QuestionsDataResources>>;
  statusFlag: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export type Portal_Context_QuestionsDataResources = {
  __typename?: 'portal_context_questionsDataResources';
  _id: Maybe<Scalars['MongoID']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Portal_Context_Responses = {
  __typename?: 'portal_context_responses';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  assigned: Maybe<Enumportal_Context_ResponsesAssigned>;
  categoryCode: Scalars['String']['output'];
  data: Portal_Context_ResponsesData;
  firstDivisionCode: Scalars['String']['output'];
  questionCode: Scalars['String']['output'];
  secondDivisionCode: Scalars['String']['output'];
  status: Maybe<Enumportal_Context_ResponsesStatus>;
  tags: Array<Maybe<Scalars['String']['output']>>;
  unitCode: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
  vendorStatus: Enumportal_Context_ResponsesVendorStatus;
};

export type Portal_Context_ResponsesData = {
  __typename?: 'portal_context_responsesData';
  _id: Maybe<Scalars['MongoID']['output']>;
  answer: Scalars['String']['output'];
  comment: Portal_Context_Progress_ReportQuestionsReviewedComments;
  score: Portal_Context_Progress_ReportQuestionsReviewedScore;
  screenshots: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Portal_Context_Tags = {
  __typename?: 'portal_context_tags';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  comp: Portal_Context_TagsComp;
  data: Portal_Context_TagsData;
  tagCode: Scalars['String']['output'];
};

export type Portal_Context_TagsComp = {
  __typename?: 'portal_context_tagsComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_TagsData = {
  __typename?: 'portal_context_tagsData';
  _id: Maybe<Scalars['MongoID']['output']>;
  label: Portal_Context_AssessmentsDataLabel;
};

export type Portal_Context_Units = {
  __typename?: 'portal_context_units';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  comp: Portal_Context_UnitsComp;
  data: Portal_Context_UnitsData;
  firstDivisionCode: Scalars['String']['output'];
  secondDivisionCode: Scalars['String']['output'];
  unitCode: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
};

export type Portal_Context_UnitsComp = {
  __typename?: 'portal_context_unitsComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_UnitsData = {
  __typename?: 'portal_context_unitsData';
  _id: Maybe<Scalars['MongoID']['output']>;
  label: Scalars['String']['output'];
  reviewer: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Portal_Context_Vendors = {
  __typename?: 'portal_context_vendors';
  _id: Scalars['MongoID']['output'];
  assessmentCode: Scalars['String']['output'];
  code: Scalars['String']['output'];
  comp: Portal_Context_VendorsComp;
  data: Portal_Context_VendorsData;
  vendorCode: Scalars['String']['output'];
};

export type Portal_Context_VendorsComp = {
  __typename?: 'portal_context_vendorsComp';
  _id: Maybe<Scalars['MongoID']['output']>;
  code: Maybe<Scalars['String']['output']>;
};

export type Portal_Context_VendorsData = {
  __typename?: 'portal_context_vendorsData';
  _id: Maybe<Scalars['MongoID']['output']>;
  label: Scalars['String']['output'];
  vendorStatus: Enumportal_Context_VendorsDataVendorStatus;
};

export type UpdatePreferredLanguageMutationVariables = Exact<{
  language: LanguageCode;
}>;


export type UpdatePreferredLanguageMutation = { __typename?: 'Mutation', userUpdateLanguage: EnumUsersPreferred_Language };

export type LogoutQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoutQuery = { __typename?: 'Query', validateLogout: { __typename?: 'LogoutResponse', success: boolean } };

export type SegmentsByRoleQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type SegmentsByRoleQuery = { __typename?: 'Query', segmentsManyByRole: Array<{ __typename?: 'Segments', hierarchy: number, name: string, value: string, parent: string }> };

export type UnitsWithViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitsWithViewsQuery = { __typename?: 'Query', unitsManyByReporting: Array<{ __typename?: 'Units', name: string, code: string }> };

export type GetAssessmentDateQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type GetAssessmentDateQuery = { __typename?: 'Query', assessmentStartDate: string, assessmentEndDate: string };

export type PerformanceReportCsvQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type PerformanceReportCsvQuery = { __typename?: 'Query', reviewsMany: Array<{ __typename?: 'Reviews', unit_code: string, unit_name: string, assessment_code: string, period_label: string, category_code: string, category_label: string, category_label_fr: string, answers: Array<{ __typename?: 'ReviewsAnswers', name: string, answer: string, comments: string, screenshots: Array<string> }> }> };

export type CategoriesManyCsvQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type CategoriesManyCsvQuery = { __typename?: 'Query', categoriesMany: Array<{ __typename?: 'Categories', code: string, questions: Array<{ __typename?: 'CategoriesQuestions', name: string, number: number, layout: EnumCategoriesQuestionsLayout, required: boolean, label: string, label_french: string }> }> };

export type RankedDealersQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  sortOrder: Scalars['String']['input'];
}>;


export type RankedDealersQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', final_score: number, review_details: { __typename?: 'AssessmentSummaryOld', unit_name: string, region_code: string } }> } };

export type RankedDealersSegmentedQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  filterText: Scalars['String']['input'];
}>;


export type RankedDealersSegmentedQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', final_score: number, review_details: { __typename?: 'AssessmentSummaryOld', unit_name: string, region_code: string } }> } };

export type RankedSegmentsQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  sortOrder: Scalars['String']['input'];
  groupBy: Scalars['String']['input'];
}>;


export type RankedSegmentsQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', group_id: string, final_score: number }> } };

export type GetWebinarCalendarQueryVariables = Exact<{
  lang: EnumContent_WebinarsLanguage;
}>;


export type GetWebinarCalendarQuery = { __typename?: 'Query', contentWebinarMany: Array<{ __typename?: 'Content_Webinars', _id: any, title: string, start_time: string, created_date: string, modified_date: string }> };

export type PrivateRouteQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type PrivateRouteQuery = { __typename?: 'Query', routePermission: boolean };

export type FetchAllConfigurationsAllFieldsQueryVariables = Exact<{
  type: EnumConfigurationsType;
  oem: EnumConfigurationsOem;
}>;


export type FetchAllConfigurationsAllFieldsQuery = { __typename?: 'Query', config: { __typename?: 'Configurations', type: EnumConfigurationsType, oem: EnumConfigurationsOem, maintenance_message_en: string, maintenance_message_fr: string, region_label_en: string, region_label_fr: string, district_label_en: string, district_label_fr: string } };

export type SegmentsManyQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentsManyQuery = { __typename?: 'Query', segmentsMany: Array<{ __typename?: 'Segments', hierarchy: number, type: string, name: string, value: string, parent: string }> };

export type AdherenceContentRouteFragment = { __typename?: 'Adherence_Content', _id: any, parent: any, title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean };

export type AdherenceContentNavOptionsQueryVariables = Exact<{
  language: EnumAdherence_ContentLanguage;
}>;


export type AdherenceContentNavOptionsQuery = { __typename?: 'Query', adherenceContentMany: Array<{ __typename?: 'Adherence_Content', _id: any, parent: any, title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Adherence_Content', _id: any, parent: any, title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Adherence_Content', _id: any, parent: any, title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Adherence_Content', _id: any, parent: any, title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Adherence_Content', _id: any, parent: any, title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Adherence_Content', _id: any, parent: any, title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean }> }> }> }> }> }> };

export type GetAdherenceReviewByIdQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type GetAdherenceReviewByIdQuery = { __typename?: 'Query', adherenceSubmissionOne: { __typename?: 'Adherence_Submissions', _id: any, requestId: string, dealershipName: string, createdAt: any, status: string, invoiceNumber: string, mediaChannel: string, audience: string, carModel: string, campaign: string, activity: string, period: string, attachments: Array<{ __typename?: 'Adherence_SubmissionsAttachments', filename: string, preview: string }>, criteria: Array<{ __typename?: 'Adherence_Criteria', _id: any, category: string, category_order: number, question: string, question_key: string, question_order: number, correct_response: string, question_dependencies: Array<string>, criteria_image: string, media_channels: Array<string>, periods: Array<string> }> } };

export type GetAdherenceMediaChannelsPassratesQueryVariables = Exact<{
  campaign: Scalars['String']['input'];
  previousCampaign: InputMaybe<Scalars['String']['input']>;
  skipPrevious: Scalars['Boolean']['input'];
}>;


export type GetAdherenceMediaChannelsPassratesQuery = { __typename?: 'Query', adherenceMediaChannelPassrateByCampaign: { __typename?: 'AdherenceCampaignResults', currentCampaign: Array<{ __typename?: 'MediaChannelStats', mediaChannel: string, reviewsCount: number, failed: number }>, previousCampaign?: Array<{ __typename?: 'MediaChannelStats', mediaChannel: string, reviewsCount: number, failed: number }> } };

export type GetAdherenceDealerSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdherenceDealerSummaryQuery = { __typename?: 'Query', adherenceReviewSummaryDashboard: Array<{ __typename?: 'AdherenceReviewDealerSummary', id: string, dealershipName: string, zone: string, topMediaChannel: string, bestMediaChannel: string, passed: number, failed: number }> };

export type GetAdherenceRequestedPageInfoQueryVariables = Exact<{
  pageSize: Scalars['Int']['input'];
  filter: InputMaybe<FilterFindManyAdherence_SubmissionsInput>;
}>;


export type GetAdherenceRequestedPageInfoQuery = { __typename?: 'Query', adherenceSubmissionPagination: { __typename?: 'Adherence_SubmissionsPagination', pageInfo: { __typename?: 'PaginationInfo', pageCount: number } } };

export type GetAdherenceRequestedReviewsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  filter: InputMaybe<FilterFindManyAdherence_SubmissionsInput>;
}>;


export type GetAdherenceRequestedReviewsQuery = { __typename?: 'Query', adherenceSubmissionMany: Array<{ __typename?: 'Adherence_Submissions', _id: any, requestId: string, dealershipName: string, createdAt: any, updatedAt: any, lastUpdated: any, status: string, invoiceNumber: string, campaign: string, mediaChannel: string, attachments: Array<{ __typename?: 'Adherence_SubmissionsAttachments', filename: string }> }> };

export type SetAllReviewsRequestedMutationVariables = Exact<{ [key: string]: never; }>;


export type SetAllReviewsRequestedMutation = { __typename?: 'Mutation', DEBUG_markAllReviewsAsRequested: boolean };

export type GetAdherenceCardsQueryVariables = Exact<{
  language: EnumAdherence_CardsLanguage;
}>;


export type GetAdherenceCardsQuery = { __typename?: 'Query', adherenceCardsMany: Array<{ __typename?: 'Adherence_Cards', title: string, source: string, language: EnumAdherence_CardsLanguage, link_url: string, link_label: string, type: string, featured: boolean, description: string, key: string, image: { __typename?: 'Adherence_CardsImage', src: string, alt: string } }> };

export type GetAdherenceComponentCardsQueryVariables = Exact<{
  language: EnumAdherence_CardsLanguage;
}>;


export type GetAdherenceComponentCardsQuery = { __typename?: 'Query', adherenceCardsMany: Array<{ __typename?: 'Adherence_Cards', title: string, source: string, language: EnumAdherence_CardsLanguage, link_url: string, link_label: string, type: string, featured: boolean, description: string, key: string, image: { __typename?: 'Adherence_CardsImage', src: string, alt: string } }> };

export type GetAdherenceMediaCardsQueryVariables = Exact<{
  language: EnumAdherence_CardsLanguage;
}>;


export type GetAdherenceMediaCardsQuery = { __typename?: 'Query', mediaFeatured: Array<{ __typename?: 'Adherence_Cards', title: string, source: string, language: EnumAdherence_CardsLanguage, link_url: string, link_label: string, type: string, featured: boolean, description: string, key: string, image: { __typename?: 'Adherence_CardsImage', src: string, alt: string } }>, componentsFeatured: Array<{ __typename?: 'Adherence_Cards', title: string, source: string, language: EnumAdherence_CardsLanguage, link_url: string, link_label: string, type: string, featured: boolean, description: string, key: string, image: { __typename?: 'Adherence_CardsImage', src: string, alt: string } }> };

export type ReviewExistenceQueryQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type ReviewExistenceQueryQuery = { __typename?: 'Query', adherenceReviewFindOne: { __typename?: 'Adherence_Reviews', requestId: string, mediaFilename: string, feedback: string, answerState: any } };

export type GetAdherenceSubmissionMediaByIdQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type GetAdherenceSubmissionMediaByIdQuery = { __typename?: 'Query', adherenceSubmissionOne: { __typename?: 'Adherence_Submissions', _id: any, requestId: string, attachments: Array<{ __typename?: 'Adherence_SubmissionsAttachments', id: string, url: string }> } };

export type GetAdherenceSubmissionByIdQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type GetAdherenceSubmissionByIdQuery = { __typename?: 'Query', adherenceSubmissionOne: { __typename?: 'Adherence_Submissions', _id: any, requestId: string, mediaChannel: string, audience: string, carModel: string, attachments: Array<{ __typename?: 'Adherence_SubmissionsAttachments', id: string, filename: string, type: string, filesize: number, preview: string }> } };

export type AdherenceResourcesQueryVariables = Exact<{
  path: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type AdherenceResourcesQuery = { __typename?: 'Query', adherenceContentOne: { __typename?: 'Adherence_Content', title: string, content: string, itemtype: string, parent: any, order: number, language: EnumAdherence_ContentLanguage, next: { __typename?: 'Adherence_Content', path: string, title: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Adherence_Content', path: string, title: string, titleFr: string }> }, previous: { __typename?: 'Adherence_Content', path: string, title: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Adherence_Content', path: string, title: string, titleFr: string }> } } };

export type GetQuestionsWithEmptyFeedbackQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuestionsWithEmptyFeedbackQuery = { __typename?: 'Query', adherenceCriteriaMany: Array<{ __typename?: 'Adherence_Criteria', question_key: string }> };

export type ReviewCriteriaQueryQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type ReviewCriteriaQueryQuery = { __typename?: 'Query', adherenceSubmissionOne: { __typename?: 'Adherence_Submissions', mediaChannel: string, criteria: Array<{ __typename?: 'Adherence_Criteria', question: string, question_key: string }> } };

export type CreateAdherenceReviewMutationVariables = Exact<{
  review: CreateOneAdherence_ReviewsInput;
  requestId: Scalars['String']['input'];
}>;


export type CreateAdherenceReviewMutation = { __typename?: 'Mutation', adherenceSubmissionMarkComplete: boolean, adherenceReviewCreateOne: { __typename?: 'CreateOneAdherence_ReviewsPayload', recordId: any } };

export type UpdateAdherenceReviewMutationVariables = Exact<{
  review: UpdateOneAdherence_ReviewsInput;
  requestId: Scalars['String']['input'];
}>;


export type UpdateAdherenceReviewMutation = { __typename?: 'Mutation', adherenceReviewUpdateOne: { __typename?: 'UpdateOneAdherence_ReviewsPayload', recordId: any } };

export type RemoveAdherenceReviewMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type RemoveAdherenceReviewMutation = { __typename?: 'Mutation', adherenceReviewRemoveOne: { __typename?: 'RemoveOneAdherence_ReviewsPayload', recordId: any } };

export type SendJudgementToTmbMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
  approved: Scalars['Boolean']['input'];
  rejected: Scalars['Boolean']['input'];
}>;


export type SendJudgementToTmbMutation = { __typename?: 'Mutation', adherenceReviewSendApproval?: string, adherenceReviewSendDenial?: string };

export type UnitsManyQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitsManyQuery = { __typename?: 'Query', unitsMany: Array<{ __typename?: 'Units', code: string, name: string }> };

export type ComplianceCasesManyQueryVariables = Exact<{
  adminView: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ComplianceCasesManyQuery = { __typename?: 'Query', complianceCasesMany: Array<{ __typename?: 'compliance_cases', _id: any, caseId: string, status: Enumcompliance_CasesStatus, outcome: Enumcompliance_CasesOutcome, inProgress: boolean, outcomeDate: string, repeatCaseIds: Array<string>, statusTransition: { __typename?: 'compliance_casesStatusTransition', from: Enumcompliance_CasesStatusTransitionFrom, to: Enumcompliance_CasesStatusTransitionTo }, reported: { __typename?: 'compliance_casesReported', dealerCode: string, dealerName: string }, reporter: { __typename?: 'compliance_casesReporter', name: string, dealerCode: string, dealerName: string, email: string }, caseInformation: Array<{ __typename?: 'compliance_casesCaseInformation', ongoing: Enumcompliance_CasesCaseInformationOngoing, infractionDate: string, infractionLocation: string, modifiedDate: string, category: Enumcompliance_CasesCaseInformationCategory, categoryOther: string, summary: string, revision: number, evidence: Array<{ __typename?: 'compliance_casesCaseInformationEvidence', mimetype: string, filename: string }> }>, history: Array<{ __typename?: 'compliance_casesHistory', status: Enumcompliance_CasesHistoryStatus, dealerNotes: string, internalNotes: string, internalNotesName: string, modifiedDate: string }> }> };

export type ComplianceCaseUpdateInProgressMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  inProgress: Scalars['Boolean']['input'];
}>;


export type ComplianceCaseUpdateInProgressMutation = { __typename?: 'Mutation', complianceCaseUpdateInProgress: boolean };

export type ComplianceCaseCreateOneMutationVariables = Exact<{
  payload: CreateOnecompliance_CasesInput;
}>;


export type ComplianceCaseCreateOneMutation = { __typename?: 'Mutation', complianceCaseCreateOne: { __typename?: 'CreateOnecompliance_casesPayload', recordId: any } };

export type ComplianceCaseUpdateStatusMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  status: Enumcompliance_CasesStatus;
  outcome: Enumcompliance_CasesOutcome;
  dealerNotes: InputMaybe<Scalars['String']['input']>;
  internalNotes: InputMaybe<Scalars['String']['input']>;
  internalNotesName: InputMaybe<Scalars['String']['input']>;
}>;


export type ComplianceCaseUpdateStatusMutation = { __typename?: 'Mutation', complianceCaseUpdateStatus: boolean };

export type ComplianceCaseUpdateCaseInformationMutationVariables = Exact<{
  caseId: Scalars['String']['input'];
  ongoing: Enumcompliance_CasesCaseInformationOngoing;
  infractionDate: Scalars['String']['input'];
  infractionLocation: InputMaybe<Scalars['String']['input']>;
  category: Enumcompliance_CasesCaseInformationCategory;
  categoryOther: Scalars['String']['input'];
  summary: Scalars['String']['input'];
  evidence: Array<InputMaybe<Compliance_CasesCaseInformationEvidenceInput>> | InputMaybe<Compliance_CasesCaseInformationEvidenceInput>;
}>;


export type ComplianceCaseUpdateCaseInformationMutation = { __typename?: 'Mutation', complianceCaseUpdateCaseInformation: string };

export type LoginQueryVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
  isPresentation: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LoginQuery = { __typename?: 'Query', validateLogin: { __typename?: 'LoginResponse', error: string, language: string } };

export type SterlingQueryVariables = Exact<{ [key: string]: never; }>;


export type SterlingQuery = { __typename?: 'Query', permittedRoutes: Array<string>, unitsManyByRole: Array<{ __typename?: 'Units', unit_code: string, unit_name: string }>, assessmentMany: Array<{ __typename?: 'Assessments', code: string, title: string, title_fr: string, categoryDetails: Array<{ __typename?: 'Category', code: string, label: string, label_fr: string }> }> };

export type ApiRouteFragment = { __typename?: 'ContentOld', title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean };

export type ApiRoutesQueryVariables = Exact<{
  language: LanguageCode;
  itemType: Scalars['String']['input'];
}>;


export type ApiRoutesQuery = { __typename?: 'Query', apiRoutes: Array<{ __typename?: 'ContentOld', title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'ContentOld', title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'ContentOld', title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'ContentOld', title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'ContentOld', title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'ContentOld', title: string, itemtype: string, key: string, path: string, order: number, alternatePath: string, titleFr: string, noContent: boolean }> }> }> }> }> }> };

export type ContentSearchQueryVariables = Exact<{
  text: Scalars['String']['input'];
  language: Scalars['String']['input'];
  noLimit: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContentSearchQuery = { __typename?: 'Query', contentSearch: Array<{ __typename?: 'SearchResult', _id: any, title: string, path: string, search_score: number, content: string, ancestors: Array<{ __typename?: 'ContentAncestor', title: string, path: string }> }> };

export type TagSuggestionSearchQueryVariables = Exact<{
  text: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type TagSuggestionSearchQuery = { __typename?: 'Query', tagSuggestionSearch: Array<string> };

export type AutocompleteSearchQueryVariables = Exact<{
  text: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type AutocompleteSearchQuery = { __typename?: 'Query', autocompleteSearch: Array<{ __typename?: 'SearchResult', title: string, path: string, ancestors: Array<{ __typename?: 'ContentAncestor', title: string, path: string }> }> };

export type TagSearchQueryVariables = Exact<{
  text: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type TagSearchQuery = { __typename?: 'Query', tagSearch: Array<{ __typename?: 'SearchResult', title: string, path: string, ancestors: Array<{ __typename?: 'ContentAncestor', title: string, path: string }> }> };

export type AccountManagementByUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type AccountManagementByUsernameQuery = { __typename?: 'Query', userOne: { __typename?: 'Users', _id: any, username: string, type: EnumUsersType, password: string, domains: Array<string>, email: string, title: string, first_name: string, last_name: string, preferred_language: EnumUsersPreferred_Language, coe_role: EnumUsersCoe_Role, coe_role_permissions: Array<string>, reviewer_role: EnumUsersReviewer_Role, comment: string, last_login: string, refresh_token: string, oem_access: Array<EnumUsersOem_Access> } };

export type AccountManagementByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AccountManagementByEmailQuery = { __typename?: 'Query', userOne: { __typename?: 'Users', _id: any, username: string, type: EnumUsersType, password: string, domains: Array<string>, email: string, title: string, first_name: string, last_name: string, preferred_language: EnumUsersPreferred_Language, coe_role: EnumUsersCoe_Role, coe_role_permissions: Array<string>, reviewer_role: EnumUsersReviewer_Role, comment: string, last_login: string, refresh_token: string, oem_access: Array<EnumUsersOem_Access> } };

export type UserUpdateOneMutationVariables = Exact<{
  filter: InputMaybe<FilterUpdateOneUsersInput>;
  record: UpdateOneUsersInput;
}>;


export type UserUpdateOneMutation = { __typename?: 'Mutation', userUpdateOne: { __typename?: 'UpdateOneUsersPayload', recordId: any } };

export type UserCreateOneMutationVariables = Exact<{
  record: CreateOneUsersInput;
}>;


export type UserCreateOneMutation = { __typename?: 'Mutation', userCreateOne: { __typename?: 'CreateOneUsersPayload', recordId: any } };

export type AccountManagementRolePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountManagementRolePermissionsQuery = { __typename?: 'Query', unitsMany: Array<{ __typename?: 'Units', code: string, name: string }>, segmentsMany: Array<{ __typename?: 'Segments', name: string, value: string }>, vendorsMany: Array<{ __typename?: 'Vendors', vendor_name: string }> };

export type UserUpdateListQueryVariables = Exact<{ [key: string]: never; }>;


export type UserUpdateListQuery = { __typename?: 'Query', userMany: Array<{ __typename?: 'Users', username: string, email: string }> };

export type Executive_SummaryQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type Executive_SummaryQuery = { __typename?: 'Query', executive_summary: Array<{ __typename?: 'ExecutiveSummary', question_name: string, question_number: number, question_label_EN: string, question_label_FR: string, category_code: string, category_number: number, category_label_EN: string, category_label_FR: string, response_count: { __typename?: 'ResponseAnalysis', yes: number, no: number, total: number, somewhat: number }, response_percent: { __typename?: 'ResponseAnalysis', yes: number, no: number, total: number, somewhat: number } }> };

export type LighthouseQuestionsAnalysisQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type LighthouseQuestionsAnalysisQuery = { __typename?: 'Query', lighthouse_question_analysis: Array<{ __typename?: 'QuestionScoreByLighthouseCategory', question_name: string, category_code: string, scores: Array<{ __typename?: 'LighthouseScore', answer: string, performance: number, accessibility: number, seo: number }> }> };

export type SearchContentPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchContentPagesQuery = { __typename?: 'Query', searchContentPages: Array<{ __typename?: 'Content', wordpress_id: number, title: string, content_search: string, tags: Array<string> }> };

export type GenerateSearchKeywordsQueryVariables = Exact<{
  text: Scalars['String']['input'];
  language: LanguageCode;
}>;


export type GenerateSearchKeywordsQuery = { __typename?: 'Query', generateSearchKeywords: Array<string> };

export type UpdateContentTagsMutationVariables = Exact<{
  wordpress_id: Scalars['Int']['input'];
  tags: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateContentTagsMutation = { __typename?: 'Mutation', updateContentTags: { __typename?: 'Content', wordpress_id: number } };

export type GetOrCreateReportingAggregateQueryVariables = Exact<{
  search_term: Scalars['String']['input'];
}>;


export type GetOrCreateReportingAggregateQuery = { __typename?: 'Query', reportingAggregateGetOrCreate: Array<{ __typename?: 'Reporting_Aggregates', search_term: string, count: number, timestamp: any, avgSessionPages: any, viewportTraffic: any, contactPageVisits: any, deviceTraffic: any, browserTraffic: any, uniqueVisits: any, avgBounceRate: any, avgUserSession: any }> };

export type GoogleTrendsQueryVariables = Exact<{
  dealerName: Scalars['String']['input'];
}>;


export type GoogleTrendsQuery = { __typename?: 'Query', google_trends: { __typename?: 'GoogleTrend', averageInterest: number, noData: boolean, trendData: Array<{ __typename?: 'GoogleTrendSegment', time: string, interest: number }> } };

export type LighthouseScoresQueryVariables = Exact<{
  dealerCode: InputMaybe<Scalars['String']['input']>;
}>;


export type LighthouseScoresQuery = { __typename?: 'Query', lighthouseOne: { __typename?: 'Lighthouse', dealerCode: string, categories: { __typename?: 'LighthouseCategories', performance: { __typename?: 'LighthouseCategoriesPerformance', title: string, score: number }, bestPractices: { __typename?: 'LighthouseCategoriesPerformance', title: string, score: number }, accessibility: { __typename?: 'LighthouseCategoriesAccessibility', title: string, score: number }, seo: { __typename?: 'LighthouseCategoriesAccessibility', title: string, score: number }, pwa: { __typename?: 'LighthouseCategoriesAccessibility', title: string, score: number } } } };

export type LighthouseAggregateByOemQueryVariables = Exact<{ [key: string]: never; }>;


export type LighthouseAggregateByOemQuery = { __typename?: 'Query', lighthouseAggregateByOem: Array<{ __typename?: 'LighthouseCategoryAggregate', oem: string, seo: { __typename?: 'LighthouseCategoryAggregateScore', max: number, avg: number }, performance: { __typename?: 'LighthouseCategoryAggregateScore', max: number, avg: number }, bestPractices: { __typename?: 'LighthouseCategoryAggregateScore', max: number, avg: number }, accessibility: { __typename?: 'LighthouseCategoryAggregateScore', max: number, avg: number } }> };

export type GetUnitReportsQueryVariables = Exact<{
  unit_code: Scalars['String']['input'];
}>;


export type GetUnitReportsQuery = { __typename?: 'Query', reportingConfigOne: { __typename?: 'Reporting_Configs', ua_view_id: string, region: string, reports: any } };

export type GetVendorAggregateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVendorAggregateQuery = { __typename?: 'Query', reportingAggregateGetVendor: Array<{ __typename?: 'Reporting_Aggregates', search_term: string, count: number, timestamp: any, avgSessionPages: any, viewportTraffic: any, contactPageVisits: any, deviceTraffic: any, browserTraffic: any, uniqueVisits: any, avgBounceRate: any, avgUserSession: any }> };

export type VendorUnitConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorUnitConfigsQuery = { __typename?: 'Query', reportingConfigVendorSites: Array<{ __typename?: 'Reporting_Configs', unit_code: string, measurement_id: string, unit: { __typename?: 'DealerTrackingDetails', name: string, url: string } }> };

export type VendorTrackingPropertyQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorTrackingPropertyQuery = { __typename?: 'Query', reportingConfigVendorProp: { __typename?: 'Reporting_Configs', tracking_code: string } };

export type UnitTrackingQueryVariables = Exact<{
  unit_code: Scalars['String']['input'];
  create: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UnitTrackingQuery = { __typename?: 'Query', reportingConfigUnitTracking: { __typename?: 'Reporting_Configs', measurement_id: string } };

export type ValidateViewIdQueryVariables = Exact<{
  update: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ValidateViewIdQuery = { __typename?: 'Query', reportingConfigViewIds: { __typename?: 'WebProperties', views: Array<{ __typename?: 'WebProperty', id: string, name: string, vendor_name: string, unit_code: string, url: string }> } };

export type ResourceQueryVariables = Exact<{
  path: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type ResourceQuery = { __typename?: 'Query', contentOne: { __typename?: 'Content', title: string, titleFr: string, content: string, itemtype: string, parent: any, order: number, language: EnumContentLanguage, next: { __typename?: 'Content', path: string, title: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Content', path: string, title: string, titleFr: string }> }, previous: { __typename?: 'Content', path: string, title: string, titleFr: string, noContent: boolean, children: Array<{ __typename?: 'Content', path: string, title: string, titleFr: string }> } } };

export type GetWebinarsQueryVariables = Exact<{
  lang: InputMaybe<EnumContent_WebinarsLanguage>;
}>;


export type GetWebinarsQuery = { __typename?: 'Query', contentWebinarMany: Array<{ __typename?: 'Content_Webinars', _id: any, title: string, description: string, language: EnumContent_WebinarsLanguage, body: string, post_date: string, created_date: string, modified_date: string, legacy_id: string, presenter: string, path: string, alternate_path: string, key: string, video_link: string, start_time: string, preview_image: { __typename?: 'Content_WebinarsPreview_image', _id: any, src: string, alt: string }, video: { __typename?: 'Content_WebinarsVideo', _id: any, src: string, caption: string, thumbnail: { __typename?: 'Content_WebinarsVideoThumbnail', _id: any, src: string, alt: string } } }> };

export type GetBusinessInsightsQueryVariables = Exact<{
  lang: InputMaybe<EnumContent_Business_InsightsLanguage>;
}>;


export type GetBusinessInsightsQuery = { __typename?: 'Query', contentBusinessInsightMany: Array<{ __typename?: 'Content_Business_Insights', _id: any, title: string, description: string, post_date: string, language: EnumContent_Business_InsightsLanguage, button_label: string, body: string, button_link: string, created_date: string, modified_date: string, key: string, path: string, new: boolean, alternate_path: string, legacy_id: string, preview_image: { __typename?: 'Content_Business_InsightsPreview_image', _id: any, src: string, alt: string }, categories: Array<{ __typename?: 'Content_Business_InsightsCategories', code: string, label: string }> }> };

export type ManagementDashboardSummaryQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  filterBy: Scalars['String']['input'];
  filterText: Scalars['String']['input'];
}>;


export type ManagementDashboardSummaryQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', group_id: string, total_score: number, max_score: number, final_score: number, review_details: { __typename?: 'AssessmentSummaryOld', unit_code: string, vendor_name: string, enabled: boolean }, best_category: { __typename?: 'CategorySummary', category_code: string, category_label: string, category_label_fr: string, total_score: number, max_score: number, final_score: number }, improvement_category: { __typename?: 'CategorySummary', category_code: string, category_label: string, category_label_fr: string, total_score: number, max_score: number, final_score: number }, category_scores: Array<{ __typename?: 'CategorySummary', category_code: string, category_label: string, category_label_fr: string, total_score: number, max_score: number, final_score: number }> }> } };

export type NewSummaryReportQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  sortBy: Scalars['String']['input'];
  sortOrder: Scalars['String']['input'];
  filterBy: Scalars['String']['input'];
  filterText: Scalars['String']['input'];
  categorySort: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  pageNum: Scalars['Int']['input'];
}>;


export type NewSummaryReportQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', group_id: string, total_score: number, max_score: number, final_score: number, review_details: { __typename?: 'AssessmentSummaryOld', unit_name: string, district_code: string, region_code: string, vendor_name: string, url: string }, category_scores: Array<{ __typename?: 'CategorySummary', total_score: number, max_score: number, final_score: number, code: string, label: string, label_fr: string }> }>, meta: { __typename?: 'Meta', documents: number, pages: number } } };

export type VendorsInAssessmentPeriodQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type VendorsInAssessmentPeriodQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', vendor_name: string }> } };

export type UnitLoggedInQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  codes: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UnitLoggedInQuery = { __typename?: 'Query', unitsMany: Array<{ __typename?: 'Units', code: string, assessment_login: boolean }> };

export type SummaryFragment = { __typename?: 'ScoreAggregatePackage', summary: { __typename?: 'ScoreAggregateSummary', id: string, unitCount: number, finalScore: number, ranked: Array<string>, range: { __typename?: 'ScoreAggregateRange', count59AndBelow: number, count60To69: number, count70To79: number, count80To89: number, count90AndAbove: number } } };

export type ResultsExcludingCategoriesFragment = { __typename?: 'ScoreAggregate', id: string, code: string, unitCount: number, finalScore: number, responses: { __typename?: 'ScoreAggregateResponses', yes: number, somewhat: number, no: number, total: number } };

export type ResultsCategoriesFragment = { __typename?: 'ScoreAggregate', categories: { __typename?: 'CategoryScoreAggregatePackage', scores: Array<{ __typename?: 'CategoryScoreAggregate', code: string, finalScore: number }>, best: { __typename?: 'CategoryScoreAggregate', code: string, finalScore: number }, growth: { __typename?: 'CategoryScoreAggregate', code: string, finalScore: number } } };

export type ScoresQueryVariables = Exact<{
  aggregateOn: SterlingKey;
  filter: ScoreFilter;
}>;


export type ScoresQuery = { __typename?: 'Query', scores: { __typename?: 'ScoreAggregatePackage', results: Array<{ __typename?: 'ScoreAggregate', id: string, code: string, unitCount: number, finalScore: number, responses: { __typename?: 'ScoreAggregateResponses', yes: number, somewhat: number, no: number, total: number }, categories: { __typename?: 'CategoryScoreAggregatePackage', scores: Array<{ __typename?: 'CategoryScoreAggregate', code: string, finalScore: number }>, best: { __typename?: 'CategoryScoreAggregate', code: string, finalScore: number }, growth: { __typename?: 'CategoryScoreAggregate', code: string, finalScore: number } } }>, summary: { __typename?: 'ScoreAggregateSummary', id: string, unitCount: number, finalScore: number, ranked: Array<string>, range: { __typename?: 'ScoreAggregateRange', count59AndBelow: number, count60To69: number, count70To79: number, count80To89: number, count90AndAbove: number } } } };

export type PortalContextAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalContextAssessmentsQuery = { __typename?: 'Query', portalContextAssessmentsMany: Array<{ __typename?: 'portal_context_assessments', code: string, assessmentCode: string, data: { __typename?: 'portal_context_assessmentsData', label: { __typename?: 'portal_context_assessmentsDataLabel', EN: string, FR: string } }, comp: { __typename?: 'portal_context_assessmentsComp', code: string } }> };

export type PortalContextCategoriesQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type PortalContextCategoriesQuery = { __typename?: 'Query', portalContextCategoriesMany: Array<{ __typename?: 'portal_context_categories', code: string, categoryCode: string, assessmentCode: string, order: number, data: { __typename?: 'portal_context_categoriesData', label: { __typename?: 'portal_context_assessmentsDataLabel', EN: string, FR: string } }, comp: { __typename?: 'portal_context_categoriesComp', code: string } }> };

export type PortalContextQuestionsQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  languageCode: Enumportal_Context_QuestionsLanguageCode;
}>;


export type PortalContextQuestionsQuery = { __typename?: 'Query', portalContextQuestionsMany: Array<{ __typename?: 'portal_context_questions', code: string, categoryCode: string, questionCode: string, order: number, data: { __typename?: 'portal_context_questionsData', label: string, isRequired: boolean, rationale: string, resources: Array<{ __typename?: 'portal_context_questionsDataResources', title: string, url: string }> }, comp: { __typename?: 'portal_context_questionsComp', code: string } }> };

export type PortalContextUnitsQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type PortalContextUnitsQuery = { __typename?: 'Query', portalContextUnitsMany: Array<{ __typename?: 'portal_context_units', code: string, unitCode: string, vendorCode: string, firstDivisionCode: string, secondDivisionCode: string, data: { __typename?: 'portal_context_unitsData', label: string, url: string }, comp: { __typename?: 'portal_context_unitsComp', code: string } }> };

export type PortalContextVendorsQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type PortalContextVendorsQuery = { __typename?: 'Query', portalContextVendorsMany: Array<{ __typename?: 'portal_context_vendors', code: string, assessmentCode: string, vendorCode: string, data: { __typename?: 'portal_context_vendorsData', label: string, vendorStatus: Enumportal_Context_VendorsDataVendorStatus }, comp: { __typename?: 'portal_context_vendorsComp', code: string } }> };

export type PortalContextFirstDivisionsQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type PortalContextFirstDivisionsQuery = { __typename?: 'Query', portalContextFirstDivisionsMany: Array<{ __typename?: 'portal_context_divisions_first', code: string, assessmentCode: string, firstDivisionCode: string, data: { __typename?: 'portal_context_divisions_firstData', label: string }, comp: { __typename?: 'portal_context_divisions_firstComp', code: string } }> };

export type PortalContextSecondDivisionsQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type PortalContextSecondDivisionsQuery = { __typename?: 'Query', portalContextSecondDivisionsMany: Array<{ __typename?: 'portal_context_divisions_second', code: string, assessmentCode: string, firstDivisionCode: string, secondDivisionCode: string, data: { __typename?: 'portal_context_divisions_secondData', label: string }, comp: { __typename?: 'portal_context_divisions_secondComp', code: string } }> };

export type PortalContextTagsQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type PortalContextTagsQuery = { __typename?: 'Query', portalContextTagsMany: Array<{ __typename?: 'portal_context_tags', code: string, tagCode: string, assessmentCode: string, data: { __typename?: 'portal_context_tagsData', label: { __typename?: 'portal_context_assessmentsDataLabel', EN: string, FR: string } }, comp: { __typename?: 'portal_context_tagsComp', code: string } }> };

export type PortalContextResponsesQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  categoryCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  firstDivisionCode: InputMaybe<Scalars['String']['input']>;
  secondDivisionCode: InputMaybe<Scalars['String']['input']>;
  questionCode: InputMaybe<Scalars['String']['input']>;
  tags: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PortalContextResponsesQuery = { __typename?: 'Query', portalContextResponsesMany: Array<{ __typename?: 'portal_context_responses', unitCode: string, vendorCode: string, firstDivisionCode: string, secondDivisionCode: string, questionCode: string, categoryCode: string, data: { __typename?: 'portal_context_responsesData', answer: string } }> };

export type NewVendorDashboardQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  sortBy: Scalars['String']['input'];
  sortOrder: Scalars['String']['input'];
  pageSize: Scalars['Int']['input'];
  pageNum: Scalars['Int']['input'];
}>;


export type NewVendorDashboardQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', group_id: string, units_in_group: number, percent_in_group: number, final_score: number, preferred_vendor: boolean }>, meta: { __typename?: 'Meta', pages: number } } };

export type VendorComparisonQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
}>;


export type VendorComparisonQuery = { __typename?: 'Query', preferredVendorComparison: { __typename?: 'PreferredVendorComparisonDocument', preferredAvgScore: number, nonPreferredAvgScore: number, preferredMarketShare: number, nonPreferredMarketShare: number } };

export type SelectedAssessmentQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  unitCode: Scalars['String']['input'];
}>;


export type SelectedAssessmentQuery = { __typename?: 'Query', unitsMany: Array<{ __typename?: 'Units', vendor_name: string }>, assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', preferred_vendor: boolean, total_score: number, max_score: number, final_score: number, review_details: { __typename?: 'AssessmentSummaryOld', region_code: string, region_label: string, district_code: string, district_label: string }, category_scores: Array<{ __typename?: 'CategorySummary', category_code: string, category_label: string, category_label_fr: string, total_score: number, max_score: number }>, best_category: { __typename?: 'CategorySummary', category_code: string, category_label: string, category_label_fr: string, total_score: number, max_score: number }, improvement_category: { __typename?: 'CategorySummary', category_code: string, category_label: string, category_label_fr: string, total_score: number, max_score: number } }> } };

export type SelectedAssessmentGroupQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  groupBy: Scalars['String']['input'];
  filterBy: Scalars['String']['input'];
  filterText: Scalars['String']['input'];
}>;


export type SelectedAssessmentGroupQuery = { __typename?: 'Query', assessmentSummaryManyGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', group_id: string, total_score: number, max_score: number, final_score: number, category_scores: Array<{ __typename?: 'CategorySummary', category_code: string, category_label: string, category_label_fr: string, total_score: number, max_score: number, final_score: number }>, units_in_rank: { __typename?: 'RankCount', score_90_and_above: number, score_80_to_89: number, score_70_to_79: number, score_60_to_69: number, score_59_and_below: number } }> } };

export type UnitVendorCodeQueryVariables = Exact<{
  unitCode: Scalars['String']['input'];
  assessmentCode: Scalars['String']['input'];
}>;


export type UnitVendorCodeQuery = { __typename?: 'Query', unitsMany: Array<{ __typename?: 'Units', code: string, vendor_name: string, vendor: { __typename?: 'Vendors', displayName: string } }> };

export type PerformanceReportQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  unitCode: Scalars['String']['input'];
}>;


export type PerformanceReportQuery = { __typename?: 'Query', assessmentSummariesGroup: { __typename?: 'AssessmentSummaryGroupPreQuery', edges: Array<{ __typename?: 'AssessmentSummaryGroup', review_details: { __typename?: 'AssessmentSummaryOld', unit_name: string, url: string }, review_category_responses: Array<{ __typename?: 'Category', code: string, label: string, label_fr: string, order: number, review: { __typename?: 'Review', period_label: string, answers: Array<{ __typename?: 'Answer', name: string, answer: number, comments: string, comments_fr: string, screenshots: Array<string>, question: { __typename?: 'Question', name: string, label: string, number: number, label_french: string, required: boolean, layout: string, rationale_EN: string, rationale_FR: string, resources: Array<{ __typename?: 'Resource', url: string, title: string }>, resources_french: Array<{ __typename?: 'Resource', url: string, title: string }> } }> } }> }> } };

export type SeenNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SeenNotificationsQuery = { __typename?: 'Query', seenNotifications: Array<{ __typename?: 'NotificationTrackings', notification_id: string }> };

export type MarkAllAsReadMutationVariables = Exact<{
  ids: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MarkAllAsReadMutation = { __typename?: 'Mutation', markAllAsRead: boolean };

export type MarkAllAsUnreadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllAsUnreadMutation = { __typename?: 'Mutation', markAllAsUnread: boolean };

export type GetNotificationsQueryVariables = Exact<{
  lang: InputMaybe<EnumContent_NotificationsLanguage>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', contentNotificationMany: Array<{ __typename?: 'Content_Notifications', _id: any, enabled: boolean, post_date: string, key: string, description: string, language: EnumContent_NotificationsLanguage, button_label: string, button_link: string, legacy_id: string, categories: Array<{ __typename?: 'Content_NotificationsCategories', code: string, label: string }> }> };

export type GetWebinarDetailsQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  lang: InputMaybe<EnumContent_WebinarsLanguage>;
}>;


export type GetWebinarDetailsQuery = { __typename?: 'Query', contentWebinarMany: Array<{ __typename: 'Content_Webinars', _id: any, title: string, description: string, key: string, path: string, alternate_path: string, presenter: string, post_date: string, start_time: string, body: string, video_link: string, legacy_id: string, video: { __typename?: 'Content_WebinarsVideo', src: string, caption: string, thumbnail: { __typename?: 'Content_WebinarsVideoThumbnail', src: string, alt: string } }, preview_image: { __typename?: 'Content_WebinarsPreview_image', src: string, alt: string } }> };

export type GetProgramUpdateDetailsQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  lang: InputMaybe<EnumContent_Program_UpdatesLanguage>;
}>;


export type GetProgramUpdateDetailsQuery = { __typename?: 'Query', contentProgramUpdateMany: Array<{ __typename: 'Content_Program_Updates', _id: any, title: string, description: string, new: boolean, important: boolean, body: string, key: string, path: string, alternate_path: string, enabled: boolean, language: EnumContent_Program_UpdatesLanguage, legacy_id: string, post_date: string, created_date: string, modified_date: string, preview_image: { __typename?: 'Content_Program_UpdatesPreview_image', src: string, alt: string }, hero_image: { __typename?: 'Content_Program_UpdatesHero_image', src: string, alt: string } }> };

export type GetBusinessInsightDetailsQueryVariables = Exact<{
  postId: Scalars['String']['input'];
  lang: InputMaybe<EnumContent_Business_InsightsLanguage>;
}>;


export type GetBusinessInsightDetailsQuery = { __typename?: 'Query', contentBusinessInsightMany: Array<{ __typename: 'Content_Business_Insights', _id: any, title: string, description: string, new: boolean, body: string, key: string, path: string, alternate_path: string, enabled: boolean, language: EnumContent_Business_InsightsLanguage, legacy_id: string, post_date: string, created_date: string, modified_date: string, preview_image: { __typename?: 'Content_Business_InsightsPreview_image', src: string, alt: string }, hero_image: { __typename?: 'Content_Business_InsightsHero_image', src: string, alt: string } }> };

export type TopByVendorQueryVariables = Exact<{
  assessmentCode: Scalars['String']['input'];
  vendorName: Scalars['String']['input'];
}>;


export type TopByVendorQuery = { __typename?: 'Query', assessmentSummaryTopByVendor: { __typename?: 'TopByVendor', final_score: number } };

export type GetPreferredVendorsQueryVariables = Exact<{
  lang: EnumContent_VendorLanguage;
}>;


export type GetPreferredVendorsQuery = { __typename?: 'Query', contentVendorMany: Array<{ __typename?: 'Content_Vendor', _id: any, code: string, title: string, language: EnumContent_VendorLanguage, website: string, websiteMMSC: string, websiteHACC: string, email: string, emailMMSC: string, emailHACC: string, description: string, service_area: string, location: string, languages: string, years_of_operation: string, number_of_employees: string, minimum_price: number, maximum_price: number, minimum_contract: string, cancellation_notice: string, dedicated_support_team: boolean, created_by: string, created_date: string, modified_by: string, modified_date: string, services: Array<{ __typename?: 'Content_VendorServices', code: string, label: string }>, value_added_services: Array<{ __typename?: 'Content_VendorValue_added_services', code: string, label: string }>, preferred: { __typename?: 'Content_VendorPreferred', HACC: boolean, MMSC: boolean, DEMO: boolean } }> };

export type GetProgramUpdatesQueryVariables = Exact<{
  lang: InputMaybe<EnumContent_Program_UpdatesLanguage>;
}>;


export type GetProgramUpdatesQuery = { __typename?: 'Query', contentProgramUpdateMany: Array<{ __typename?: 'Content_Program_Updates', _id: any, title: string, description: string, new: boolean, important: boolean, body: string, key: string, path: string, alternate_path: string, enabled: boolean, language: EnumContent_Program_UpdatesLanguage, legacy_id: string, post_date: string, created_date: string, modified_date: string, button_label: string, button_link: string, created_by: string, modified_by: string, preview_image: { __typename?: 'Content_Program_UpdatesPreview_image', _id: any, src: string, alt: string }, hero_image: { __typename?: 'Content_Program_UpdatesHero_image', _id: any, src: string, alt: string } }> };

export type UpdateVendorCheckpointMutationVariables = Exact<{
  questionCodes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  unitCodes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  status: InputMaybe<Scalars['String']['input']>;
  assigned: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateVendorCheckpointMutation = { __typename?: 'Mutation', updateCheckpointState: boolean };

export type DealerNameFromTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type DealerNameFromTokenQuery = { __typename?: 'Query', unitNameByUser: string, unitCodeByUser: string };

export type VendorNameFromTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type VendorNameFromTokenQuery = { __typename?: 'Query', portalContextVendorNameFromToken: string };

export type ProgressReportItemFragment = { __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } };

export type GetIsMultiDealerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsMultiDealerQuery = { __typename?: 'Query', portalContextProgressReportIsMultiDealer: boolean };

export type GetDealerProgressHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDealerProgressHomeQuery = { __typename?: 'Query', portalContextProgressReportByPriority: { __typename?: 'ProgressQuestionsByPriority', CRITICAL: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, SIGNIFICANT: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, FUNDAMENTAL: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, PROGRESSIVE: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, EVOLVED: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }> }, portalContextProgressReportByStatus: { __typename?: 'DealerStatusReportType', todo: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, revise: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }> } };

export type GetDealerStatusReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDealerStatusReportQuery = { __typename?: 'Query', portalContextProgressReportByStatus: { __typename?: 'DealerStatusReportType', todo: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, revise: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, inreview: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }>, completed: Array<{ __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }> } };

export type GetProgressReportQuestionByCodeQueryVariables = Exact<{
  unitCode: Scalars['String']['input'];
  questionCode: Scalars['String']['input'];
}>;


export type GetProgressReportQuestionByCodeQuery = { __typename?: 'Query', portalContextProgressReportQuestionById: { __typename?: 'DealerReportPanelData', dealer: { __typename?: 'DealerReportPanelDataDealerField', vendorCode: string, vendorName: string, firstDivisionCode: string, secondDivisionCode: string, dealerName: string }, question: { __typename?: 'portal_context_progress_reportQuestionsReviewed', questionCode: string, vendorCode: string, categoryCode: string, priority: Enumportal_Context_Progress_ReportQuestionsReviewedPriority, tags: Array<string>, weight: number, answer: string, vendorName: string, dealerName: string, answerValue: number, resolveImpact: number, assigned: Enumportal_Context_Progress_ReportQuestionsReviewedAssigned, status: Enumportal_Context_Progress_ReportQuestionsReviewedStatus, screenshots: Array<string>, isRequired: boolean, comments: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } } } };

export type GetAssessmentLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssessmentLabelsQuery = { __typename?: 'Query', portalContextAssessmentLabelOne: { __typename?: 'portal_context_assessment_labels', assessmentLabel: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string }, categories: Array<{ __typename?: 'portal_context_assessment_labelsCategories', categoryCode: string, categoryLabel: { __typename?: 'portal_context_assessmentsDataLabel', EN: string, FR: string } }>, questions: Array<{ __typename?: 'portal_context_assessment_labelsQuestions', questionCode: string, categoryLabel: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string }, improvement: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string }, resource: { __typename?: 'portal_context_assessment_labelsQuestionsResource', EN: Array<{ __typename?: 'portal_context_assessment_labelsQuestionsResourceEN', title: string, url: string }>, FR: Array<{ __typename?: 'portal_context_assessment_labelsQuestionsResourceEN', title: string, url: string }> }, videoLink: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string }, questionLabel: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string }, questionRationale: { __typename?: 'portal_context_progress_reportQuestionsReviewedComments', EN: string, FR: string } }> } };

export type ManagementProgressHomeFragmentFragment = { __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> };

export type GetManagementProgressHomeQueryVariables = Exact<{
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManagementProgressHomeQuery = { __typename?: 'Query', portalContextManagementDealerFilters: { __typename?: 'ProgressHomeFilterOptionsType', divisions: Array<string>, dealers: Array<{ __typename?: 'DealerCodesAndNames', unitCode: string, dealerName: string, firstDivisionCode: string, secondDivisionCode: string }>, vendor: Array<{ __typename?: 'VendorCodesAndNames', vendorCode: string, vendorName: string }> }, portalContextManagementProgressHome: { __typename?: 'ManagementReportType', CRITICAL: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, SIGNIFICANT: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, FUNDAMENTAL: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, PROGRESSIVE: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, EVOLVED: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }> } };

export type GetManagementHomeSummaryQueryVariables = Exact<{
  unitCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManagementHomeSummaryQuery = { __typename?: 'Query', portalContextManagementProgressHomeSummary: { __typename?: 'ManagementHomeSummaryType', averageScore: number, averageScoreChange: number, bestCategory: { __typename?: 'ManagementHomeSummaryCategoryType', averageScore: number, scoreChange: number, category: string }, worstCategory: { __typename?: 'ManagementHomeSummaryCategoryType', averageScore: number, scoreChange: number, category: string } } };

export type GetManagementDealerRanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagementDealerRanksQuery = { __typename?: 'Query', portalContextManagementDealerRanks: Array<{ __typename?: 'ManagementRankType', dealerName: string, assessmentManagerRank: number, score: number, roundedScore: number, previousScore: number, tapEligible: boolean }> };

export type GetManagementDivisionDisplayQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagementDivisionDisplayQuery = { __typename?: 'Query', portalContextManagementDivisionDisplay: string };

export type GetVendorProgressHomeQueryVariables = Exact<{
  unitCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVendorProgressHomeQuery = { __typename?: 'Query', portalContextVendorDealerFilters: { __typename?: 'ProgressHomeFilterOptionsType', dealers: Array<{ __typename?: 'DealerCodesAndNames', unitCode: string, dealerName: string }> }, portalContextVendorProgressHome: { __typename?: 'ManagementReportType', CRITICAL: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, SIGNIFICANT: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, FUNDAMENTAL: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, PROGRESSIVE: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, EVOLVED: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }> }, portalContextVendorProgressHomeRevisions: Array<{ __typename?: 'VendorProgressHomeRevision', questionCode: string, priority: string, unitCode: string, vendorCode: string, categoryCode: string, vendorName: string, dealerName: string, assigned: string, status: string, answerValue: number }> };

export type GetVendorHomeSummaryQueryVariables = Exact<{
  unitCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVendorHomeSummaryQuery = { __typename?: 'Query', portalContextVendorProgressHomeSummary: { __typename?: 'ManagementHomeSummaryType', averageScore: number, averageScoreChange: number, bestCategory: { __typename?: 'ManagementHomeSummaryCategoryType', averageScore: number, scoreChange: number, category: string }, worstCategory: { __typename?: 'ManagementHomeSummaryCategoryType', averageScore: number, scoreChange: number, category: string } } };

export type GetVendorDealerRanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVendorDealerRanksQuery = { __typename?: 'Query', portalContextVendorDealerRanks: Array<{ __typename?: 'ManagementRankType', dealerName: string, assessmentManagerRank: number, score: number, roundedScore: number, previousScore: number }> };

export type GetVendorStatusReportQueryVariables = Exact<{
  unitCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVendorStatusReportQuery = { __typename?: 'Query', portalContextVendorDealerFilters: { __typename?: 'ProgressHomeFilterOptionsType', dealers: Array<{ __typename?: 'DealerCodesAndNames', unitCode: string, dealerName: string }> }, portalContextVendorProgressStatusReport: { __typename?: 'ManagementStatusReportType', todo: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, revise: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, inreview: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, completed: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }> } };

export type GetOemProgressHomeQueryVariables = Exact<{
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOemProgressHomeQuery = { __typename?: 'Query', portalContextOemDealerFilters: { __typename?: 'ProgressHomeFilterOptionsType', divisions: Array<string>, status: Array<string>, dealers: Array<{ __typename?: 'DealerCodesAndNames', unitCode: string, dealerName: string, firstDivisionCode: string, secondDivisionCode: string }>, vendor: Array<{ __typename?: 'VendorCodesAndNames', vendorCode: string, vendorName: string }> }, portalContextOemProgressHome: { __typename?: 'ManagementReportType', CRITICAL: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, SIGNIFICANT: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, FUNDAMENTAL: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, PROGRESSIVE: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, EVOLVED: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }> } };

export type GetOemHomeSummaryQueryVariables = Exact<{
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOemHomeSummaryQuery = { __typename?: 'Query', portalContextOemProgressHomeSummary: { __typename?: 'ManagementHomeSummaryType', averageScore: number, averageScoreChange: number, bestCategory: { __typename?: 'ManagementHomeSummaryCategoryType', averageScore: number, scoreChange: number, category: string }, worstCategory: { __typename?: 'ManagementHomeSummaryCategoryType', averageScore: number, scoreChange: number, category: string } } };

export type GetOemStatusReportQueryVariables = Exact<{
  division: InputMaybe<Scalars['String']['input']>;
  unitCode: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  vendorCode: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOemStatusReportQuery = { __typename?: 'Query', portalContextOemDealerFilters: { __typename?: 'ProgressHomeFilterOptionsType', divisions: Array<string>, status: Array<string>, dealers: Array<{ __typename?: 'DealerCodesAndNames', unitCode: string, dealerName: string, firstDivisionCode: string, secondDivisionCode: string }>, vendor: Array<{ __typename?: 'VendorCodesAndNames', vendorCode: string, vendorName: string }> }, portalContextOemProgressStatusReport: { __typename?: 'ManagementStatusReportType', todo: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, revise: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, inreview: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }>, completed: Array<{ __typename?: 'ManagementReportQuestionType', _id: string, questionCode: string, categoryCode: string, instances: number, priority: string, totalMaxPoints: number, assignedProblemInstances: number, problemInstances: number, completionPercentage: number, resolveImpact: number, pointDeficit: number, assignedProblemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }>, problemQuestions: Array<{ __typename?: 'ProblemQuestionType', answerValue: number, weight: number, unitCode: string, vendorName: string, vendorCode: string, dealerName: string, status: string, assigned: string, score: { __typename?: 'ReportScore', max: number, earned: number } }> }> } };

export type GetOemDealerRanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOemDealerRanksQuery = { __typename?: 'Query', portalContextOemDealerRanks: Array<{ __typename?: 'ManagementRankType', dealerName: string, assessmentManagerRank: number, score: number, roundedScore: number, previousScore: number, tapEligible: boolean }> };

export const AdherenceContentRouteFragmentDoc = gql`
    fragment AdherenceContentRoute on Adherence_Content {
  _id
  parent
  title
  itemtype
  key
  path
  order
  alternatePath
  titleFr
  noContent
}
    `;
export const ApiRouteFragmentDoc = gql`
    fragment ApiRoute on ContentOld {
  title
  itemtype
  key
  path
  order
  alternatePath
  titleFr
  noContent
}
    `;
export const SummaryFragmentDoc = gql`
    fragment Summary on ScoreAggregatePackage {
  summary {
    id
    unitCount
    finalScore
    ranked
    range {
      count59AndBelow
      count60To69
      count70To79
      count80To89
      count90AndAbove
    }
  }
}
    `;
export const ResultsExcludingCategoriesFragmentDoc = gql`
    fragment ResultsExcludingCategories on ScoreAggregate {
  id
  code
  unitCount
  finalScore
  responses {
    yes
    somewhat
    no
    total
  }
}
    `;
export const ResultsCategoriesFragmentDoc = gql`
    fragment ResultsCategories on ScoreAggregate {
  categories {
    scores {
      code
      finalScore
    }
    best {
      code
      finalScore
    }
    growth {
      code
      finalScore
    }
  }
}
    `;
export const ProgressReportItemFragmentDoc = gql`
    fragment ProgressReportItem on portal_context_progress_reportQuestionsReviewed {
  questionCode
  vendorCode
  categoryCode
  priority
  comments {
    EN
    FR
  }
  tags
  weight
  answer
  vendorName
  dealerName
  answerValue
  resolveImpact
  assigned
  status
  screenshots
  isRequired
}
    `;
export const ManagementProgressHomeFragmentFragmentDoc = gql`
    fragment ManagementProgressHomeFragment on ManagementReportQuestionType {
  _id
  questionCode
  categoryCode
  assignedProblemQuestions {
    score {
      max
      earned
    }
    answerValue
    weight
    unitCode
    vendorName
    vendorCode
    dealerName
    status
    assigned
  }
  problemQuestions {
    score {
      max
      earned
    }
    answerValue
    weight
    unitCode
    vendorName
    vendorCode
    dealerName
    status
    assigned
  }
  instances
  priority
  totalMaxPoints
  assignedProblemInstances
  problemInstances
  completionPercentage
  resolveImpact
  pointDeficit
}
    `;
export const UpdatePreferredLanguageDocument = gql`
    mutation updatePreferredLanguage($language: LanguageCode!) {
  userUpdateLanguage(language: $language)
}
    `;
export type UpdatePreferredLanguageMutationFn = ApolloReactCommon.MutationFunction<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>;

/**
 * __useUpdatePreferredLanguageMutation__
 *
 * To run a mutation, you first call `useUpdatePreferredLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferredLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferredLanguageMutation, { data, loading, error }] = useUpdatePreferredLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdatePreferredLanguageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>(UpdatePreferredLanguageDocument, options);
      }
export type UpdatePreferredLanguageMutationHookResult = ReturnType<typeof useUpdatePreferredLanguageMutation>;
export type UpdatePreferredLanguageMutationResult = ApolloReactCommon.MutationResult<UpdatePreferredLanguageMutation>;
export type UpdatePreferredLanguageMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePreferredLanguageMutation, UpdatePreferredLanguageMutationVariables>;
export const LogoutDocument = gql`
    query logout {
  validateLogout: logout {
    success
  }
}
    `;

/**
 * __useLogoutQuery__
 *
 * To run a query within a React component, call `useLogoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useLogoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LogoutQuery, LogoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
      }
export function useLogoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LogoutQuery, LogoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
        }
export function useLogoutSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LogoutQuery, LogoutQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LogoutQuery, LogoutQueryVariables>(LogoutDocument, options);
        }
export type LogoutQueryHookResult = ReturnType<typeof useLogoutQuery>;
export type LogoutLazyQueryHookResult = ReturnType<typeof useLogoutLazyQuery>;
export type LogoutSuspenseQueryHookResult = ReturnType<typeof useLogoutSuspenseQuery>;
export type LogoutQueryResult = ApolloReactCommon.QueryResult<LogoutQuery, LogoutQueryVariables>;
export function refetchLogoutQuery(variables?: LogoutQueryVariables) {
      return { query: LogoutDocument, variables: variables }
    }
export const SegmentsByRoleDocument = gql`
    query segmentsByRole($assessmentCode: String!) {
  segmentsManyByRole(assessmentCode: $assessmentCode) {
    hierarchy
    name
    value
    parent
  }
}
    `;

/**
 * __useSegmentsByRoleQuery__
 *
 * To run a query within a React component, call `useSegmentsByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsByRoleQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useSegmentsByRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SegmentsByRoleQuery, SegmentsByRoleQueryVariables> & ({ variables: SegmentsByRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SegmentsByRoleQuery, SegmentsByRoleQueryVariables>(SegmentsByRoleDocument, options);
      }
export function useSegmentsByRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SegmentsByRoleQuery, SegmentsByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SegmentsByRoleQuery, SegmentsByRoleQueryVariables>(SegmentsByRoleDocument, options);
        }
export function useSegmentsByRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SegmentsByRoleQuery, SegmentsByRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SegmentsByRoleQuery, SegmentsByRoleQueryVariables>(SegmentsByRoleDocument, options);
        }
export type SegmentsByRoleQueryHookResult = ReturnType<typeof useSegmentsByRoleQuery>;
export type SegmentsByRoleLazyQueryHookResult = ReturnType<typeof useSegmentsByRoleLazyQuery>;
export type SegmentsByRoleSuspenseQueryHookResult = ReturnType<typeof useSegmentsByRoleSuspenseQuery>;
export type SegmentsByRoleQueryResult = ApolloReactCommon.QueryResult<SegmentsByRoleQuery, SegmentsByRoleQueryVariables>;
export function refetchSegmentsByRoleQuery(variables: SegmentsByRoleQueryVariables) {
      return { query: SegmentsByRoleDocument, variables: variables }
    }
export const UnitsWithViewsDocument = gql`
    query unitsWithViews {
  unitsManyByReporting {
    name
    code
  }
}
    `;

/**
 * __useUnitsWithViewsQuery__
 *
 * To run a query within a React component, call `useUnitsWithViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitsWithViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitsWithViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitsWithViewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnitsWithViewsQuery, UnitsWithViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitsWithViewsQuery, UnitsWithViewsQueryVariables>(UnitsWithViewsDocument, options);
      }
export function useUnitsWithViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitsWithViewsQuery, UnitsWithViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitsWithViewsQuery, UnitsWithViewsQueryVariables>(UnitsWithViewsDocument, options);
        }
export function useUnitsWithViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitsWithViewsQuery, UnitsWithViewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitsWithViewsQuery, UnitsWithViewsQueryVariables>(UnitsWithViewsDocument, options);
        }
export type UnitsWithViewsQueryHookResult = ReturnType<typeof useUnitsWithViewsQuery>;
export type UnitsWithViewsLazyQueryHookResult = ReturnType<typeof useUnitsWithViewsLazyQuery>;
export type UnitsWithViewsSuspenseQueryHookResult = ReturnType<typeof useUnitsWithViewsSuspenseQuery>;
export type UnitsWithViewsQueryResult = ApolloReactCommon.QueryResult<UnitsWithViewsQuery, UnitsWithViewsQueryVariables>;
export function refetchUnitsWithViewsQuery(variables?: UnitsWithViewsQueryVariables) {
      return { query: UnitsWithViewsDocument, variables: variables }
    }
export const GetAssessmentDateDocument = gql`
    query getAssessmentDate($assessmentCode: String!) {
  assessmentStartDate(assessmentCode: $assessmentCode)
  assessmentEndDate(assessmentCode: $assessmentCode)
}
    `;

/**
 * __useGetAssessmentDateQuery__
 *
 * To run a query within a React component, call `useGetAssessmentDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentDateQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useGetAssessmentDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAssessmentDateQuery, GetAssessmentDateQueryVariables> & ({ variables: GetAssessmentDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAssessmentDateQuery, GetAssessmentDateQueryVariables>(GetAssessmentDateDocument, options);
      }
export function useGetAssessmentDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAssessmentDateQuery, GetAssessmentDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAssessmentDateQuery, GetAssessmentDateQueryVariables>(GetAssessmentDateDocument, options);
        }
export function useGetAssessmentDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAssessmentDateQuery, GetAssessmentDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAssessmentDateQuery, GetAssessmentDateQueryVariables>(GetAssessmentDateDocument, options);
        }
export type GetAssessmentDateQueryHookResult = ReturnType<typeof useGetAssessmentDateQuery>;
export type GetAssessmentDateLazyQueryHookResult = ReturnType<typeof useGetAssessmentDateLazyQuery>;
export type GetAssessmentDateSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentDateSuspenseQuery>;
export type GetAssessmentDateQueryResult = ApolloReactCommon.QueryResult<GetAssessmentDateQuery, GetAssessmentDateQueryVariables>;
export function refetchGetAssessmentDateQuery(variables: GetAssessmentDateQueryVariables) {
      return { query: GetAssessmentDateDocument, variables: variables }
    }
export const PerformanceReportCsvDocument = gql`
    query performanceReportCSV($assessmentCode: String!) {
  reviewsMany(filter: {assessment_code: $assessmentCode}, sort: UNIT_CODE_ASC) {
    unit_code
    unit_name
    assessment_code
    period_label
    category_code
    category_label
    category_label_fr
    answers {
      name
      answer
      comments
      screenshots
    }
  }
}
    `;

/**
 * __usePerformanceReportCsvQuery__
 *
 * To run a query within a React component, call `usePerformanceReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceReportCsvQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function usePerformanceReportCsvQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PerformanceReportCsvQuery, PerformanceReportCsvQueryVariables> & ({ variables: PerformanceReportCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PerformanceReportCsvQuery, PerformanceReportCsvQueryVariables>(PerformanceReportCsvDocument, options);
      }
export function usePerformanceReportCsvLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PerformanceReportCsvQuery, PerformanceReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PerformanceReportCsvQuery, PerformanceReportCsvQueryVariables>(PerformanceReportCsvDocument, options);
        }
export function usePerformanceReportCsvSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PerformanceReportCsvQuery, PerformanceReportCsvQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PerformanceReportCsvQuery, PerformanceReportCsvQueryVariables>(PerformanceReportCsvDocument, options);
        }
export type PerformanceReportCsvQueryHookResult = ReturnType<typeof usePerformanceReportCsvQuery>;
export type PerformanceReportCsvLazyQueryHookResult = ReturnType<typeof usePerformanceReportCsvLazyQuery>;
export type PerformanceReportCsvSuspenseQueryHookResult = ReturnType<typeof usePerformanceReportCsvSuspenseQuery>;
export type PerformanceReportCsvQueryResult = ApolloReactCommon.QueryResult<PerformanceReportCsvQuery, PerformanceReportCsvQueryVariables>;
export function refetchPerformanceReportCsvQuery(variables: PerformanceReportCsvQueryVariables) {
      return { query: PerformanceReportCsvDocument, variables: variables }
    }
export const CategoriesManyCsvDocument = gql`
    query categoriesManyCSV($assessmentCode: String!) {
  categoriesMany(filter: {assessment_code: $assessmentCode}) {
    code
    questions {
      name
      number
      layout
      number
      required
      label
      label_french
    }
  }
}
    `;

/**
 * __useCategoriesManyCsvQuery__
 *
 * To run a query within a React component, call `useCategoriesManyCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesManyCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesManyCsvQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useCategoriesManyCsvQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CategoriesManyCsvQuery, CategoriesManyCsvQueryVariables> & ({ variables: CategoriesManyCsvQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CategoriesManyCsvQuery, CategoriesManyCsvQueryVariables>(CategoriesManyCsvDocument, options);
      }
export function useCategoriesManyCsvLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CategoriesManyCsvQuery, CategoriesManyCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CategoriesManyCsvQuery, CategoriesManyCsvQueryVariables>(CategoriesManyCsvDocument, options);
        }
export function useCategoriesManyCsvSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CategoriesManyCsvQuery, CategoriesManyCsvQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CategoriesManyCsvQuery, CategoriesManyCsvQueryVariables>(CategoriesManyCsvDocument, options);
        }
export type CategoriesManyCsvQueryHookResult = ReturnType<typeof useCategoriesManyCsvQuery>;
export type CategoriesManyCsvLazyQueryHookResult = ReturnType<typeof useCategoriesManyCsvLazyQuery>;
export type CategoriesManyCsvSuspenseQueryHookResult = ReturnType<typeof useCategoriesManyCsvSuspenseQuery>;
export type CategoriesManyCsvQueryResult = ApolloReactCommon.QueryResult<CategoriesManyCsvQuery, CategoriesManyCsvQueryVariables>;
export function refetchCategoriesManyCsvQuery(variables: CategoriesManyCsvQueryVariables) {
      return { query: CategoriesManyCsvDocument, variables: variables }
    }
export const RankedDealersDocument = gql`
    query rankedDealers($assessmentCode: String!, $sortOrder: String!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    filterRole: true
    groupBy: "UNIT_CODE"
    sortBy: "FINAL_SCORE"
    sortOrder: $sortOrder
    pageNum: 0
    pageSize: 10
  ) {
    edges {
      review_details {
        unit_name
        region_code
      }
      final_score
    }
  }
}
    `;

/**
 * __useRankedDealersQuery__
 *
 * To run a query within a React component, call `useRankedDealersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankedDealersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankedDealersQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useRankedDealersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RankedDealersQuery, RankedDealersQueryVariables> & ({ variables: RankedDealersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RankedDealersQuery, RankedDealersQueryVariables>(RankedDealersDocument, options);
      }
export function useRankedDealersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RankedDealersQuery, RankedDealersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RankedDealersQuery, RankedDealersQueryVariables>(RankedDealersDocument, options);
        }
export function useRankedDealersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RankedDealersQuery, RankedDealersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RankedDealersQuery, RankedDealersQueryVariables>(RankedDealersDocument, options);
        }
export type RankedDealersQueryHookResult = ReturnType<typeof useRankedDealersQuery>;
export type RankedDealersLazyQueryHookResult = ReturnType<typeof useRankedDealersLazyQuery>;
export type RankedDealersSuspenseQueryHookResult = ReturnType<typeof useRankedDealersSuspenseQuery>;
export type RankedDealersQueryResult = ApolloReactCommon.QueryResult<RankedDealersQuery, RankedDealersQueryVariables>;
export function refetchRankedDealersQuery(variables: RankedDealersQueryVariables) {
      return { query: RankedDealersDocument, variables: variables }
    }
export const RankedDealersSegmentedDocument = gql`
    query rankedDealersSegmented($assessmentCode: String!, $filterText: String!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    filterRole: false
    filterText: $filterText
    groupBy: "UNIT_CODE"
    sortBy: "FINAL_SCORE"
    sortOrder: "DESC"
    filterBy: "REGION_CODE"
    pageNum: 0
    pageSize: 10
  ) {
    edges {
      review_details {
        unit_name
        region_code
      }
      final_score
    }
  }
}
    `;

/**
 * __useRankedDealersSegmentedQuery__
 *
 * To run a query within a React component, call `useRankedDealersSegmentedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankedDealersSegmentedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankedDealersSegmentedQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      filterText: // value for 'filterText'
 *   },
 * });
 */
export function useRankedDealersSegmentedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RankedDealersSegmentedQuery, RankedDealersSegmentedQueryVariables> & ({ variables: RankedDealersSegmentedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RankedDealersSegmentedQuery, RankedDealersSegmentedQueryVariables>(RankedDealersSegmentedDocument, options);
      }
export function useRankedDealersSegmentedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RankedDealersSegmentedQuery, RankedDealersSegmentedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RankedDealersSegmentedQuery, RankedDealersSegmentedQueryVariables>(RankedDealersSegmentedDocument, options);
        }
export function useRankedDealersSegmentedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RankedDealersSegmentedQuery, RankedDealersSegmentedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RankedDealersSegmentedQuery, RankedDealersSegmentedQueryVariables>(RankedDealersSegmentedDocument, options);
        }
export type RankedDealersSegmentedQueryHookResult = ReturnType<typeof useRankedDealersSegmentedQuery>;
export type RankedDealersSegmentedLazyQueryHookResult = ReturnType<typeof useRankedDealersSegmentedLazyQuery>;
export type RankedDealersSegmentedSuspenseQueryHookResult = ReturnType<typeof useRankedDealersSegmentedSuspenseQuery>;
export type RankedDealersSegmentedQueryResult = ApolloReactCommon.QueryResult<RankedDealersSegmentedQuery, RankedDealersSegmentedQueryVariables>;
export function refetchRankedDealersSegmentedQuery(variables: RankedDealersSegmentedQueryVariables) {
      return { query: RankedDealersSegmentedDocument, variables: variables }
    }
export const RankedSegmentsDocument = gql`
    query rankedSegments($assessmentCode: String!, $sortOrder: String!, $groupBy: String!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    groupBy: $groupBy
    filterRole: true
    sortBy: "FINAL_SCORE"
    sortOrder: $sortOrder
    pageNum: 0
    pageSize: 0
  ) {
    edges {
      group_id
      final_score
    }
  }
}
    `;

/**
 * __useRankedSegmentsQuery__
 *
 * To run a query within a React component, call `useRankedSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankedSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankedSegmentsQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      sortOrder: // value for 'sortOrder'
 *      groupBy: // value for 'groupBy'
 *   },
 * });
 */
export function useRankedSegmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RankedSegmentsQuery, RankedSegmentsQueryVariables> & ({ variables: RankedSegmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RankedSegmentsQuery, RankedSegmentsQueryVariables>(RankedSegmentsDocument, options);
      }
export function useRankedSegmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RankedSegmentsQuery, RankedSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RankedSegmentsQuery, RankedSegmentsQueryVariables>(RankedSegmentsDocument, options);
        }
export function useRankedSegmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RankedSegmentsQuery, RankedSegmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RankedSegmentsQuery, RankedSegmentsQueryVariables>(RankedSegmentsDocument, options);
        }
export type RankedSegmentsQueryHookResult = ReturnType<typeof useRankedSegmentsQuery>;
export type RankedSegmentsLazyQueryHookResult = ReturnType<typeof useRankedSegmentsLazyQuery>;
export type RankedSegmentsSuspenseQueryHookResult = ReturnType<typeof useRankedSegmentsSuspenseQuery>;
export type RankedSegmentsQueryResult = ApolloReactCommon.QueryResult<RankedSegmentsQuery, RankedSegmentsQueryVariables>;
export function refetchRankedSegmentsQuery(variables: RankedSegmentsQueryVariables) {
      return { query: RankedSegmentsDocument, variables: variables }
    }
export const GetWebinarCalendarDocument = gql`
    query getWebinarCalendar($lang: EnumContent_WebinarsLanguage!) {
  contentWebinarMany(filter: {language: $lang}) {
    _id
    title
    start_time
    created_date
    modified_date
  }
}
    `;

/**
 * __useGetWebinarCalendarQuery__
 *
 * To run a query within a React component, call `useGetWebinarCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebinarCalendarQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetWebinarCalendarQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWebinarCalendarQuery, GetWebinarCalendarQueryVariables> & ({ variables: GetWebinarCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWebinarCalendarQuery, GetWebinarCalendarQueryVariables>(GetWebinarCalendarDocument, options);
      }
export function useGetWebinarCalendarLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebinarCalendarQuery, GetWebinarCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWebinarCalendarQuery, GetWebinarCalendarQueryVariables>(GetWebinarCalendarDocument, options);
        }
export function useGetWebinarCalendarSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWebinarCalendarQuery, GetWebinarCalendarQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWebinarCalendarQuery, GetWebinarCalendarQueryVariables>(GetWebinarCalendarDocument, options);
        }
export type GetWebinarCalendarQueryHookResult = ReturnType<typeof useGetWebinarCalendarQuery>;
export type GetWebinarCalendarLazyQueryHookResult = ReturnType<typeof useGetWebinarCalendarLazyQuery>;
export type GetWebinarCalendarSuspenseQueryHookResult = ReturnType<typeof useGetWebinarCalendarSuspenseQuery>;
export type GetWebinarCalendarQueryResult = ApolloReactCommon.QueryResult<GetWebinarCalendarQuery, GetWebinarCalendarQueryVariables>;
export function refetchGetWebinarCalendarQuery(variables: GetWebinarCalendarQueryVariables) {
      return { query: GetWebinarCalendarDocument, variables: variables }
    }
export const PrivateRouteDocument = gql`
    query privateRoute($path: String!) {
  routePermission(path: $path)
}
    `;

/**
 * __usePrivateRouteQuery__
 *
 * To run a query within a React component, call `usePrivateRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateRouteQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function usePrivateRouteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrivateRouteQuery, PrivateRouteQueryVariables> & ({ variables: PrivateRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrivateRouteQuery, PrivateRouteQueryVariables>(PrivateRouteDocument, options);
      }
export function usePrivateRouteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrivateRouteQuery, PrivateRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrivateRouteQuery, PrivateRouteQueryVariables>(PrivateRouteDocument, options);
        }
export function usePrivateRouteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrivateRouteQuery, PrivateRouteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrivateRouteQuery, PrivateRouteQueryVariables>(PrivateRouteDocument, options);
        }
export type PrivateRouteQueryHookResult = ReturnType<typeof usePrivateRouteQuery>;
export type PrivateRouteLazyQueryHookResult = ReturnType<typeof usePrivateRouteLazyQuery>;
export type PrivateRouteSuspenseQueryHookResult = ReturnType<typeof usePrivateRouteSuspenseQuery>;
export type PrivateRouteQueryResult = ApolloReactCommon.QueryResult<PrivateRouteQuery, PrivateRouteQueryVariables>;
export function refetchPrivateRouteQuery(variables: PrivateRouteQueryVariables) {
      return { query: PrivateRouteDocument, variables: variables }
    }
export const FetchAllConfigurationsAllFieldsDocument = gql`
    query fetchAllConfigurationsAllFields($type: EnumConfigurationsType!, $oem: EnumConfigurationsOem!) {
  config: configurationOne(filter: {type: $type, oem: $oem}) {
    type
    oem
    maintenance_message_en
    maintenance_message_fr
    region_label_en
    region_label_fr
    district_label_en
    district_label_fr
  }
}
    `;

/**
 * __useFetchAllConfigurationsAllFieldsQuery__
 *
 * To run a query within a React component, call `useFetchAllConfigurationsAllFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllConfigurationsAllFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllConfigurationsAllFieldsQuery({
 *   variables: {
 *      type: // value for 'type'
 *      oem: // value for 'oem'
 *   },
 * });
 */
export function useFetchAllConfigurationsAllFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchAllConfigurationsAllFieldsQuery, FetchAllConfigurationsAllFieldsQueryVariables> & ({ variables: FetchAllConfigurationsAllFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchAllConfigurationsAllFieldsQuery, FetchAllConfigurationsAllFieldsQueryVariables>(FetchAllConfigurationsAllFieldsDocument, options);
      }
export function useFetchAllConfigurationsAllFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchAllConfigurationsAllFieldsQuery, FetchAllConfigurationsAllFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchAllConfigurationsAllFieldsQuery, FetchAllConfigurationsAllFieldsQueryVariables>(FetchAllConfigurationsAllFieldsDocument, options);
        }
export function useFetchAllConfigurationsAllFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchAllConfigurationsAllFieldsQuery, FetchAllConfigurationsAllFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchAllConfigurationsAllFieldsQuery, FetchAllConfigurationsAllFieldsQueryVariables>(FetchAllConfigurationsAllFieldsDocument, options);
        }
export type FetchAllConfigurationsAllFieldsQueryHookResult = ReturnType<typeof useFetchAllConfigurationsAllFieldsQuery>;
export type FetchAllConfigurationsAllFieldsLazyQueryHookResult = ReturnType<typeof useFetchAllConfigurationsAllFieldsLazyQuery>;
export type FetchAllConfigurationsAllFieldsSuspenseQueryHookResult = ReturnType<typeof useFetchAllConfigurationsAllFieldsSuspenseQuery>;
export type FetchAllConfigurationsAllFieldsQueryResult = ApolloReactCommon.QueryResult<FetchAllConfigurationsAllFieldsQuery, FetchAllConfigurationsAllFieldsQueryVariables>;
export function refetchFetchAllConfigurationsAllFieldsQuery(variables: FetchAllConfigurationsAllFieldsQueryVariables) {
      return { query: FetchAllConfigurationsAllFieldsDocument, variables: variables }
    }
export const SegmentsManyDocument = gql`
    query segmentsMany {
  segmentsMany {
    hierarchy
    type
    name
    value
    parent
  }
}
    `;

/**
 * __useSegmentsManyQuery__
 *
 * To run a query within a React component, call `useSegmentsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentsManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentsManyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SegmentsManyQuery, SegmentsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SegmentsManyQuery, SegmentsManyQueryVariables>(SegmentsManyDocument, options);
      }
export function useSegmentsManyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SegmentsManyQuery, SegmentsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SegmentsManyQuery, SegmentsManyQueryVariables>(SegmentsManyDocument, options);
        }
export function useSegmentsManySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SegmentsManyQuery, SegmentsManyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SegmentsManyQuery, SegmentsManyQueryVariables>(SegmentsManyDocument, options);
        }
export type SegmentsManyQueryHookResult = ReturnType<typeof useSegmentsManyQuery>;
export type SegmentsManyLazyQueryHookResult = ReturnType<typeof useSegmentsManyLazyQuery>;
export type SegmentsManySuspenseQueryHookResult = ReturnType<typeof useSegmentsManySuspenseQuery>;
export type SegmentsManyQueryResult = ApolloReactCommon.QueryResult<SegmentsManyQuery, SegmentsManyQueryVariables>;
export function refetchSegmentsManyQuery(variables?: SegmentsManyQueryVariables) {
      return { query: SegmentsManyDocument, variables: variables }
    }
export const AdherenceContentNavOptionsDocument = gql`
    query adherenceContentNavOptions($language: EnumAdherence_ContentLanguage!) {
  adherenceContentMany(filter: {parent: null, language: $language}) {
    ...AdherenceContentRoute
    children {
      ...AdherenceContentRoute
      children {
        ...AdherenceContentRoute
        children {
          ...AdherenceContentRoute
          children {
            ...AdherenceContentRoute
            children {
              ...AdherenceContentRoute
            }
          }
        }
      }
    }
  }
}
    ${AdherenceContentRouteFragmentDoc}`;

/**
 * __useAdherenceContentNavOptionsQuery__
 *
 * To run a query within a React component, call `useAdherenceContentNavOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdherenceContentNavOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdherenceContentNavOptionsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAdherenceContentNavOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdherenceContentNavOptionsQuery, AdherenceContentNavOptionsQueryVariables> & ({ variables: AdherenceContentNavOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdherenceContentNavOptionsQuery, AdherenceContentNavOptionsQueryVariables>(AdherenceContentNavOptionsDocument, options);
      }
export function useAdherenceContentNavOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdherenceContentNavOptionsQuery, AdherenceContentNavOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdherenceContentNavOptionsQuery, AdherenceContentNavOptionsQueryVariables>(AdherenceContentNavOptionsDocument, options);
        }
export function useAdherenceContentNavOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdherenceContentNavOptionsQuery, AdherenceContentNavOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdherenceContentNavOptionsQuery, AdherenceContentNavOptionsQueryVariables>(AdherenceContentNavOptionsDocument, options);
        }
export type AdherenceContentNavOptionsQueryHookResult = ReturnType<typeof useAdherenceContentNavOptionsQuery>;
export type AdherenceContentNavOptionsLazyQueryHookResult = ReturnType<typeof useAdherenceContentNavOptionsLazyQuery>;
export type AdherenceContentNavOptionsSuspenseQueryHookResult = ReturnType<typeof useAdherenceContentNavOptionsSuspenseQuery>;
export type AdherenceContentNavOptionsQueryResult = ApolloReactCommon.QueryResult<AdherenceContentNavOptionsQuery, AdherenceContentNavOptionsQueryVariables>;
export function refetchAdherenceContentNavOptionsQuery(variables: AdherenceContentNavOptionsQueryVariables) {
      return { query: AdherenceContentNavOptionsDocument, variables: variables }
    }
export const GetAdherenceReviewByIdDocument = gql`
    query getAdherenceReviewById($requestId: String!) {
  adherenceSubmissionOne(filter: {requestId: $requestId}) {
    _id
    requestId
    dealershipName
    createdAt
    status
    invoiceNumber
    mediaChannel
    audience
    carModel
    campaign
    activity
    attachments {
      filename
      preview
    }
    period
    criteria {
      _id
      category
      category_order
      question
      question_key
      question_order
      correct_response
      question_dependencies
      correct_response
      criteria_image
      media_channels
      periods
    }
  }
}
    `;

/**
 * __useGetAdherenceReviewByIdQuery__
 *
 * To run a query within a React component, call `useGetAdherenceReviewByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceReviewByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceReviewByIdQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetAdherenceReviewByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceReviewByIdQuery, GetAdherenceReviewByIdQueryVariables> & ({ variables: GetAdherenceReviewByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceReviewByIdQuery, GetAdherenceReviewByIdQueryVariables>(GetAdherenceReviewByIdDocument, options);
      }
export function useGetAdherenceReviewByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceReviewByIdQuery, GetAdherenceReviewByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceReviewByIdQuery, GetAdherenceReviewByIdQueryVariables>(GetAdherenceReviewByIdDocument, options);
        }
export function useGetAdherenceReviewByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceReviewByIdQuery, GetAdherenceReviewByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceReviewByIdQuery, GetAdherenceReviewByIdQueryVariables>(GetAdherenceReviewByIdDocument, options);
        }
export type GetAdherenceReviewByIdQueryHookResult = ReturnType<typeof useGetAdherenceReviewByIdQuery>;
export type GetAdherenceReviewByIdLazyQueryHookResult = ReturnType<typeof useGetAdherenceReviewByIdLazyQuery>;
export type GetAdherenceReviewByIdSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceReviewByIdSuspenseQuery>;
export type GetAdherenceReviewByIdQueryResult = ApolloReactCommon.QueryResult<GetAdherenceReviewByIdQuery, GetAdherenceReviewByIdQueryVariables>;
export function refetchGetAdherenceReviewByIdQuery(variables: GetAdherenceReviewByIdQueryVariables) {
      return { query: GetAdherenceReviewByIdDocument, variables: variables }
    }
export const GetAdherenceMediaChannelsPassratesDocument = gql`
    query getAdherenceMediaChannelsPassrates($campaign: String!, $previousCampaign: String, $skipPrevious: Boolean!) {
  adherenceMediaChannelPassrateByCampaign(
    campaign: $campaign
    previousCampaign: $previousCampaign
  ) {
    currentCampaign {
      mediaChannel
      reviewsCount
      failed
    }
    previousCampaign @skip(if: $skipPrevious) {
      mediaChannel
      reviewsCount
      failed
    }
  }
}
    `;

/**
 * __useGetAdherenceMediaChannelsPassratesQuery__
 *
 * To run a query within a React component, call `useGetAdherenceMediaChannelsPassratesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceMediaChannelsPassratesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceMediaChannelsPassratesQuery({
 *   variables: {
 *      campaign: // value for 'campaign'
 *      previousCampaign: // value for 'previousCampaign'
 *      skipPrevious: // value for 'skipPrevious'
 *   },
 * });
 */
export function useGetAdherenceMediaChannelsPassratesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceMediaChannelsPassratesQuery, GetAdherenceMediaChannelsPassratesQueryVariables> & ({ variables: GetAdherenceMediaChannelsPassratesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceMediaChannelsPassratesQuery, GetAdherenceMediaChannelsPassratesQueryVariables>(GetAdherenceMediaChannelsPassratesDocument, options);
      }
export function useGetAdherenceMediaChannelsPassratesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceMediaChannelsPassratesQuery, GetAdherenceMediaChannelsPassratesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceMediaChannelsPassratesQuery, GetAdherenceMediaChannelsPassratesQueryVariables>(GetAdherenceMediaChannelsPassratesDocument, options);
        }
export function useGetAdherenceMediaChannelsPassratesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceMediaChannelsPassratesQuery, GetAdherenceMediaChannelsPassratesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceMediaChannelsPassratesQuery, GetAdherenceMediaChannelsPassratesQueryVariables>(GetAdherenceMediaChannelsPassratesDocument, options);
        }
export type GetAdherenceMediaChannelsPassratesQueryHookResult = ReturnType<typeof useGetAdherenceMediaChannelsPassratesQuery>;
export type GetAdherenceMediaChannelsPassratesLazyQueryHookResult = ReturnType<typeof useGetAdherenceMediaChannelsPassratesLazyQuery>;
export type GetAdherenceMediaChannelsPassratesSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceMediaChannelsPassratesSuspenseQuery>;
export type GetAdherenceMediaChannelsPassratesQueryResult = ApolloReactCommon.QueryResult<GetAdherenceMediaChannelsPassratesQuery, GetAdherenceMediaChannelsPassratesQueryVariables>;
export function refetchGetAdherenceMediaChannelsPassratesQuery(variables: GetAdherenceMediaChannelsPassratesQueryVariables) {
      return { query: GetAdherenceMediaChannelsPassratesDocument, variables: variables }
    }
export const GetAdherenceDealerSummaryDocument = gql`
    query getAdherenceDealerSummary {
  adherenceReviewSummaryDashboard {
    id
    dealershipName
    zone
    topMediaChannel
    bestMediaChannel
    passed
    failed
  }
}
    `;

/**
 * __useGetAdherenceDealerSummaryQuery__
 *
 * To run a query within a React component, call `useGetAdherenceDealerSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceDealerSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceDealerSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdherenceDealerSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdherenceDealerSummaryQuery, GetAdherenceDealerSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceDealerSummaryQuery, GetAdherenceDealerSummaryQueryVariables>(GetAdherenceDealerSummaryDocument, options);
      }
export function useGetAdherenceDealerSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceDealerSummaryQuery, GetAdherenceDealerSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceDealerSummaryQuery, GetAdherenceDealerSummaryQueryVariables>(GetAdherenceDealerSummaryDocument, options);
        }
export function useGetAdherenceDealerSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceDealerSummaryQuery, GetAdherenceDealerSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceDealerSummaryQuery, GetAdherenceDealerSummaryQueryVariables>(GetAdherenceDealerSummaryDocument, options);
        }
export type GetAdherenceDealerSummaryQueryHookResult = ReturnType<typeof useGetAdherenceDealerSummaryQuery>;
export type GetAdherenceDealerSummaryLazyQueryHookResult = ReturnType<typeof useGetAdherenceDealerSummaryLazyQuery>;
export type GetAdherenceDealerSummarySuspenseQueryHookResult = ReturnType<typeof useGetAdherenceDealerSummarySuspenseQuery>;
export type GetAdherenceDealerSummaryQueryResult = ApolloReactCommon.QueryResult<GetAdherenceDealerSummaryQuery, GetAdherenceDealerSummaryQueryVariables>;
export function refetchGetAdherenceDealerSummaryQuery(variables?: GetAdherenceDealerSummaryQueryVariables) {
      return { query: GetAdherenceDealerSummaryDocument, variables: variables }
    }
export const GetAdherenceRequestedPageInfoDocument = gql`
    query getAdherenceRequestedPageInfo($pageSize: Int!, $filter: FilterFindManyAdherence_SubmissionsInput) {
  adherenceSubmissionPagination(
    perPage: $pageSize
    sort: CREATEDAT_DESC
    filter: $filter
  ) {
    pageInfo {
      pageCount
    }
  }
}
    `;

/**
 * __useGetAdherenceRequestedPageInfoQuery__
 *
 * To run a query within a React component, call `useGetAdherenceRequestedPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceRequestedPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceRequestedPageInfoQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdherenceRequestedPageInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceRequestedPageInfoQuery, GetAdherenceRequestedPageInfoQueryVariables> & ({ variables: GetAdherenceRequestedPageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceRequestedPageInfoQuery, GetAdherenceRequestedPageInfoQueryVariables>(GetAdherenceRequestedPageInfoDocument, options);
      }
export function useGetAdherenceRequestedPageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceRequestedPageInfoQuery, GetAdherenceRequestedPageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceRequestedPageInfoQuery, GetAdherenceRequestedPageInfoQueryVariables>(GetAdherenceRequestedPageInfoDocument, options);
        }
export function useGetAdherenceRequestedPageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceRequestedPageInfoQuery, GetAdherenceRequestedPageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceRequestedPageInfoQuery, GetAdherenceRequestedPageInfoQueryVariables>(GetAdherenceRequestedPageInfoDocument, options);
        }
export type GetAdherenceRequestedPageInfoQueryHookResult = ReturnType<typeof useGetAdherenceRequestedPageInfoQuery>;
export type GetAdherenceRequestedPageInfoLazyQueryHookResult = ReturnType<typeof useGetAdherenceRequestedPageInfoLazyQuery>;
export type GetAdherenceRequestedPageInfoSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceRequestedPageInfoSuspenseQuery>;
export type GetAdherenceRequestedPageInfoQueryResult = ApolloReactCommon.QueryResult<GetAdherenceRequestedPageInfoQuery, GetAdherenceRequestedPageInfoQueryVariables>;
export function refetchGetAdherenceRequestedPageInfoQuery(variables: GetAdherenceRequestedPageInfoQueryVariables) {
      return { query: GetAdherenceRequestedPageInfoDocument, variables: variables }
    }
export const GetAdherenceRequestedReviewsDocument = gql`
    query getAdherenceRequestedReviews($limit: Int!, $offset: Int!, $filter: FilterFindManyAdherence_SubmissionsInput) {
  adherenceSubmissionMany(
    filter: $filter
    sort: CREATEDAT_DESC
    limit: $limit
    skip: $offset
  ) {
    _id
    requestId
    dealershipName
    createdAt
    updatedAt
    lastUpdated
    status
    invoiceNumber
    campaign
    mediaChannel
    attachments {
      filename
    }
  }
}
    `;

/**
 * __useGetAdherenceRequestedReviewsQuery__
 *
 * To run a query within a React component, call `useGetAdherenceRequestedReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceRequestedReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceRequestedReviewsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdherenceRequestedReviewsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceRequestedReviewsQuery, GetAdherenceRequestedReviewsQueryVariables> & ({ variables: GetAdherenceRequestedReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceRequestedReviewsQuery, GetAdherenceRequestedReviewsQueryVariables>(GetAdherenceRequestedReviewsDocument, options);
      }
export function useGetAdherenceRequestedReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceRequestedReviewsQuery, GetAdherenceRequestedReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceRequestedReviewsQuery, GetAdherenceRequestedReviewsQueryVariables>(GetAdherenceRequestedReviewsDocument, options);
        }
export function useGetAdherenceRequestedReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceRequestedReviewsQuery, GetAdherenceRequestedReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceRequestedReviewsQuery, GetAdherenceRequestedReviewsQueryVariables>(GetAdherenceRequestedReviewsDocument, options);
        }
export type GetAdherenceRequestedReviewsQueryHookResult = ReturnType<typeof useGetAdherenceRequestedReviewsQuery>;
export type GetAdherenceRequestedReviewsLazyQueryHookResult = ReturnType<typeof useGetAdherenceRequestedReviewsLazyQuery>;
export type GetAdherenceRequestedReviewsSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceRequestedReviewsSuspenseQuery>;
export type GetAdherenceRequestedReviewsQueryResult = ApolloReactCommon.QueryResult<GetAdherenceRequestedReviewsQuery, GetAdherenceRequestedReviewsQueryVariables>;
export function refetchGetAdherenceRequestedReviewsQuery(variables: GetAdherenceRequestedReviewsQueryVariables) {
      return { query: GetAdherenceRequestedReviewsDocument, variables: variables }
    }
export const SetAllReviewsRequestedDocument = gql`
    mutation setAllReviewsRequested {
  DEBUG_markAllReviewsAsRequested
}
    `;
export type SetAllReviewsRequestedMutationFn = ApolloReactCommon.MutationFunction<SetAllReviewsRequestedMutation, SetAllReviewsRequestedMutationVariables>;

/**
 * __useSetAllReviewsRequestedMutation__
 *
 * To run a mutation, you first call `useSetAllReviewsRequestedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAllReviewsRequestedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAllReviewsRequestedMutation, { data, loading, error }] = useSetAllReviewsRequestedMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetAllReviewsRequestedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAllReviewsRequestedMutation, SetAllReviewsRequestedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetAllReviewsRequestedMutation, SetAllReviewsRequestedMutationVariables>(SetAllReviewsRequestedDocument, options);
      }
export type SetAllReviewsRequestedMutationHookResult = ReturnType<typeof useSetAllReviewsRequestedMutation>;
export type SetAllReviewsRequestedMutationResult = ApolloReactCommon.MutationResult<SetAllReviewsRequestedMutation>;
export type SetAllReviewsRequestedMutationOptions = ApolloReactCommon.BaseMutationOptions<SetAllReviewsRequestedMutation, SetAllReviewsRequestedMutationVariables>;
export const GetAdherenceCardsDocument = gql`
    query getAdherenceCards($language: EnumAdherence_CardsLanguage!) {
  adherenceCardsMany(
    filter: {language: $language, type: "media-type"}
    sort: TITLE_ASC
  ) {
    title
    source
    image {
      src
      alt
    }
    language
    link_url
    link_label
    type
    featured
    description
    key
  }
}
    `;

/**
 * __useGetAdherenceCardsQuery__
 *
 * To run a query within a React component, call `useGetAdherenceCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceCardsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetAdherenceCardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceCardsQuery, GetAdherenceCardsQueryVariables> & ({ variables: GetAdherenceCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceCardsQuery, GetAdherenceCardsQueryVariables>(GetAdherenceCardsDocument, options);
      }
export function useGetAdherenceCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceCardsQuery, GetAdherenceCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceCardsQuery, GetAdherenceCardsQueryVariables>(GetAdherenceCardsDocument, options);
        }
export function useGetAdherenceCardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceCardsQuery, GetAdherenceCardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceCardsQuery, GetAdherenceCardsQueryVariables>(GetAdherenceCardsDocument, options);
        }
export type GetAdherenceCardsQueryHookResult = ReturnType<typeof useGetAdherenceCardsQuery>;
export type GetAdherenceCardsLazyQueryHookResult = ReturnType<typeof useGetAdherenceCardsLazyQuery>;
export type GetAdherenceCardsSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceCardsSuspenseQuery>;
export type GetAdherenceCardsQueryResult = ApolloReactCommon.QueryResult<GetAdherenceCardsQuery, GetAdherenceCardsQueryVariables>;
export function refetchGetAdherenceCardsQuery(variables: GetAdherenceCardsQueryVariables) {
      return { query: GetAdherenceCardsDocument, variables: variables }
    }
export const GetAdherenceComponentCardsDocument = gql`
    query getAdherenceComponentCards($language: EnumAdherence_CardsLanguage!) {
  adherenceCardsMany(
    filter: {language: $language, type: "component-standard"}
    sort: ORDER_ASC
  ) {
    title
    source
    image {
      src
      alt
    }
    language
    link_url
    link_label
    type
    featured
    description
    key
  }
}
    `;

/**
 * __useGetAdherenceComponentCardsQuery__
 *
 * To run a query within a React component, call `useGetAdherenceComponentCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceComponentCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceComponentCardsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetAdherenceComponentCardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceComponentCardsQuery, GetAdherenceComponentCardsQueryVariables> & ({ variables: GetAdherenceComponentCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceComponentCardsQuery, GetAdherenceComponentCardsQueryVariables>(GetAdherenceComponentCardsDocument, options);
      }
export function useGetAdherenceComponentCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceComponentCardsQuery, GetAdherenceComponentCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceComponentCardsQuery, GetAdherenceComponentCardsQueryVariables>(GetAdherenceComponentCardsDocument, options);
        }
export function useGetAdherenceComponentCardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceComponentCardsQuery, GetAdherenceComponentCardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceComponentCardsQuery, GetAdherenceComponentCardsQueryVariables>(GetAdherenceComponentCardsDocument, options);
        }
export type GetAdherenceComponentCardsQueryHookResult = ReturnType<typeof useGetAdherenceComponentCardsQuery>;
export type GetAdherenceComponentCardsLazyQueryHookResult = ReturnType<typeof useGetAdherenceComponentCardsLazyQuery>;
export type GetAdherenceComponentCardsSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceComponentCardsSuspenseQuery>;
export type GetAdherenceComponentCardsQueryResult = ApolloReactCommon.QueryResult<GetAdherenceComponentCardsQuery, GetAdherenceComponentCardsQueryVariables>;
export function refetchGetAdherenceComponentCardsQuery(variables: GetAdherenceComponentCardsQueryVariables) {
      return { query: GetAdherenceComponentCardsDocument, variables: variables }
    }
export const GetAdherenceMediaCardsDocument = gql`
    query getAdherenceMediaCards($language: EnumAdherence_CardsLanguage!) {
  mediaFeatured: adherenceCardsMany(
    filter: {featured: true, type: "media-type", language: $language}
  ) {
    title
    source
    image {
      src
      alt
    }
    language
    link_url
    link_label
    type
    featured
    description
    key
  }
  componentsFeatured: adherenceCardsMany(
    filter: {featured: true, type: "component-standard", language: $language}
  ) {
    title
    source
    image {
      src
      alt
    }
    language
    link_url
    link_label
    type
    featured
    description
    key
  }
}
    `;

/**
 * __useGetAdherenceMediaCardsQuery__
 *
 * To run a query within a React component, call `useGetAdherenceMediaCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceMediaCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceMediaCardsQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetAdherenceMediaCardsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceMediaCardsQuery, GetAdherenceMediaCardsQueryVariables> & ({ variables: GetAdherenceMediaCardsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceMediaCardsQuery, GetAdherenceMediaCardsQueryVariables>(GetAdherenceMediaCardsDocument, options);
      }
export function useGetAdherenceMediaCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceMediaCardsQuery, GetAdherenceMediaCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceMediaCardsQuery, GetAdherenceMediaCardsQueryVariables>(GetAdherenceMediaCardsDocument, options);
        }
export function useGetAdherenceMediaCardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceMediaCardsQuery, GetAdherenceMediaCardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceMediaCardsQuery, GetAdherenceMediaCardsQueryVariables>(GetAdherenceMediaCardsDocument, options);
        }
export type GetAdherenceMediaCardsQueryHookResult = ReturnType<typeof useGetAdherenceMediaCardsQuery>;
export type GetAdherenceMediaCardsLazyQueryHookResult = ReturnType<typeof useGetAdherenceMediaCardsLazyQuery>;
export type GetAdherenceMediaCardsSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceMediaCardsSuspenseQuery>;
export type GetAdherenceMediaCardsQueryResult = ApolloReactCommon.QueryResult<GetAdherenceMediaCardsQuery, GetAdherenceMediaCardsQueryVariables>;
export function refetchGetAdherenceMediaCardsQuery(variables: GetAdherenceMediaCardsQueryVariables) {
      return { query: GetAdherenceMediaCardsDocument, variables: variables }
    }
export const ReviewExistenceQueryDocument = gql`
    query reviewExistenceQuery($requestId: String!) {
  adherenceReviewFindOne(filter: {requestId: $requestId}) {
    requestId
    mediaFilename
    feedback
    answerState
  }
}
    `;

/**
 * __useReviewExistenceQueryQuery__
 *
 * To run a query within a React component, call `useReviewExistenceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewExistenceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewExistenceQueryQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useReviewExistenceQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewExistenceQueryQuery, ReviewExistenceQueryQueryVariables> & ({ variables: ReviewExistenceQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewExistenceQueryQuery, ReviewExistenceQueryQueryVariables>(ReviewExistenceQueryDocument, options);
      }
export function useReviewExistenceQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewExistenceQueryQuery, ReviewExistenceQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewExistenceQueryQuery, ReviewExistenceQueryQueryVariables>(ReviewExistenceQueryDocument, options);
        }
export function useReviewExistenceQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewExistenceQueryQuery, ReviewExistenceQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewExistenceQueryQuery, ReviewExistenceQueryQueryVariables>(ReviewExistenceQueryDocument, options);
        }
export type ReviewExistenceQueryQueryHookResult = ReturnType<typeof useReviewExistenceQueryQuery>;
export type ReviewExistenceQueryLazyQueryHookResult = ReturnType<typeof useReviewExistenceQueryLazyQuery>;
export type ReviewExistenceQuerySuspenseQueryHookResult = ReturnType<typeof useReviewExistenceQuerySuspenseQuery>;
export type ReviewExistenceQueryQueryResult = ApolloReactCommon.QueryResult<ReviewExistenceQueryQuery, ReviewExistenceQueryQueryVariables>;
export function refetchReviewExistenceQueryQuery(variables: ReviewExistenceQueryQueryVariables) {
      return { query: ReviewExistenceQueryDocument, variables: variables }
    }
export const GetAdherenceSubmissionMediaByIdDocument = gql`
    query getAdherenceSubmissionMediaById($requestId: String!) {
  adherenceSubmissionOne(filter: {requestId: $requestId}) {
    _id
    requestId
    attachments {
      id
      url(requestId: $requestId)
    }
  }
}
    `;

/**
 * __useGetAdherenceSubmissionMediaByIdQuery__
 *
 * To run a query within a React component, call `useGetAdherenceSubmissionMediaByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceSubmissionMediaByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceSubmissionMediaByIdQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetAdherenceSubmissionMediaByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceSubmissionMediaByIdQuery, GetAdherenceSubmissionMediaByIdQueryVariables> & ({ variables: GetAdherenceSubmissionMediaByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceSubmissionMediaByIdQuery, GetAdherenceSubmissionMediaByIdQueryVariables>(GetAdherenceSubmissionMediaByIdDocument, options);
      }
export function useGetAdherenceSubmissionMediaByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceSubmissionMediaByIdQuery, GetAdherenceSubmissionMediaByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceSubmissionMediaByIdQuery, GetAdherenceSubmissionMediaByIdQueryVariables>(GetAdherenceSubmissionMediaByIdDocument, options);
        }
export function useGetAdherenceSubmissionMediaByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceSubmissionMediaByIdQuery, GetAdherenceSubmissionMediaByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceSubmissionMediaByIdQuery, GetAdherenceSubmissionMediaByIdQueryVariables>(GetAdherenceSubmissionMediaByIdDocument, options);
        }
export type GetAdherenceSubmissionMediaByIdQueryHookResult = ReturnType<typeof useGetAdherenceSubmissionMediaByIdQuery>;
export type GetAdherenceSubmissionMediaByIdLazyQueryHookResult = ReturnType<typeof useGetAdherenceSubmissionMediaByIdLazyQuery>;
export type GetAdherenceSubmissionMediaByIdSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceSubmissionMediaByIdSuspenseQuery>;
export type GetAdherenceSubmissionMediaByIdQueryResult = ApolloReactCommon.QueryResult<GetAdherenceSubmissionMediaByIdQuery, GetAdherenceSubmissionMediaByIdQueryVariables>;
export function refetchGetAdherenceSubmissionMediaByIdQuery(variables: GetAdherenceSubmissionMediaByIdQueryVariables) {
      return { query: GetAdherenceSubmissionMediaByIdDocument, variables: variables }
    }
export const GetAdherenceSubmissionByIdDocument = gql`
    query getAdherenceSubmissionById($requestId: String!) {
  adherenceSubmissionOne(filter: {requestId: $requestId}) {
    _id
    requestId
    mediaChannel
    audience
    carModel
    attachments {
      id
      filename
      type
      filesize
      preview
    }
  }
}
    `;

/**
 * __useGetAdherenceSubmissionByIdQuery__
 *
 * To run a query within a React component, call `useGetAdherenceSubmissionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdherenceSubmissionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdherenceSubmissionByIdQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useGetAdherenceSubmissionByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAdherenceSubmissionByIdQuery, GetAdherenceSubmissionByIdQueryVariables> & ({ variables: GetAdherenceSubmissionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAdherenceSubmissionByIdQuery, GetAdherenceSubmissionByIdQueryVariables>(GetAdherenceSubmissionByIdDocument, options);
      }
export function useGetAdherenceSubmissionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdherenceSubmissionByIdQuery, GetAdherenceSubmissionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAdherenceSubmissionByIdQuery, GetAdherenceSubmissionByIdQueryVariables>(GetAdherenceSubmissionByIdDocument, options);
        }
export function useGetAdherenceSubmissionByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAdherenceSubmissionByIdQuery, GetAdherenceSubmissionByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAdherenceSubmissionByIdQuery, GetAdherenceSubmissionByIdQueryVariables>(GetAdherenceSubmissionByIdDocument, options);
        }
export type GetAdherenceSubmissionByIdQueryHookResult = ReturnType<typeof useGetAdherenceSubmissionByIdQuery>;
export type GetAdherenceSubmissionByIdLazyQueryHookResult = ReturnType<typeof useGetAdherenceSubmissionByIdLazyQuery>;
export type GetAdherenceSubmissionByIdSuspenseQueryHookResult = ReturnType<typeof useGetAdherenceSubmissionByIdSuspenseQuery>;
export type GetAdherenceSubmissionByIdQueryResult = ApolloReactCommon.QueryResult<GetAdherenceSubmissionByIdQuery, GetAdherenceSubmissionByIdQueryVariables>;
export function refetchGetAdherenceSubmissionByIdQuery(variables: GetAdherenceSubmissionByIdQueryVariables) {
      return { query: GetAdherenceSubmissionByIdDocument, variables: variables }
    }
export const AdherenceResourcesDocument = gql`
    query adherenceResources($path: String!, $language: String!) {
  adherenceContentOne(path: $path, language: $language) {
    title
    content
    itemtype
    parent
    order
    language
    next {
      path
      title
      titleFr
      noContent
      children {
        path
        title
        titleFr
      }
    }
    previous {
      path
      title
      titleFr
      noContent
      children {
        path
        title
        titleFr
      }
    }
  }
}
    `;

/**
 * __useAdherenceResourcesQuery__
 *
 * To run a query within a React component, call `useAdherenceResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdherenceResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdherenceResourcesQuery({
 *   variables: {
 *      path: // value for 'path'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAdherenceResourcesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdherenceResourcesQuery, AdherenceResourcesQueryVariables> & ({ variables: AdherenceResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdherenceResourcesQuery, AdherenceResourcesQueryVariables>(AdherenceResourcesDocument, options);
      }
export function useAdherenceResourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdherenceResourcesQuery, AdherenceResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdherenceResourcesQuery, AdherenceResourcesQueryVariables>(AdherenceResourcesDocument, options);
        }
export function useAdherenceResourcesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdherenceResourcesQuery, AdherenceResourcesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdherenceResourcesQuery, AdherenceResourcesQueryVariables>(AdherenceResourcesDocument, options);
        }
export type AdherenceResourcesQueryHookResult = ReturnType<typeof useAdherenceResourcesQuery>;
export type AdherenceResourcesLazyQueryHookResult = ReturnType<typeof useAdherenceResourcesLazyQuery>;
export type AdherenceResourcesSuspenseQueryHookResult = ReturnType<typeof useAdherenceResourcesSuspenseQuery>;
export type AdherenceResourcesQueryResult = ApolloReactCommon.QueryResult<AdherenceResourcesQuery, AdherenceResourcesQueryVariables>;
export function refetchAdherenceResourcesQuery(variables: AdherenceResourcesQueryVariables) {
      return { query: AdherenceResourcesDocument, variables: variables }
    }
export const GetQuestionsWithEmptyFeedbackDocument = gql`
    query getQuestionsWithEmptyFeedback {
  adherenceCriteriaMany(filter: {fail_response: ""}) {
    question_key
  }
}
    `;

/**
 * __useGetQuestionsWithEmptyFeedbackQuery__
 *
 * To run a query within a React component, call `useGetQuestionsWithEmptyFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsWithEmptyFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsWithEmptyFeedbackQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuestionsWithEmptyFeedbackQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuestionsWithEmptyFeedbackQuery, GetQuestionsWithEmptyFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuestionsWithEmptyFeedbackQuery, GetQuestionsWithEmptyFeedbackQueryVariables>(GetQuestionsWithEmptyFeedbackDocument, options);
      }
export function useGetQuestionsWithEmptyFeedbackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuestionsWithEmptyFeedbackQuery, GetQuestionsWithEmptyFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuestionsWithEmptyFeedbackQuery, GetQuestionsWithEmptyFeedbackQueryVariables>(GetQuestionsWithEmptyFeedbackDocument, options);
        }
export function useGetQuestionsWithEmptyFeedbackSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetQuestionsWithEmptyFeedbackQuery, GetQuestionsWithEmptyFeedbackQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetQuestionsWithEmptyFeedbackQuery, GetQuestionsWithEmptyFeedbackQueryVariables>(GetQuestionsWithEmptyFeedbackDocument, options);
        }
export type GetQuestionsWithEmptyFeedbackQueryHookResult = ReturnType<typeof useGetQuestionsWithEmptyFeedbackQuery>;
export type GetQuestionsWithEmptyFeedbackLazyQueryHookResult = ReturnType<typeof useGetQuestionsWithEmptyFeedbackLazyQuery>;
export type GetQuestionsWithEmptyFeedbackSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsWithEmptyFeedbackSuspenseQuery>;
export type GetQuestionsWithEmptyFeedbackQueryResult = ApolloReactCommon.QueryResult<GetQuestionsWithEmptyFeedbackQuery, GetQuestionsWithEmptyFeedbackQueryVariables>;
export function refetchGetQuestionsWithEmptyFeedbackQuery(variables?: GetQuestionsWithEmptyFeedbackQueryVariables) {
      return { query: GetQuestionsWithEmptyFeedbackDocument, variables: variables }
    }
export const ReviewCriteriaQueryDocument = gql`
    query reviewCriteriaQuery($requestId: String!) {
  adherenceSubmissionOne(filter: {requestId: $requestId}) {
    mediaChannel
    criteria {
      question
      question_key
    }
  }
}
    `;

/**
 * __useReviewCriteriaQueryQuery__
 *
 * To run a query within a React component, call `useReviewCriteriaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewCriteriaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewCriteriaQueryQuery({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useReviewCriteriaQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewCriteriaQueryQuery, ReviewCriteriaQueryQueryVariables> & ({ variables: ReviewCriteriaQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewCriteriaQueryQuery, ReviewCriteriaQueryQueryVariables>(ReviewCriteriaQueryDocument, options);
      }
export function useReviewCriteriaQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewCriteriaQueryQuery, ReviewCriteriaQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewCriteriaQueryQuery, ReviewCriteriaQueryQueryVariables>(ReviewCriteriaQueryDocument, options);
        }
export function useReviewCriteriaQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewCriteriaQueryQuery, ReviewCriteriaQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewCriteriaQueryQuery, ReviewCriteriaQueryQueryVariables>(ReviewCriteriaQueryDocument, options);
        }
export type ReviewCriteriaQueryQueryHookResult = ReturnType<typeof useReviewCriteriaQueryQuery>;
export type ReviewCriteriaQueryLazyQueryHookResult = ReturnType<typeof useReviewCriteriaQueryLazyQuery>;
export type ReviewCriteriaQuerySuspenseQueryHookResult = ReturnType<typeof useReviewCriteriaQuerySuspenseQuery>;
export type ReviewCriteriaQueryQueryResult = ApolloReactCommon.QueryResult<ReviewCriteriaQueryQuery, ReviewCriteriaQueryQueryVariables>;
export function refetchReviewCriteriaQueryQuery(variables: ReviewCriteriaQueryQueryVariables) {
      return { query: ReviewCriteriaQueryDocument, variables: variables }
    }
export const CreateAdherenceReviewDocument = gql`
    mutation createAdherenceReview($review: CreateOneAdherence_ReviewsInput!, $requestId: String!) {
  adherenceReviewCreateOne(record: $review) {
    recordId
  }
  adherenceSubmissionMarkComplete(requestId: $requestId)
}
    `;
export type CreateAdherenceReviewMutationFn = ApolloReactCommon.MutationFunction<CreateAdherenceReviewMutation, CreateAdherenceReviewMutationVariables>;

/**
 * __useCreateAdherenceReviewMutation__
 *
 * To run a mutation, you first call `useCreateAdherenceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdherenceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdherenceReviewMutation, { data, loading, error }] = useCreateAdherenceReviewMutation({
 *   variables: {
 *      review: // value for 'review'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useCreateAdherenceReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAdherenceReviewMutation, CreateAdherenceReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAdherenceReviewMutation, CreateAdherenceReviewMutationVariables>(CreateAdherenceReviewDocument, options);
      }
export type CreateAdherenceReviewMutationHookResult = ReturnType<typeof useCreateAdherenceReviewMutation>;
export type CreateAdherenceReviewMutationResult = ApolloReactCommon.MutationResult<CreateAdherenceReviewMutation>;
export type CreateAdherenceReviewMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAdherenceReviewMutation, CreateAdherenceReviewMutationVariables>;
export const UpdateAdherenceReviewDocument = gql`
    mutation updateAdherenceReview($review: UpdateOneAdherence_ReviewsInput!, $requestId: String!) {
  adherenceReviewUpdateOne(record: $review, filter: {requestId: $requestId}) {
    recordId
  }
}
    `;
export type UpdateAdherenceReviewMutationFn = ApolloReactCommon.MutationFunction<UpdateAdherenceReviewMutation, UpdateAdherenceReviewMutationVariables>;

/**
 * __useUpdateAdherenceReviewMutation__
 *
 * To run a mutation, you first call `useUpdateAdherenceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdherenceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdherenceReviewMutation, { data, loading, error }] = useUpdateAdherenceReviewMutation({
 *   variables: {
 *      review: // value for 'review'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useUpdateAdherenceReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdherenceReviewMutation, UpdateAdherenceReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdherenceReviewMutation, UpdateAdherenceReviewMutationVariables>(UpdateAdherenceReviewDocument, options);
      }
export type UpdateAdherenceReviewMutationHookResult = ReturnType<typeof useUpdateAdherenceReviewMutation>;
export type UpdateAdherenceReviewMutationResult = ApolloReactCommon.MutationResult<UpdateAdherenceReviewMutation>;
export type UpdateAdherenceReviewMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdherenceReviewMutation, UpdateAdherenceReviewMutationVariables>;
export const RemoveAdherenceReviewDocument = gql`
    mutation removeAdherenceReview($requestId: String!) {
  adherenceReviewRemoveOne(filter: {requestId: $requestId}) {
    recordId
  }
}
    `;
export type RemoveAdherenceReviewMutationFn = ApolloReactCommon.MutationFunction<RemoveAdherenceReviewMutation, RemoveAdherenceReviewMutationVariables>;

/**
 * __useRemoveAdherenceReviewMutation__
 *
 * To run a mutation, you first call `useRemoveAdherenceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdherenceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdherenceReviewMutation, { data, loading, error }] = useRemoveAdherenceReviewMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRemoveAdherenceReviewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveAdherenceReviewMutation, RemoveAdherenceReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveAdherenceReviewMutation, RemoveAdherenceReviewMutationVariables>(RemoveAdherenceReviewDocument, options);
      }
export type RemoveAdherenceReviewMutationHookResult = ReturnType<typeof useRemoveAdherenceReviewMutation>;
export type RemoveAdherenceReviewMutationResult = ApolloReactCommon.MutationResult<RemoveAdherenceReviewMutation>;
export type RemoveAdherenceReviewMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveAdherenceReviewMutation, RemoveAdherenceReviewMutationVariables>;
export const SendJudgementToTmbDocument = gql`
    mutation sendJudgementToTMB($requestId: String!, $approved: Boolean!, $rejected: Boolean!) {
  adherenceReviewSendApproval(requestId: $requestId) @include(if: $approved)
  adherenceReviewSendDenial(requestId: $requestId) @include(if: $rejected)
}
    `;
export type SendJudgementToTmbMutationFn = ApolloReactCommon.MutationFunction<SendJudgementToTmbMutation, SendJudgementToTmbMutationVariables>;

/**
 * __useSendJudgementToTmbMutation__
 *
 * To run a mutation, you first call `useSendJudgementToTmbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendJudgementToTmbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendJudgementToTmbMutation, { data, loading, error }] = useSendJudgementToTmbMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      approved: // value for 'approved'
 *      rejected: // value for 'rejected'
 *   },
 * });
 */
export function useSendJudgementToTmbMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendJudgementToTmbMutation, SendJudgementToTmbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendJudgementToTmbMutation, SendJudgementToTmbMutationVariables>(SendJudgementToTmbDocument, options);
      }
export type SendJudgementToTmbMutationHookResult = ReturnType<typeof useSendJudgementToTmbMutation>;
export type SendJudgementToTmbMutationResult = ApolloReactCommon.MutationResult<SendJudgementToTmbMutation>;
export type SendJudgementToTmbMutationOptions = ApolloReactCommon.BaseMutationOptions<SendJudgementToTmbMutation, SendJudgementToTmbMutationVariables>;
export const UnitsManyDocument = gql`
    query unitsMany {
  unitsMany(sort: NAME_ASC, limit: 0) {
    code
    name
  }
}
    `;

/**
 * __useUnitsManyQuery__
 *
 * To run a query within a React component, call `useUnitsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitsManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnitsManyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnitsManyQuery, UnitsManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitsManyQuery, UnitsManyQueryVariables>(UnitsManyDocument, options);
      }
export function useUnitsManyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitsManyQuery, UnitsManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitsManyQuery, UnitsManyQueryVariables>(UnitsManyDocument, options);
        }
export function useUnitsManySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitsManyQuery, UnitsManyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitsManyQuery, UnitsManyQueryVariables>(UnitsManyDocument, options);
        }
export type UnitsManyQueryHookResult = ReturnType<typeof useUnitsManyQuery>;
export type UnitsManyLazyQueryHookResult = ReturnType<typeof useUnitsManyLazyQuery>;
export type UnitsManySuspenseQueryHookResult = ReturnType<typeof useUnitsManySuspenseQuery>;
export type UnitsManyQueryResult = ApolloReactCommon.QueryResult<UnitsManyQuery, UnitsManyQueryVariables>;
export function refetchUnitsManyQuery(variables?: UnitsManyQueryVariables) {
      return { query: UnitsManyDocument, variables: variables }
    }
export const ComplianceCasesManyDocument = gql`
    query complianceCasesMany($adminView: Boolean) {
  complianceCasesMany(adminView: $adminView) {
    _id
    caseId
    status
    statusTransition {
      from
      to
    }
    outcome
    inProgress
    reported {
      dealerCode
      dealerName
    }
    reporter {
      name
      dealerCode
      dealerName
      email
    }
    caseInformation {
      ongoing
      infractionDate
      infractionLocation
      modifiedDate
      category
      categoryOther
      evidence {
        mimetype
        filename
      }
      summary
      revision
    }
    history {
      status
      dealerNotes
      internalNotes
      internalNotesName
      modifiedDate
    }
    outcome
    outcomeDate
    repeatCaseIds
  }
}
    `;

/**
 * __useComplianceCasesManyQuery__
 *
 * To run a query within a React component, call `useComplianceCasesManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceCasesManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceCasesManyQuery({
 *   variables: {
 *      adminView: // value for 'adminView'
 *   },
 * });
 */
export function useComplianceCasesManyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ComplianceCasesManyQuery, ComplianceCasesManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ComplianceCasesManyQuery, ComplianceCasesManyQueryVariables>(ComplianceCasesManyDocument, options);
      }
export function useComplianceCasesManyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ComplianceCasesManyQuery, ComplianceCasesManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ComplianceCasesManyQuery, ComplianceCasesManyQueryVariables>(ComplianceCasesManyDocument, options);
        }
export function useComplianceCasesManySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ComplianceCasesManyQuery, ComplianceCasesManyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ComplianceCasesManyQuery, ComplianceCasesManyQueryVariables>(ComplianceCasesManyDocument, options);
        }
export type ComplianceCasesManyQueryHookResult = ReturnType<typeof useComplianceCasesManyQuery>;
export type ComplianceCasesManyLazyQueryHookResult = ReturnType<typeof useComplianceCasesManyLazyQuery>;
export type ComplianceCasesManySuspenseQueryHookResult = ReturnType<typeof useComplianceCasesManySuspenseQuery>;
export type ComplianceCasesManyQueryResult = ApolloReactCommon.QueryResult<ComplianceCasesManyQuery, ComplianceCasesManyQueryVariables>;
export function refetchComplianceCasesManyQuery(variables?: ComplianceCasesManyQueryVariables) {
      return { query: ComplianceCasesManyDocument, variables: variables }
    }
export const ComplianceCaseUpdateInProgressDocument = gql`
    mutation complianceCaseUpdateInProgress($caseId: String!, $inProgress: Boolean!) {
  complianceCaseUpdateInProgress(caseId: $caseId, inProgress: $inProgress)
}
    `;
export type ComplianceCaseUpdateInProgressMutationFn = ApolloReactCommon.MutationFunction<ComplianceCaseUpdateInProgressMutation, ComplianceCaseUpdateInProgressMutationVariables>;

/**
 * __useComplianceCaseUpdateInProgressMutation__
 *
 * To run a mutation, you first call `useComplianceCaseUpdateInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComplianceCaseUpdateInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [complianceCaseUpdateInProgressMutation, { data, loading, error }] = useComplianceCaseUpdateInProgressMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      inProgress: // value for 'inProgress'
 *   },
 * });
 */
export function useComplianceCaseUpdateInProgressMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ComplianceCaseUpdateInProgressMutation, ComplianceCaseUpdateInProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ComplianceCaseUpdateInProgressMutation, ComplianceCaseUpdateInProgressMutationVariables>(ComplianceCaseUpdateInProgressDocument, options);
      }
export type ComplianceCaseUpdateInProgressMutationHookResult = ReturnType<typeof useComplianceCaseUpdateInProgressMutation>;
export type ComplianceCaseUpdateInProgressMutationResult = ApolloReactCommon.MutationResult<ComplianceCaseUpdateInProgressMutation>;
export type ComplianceCaseUpdateInProgressMutationOptions = ApolloReactCommon.BaseMutationOptions<ComplianceCaseUpdateInProgressMutation, ComplianceCaseUpdateInProgressMutationVariables>;
export const ComplianceCaseCreateOneDocument = gql`
    mutation complianceCaseCreateOne($payload: CreateOnecompliance_casesInput!) {
  complianceCaseCreateOne(record: $payload) {
    recordId
  }
}
    `;
export type ComplianceCaseCreateOneMutationFn = ApolloReactCommon.MutationFunction<ComplianceCaseCreateOneMutation, ComplianceCaseCreateOneMutationVariables>;

/**
 * __useComplianceCaseCreateOneMutation__
 *
 * To run a mutation, you first call `useComplianceCaseCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComplianceCaseCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [complianceCaseCreateOneMutation, { data, loading, error }] = useComplianceCaseCreateOneMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useComplianceCaseCreateOneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ComplianceCaseCreateOneMutation, ComplianceCaseCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ComplianceCaseCreateOneMutation, ComplianceCaseCreateOneMutationVariables>(ComplianceCaseCreateOneDocument, options);
      }
export type ComplianceCaseCreateOneMutationHookResult = ReturnType<typeof useComplianceCaseCreateOneMutation>;
export type ComplianceCaseCreateOneMutationResult = ApolloReactCommon.MutationResult<ComplianceCaseCreateOneMutation>;
export type ComplianceCaseCreateOneMutationOptions = ApolloReactCommon.BaseMutationOptions<ComplianceCaseCreateOneMutation, ComplianceCaseCreateOneMutationVariables>;
export const ComplianceCaseUpdateStatusDocument = gql`
    mutation complianceCaseUpdateStatus($caseId: String!, $status: Enumcompliance_casesStatus!, $outcome: Enumcompliance_casesOutcome!, $dealerNotes: String, $internalNotes: String, $internalNotesName: String) {
  complianceCaseUpdateStatus(
    caseId: $caseId
    status: $status
    dealerNotes: $dealerNotes
    internalNotes: $internalNotes
    internalNotesName: $internalNotesName
    outcome: $outcome
  )
}
    `;
export type ComplianceCaseUpdateStatusMutationFn = ApolloReactCommon.MutationFunction<ComplianceCaseUpdateStatusMutation, ComplianceCaseUpdateStatusMutationVariables>;

/**
 * __useComplianceCaseUpdateStatusMutation__
 *
 * To run a mutation, you first call `useComplianceCaseUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComplianceCaseUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [complianceCaseUpdateStatusMutation, { data, loading, error }] = useComplianceCaseUpdateStatusMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      status: // value for 'status'
 *      outcome: // value for 'outcome'
 *      dealerNotes: // value for 'dealerNotes'
 *      internalNotes: // value for 'internalNotes'
 *      internalNotesName: // value for 'internalNotesName'
 *   },
 * });
 */
export function useComplianceCaseUpdateStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ComplianceCaseUpdateStatusMutation, ComplianceCaseUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ComplianceCaseUpdateStatusMutation, ComplianceCaseUpdateStatusMutationVariables>(ComplianceCaseUpdateStatusDocument, options);
      }
export type ComplianceCaseUpdateStatusMutationHookResult = ReturnType<typeof useComplianceCaseUpdateStatusMutation>;
export type ComplianceCaseUpdateStatusMutationResult = ApolloReactCommon.MutationResult<ComplianceCaseUpdateStatusMutation>;
export type ComplianceCaseUpdateStatusMutationOptions = ApolloReactCommon.BaseMutationOptions<ComplianceCaseUpdateStatusMutation, ComplianceCaseUpdateStatusMutationVariables>;
export const ComplianceCaseUpdateCaseInformationDocument = gql`
    mutation complianceCaseUpdateCaseInformation($caseId: String!, $ongoing: Enumcompliance_casesCaseInformationOngoing!, $infractionDate: String!, $infractionLocation: String, $category: Enumcompliance_casesCaseInformationCategory!, $categoryOther: String!, $summary: String!, $evidence: [compliance_casesCaseInformationEvidenceInput]!) {
  complianceCaseUpdateCaseInformation(
    caseId: $caseId
    ongoing: $ongoing
    infractionDate: $infractionDate
    infractionLocation: $infractionLocation
    category: $category
    categoryOther: $categoryOther
    summary: $summary
    evidence: $evidence
  )
}
    `;
export type ComplianceCaseUpdateCaseInformationMutationFn = ApolloReactCommon.MutationFunction<ComplianceCaseUpdateCaseInformationMutation, ComplianceCaseUpdateCaseInformationMutationVariables>;

/**
 * __useComplianceCaseUpdateCaseInformationMutation__
 *
 * To run a mutation, you first call `useComplianceCaseUpdateCaseInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useComplianceCaseUpdateCaseInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [complianceCaseUpdateCaseInformationMutation, { data, loading, error }] = useComplianceCaseUpdateCaseInformationMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      ongoing: // value for 'ongoing'
 *      infractionDate: // value for 'infractionDate'
 *      infractionLocation: // value for 'infractionLocation'
 *      category: // value for 'category'
 *      categoryOther: // value for 'categoryOther'
 *      summary: // value for 'summary'
 *      evidence: // value for 'evidence'
 *   },
 * });
 */
export function useComplianceCaseUpdateCaseInformationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ComplianceCaseUpdateCaseInformationMutation, ComplianceCaseUpdateCaseInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ComplianceCaseUpdateCaseInformationMutation, ComplianceCaseUpdateCaseInformationMutationVariables>(ComplianceCaseUpdateCaseInformationDocument, options);
      }
export type ComplianceCaseUpdateCaseInformationMutationHookResult = ReturnType<typeof useComplianceCaseUpdateCaseInformationMutation>;
export type ComplianceCaseUpdateCaseInformationMutationResult = ApolloReactCommon.MutationResult<ComplianceCaseUpdateCaseInformationMutation>;
export type ComplianceCaseUpdateCaseInformationMutationOptions = ApolloReactCommon.BaseMutationOptions<ComplianceCaseUpdateCaseInformationMutation, ComplianceCaseUpdateCaseInformationMutationVariables>;
export const LoginDocument = gql`
    query login($username: String!, $password: String!, $isPresentation: Boolean) {
  validateLogin: login(
    username: $username
    password: $password
    isPresentation: $isPresentation
  ) {
    error
    language
  }
}
    `;

/**
 * __useLoginQuery__
 *
 * To run a query within a React component, call `useLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginQuery({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      isPresentation: // value for 'isPresentation'
 *   },
 * });
 */
export function useLoginQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LoginQuery, LoginQueryVariables> & ({ variables: LoginQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
      }
export function useLoginLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export function useLoginSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LoginQuery, LoginQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LoginQuery, LoginQueryVariables>(LoginDocument, options);
        }
export type LoginQueryHookResult = ReturnType<typeof useLoginQuery>;
export type LoginLazyQueryHookResult = ReturnType<typeof useLoginLazyQuery>;
export type LoginSuspenseQueryHookResult = ReturnType<typeof useLoginSuspenseQuery>;
export type LoginQueryResult = ApolloReactCommon.QueryResult<LoginQuery, LoginQueryVariables>;
export function refetchLoginQuery(variables: LoginQueryVariables) {
      return { query: LoginDocument, variables: variables }
    }
export const SterlingDocument = gql`
    query sterling {
  unitsManyByRole {
    unit_code: code
    unit_name: name
  }
  assessmentMany(sort: DATE_DESC) {
    code
    title
    title_fr
    categoryDetails {
      code
      label
      label_fr
    }
  }
  permittedRoutes
}
    `;

/**
 * __useSterlingQuery__
 *
 * To run a query within a React component, call `useSterlingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSterlingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSterlingQuery({
 *   variables: {
 *   },
 * });
 */
export function useSterlingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SterlingQuery, SterlingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SterlingQuery, SterlingQueryVariables>(SterlingDocument, options);
      }
export function useSterlingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SterlingQuery, SterlingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SterlingQuery, SterlingQueryVariables>(SterlingDocument, options);
        }
export function useSterlingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SterlingQuery, SterlingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SterlingQuery, SterlingQueryVariables>(SterlingDocument, options);
        }
export type SterlingQueryHookResult = ReturnType<typeof useSterlingQuery>;
export type SterlingLazyQueryHookResult = ReturnType<typeof useSterlingLazyQuery>;
export type SterlingSuspenseQueryHookResult = ReturnType<typeof useSterlingSuspenseQuery>;
export type SterlingQueryResult = ApolloReactCommon.QueryResult<SterlingQuery, SterlingQueryVariables>;
export function refetchSterlingQuery(variables?: SterlingQueryVariables) {
      return { query: SterlingDocument, variables: variables }
    }
export const ApiRoutesDocument = gql`
    query apiRoutes($language: LanguageCode!, $itemType: String!) {
  apiRoutes: top_level_contents(language: $language, itemType: $itemType) {
    ...ApiRoute
    children {
      ...ApiRoute
      children {
        ...ApiRoute
        children {
          ...ApiRoute
          children {
            ...ApiRoute
            children {
              ...ApiRoute
            }
          }
        }
      }
    }
  }
}
    ${ApiRouteFragmentDoc}`;

/**
 * __useApiRoutesQuery__
 *
 * To run a query within a React component, call `useApiRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiRoutesQuery({
 *   variables: {
 *      language: // value for 'language'
 *      itemType: // value for 'itemType'
 *   },
 * });
 */
export function useApiRoutesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApiRoutesQuery, ApiRoutesQueryVariables> & ({ variables: ApiRoutesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApiRoutesQuery, ApiRoutesQueryVariables>(ApiRoutesDocument, options);
      }
export function useApiRoutesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApiRoutesQuery, ApiRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApiRoutesQuery, ApiRoutesQueryVariables>(ApiRoutesDocument, options);
        }
export function useApiRoutesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApiRoutesQuery, ApiRoutesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApiRoutesQuery, ApiRoutesQueryVariables>(ApiRoutesDocument, options);
        }
export type ApiRoutesQueryHookResult = ReturnType<typeof useApiRoutesQuery>;
export type ApiRoutesLazyQueryHookResult = ReturnType<typeof useApiRoutesLazyQuery>;
export type ApiRoutesSuspenseQueryHookResult = ReturnType<typeof useApiRoutesSuspenseQuery>;
export type ApiRoutesQueryResult = ApolloReactCommon.QueryResult<ApiRoutesQuery, ApiRoutesQueryVariables>;
export function refetchApiRoutesQuery(variables: ApiRoutesQueryVariables) {
      return { query: ApiRoutesDocument, variables: variables }
    }
export const ContentSearchDocument = gql`
    query contentSearch($text: String!, $language: String!, $noLimit: Boolean) {
  contentSearch(text: $text, language: $language, noLimit: $noLimit) {
    _id
    title
    path
    search_score
    content
    ancestors {
      title
      path
    }
  }
}
    `;

/**
 * __useContentSearchQuery__
 *
 * To run a query within a React component, call `useContentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      language: // value for 'language'
 *      noLimit: // value for 'noLimit'
 *   },
 * });
 */
export function useContentSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ContentSearchQuery, ContentSearchQueryVariables> & ({ variables: ContentSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ContentSearchQuery, ContentSearchQueryVariables>(ContentSearchDocument, options);
      }
export function useContentSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ContentSearchQuery, ContentSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ContentSearchQuery, ContentSearchQueryVariables>(ContentSearchDocument, options);
        }
export function useContentSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ContentSearchQuery, ContentSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ContentSearchQuery, ContentSearchQueryVariables>(ContentSearchDocument, options);
        }
export type ContentSearchQueryHookResult = ReturnType<typeof useContentSearchQuery>;
export type ContentSearchLazyQueryHookResult = ReturnType<typeof useContentSearchLazyQuery>;
export type ContentSearchSuspenseQueryHookResult = ReturnType<typeof useContentSearchSuspenseQuery>;
export type ContentSearchQueryResult = ApolloReactCommon.QueryResult<ContentSearchQuery, ContentSearchQueryVariables>;
export function refetchContentSearchQuery(variables: ContentSearchQueryVariables) {
      return { query: ContentSearchDocument, variables: variables }
    }
export const TagSuggestionSearchDocument = gql`
    query tagSuggestionSearch($text: String!, $language: String!) {
  tagSuggestionSearch(text: $text, language: $language)
}
    `;

/**
 * __useTagSuggestionSearchQuery__
 *
 * To run a query within a React component, call `useTagSuggestionSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagSuggestionSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagSuggestionSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTagSuggestionSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TagSuggestionSearchQuery, TagSuggestionSearchQueryVariables> & ({ variables: TagSuggestionSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagSuggestionSearchQuery, TagSuggestionSearchQueryVariables>(TagSuggestionSearchDocument, options);
      }
export function useTagSuggestionSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagSuggestionSearchQuery, TagSuggestionSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagSuggestionSearchQuery, TagSuggestionSearchQueryVariables>(TagSuggestionSearchDocument, options);
        }
export function useTagSuggestionSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TagSuggestionSearchQuery, TagSuggestionSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TagSuggestionSearchQuery, TagSuggestionSearchQueryVariables>(TagSuggestionSearchDocument, options);
        }
export type TagSuggestionSearchQueryHookResult = ReturnType<typeof useTagSuggestionSearchQuery>;
export type TagSuggestionSearchLazyQueryHookResult = ReturnType<typeof useTagSuggestionSearchLazyQuery>;
export type TagSuggestionSearchSuspenseQueryHookResult = ReturnType<typeof useTagSuggestionSearchSuspenseQuery>;
export type TagSuggestionSearchQueryResult = ApolloReactCommon.QueryResult<TagSuggestionSearchQuery, TagSuggestionSearchQueryVariables>;
export function refetchTagSuggestionSearchQuery(variables: TagSuggestionSearchQueryVariables) {
      return { query: TagSuggestionSearchDocument, variables: variables }
    }
export const AutocompleteSearchDocument = gql`
    query autocompleteSearch($text: String!, $language: String!) {
  autocompleteSearch(text: $text, language: $language) {
    title
    path
    ancestors {
      title
      path
    }
  }
}
    `;

/**
 * __useAutocompleteSearchQuery__
 *
 * To run a query within a React component, call `useAutocompleteSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutocompleteSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutocompleteSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useAutocompleteSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AutocompleteSearchQuery, AutocompleteSearchQueryVariables> & ({ variables: AutocompleteSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AutocompleteSearchQuery, AutocompleteSearchQueryVariables>(AutocompleteSearchDocument, options);
      }
export function useAutocompleteSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AutocompleteSearchQuery, AutocompleteSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AutocompleteSearchQuery, AutocompleteSearchQueryVariables>(AutocompleteSearchDocument, options);
        }
export function useAutocompleteSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AutocompleteSearchQuery, AutocompleteSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AutocompleteSearchQuery, AutocompleteSearchQueryVariables>(AutocompleteSearchDocument, options);
        }
export type AutocompleteSearchQueryHookResult = ReturnType<typeof useAutocompleteSearchQuery>;
export type AutocompleteSearchLazyQueryHookResult = ReturnType<typeof useAutocompleteSearchLazyQuery>;
export type AutocompleteSearchSuspenseQueryHookResult = ReturnType<typeof useAutocompleteSearchSuspenseQuery>;
export type AutocompleteSearchQueryResult = ApolloReactCommon.QueryResult<AutocompleteSearchQuery, AutocompleteSearchQueryVariables>;
export function refetchAutocompleteSearchQuery(variables: AutocompleteSearchQueryVariables) {
      return { query: AutocompleteSearchDocument, variables: variables }
    }
export const TagSearchDocument = gql`
    query tagSearch($text: String!, $language: String!) {
  tagSearch(text: $text, language: $language) {
    title
    path
    ancestors {
      title
      path
    }
  }
}
    `;

/**
 * __useTagSearchQuery__
 *
 * To run a query within a React component, call `useTagSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTagSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TagSearchQuery, TagSearchQueryVariables> & ({ variables: TagSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagSearchQuery, TagSearchQueryVariables>(TagSearchDocument, options);
      }
export function useTagSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagSearchQuery, TagSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagSearchQuery, TagSearchQueryVariables>(TagSearchDocument, options);
        }
export function useTagSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TagSearchQuery, TagSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TagSearchQuery, TagSearchQueryVariables>(TagSearchDocument, options);
        }
export type TagSearchQueryHookResult = ReturnType<typeof useTagSearchQuery>;
export type TagSearchLazyQueryHookResult = ReturnType<typeof useTagSearchLazyQuery>;
export type TagSearchSuspenseQueryHookResult = ReturnType<typeof useTagSearchSuspenseQuery>;
export type TagSearchQueryResult = ApolloReactCommon.QueryResult<TagSearchQuery, TagSearchQueryVariables>;
export function refetchTagSearchQuery(variables: TagSearchQueryVariables) {
      return { query: TagSearchDocument, variables: variables }
    }
export const AccountManagementByUsernameDocument = gql`
    query accountManagementByUsername($username: String!) {
  userOne(filter: {username: $username}) {
    _id
    username
    type
    password
    domains
    email
    title
    first_name
    last_name
    preferred_language
    coe_role
    coe_role_permissions
    reviewer_role
    comment
    last_login
    refresh_token
    oem_access
  }
}
    `;

/**
 * __useAccountManagementByUsernameQuery__
 *
 * To run a query within a React component, call `useAccountManagementByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountManagementByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountManagementByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useAccountManagementByUsernameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountManagementByUsernameQuery, AccountManagementByUsernameQueryVariables> & ({ variables: AccountManagementByUsernameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountManagementByUsernameQuery, AccountManagementByUsernameQueryVariables>(AccountManagementByUsernameDocument, options);
      }
export function useAccountManagementByUsernameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountManagementByUsernameQuery, AccountManagementByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountManagementByUsernameQuery, AccountManagementByUsernameQueryVariables>(AccountManagementByUsernameDocument, options);
        }
export function useAccountManagementByUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountManagementByUsernameQuery, AccountManagementByUsernameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountManagementByUsernameQuery, AccountManagementByUsernameQueryVariables>(AccountManagementByUsernameDocument, options);
        }
export type AccountManagementByUsernameQueryHookResult = ReturnType<typeof useAccountManagementByUsernameQuery>;
export type AccountManagementByUsernameLazyQueryHookResult = ReturnType<typeof useAccountManagementByUsernameLazyQuery>;
export type AccountManagementByUsernameSuspenseQueryHookResult = ReturnType<typeof useAccountManagementByUsernameSuspenseQuery>;
export type AccountManagementByUsernameQueryResult = ApolloReactCommon.QueryResult<AccountManagementByUsernameQuery, AccountManagementByUsernameQueryVariables>;
export function refetchAccountManagementByUsernameQuery(variables: AccountManagementByUsernameQueryVariables) {
      return { query: AccountManagementByUsernameDocument, variables: variables }
    }
export const AccountManagementByEmailDocument = gql`
    query accountManagementByEmail($email: String!) {
  userOne(filter: {email: $email}) {
    _id
    username
    type
    password
    domains
    email
    title
    first_name
    last_name
    preferred_language
    coe_role
    coe_role_permissions
    reviewer_role
    comment
    last_login
    refresh_token
    oem_access
  }
}
    `;

/**
 * __useAccountManagementByEmailQuery__
 *
 * To run a query within a React component, call `useAccountManagementByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountManagementByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountManagementByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAccountManagementByEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountManagementByEmailQuery, AccountManagementByEmailQueryVariables> & ({ variables: AccountManagementByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountManagementByEmailQuery, AccountManagementByEmailQueryVariables>(AccountManagementByEmailDocument, options);
      }
export function useAccountManagementByEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountManagementByEmailQuery, AccountManagementByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountManagementByEmailQuery, AccountManagementByEmailQueryVariables>(AccountManagementByEmailDocument, options);
        }
export function useAccountManagementByEmailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountManagementByEmailQuery, AccountManagementByEmailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountManagementByEmailQuery, AccountManagementByEmailQueryVariables>(AccountManagementByEmailDocument, options);
        }
export type AccountManagementByEmailQueryHookResult = ReturnType<typeof useAccountManagementByEmailQuery>;
export type AccountManagementByEmailLazyQueryHookResult = ReturnType<typeof useAccountManagementByEmailLazyQuery>;
export type AccountManagementByEmailSuspenseQueryHookResult = ReturnType<typeof useAccountManagementByEmailSuspenseQuery>;
export type AccountManagementByEmailQueryResult = ApolloReactCommon.QueryResult<AccountManagementByEmailQuery, AccountManagementByEmailQueryVariables>;
export function refetchAccountManagementByEmailQuery(variables: AccountManagementByEmailQueryVariables) {
      return { query: AccountManagementByEmailDocument, variables: variables }
    }
export const UserUpdateOneDocument = gql`
    mutation userUpdateOne($filter: FilterUpdateOneUsersInput, $record: UpdateOneUsersInput!) {
  userUpdateOne(filter: $filter, record: $record) {
    recordId
  }
}
    `;
export type UserUpdateOneMutationFn = ApolloReactCommon.MutationFunction<UserUpdateOneMutation, UserUpdateOneMutationVariables>;

/**
 * __useUserUpdateOneMutation__
 *
 * To run a mutation, you first call `useUserUpdateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateOneMutation, { data, loading, error }] = useUserUpdateOneMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUserUpdateOneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserUpdateOneMutation, UserUpdateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserUpdateOneMutation, UserUpdateOneMutationVariables>(UserUpdateOneDocument, options);
      }
export type UserUpdateOneMutationHookResult = ReturnType<typeof useUserUpdateOneMutation>;
export type UserUpdateOneMutationResult = ApolloReactCommon.MutationResult<UserUpdateOneMutation>;
export type UserUpdateOneMutationOptions = ApolloReactCommon.BaseMutationOptions<UserUpdateOneMutation, UserUpdateOneMutationVariables>;
export const UserCreateOneDocument = gql`
    mutation userCreateOne($record: CreateOneUsersInput!) {
  userCreateOne(record: $record) {
    recordId
  }
}
    `;
export type UserCreateOneMutationFn = ApolloReactCommon.MutationFunction<UserCreateOneMutation, UserCreateOneMutationVariables>;

/**
 * __useUserCreateOneMutation__
 *
 * To run a mutation, you first call `useUserCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateOneMutation, { data, loading, error }] = useUserCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useUserCreateOneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserCreateOneMutation, UserCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserCreateOneMutation, UserCreateOneMutationVariables>(UserCreateOneDocument, options);
      }
export type UserCreateOneMutationHookResult = ReturnType<typeof useUserCreateOneMutation>;
export type UserCreateOneMutationResult = ApolloReactCommon.MutationResult<UserCreateOneMutation>;
export type UserCreateOneMutationOptions = ApolloReactCommon.BaseMutationOptions<UserCreateOneMutation, UserCreateOneMutationVariables>;
export const AccountManagementRolePermissionsDocument = gql`
    query accountManagementRolePermissions {
  unitsMany(sort: NAME_ASC) {
    code
    name
  }
  segmentsMany(sort: NAME_ASC) {
    name
    value
  }
  vendorsMany(sort: VENDOR_NAME_ASC) {
    vendor_name
  }
}
    `;

/**
 * __useAccountManagementRolePermissionsQuery__
 *
 * To run a query within a React component, call `useAccountManagementRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountManagementRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountManagementRolePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountManagementRolePermissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountManagementRolePermissionsQuery, AccountManagementRolePermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountManagementRolePermissionsQuery, AccountManagementRolePermissionsQueryVariables>(AccountManagementRolePermissionsDocument, options);
      }
export function useAccountManagementRolePermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountManagementRolePermissionsQuery, AccountManagementRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountManagementRolePermissionsQuery, AccountManagementRolePermissionsQueryVariables>(AccountManagementRolePermissionsDocument, options);
        }
export function useAccountManagementRolePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountManagementRolePermissionsQuery, AccountManagementRolePermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountManagementRolePermissionsQuery, AccountManagementRolePermissionsQueryVariables>(AccountManagementRolePermissionsDocument, options);
        }
export type AccountManagementRolePermissionsQueryHookResult = ReturnType<typeof useAccountManagementRolePermissionsQuery>;
export type AccountManagementRolePermissionsLazyQueryHookResult = ReturnType<typeof useAccountManagementRolePermissionsLazyQuery>;
export type AccountManagementRolePermissionsSuspenseQueryHookResult = ReturnType<typeof useAccountManagementRolePermissionsSuspenseQuery>;
export type AccountManagementRolePermissionsQueryResult = ApolloReactCommon.QueryResult<AccountManagementRolePermissionsQuery, AccountManagementRolePermissionsQueryVariables>;
export function refetchAccountManagementRolePermissionsQuery(variables?: AccountManagementRolePermissionsQueryVariables) {
      return { query: AccountManagementRolePermissionsDocument, variables: variables }
    }
export const UserUpdateListDocument = gql`
    query userUpdateList {
  userMany(
    sort: USERNAME_ASC
    filter: {_operators: {coe_role: {nin: [SUPER_ADMIN, DEVELOPER]}}}
  ) {
    username
    email
  }
}
    `;

/**
 * __useUserUpdateListQuery__
 *
 * To run a query within a React component, call `useUserUpdateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserUpdateListQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserUpdateListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserUpdateListQuery, UserUpdateListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserUpdateListQuery, UserUpdateListQueryVariables>(UserUpdateListDocument, options);
      }
export function useUserUpdateListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserUpdateListQuery, UserUpdateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserUpdateListQuery, UserUpdateListQueryVariables>(UserUpdateListDocument, options);
        }
export function useUserUpdateListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserUpdateListQuery, UserUpdateListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserUpdateListQuery, UserUpdateListQueryVariables>(UserUpdateListDocument, options);
        }
export type UserUpdateListQueryHookResult = ReturnType<typeof useUserUpdateListQuery>;
export type UserUpdateListLazyQueryHookResult = ReturnType<typeof useUserUpdateListLazyQuery>;
export type UserUpdateListSuspenseQueryHookResult = ReturnType<typeof useUserUpdateListSuspenseQuery>;
export type UserUpdateListQueryResult = ApolloReactCommon.QueryResult<UserUpdateListQuery, UserUpdateListQueryVariables>;
export function refetchUserUpdateListQuery(variables?: UserUpdateListQueryVariables) {
      return { query: UserUpdateListDocument, variables: variables }
    }
export const Executive_SummaryDocument = gql`
    query executive_summary($assessmentCode: String!) {
  executive_summary(assessmentCode: $assessmentCode) {
    question_name
    question_number
    question_label_EN
    question_label_FR
    category_code
    category_number
    category_label_EN
    category_label_FR
    response_count {
      yes
      no
      total
      somewhat
    }
    response_percent {
      yes
      no
      total
      somewhat
    }
  }
}
    `;

/**
 * __useExecutive_SummaryQuery__
 *
 * To run a query within a React component, call `useExecutive_SummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecutive_SummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecutive_SummaryQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useExecutive_SummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Executive_SummaryQuery, Executive_SummaryQueryVariables> & ({ variables: Executive_SummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Executive_SummaryQuery, Executive_SummaryQueryVariables>(Executive_SummaryDocument, options);
      }
export function useExecutive_SummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Executive_SummaryQuery, Executive_SummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Executive_SummaryQuery, Executive_SummaryQueryVariables>(Executive_SummaryDocument, options);
        }
export function useExecutive_SummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Executive_SummaryQuery, Executive_SummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Executive_SummaryQuery, Executive_SummaryQueryVariables>(Executive_SummaryDocument, options);
        }
export type Executive_SummaryQueryHookResult = ReturnType<typeof useExecutive_SummaryQuery>;
export type Executive_SummaryLazyQueryHookResult = ReturnType<typeof useExecutive_SummaryLazyQuery>;
export type Executive_SummarySuspenseQueryHookResult = ReturnType<typeof useExecutive_SummarySuspenseQuery>;
export type Executive_SummaryQueryResult = ApolloReactCommon.QueryResult<Executive_SummaryQuery, Executive_SummaryQueryVariables>;
export function refetchExecutive_SummaryQuery(variables: Executive_SummaryQueryVariables) {
      return { query: Executive_SummaryDocument, variables: variables }
    }
export const LighthouseQuestionsAnalysisDocument = gql`
    query lighthouseQuestionsAnalysis($assessmentCode: String!) {
  lighthouse_question_analysis(assessmentCode: $assessmentCode) {
    question_name
    category_code
    scores {
      answer
      performance
      accessibility
      seo
    }
  }
}
    `;

/**
 * __useLighthouseQuestionsAnalysisQuery__
 *
 * To run a query within a React component, call `useLighthouseQuestionsAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useLighthouseQuestionsAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLighthouseQuestionsAnalysisQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useLighthouseQuestionsAnalysisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LighthouseQuestionsAnalysisQuery, LighthouseQuestionsAnalysisQueryVariables> & ({ variables: LighthouseQuestionsAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LighthouseQuestionsAnalysisQuery, LighthouseQuestionsAnalysisQueryVariables>(LighthouseQuestionsAnalysisDocument, options);
      }
export function useLighthouseQuestionsAnalysisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LighthouseQuestionsAnalysisQuery, LighthouseQuestionsAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LighthouseQuestionsAnalysisQuery, LighthouseQuestionsAnalysisQueryVariables>(LighthouseQuestionsAnalysisDocument, options);
        }
export function useLighthouseQuestionsAnalysisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LighthouseQuestionsAnalysisQuery, LighthouseQuestionsAnalysisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LighthouseQuestionsAnalysisQuery, LighthouseQuestionsAnalysisQueryVariables>(LighthouseQuestionsAnalysisDocument, options);
        }
export type LighthouseQuestionsAnalysisQueryHookResult = ReturnType<typeof useLighthouseQuestionsAnalysisQuery>;
export type LighthouseQuestionsAnalysisLazyQueryHookResult = ReturnType<typeof useLighthouseQuestionsAnalysisLazyQuery>;
export type LighthouseQuestionsAnalysisSuspenseQueryHookResult = ReturnType<typeof useLighthouseQuestionsAnalysisSuspenseQuery>;
export type LighthouseQuestionsAnalysisQueryResult = ApolloReactCommon.QueryResult<LighthouseQuestionsAnalysisQuery, LighthouseQuestionsAnalysisQueryVariables>;
export function refetchLighthouseQuestionsAnalysisQuery(variables: LighthouseQuestionsAnalysisQueryVariables) {
      return { query: LighthouseQuestionsAnalysisDocument, variables: variables }
    }
export const SearchContentPagesDocument = gql`
    query searchContentPages {
  searchContentPages {
    wordpress_id
    title
    content_search
    tags
  }
}
    `;

/**
 * __useSearchContentPagesQuery__
 *
 * To run a query within a React component, call `useSearchContentPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContentPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContentPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchContentPagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchContentPagesQuery, SearchContentPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchContentPagesQuery, SearchContentPagesQueryVariables>(SearchContentPagesDocument, options);
      }
export function useSearchContentPagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchContentPagesQuery, SearchContentPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchContentPagesQuery, SearchContentPagesQueryVariables>(SearchContentPagesDocument, options);
        }
export function useSearchContentPagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchContentPagesQuery, SearchContentPagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchContentPagesQuery, SearchContentPagesQueryVariables>(SearchContentPagesDocument, options);
        }
export type SearchContentPagesQueryHookResult = ReturnType<typeof useSearchContentPagesQuery>;
export type SearchContentPagesLazyQueryHookResult = ReturnType<typeof useSearchContentPagesLazyQuery>;
export type SearchContentPagesSuspenseQueryHookResult = ReturnType<typeof useSearchContentPagesSuspenseQuery>;
export type SearchContentPagesQueryResult = ApolloReactCommon.QueryResult<SearchContentPagesQuery, SearchContentPagesQueryVariables>;
export function refetchSearchContentPagesQuery(variables?: SearchContentPagesQueryVariables) {
      return { query: SearchContentPagesDocument, variables: variables }
    }
export const GenerateSearchKeywordsDocument = gql`
    query generateSearchKeywords($text: String!, $language: LanguageCode!) {
  generateSearchKeywords(text: $text, language: $language)
}
    `;

/**
 * __useGenerateSearchKeywordsQuery__
 *
 * To run a query within a React component, call `useGenerateSearchKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateSearchKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateSearchKeywordsQuery({
 *   variables: {
 *      text: // value for 'text'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGenerateSearchKeywordsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GenerateSearchKeywordsQuery, GenerateSearchKeywordsQueryVariables> & ({ variables: GenerateSearchKeywordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GenerateSearchKeywordsQuery, GenerateSearchKeywordsQueryVariables>(GenerateSearchKeywordsDocument, options);
      }
export function useGenerateSearchKeywordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GenerateSearchKeywordsQuery, GenerateSearchKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GenerateSearchKeywordsQuery, GenerateSearchKeywordsQueryVariables>(GenerateSearchKeywordsDocument, options);
        }
export function useGenerateSearchKeywordsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GenerateSearchKeywordsQuery, GenerateSearchKeywordsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GenerateSearchKeywordsQuery, GenerateSearchKeywordsQueryVariables>(GenerateSearchKeywordsDocument, options);
        }
export type GenerateSearchKeywordsQueryHookResult = ReturnType<typeof useGenerateSearchKeywordsQuery>;
export type GenerateSearchKeywordsLazyQueryHookResult = ReturnType<typeof useGenerateSearchKeywordsLazyQuery>;
export type GenerateSearchKeywordsSuspenseQueryHookResult = ReturnType<typeof useGenerateSearchKeywordsSuspenseQuery>;
export type GenerateSearchKeywordsQueryResult = ApolloReactCommon.QueryResult<GenerateSearchKeywordsQuery, GenerateSearchKeywordsQueryVariables>;
export function refetchGenerateSearchKeywordsQuery(variables: GenerateSearchKeywordsQueryVariables) {
      return { query: GenerateSearchKeywordsDocument, variables: variables }
    }
export const UpdateContentTagsDocument = gql`
    mutation updateContentTags($wordpress_id: Int!, $tags: [String]!) {
  updateContentTags(wordpress_id: $wordpress_id, tags: $tags) {
    wordpress_id
  }
}
    `;
export type UpdateContentTagsMutationFn = ApolloReactCommon.MutationFunction<UpdateContentTagsMutation, UpdateContentTagsMutationVariables>;

/**
 * __useUpdateContentTagsMutation__
 *
 * To run a mutation, you first call `useUpdateContentTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentTagsMutation, { data, loading, error }] = useUpdateContentTagsMutation({
 *   variables: {
 *      wordpress_id: // value for 'wordpress_id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateContentTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContentTagsMutation, UpdateContentTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateContentTagsMutation, UpdateContentTagsMutationVariables>(UpdateContentTagsDocument, options);
      }
export type UpdateContentTagsMutationHookResult = ReturnType<typeof useUpdateContentTagsMutation>;
export type UpdateContentTagsMutationResult = ApolloReactCommon.MutationResult<UpdateContentTagsMutation>;
export type UpdateContentTagsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateContentTagsMutation, UpdateContentTagsMutationVariables>;
export const GetOrCreateReportingAggregateDocument = gql`
    query getOrCreateReportingAggregate($search_term: String!) {
  reportingAggregateGetOrCreate(search_term: $search_term) {
    search_term
    count
    timestamp
    avgSessionPages
    viewportTraffic
    contactPageVisits
    deviceTraffic
    browserTraffic
    uniqueVisits
    avgBounceRate
    avgUserSession
  }
}
    `;

/**
 * __useGetOrCreateReportingAggregateQuery__
 *
 * To run a query within a React component, call `useGetOrCreateReportingAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateReportingAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrCreateReportingAggregateQuery({
 *   variables: {
 *      search_term: // value for 'search_term'
 *   },
 * });
 */
export function useGetOrCreateReportingAggregateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrCreateReportingAggregateQuery, GetOrCreateReportingAggregateQueryVariables> & ({ variables: GetOrCreateReportingAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrCreateReportingAggregateQuery, GetOrCreateReportingAggregateQueryVariables>(GetOrCreateReportingAggregateDocument, options);
      }
export function useGetOrCreateReportingAggregateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrCreateReportingAggregateQuery, GetOrCreateReportingAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrCreateReportingAggregateQuery, GetOrCreateReportingAggregateQueryVariables>(GetOrCreateReportingAggregateDocument, options);
        }
export function useGetOrCreateReportingAggregateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrCreateReportingAggregateQuery, GetOrCreateReportingAggregateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrCreateReportingAggregateQuery, GetOrCreateReportingAggregateQueryVariables>(GetOrCreateReportingAggregateDocument, options);
        }
export type GetOrCreateReportingAggregateQueryHookResult = ReturnType<typeof useGetOrCreateReportingAggregateQuery>;
export type GetOrCreateReportingAggregateLazyQueryHookResult = ReturnType<typeof useGetOrCreateReportingAggregateLazyQuery>;
export type GetOrCreateReportingAggregateSuspenseQueryHookResult = ReturnType<typeof useGetOrCreateReportingAggregateSuspenseQuery>;
export type GetOrCreateReportingAggregateQueryResult = ApolloReactCommon.QueryResult<GetOrCreateReportingAggregateQuery, GetOrCreateReportingAggregateQueryVariables>;
export function refetchGetOrCreateReportingAggregateQuery(variables: GetOrCreateReportingAggregateQueryVariables) {
      return { query: GetOrCreateReportingAggregateDocument, variables: variables }
    }
export const GoogleTrendsDocument = gql`
    query googleTrends($dealerName: String!) {
  google_trends(dealerName: $dealerName) {
    averageInterest
    trendData {
      time
      interest
    }
    noData
  }
}
    `;

/**
 * __useGoogleTrendsQuery__
 *
 * To run a query within a React component, call `useGoogleTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleTrendsQuery({
 *   variables: {
 *      dealerName: // value for 'dealerName'
 *   },
 * });
 */
export function useGoogleTrendsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GoogleTrendsQuery, GoogleTrendsQueryVariables> & ({ variables: GoogleTrendsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GoogleTrendsQuery, GoogleTrendsQueryVariables>(GoogleTrendsDocument, options);
      }
export function useGoogleTrendsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GoogleTrendsQuery, GoogleTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GoogleTrendsQuery, GoogleTrendsQueryVariables>(GoogleTrendsDocument, options);
        }
export function useGoogleTrendsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GoogleTrendsQuery, GoogleTrendsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GoogleTrendsQuery, GoogleTrendsQueryVariables>(GoogleTrendsDocument, options);
        }
export type GoogleTrendsQueryHookResult = ReturnType<typeof useGoogleTrendsQuery>;
export type GoogleTrendsLazyQueryHookResult = ReturnType<typeof useGoogleTrendsLazyQuery>;
export type GoogleTrendsSuspenseQueryHookResult = ReturnType<typeof useGoogleTrendsSuspenseQuery>;
export type GoogleTrendsQueryResult = ApolloReactCommon.QueryResult<GoogleTrendsQuery, GoogleTrendsQueryVariables>;
export function refetchGoogleTrendsQuery(variables: GoogleTrendsQueryVariables) {
      return { query: GoogleTrendsDocument, variables: variables }
    }
export const LighthouseScoresDocument = gql`
    query lighthouseScores($dealerCode: String) {
  lighthouseOne(filter: {dealerCode: $dealerCode}) {
    dealerCode
    categories {
      performance {
        title
        score
      }
      bestPractices {
        title
        score
      }
      accessibility {
        title
        score
      }
      seo {
        title
        score
      }
      pwa {
        title
        score
      }
    }
  }
}
    `;

/**
 * __useLighthouseScoresQuery__
 *
 * To run a query within a React component, call `useLighthouseScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useLighthouseScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLighthouseScoresQuery({
 *   variables: {
 *      dealerCode: // value for 'dealerCode'
 *   },
 * });
 */
export function useLighthouseScoresQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LighthouseScoresQuery, LighthouseScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LighthouseScoresQuery, LighthouseScoresQueryVariables>(LighthouseScoresDocument, options);
      }
export function useLighthouseScoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LighthouseScoresQuery, LighthouseScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LighthouseScoresQuery, LighthouseScoresQueryVariables>(LighthouseScoresDocument, options);
        }
export function useLighthouseScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LighthouseScoresQuery, LighthouseScoresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LighthouseScoresQuery, LighthouseScoresQueryVariables>(LighthouseScoresDocument, options);
        }
export type LighthouseScoresQueryHookResult = ReturnType<typeof useLighthouseScoresQuery>;
export type LighthouseScoresLazyQueryHookResult = ReturnType<typeof useLighthouseScoresLazyQuery>;
export type LighthouseScoresSuspenseQueryHookResult = ReturnType<typeof useLighthouseScoresSuspenseQuery>;
export type LighthouseScoresQueryResult = ApolloReactCommon.QueryResult<LighthouseScoresQuery, LighthouseScoresQueryVariables>;
export function refetchLighthouseScoresQuery(variables?: LighthouseScoresQueryVariables) {
      return { query: LighthouseScoresDocument, variables: variables }
    }
export const LighthouseAggregateByOemDocument = gql`
    query lighthouseAggregateByOem {
  lighthouseAggregateByOem {
    oem
    seo {
      max
      avg
    }
    performance {
      max
      avg
    }
    bestPractices {
      max
      avg
    }
    accessibility {
      max
      avg
    }
  }
}
    `;

/**
 * __useLighthouseAggregateByOemQuery__
 *
 * To run a query within a React component, call `useLighthouseAggregateByOemQuery` and pass it any options that fit your needs.
 * When your component renders, `useLighthouseAggregateByOemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLighthouseAggregateByOemQuery({
 *   variables: {
 *   },
 * });
 */
export function useLighthouseAggregateByOemQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LighthouseAggregateByOemQuery, LighthouseAggregateByOemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LighthouseAggregateByOemQuery, LighthouseAggregateByOemQueryVariables>(LighthouseAggregateByOemDocument, options);
      }
export function useLighthouseAggregateByOemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LighthouseAggregateByOemQuery, LighthouseAggregateByOemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LighthouseAggregateByOemQuery, LighthouseAggregateByOemQueryVariables>(LighthouseAggregateByOemDocument, options);
        }
export function useLighthouseAggregateByOemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LighthouseAggregateByOemQuery, LighthouseAggregateByOemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LighthouseAggregateByOemQuery, LighthouseAggregateByOemQueryVariables>(LighthouseAggregateByOemDocument, options);
        }
export type LighthouseAggregateByOemQueryHookResult = ReturnType<typeof useLighthouseAggregateByOemQuery>;
export type LighthouseAggregateByOemLazyQueryHookResult = ReturnType<typeof useLighthouseAggregateByOemLazyQuery>;
export type LighthouseAggregateByOemSuspenseQueryHookResult = ReturnType<typeof useLighthouseAggregateByOemSuspenseQuery>;
export type LighthouseAggregateByOemQueryResult = ApolloReactCommon.QueryResult<LighthouseAggregateByOemQuery, LighthouseAggregateByOemQueryVariables>;
export function refetchLighthouseAggregateByOemQuery(variables?: LighthouseAggregateByOemQueryVariables) {
      return { query: LighthouseAggregateByOemDocument, variables: variables }
    }
export const GetUnitReportsDocument = gql`
    query getUnitReports($unit_code: String!) {
  reportingConfigOne(filter: {unit_code: $unit_code}) {
    ua_view_id
    region
    reports
  }
}
    `;

/**
 * __useGetUnitReportsQuery__
 *
 * To run a query within a React component, call `useGetUnitReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitReportsQuery({
 *   variables: {
 *      unit_code: // value for 'unit_code'
 *   },
 * });
 */
export function useGetUnitReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUnitReportsQuery, GetUnitReportsQueryVariables> & ({ variables: GetUnitReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUnitReportsQuery, GetUnitReportsQueryVariables>(GetUnitReportsDocument, options);
      }
export function useGetUnitReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnitReportsQuery, GetUnitReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUnitReportsQuery, GetUnitReportsQueryVariables>(GetUnitReportsDocument, options);
        }
export function useGetUnitReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUnitReportsQuery, GetUnitReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUnitReportsQuery, GetUnitReportsQueryVariables>(GetUnitReportsDocument, options);
        }
export type GetUnitReportsQueryHookResult = ReturnType<typeof useGetUnitReportsQuery>;
export type GetUnitReportsLazyQueryHookResult = ReturnType<typeof useGetUnitReportsLazyQuery>;
export type GetUnitReportsSuspenseQueryHookResult = ReturnType<typeof useGetUnitReportsSuspenseQuery>;
export type GetUnitReportsQueryResult = ApolloReactCommon.QueryResult<GetUnitReportsQuery, GetUnitReportsQueryVariables>;
export function refetchGetUnitReportsQuery(variables: GetUnitReportsQueryVariables) {
      return { query: GetUnitReportsDocument, variables: variables }
    }
export const GetVendorAggregateDocument = gql`
    query getVendorAggregate {
  reportingAggregateGetVendor {
    search_term
    count
    timestamp
    avgSessionPages
    viewportTraffic
    contactPageVisits
    deviceTraffic
    browserTraffic
    uniqueVisits
    avgBounceRate
    avgUserSession
  }
}
    `;

/**
 * __useGetVendorAggregateQuery__
 *
 * To run a query within a React component, call `useGetVendorAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorAggregateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVendorAggregateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVendorAggregateQuery, GetVendorAggregateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVendorAggregateQuery, GetVendorAggregateQueryVariables>(GetVendorAggregateDocument, options);
      }
export function useGetVendorAggregateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVendorAggregateQuery, GetVendorAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVendorAggregateQuery, GetVendorAggregateQueryVariables>(GetVendorAggregateDocument, options);
        }
export function useGetVendorAggregateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVendorAggregateQuery, GetVendorAggregateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVendorAggregateQuery, GetVendorAggregateQueryVariables>(GetVendorAggregateDocument, options);
        }
export type GetVendorAggregateQueryHookResult = ReturnType<typeof useGetVendorAggregateQuery>;
export type GetVendorAggregateLazyQueryHookResult = ReturnType<typeof useGetVendorAggregateLazyQuery>;
export type GetVendorAggregateSuspenseQueryHookResult = ReturnType<typeof useGetVendorAggregateSuspenseQuery>;
export type GetVendorAggregateQueryResult = ApolloReactCommon.QueryResult<GetVendorAggregateQuery, GetVendorAggregateQueryVariables>;
export function refetchGetVendorAggregateQuery(variables?: GetVendorAggregateQueryVariables) {
      return { query: GetVendorAggregateDocument, variables: variables }
    }
export const VendorUnitConfigsDocument = gql`
    query vendorUnitConfigs {
  reportingConfigVendorSites {
    unit_code
    measurement_id
    unit {
      name
      url
    }
  }
}
    `;

/**
 * __useVendorUnitConfigsQuery__
 *
 * To run a query within a React component, call `useVendorUnitConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorUnitConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorUnitConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorUnitConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorUnitConfigsQuery, VendorUnitConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VendorUnitConfigsQuery, VendorUnitConfigsQueryVariables>(VendorUnitConfigsDocument, options);
      }
export function useVendorUnitConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorUnitConfigsQuery, VendorUnitConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VendorUnitConfigsQuery, VendorUnitConfigsQueryVariables>(VendorUnitConfigsDocument, options);
        }
export function useVendorUnitConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VendorUnitConfigsQuery, VendorUnitConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VendorUnitConfigsQuery, VendorUnitConfigsQueryVariables>(VendorUnitConfigsDocument, options);
        }
export type VendorUnitConfigsQueryHookResult = ReturnType<typeof useVendorUnitConfigsQuery>;
export type VendorUnitConfigsLazyQueryHookResult = ReturnType<typeof useVendorUnitConfigsLazyQuery>;
export type VendorUnitConfigsSuspenseQueryHookResult = ReturnType<typeof useVendorUnitConfigsSuspenseQuery>;
export type VendorUnitConfigsQueryResult = ApolloReactCommon.QueryResult<VendorUnitConfigsQuery, VendorUnitConfigsQueryVariables>;
export function refetchVendorUnitConfigsQuery(variables?: VendorUnitConfigsQueryVariables) {
      return { query: VendorUnitConfigsDocument, variables: variables }
    }
export const VendorTrackingPropertyDocument = gql`
    query vendorTrackingProperty {
  reportingConfigVendorProp {
    tracking_code
  }
}
    `;

/**
 * __useVendorTrackingPropertyQuery__
 *
 * To run a query within a React component, call `useVendorTrackingPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorTrackingPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorTrackingPropertyQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorTrackingPropertyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorTrackingPropertyQuery, VendorTrackingPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VendorTrackingPropertyQuery, VendorTrackingPropertyQueryVariables>(VendorTrackingPropertyDocument, options);
      }
export function useVendorTrackingPropertyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorTrackingPropertyQuery, VendorTrackingPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VendorTrackingPropertyQuery, VendorTrackingPropertyQueryVariables>(VendorTrackingPropertyDocument, options);
        }
export function useVendorTrackingPropertySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VendorTrackingPropertyQuery, VendorTrackingPropertyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VendorTrackingPropertyQuery, VendorTrackingPropertyQueryVariables>(VendorTrackingPropertyDocument, options);
        }
export type VendorTrackingPropertyQueryHookResult = ReturnType<typeof useVendorTrackingPropertyQuery>;
export type VendorTrackingPropertyLazyQueryHookResult = ReturnType<typeof useVendorTrackingPropertyLazyQuery>;
export type VendorTrackingPropertySuspenseQueryHookResult = ReturnType<typeof useVendorTrackingPropertySuspenseQuery>;
export type VendorTrackingPropertyQueryResult = ApolloReactCommon.QueryResult<VendorTrackingPropertyQuery, VendorTrackingPropertyQueryVariables>;
export function refetchVendorTrackingPropertyQuery(variables?: VendorTrackingPropertyQueryVariables) {
      return { query: VendorTrackingPropertyDocument, variables: variables }
    }
export const UnitTrackingDocument = gql`
    query unitTracking($unit_code: String!, $create: Boolean) {
  reportingConfigUnitTracking(unit_code: $unit_code, create: $create) {
    measurement_id
  }
}
    `;

/**
 * __useUnitTrackingQuery__
 *
 * To run a query within a React component, call `useUnitTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitTrackingQuery({
 *   variables: {
 *      unit_code: // value for 'unit_code'
 *      create: // value for 'create'
 *   },
 * });
 */
export function useUnitTrackingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnitTrackingQuery, UnitTrackingQueryVariables> & ({ variables: UnitTrackingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitTrackingQuery, UnitTrackingQueryVariables>(UnitTrackingDocument, options);
      }
export function useUnitTrackingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitTrackingQuery, UnitTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitTrackingQuery, UnitTrackingQueryVariables>(UnitTrackingDocument, options);
        }
export function useUnitTrackingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitTrackingQuery, UnitTrackingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitTrackingQuery, UnitTrackingQueryVariables>(UnitTrackingDocument, options);
        }
export type UnitTrackingQueryHookResult = ReturnType<typeof useUnitTrackingQuery>;
export type UnitTrackingLazyQueryHookResult = ReturnType<typeof useUnitTrackingLazyQuery>;
export type UnitTrackingSuspenseQueryHookResult = ReturnType<typeof useUnitTrackingSuspenseQuery>;
export type UnitTrackingQueryResult = ApolloReactCommon.QueryResult<UnitTrackingQuery, UnitTrackingQueryVariables>;
export function refetchUnitTrackingQuery(variables: UnitTrackingQueryVariables) {
      return { query: UnitTrackingDocument, variables: variables }
    }
export const ValidateViewIdDocument = gql`
    query validateViewID($update: Boolean) {
  reportingConfigViewIds(update: $update) {
    views {
      id
      name
      vendor_name
      unit_code
      url
    }
  }
}
    `;

/**
 * __useValidateViewIdQuery__
 *
 * To run a query within a React component, call `useValidateViewIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateViewIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateViewIdQuery({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useValidateViewIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValidateViewIdQuery, ValidateViewIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidateViewIdQuery, ValidateViewIdQueryVariables>(ValidateViewIdDocument, options);
      }
export function useValidateViewIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateViewIdQuery, ValidateViewIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidateViewIdQuery, ValidateViewIdQueryVariables>(ValidateViewIdDocument, options);
        }
export function useValidateViewIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValidateViewIdQuery, ValidateViewIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValidateViewIdQuery, ValidateViewIdQueryVariables>(ValidateViewIdDocument, options);
        }
export type ValidateViewIdQueryHookResult = ReturnType<typeof useValidateViewIdQuery>;
export type ValidateViewIdLazyQueryHookResult = ReturnType<typeof useValidateViewIdLazyQuery>;
export type ValidateViewIdSuspenseQueryHookResult = ReturnType<typeof useValidateViewIdSuspenseQuery>;
export type ValidateViewIdQueryResult = ApolloReactCommon.QueryResult<ValidateViewIdQuery, ValidateViewIdQueryVariables>;
export function refetchValidateViewIdQuery(variables?: ValidateViewIdQueryVariables) {
      return { query: ValidateViewIdDocument, variables: variables }
    }
export const ResourceDocument = gql`
    query resource($path: String!, $language: String!) {
  contentOne(path: $path, language: $language) {
    title
    titleFr
    content
    itemtype
    parent
    order
    language
    next {
      path
      title
      titleFr
      noContent
      children {
        path
        title
        titleFr
      }
    }
    previous {
      path
      title
      titleFr
      noContent
      children {
        path
        title
        titleFr
      }
    }
  }
}
    `;

/**
 * __useResourceQuery__
 *
 * To run a query within a React component, call `useResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceQuery({
 *   variables: {
 *      path: // value for 'path'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useResourceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResourceQuery, ResourceQueryVariables> & ({ variables: ResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
      }
export function useResourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
        }
export function useResourceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
        }
export type ResourceQueryHookResult = ReturnType<typeof useResourceQuery>;
export type ResourceLazyQueryHookResult = ReturnType<typeof useResourceLazyQuery>;
export type ResourceSuspenseQueryHookResult = ReturnType<typeof useResourceSuspenseQuery>;
export type ResourceQueryResult = ApolloReactCommon.QueryResult<ResourceQuery, ResourceQueryVariables>;
export function refetchResourceQuery(variables: ResourceQueryVariables) {
      return { query: ResourceDocument, variables: variables }
    }
export const GetWebinarsDocument = gql`
    query getWebinars($lang: EnumContent_WebinarsLanguage) {
  contentWebinarMany(filter: {language: $lang, enabled: true}) {
    _id
    title
    description
    language
    body
    post_date
    created_date
    modified_date
    legacy_id
    preview_image {
      _id
      src
      alt
    }
    presenter
    path
    alternate_path
    key
    video_link
    video {
      _id
      src
      caption
      thumbnail {
        _id
        src
        alt
      }
    }
    start_time
  }
}
    `;

/**
 * __useGetWebinarsQuery__
 *
 * To run a query within a React component, call `useGetWebinarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebinarsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetWebinarsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWebinarsQuery, GetWebinarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWebinarsQuery, GetWebinarsQueryVariables>(GetWebinarsDocument, options);
      }
export function useGetWebinarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebinarsQuery, GetWebinarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWebinarsQuery, GetWebinarsQueryVariables>(GetWebinarsDocument, options);
        }
export function useGetWebinarsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWebinarsQuery, GetWebinarsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWebinarsQuery, GetWebinarsQueryVariables>(GetWebinarsDocument, options);
        }
export type GetWebinarsQueryHookResult = ReturnType<typeof useGetWebinarsQuery>;
export type GetWebinarsLazyQueryHookResult = ReturnType<typeof useGetWebinarsLazyQuery>;
export type GetWebinarsSuspenseQueryHookResult = ReturnType<typeof useGetWebinarsSuspenseQuery>;
export type GetWebinarsQueryResult = ApolloReactCommon.QueryResult<GetWebinarsQuery, GetWebinarsQueryVariables>;
export function refetchGetWebinarsQuery(variables?: GetWebinarsQueryVariables) {
      return { query: GetWebinarsDocument, variables: variables }
    }
export const GetBusinessInsightsDocument = gql`
    query getBusinessInsights($lang: EnumContent_Business_InsightsLanguage) {
  contentBusinessInsightMany(filter: {language: $lang, enabled: true}) {
    _id
    title
    description
    post_date
    language
    button_label
    body
    button_link
    created_date
    modified_date
    key
    path
    new
    alternate_path
    legacy_id
    preview_image {
      _id
      src
      alt
    }
    categories {
      code
      label
    }
  }
}
    `;

/**
 * __useGetBusinessInsightsQuery__
 *
 * To run a query within a React component, call `useGetBusinessInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessInsightsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetBusinessInsightsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBusinessInsightsQuery, GetBusinessInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBusinessInsightsQuery, GetBusinessInsightsQueryVariables>(GetBusinessInsightsDocument, options);
      }
export function useGetBusinessInsightsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBusinessInsightsQuery, GetBusinessInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBusinessInsightsQuery, GetBusinessInsightsQueryVariables>(GetBusinessInsightsDocument, options);
        }
export function useGetBusinessInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBusinessInsightsQuery, GetBusinessInsightsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBusinessInsightsQuery, GetBusinessInsightsQueryVariables>(GetBusinessInsightsDocument, options);
        }
export type GetBusinessInsightsQueryHookResult = ReturnType<typeof useGetBusinessInsightsQuery>;
export type GetBusinessInsightsLazyQueryHookResult = ReturnType<typeof useGetBusinessInsightsLazyQuery>;
export type GetBusinessInsightsSuspenseQueryHookResult = ReturnType<typeof useGetBusinessInsightsSuspenseQuery>;
export type GetBusinessInsightsQueryResult = ApolloReactCommon.QueryResult<GetBusinessInsightsQuery, GetBusinessInsightsQueryVariables>;
export function refetchGetBusinessInsightsQuery(variables?: GetBusinessInsightsQueryVariables) {
      return { query: GetBusinessInsightsDocument, variables: variables }
    }
export const ManagementDashboardSummaryDocument = gql`
    query managementDashboardSummary($assessmentCode: String!, $filterBy: String!, $filterText: String!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    filterBy: $filterBy
    filterText: $filterText
    groupBy: "ASSESSMENT_CODE"
    filterRole: true
  ) {
    edges {
      group_id
      total_score
      max_score
      final_score
      review_details {
        unit_code
        vendor_name
        enabled
      }
      best_category {
        category_code
        category_label
        category_label_fr
        total_score
        max_score
        final_score
      }
      improvement_category {
        category_code
        category_label
        category_label_fr
        total_score
        max_score
        final_score
      }
      category_scores {
        category_code
        category_label
        category_label_fr
        total_score
        max_score
        final_score
      }
    }
  }
}
    `;

/**
 * __useManagementDashboardSummaryQuery__
 *
 * To run a query within a React component, call `useManagementDashboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagementDashboardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementDashboardSummaryQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      filterBy: // value for 'filterBy'
 *      filterText: // value for 'filterText'
 *   },
 * });
 */
export function useManagementDashboardSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ManagementDashboardSummaryQuery, ManagementDashboardSummaryQueryVariables> & ({ variables: ManagementDashboardSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManagementDashboardSummaryQuery, ManagementDashboardSummaryQueryVariables>(ManagementDashboardSummaryDocument, options);
      }
export function useManagementDashboardSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManagementDashboardSummaryQuery, ManagementDashboardSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManagementDashboardSummaryQuery, ManagementDashboardSummaryQueryVariables>(ManagementDashboardSummaryDocument, options);
        }
export function useManagementDashboardSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ManagementDashboardSummaryQuery, ManagementDashboardSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ManagementDashboardSummaryQuery, ManagementDashboardSummaryQueryVariables>(ManagementDashboardSummaryDocument, options);
        }
export type ManagementDashboardSummaryQueryHookResult = ReturnType<typeof useManagementDashboardSummaryQuery>;
export type ManagementDashboardSummaryLazyQueryHookResult = ReturnType<typeof useManagementDashboardSummaryLazyQuery>;
export type ManagementDashboardSummarySuspenseQueryHookResult = ReturnType<typeof useManagementDashboardSummarySuspenseQuery>;
export type ManagementDashboardSummaryQueryResult = ApolloReactCommon.QueryResult<ManagementDashboardSummaryQuery, ManagementDashboardSummaryQueryVariables>;
export function refetchManagementDashboardSummaryQuery(variables: ManagementDashboardSummaryQueryVariables) {
      return { query: ManagementDashboardSummaryDocument, variables: variables }
    }
export const NewSummaryReportDocument = gql`
    query newSummaryReport($assessmentCode: String!, $sortBy: String!, $sortOrder: String!, $filterBy: String!, $filterText: String!, $categorySort: String!, $pageSize: Int!, $pageNum: Int!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    groupBy: "UNIT_CODE"
    filterRole: true
    filterBy: $filterBy
    filterText: $filterText
    sortBy: $sortBy
    sortOrder: $sortOrder
    categorySort: $categorySort
    pageSize: $pageSize
    pageNum: $pageNum
  ) {
    edges {
      group_id
      total_score
      max_score
      final_score
      review_details {
        unit_name
        district_code
        region_code
        vendor_name
        url
      }
      category_scores {
        code: category_code
        label: category_label
        label_fr: category_label_fr
        total_score
        max_score
        final_score
      }
    }
    meta {
      documents
      pages
    }
  }
}
    `;

/**
 * __useNewSummaryReportQuery__
 *
 * To run a query within a React component, call `useNewSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewSummaryReportQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      filterBy: // value for 'filterBy'
 *      filterText: // value for 'filterText'
 *      categorySort: // value for 'categorySort'
 *      pageSize: // value for 'pageSize'
 *      pageNum: // value for 'pageNum'
 *   },
 * });
 */
export function useNewSummaryReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NewSummaryReportQuery, NewSummaryReportQueryVariables> & ({ variables: NewSummaryReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewSummaryReportQuery, NewSummaryReportQueryVariables>(NewSummaryReportDocument, options);
      }
export function useNewSummaryReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewSummaryReportQuery, NewSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewSummaryReportQuery, NewSummaryReportQueryVariables>(NewSummaryReportDocument, options);
        }
export function useNewSummaryReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewSummaryReportQuery, NewSummaryReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewSummaryReportQuery, NewSummaryReportQueryVariables>(NewSummaryReportDocument, options);
        }
export type NewSummaryReportQueryHookResult = ReturnType<typeof useNewSummaryReportQuery>;
export type NewSummaryReportLazyQueryHookResult = ReturnType<typeof useNewSummaryReportLazyQuery>;
export type NewSummaryReportSuspenseQueryHookResult = ReturnType<typeof useNewSummaryReportSuspenseQuery>;
export type NewSummaryReportQueryResult = ApolloReactCommon.QueryResult<NewSummaryReportQuery, NewSummaryReportQueryVariables>;
export function refetchNewSummaryReportQuery(variables: NewSummaryReportQueryVariables) {
      return { query: NewSummaryReportDocument, variables: variables }
    }
export const VendorsInAssessmentPeriodDocument = gql`
    query vendorsInAssessmentPeriod($assessmentCode: String!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    groupBy: "VENDOR_NAME"
    filterRole: true
    sortBy: "VENDOR_NAME"
    sortOrder: "ASC"
  ) {
    edges {
      vendor_name: group_id
    }
  }
}
    `;

/**
 * __useVendorsInAssessmentPeriodQuery__
 *
 * To run a query within a React component, call `useVendorsInAssessmentPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorsInAssessmentPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorsInAssessmentPeriodQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useVendorsInAssessmentPeriodQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VendorsInAssessmentPeriodQuery, VendorsInAssessmentPeriodQueryVariables> & ({ variables: VendorsInAssessmentPeriodQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VendorsInAssessmentPeriodQuery, VendorsInAssessmentPeriodQueryVariables>(VendorsInAssessmentPeriodDocument, options);
      }
export function useVendorsInAssessmentPeriodLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorsInAssessmentPeriodQuery, VendorsInAssessmentPeriodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VendorsInAssessmentPeriodQuery, VendorsInAssessmentPeriodQueryVariables>(VendorsInAssessmentPeriodDocument, options);
        }
export function useVendorsInAssessmentPeriodSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VendorsInAssessmentPeriodQuery, VendorsInAssessmentPeriodQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VendorsInAssessmentPeriodQuery, VendorsInAssessmentPeriodQueryVariables>(VendorsInAssessmentPeriodDocument, options);
        }
export type VendorsInAssessmentPeriodQueryHookResult = ReturnType<typeof useVendorsInAssessmentPeriodQuery>;
export type VendorsInAssessmentPeriodLazyQueryHookResult = ReturnType<typeof useVendorsInAssessmentPeriodLazyQuery>;
export type VendorsInAssessmentPeriodSuspenseQueryHookResult = ReturnType<typeof useVendorsInAssessmentPeriodSuspenseQuery>;
export type VendorsInAssessmentPeriodQueryResult = ApolloReactCommon.QueryResult<VendorsInAssessmentPeriodQuery, VendorsInAssessmentPeriodQueryVariables>;
export function refetchVendorsInAssessmentPeriodQuery(variables: VendorsInAssessmentPeriodQueryVariables) {
      return { query: VendorsInAssessmentPeriodDocument, variables: variables }
    }
export const UnitLoggedInDocument = gql`
    query unitLoggedIn($assessmentCode: String!, $codes: [String!]) {
  unitsMany(filter: {_operators: {code: {in: $codes}}}) {
    code
    assessment_login(assessmentCode: $assessmentCode)
  }
}
    `;

/**
 * __useUnitLoggedInQuery__
 *
 * To run a query within a React component, call `useUnitLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitLoggedInQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      codes: // value for 'codes'
 *   },
 * });
 */
export function useUnitLoggedInQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnitLoggedInQuery, UnitLoggedInQueryVariables> & ({ variables: UnitLoggedInQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitLoggedInQuery, UnitLoggedInQueryVariables>(UnitLoggedInDocument, options);
      }
export function useUnitLoggedInLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitLoggedInQuery, UnitLoggedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitLoggedInQuery, UnitLoggedInQueryVariables>(UnitLoggedInDocument, options);
        }
export function useUnitLoggedInSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitLoggedInQuery, UnitLoggedInQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitLoggedInQuery, UnitLoggedInQueryVariables>(UnitLoggedInDocument, options);
        }
export type UnitLoggedInQueryHookResult = ReturnType<typeof useUnitLoggedInQuery>;
export type UnitLoggedInLazyQueryHookResult = ReturnType<typeof useUnitLoggedInLazyQuery>;
export type UnitLoggedInSuspenseQueryHookResult = ReturnType<typeof useUnitLoggedInSuspenseQuery>;
export type UnitLoggedInQueryResult = ApolloReactCommon.QueryResult<UnitLoggedInQuery, UnitLoggedInQueryVariables>;
export function refetchUnitLoggedInQuery(variables: UnitLoggedInQueryVariables) {
      return { query: UnitLoggedInDocument, variables: variables }
    }
export const ScoresDocument = gql`
    query scores($aggregateOn: SterlingKey!, $filter: ScoreFilter!) {
  scores(aggregateOn: $aggregateOn, filter: $filter) {
    results {
      ...ResultsExcludingCategories
      ...ResultsCategories
    }
    ...Summary
  }
}
    ${ResultsExcludingCategoriesFragmentDoc}
${ResultsCategoriesFragmentDoc}
${SummaryFragmentDoc}`;

/**
 * __useScoresQuery__
 *
 * To run a query within a React component, call `useScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScoresQuery({
 *   variables: {
 *      aggregateOn: // value for 'aggregateOn'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScoresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScoresQuery, ScoresQueryVariables> & ({ variables: ScoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScoresQuery, ScoresQueryVariables>(ScoresDocument, options);
      }
export function useScoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScoresQuery, ScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScoresQuery, ScoresQueryVariables>(ScoresDocument, options);
        }
export function useScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScoresQuery, ScoresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScoresQuery, ScoresQueryVariables>(ScoresDocument, options);
        }
export type ScoresQueryHookResult = ReturnType<typeof useScoresQuery>;
export type ScoresLazyQueryHookResult = ReturnType<typeof useScoresLazyQuery>;
export type ScoresSuspenseQueryHookResult = ReturnType<typeof useScoresSuspenseQuery>;
export type ScoresQueryResult = ApolloReactCommon.QueryResult<ScoresQuery, ScoresQueryVariables>;
export function refetchScoresQuery(variables: ScoresQueryVariables) {
      return { query: ScoresDocument, variables: variables }
    }
export const PortalContextAssessmentsDocument = gql`
    query portalContextAssessments {
  portalContextAssessmentsMany(
    limit: 0
    sort: ORDER_ASC
    filter: {data: {active: true}}
  ) {
    code
    assessmentCode
    data {
      label {
        EN
        FR
      }
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextAssessmentsQuery__
 *
 * To run a query within a React component, call `usePortalContextAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextAssessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalContextAssessmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PortalContextAssessmentsQuery, PortalContextAssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextAssessmentsQuery, PortalContextAssessmentsQueryVariables>(PortalContextAssessmentsDocument, options);
      }
export function usePortalContextAssessmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextAssessmentsQuery, PortalContextAssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextAssessmentsQuery, PortalContextAssessmentsQueryVariables>(PortalContextAssessmentsDocument, options);
        }
export function usePortalContextAssessmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextAssessmentsQuery, PortalContextAssessmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextAssessmentsQuery, PortalContextAssessmentsQueryVariables>(PortalContextAssessmentsDocument, options);
        }
export type PortalContextAssessmentsQueryHookResult = ReturnType<typeof usePortalContextAssessmentsQuery>;
export type PortalContextAssessmentsLazyQueryHookResult = ReturnType<typeof usePortalContextAssessmentsLazyQuery>;
export type PortalContextAssessmentsSuspenseQueryHookResult = ReturnType<typeof usePortalContextAssessmentsSuspenseQuery>;
export type PortalContextAssessmentsQueryResult = ApolloReactCommon.QueryResult<PortalContextAssessmentsQuery, PortalContextAssessmentsQueryVariables>;
export function refetchPortalContextAssessmentsQuery(variables?: PortalContextAssessmentsQueryVariables) {
      return { query: PortalContextAssessmentsDocument, variables: variables }
    }
export const PortalContextCategoriesDocument = gql`
    query portalContextCategories($assessmentCode: String!) {
  portalContextCategoriesMany(
    limit: 0
    sort: ORDER_ASC
    filter: {assessmentCode: $assessmentCode}
  ) {
    code
    categoryCode
    assessmentCode
    order
    data {
      label {
        EN
        FR
      }
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextCategoriesQuery__
 *
 * To run a query within a React component, call `usePortalContextCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextCategoriesQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function usePortalContextCategoriesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextCategoriesQuery, PortalContextCategoriesQueryVariables> & ({ variables: PortalContextCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextCategoriesQuery, PortalContextCategoriesQueryVariables>(PortalContextCategoriesDocument, options);
      }
export function usePortalContextCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextCategoriesQuery, PortalContextCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextCategoriesQuery, PortalContextCategoriesQueryVariables>(PortalContextCategoriesDocument, options);
        }
export function usePortalContextCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextCategoriesQuery, PortalContextCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextCategoriesQuery, PortalContextCategoriesQueryVariables>(PortalContextCategoriesDocument, options);
        }
export type PortalContextCategoriesQueryHookResult = ReturnType<typeof usePortalContextCategoriesQuery>;
export type PortalContextCategoriesLazyQueryHookResult = ReturnType<typeof usePortalContextCategoriesLazyQuery>;
export type PortalContextCategoriesSuspenseQueryHookResult = ReturnType<typeof usePortalContextCategoriesSuspenseQuery>;
export type PortalContextCategoriesQueryResult = ApolloReactCommon.QueryResult<PortalContextCategoriesQuery, PortalContextCategoriesQueryVariables>;
export function refetchPortalContextCategoriesQuery(variables: PortalContextCategoriesQueryVariables) {
      return { query: PortalContextCategoriesDocument, variables: variables }
    }
export const PortalContextQuestionsDocument = gql`
    query portalContextQuestions($assessmentCode: String!, $languageCode: Enumportal_context_questionsLanguageCode!) {
  portalContextQuestionsMany(
    limit: 0
    sort: ORDER_ASC
    filter: {assessmentCode: $assessmentCode, languageCode: $languageCode}
  ) {
    code
    categoryCode
    questionCode
    order
    data {
      label
      isRequired
      rationale
      resources {
        title
        url
      }
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextQuestionsQuery__
 *
 * To run a query within a React component, call `usePortalContextQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextQuestionsQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function usePortalContextQuestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextQuestionsQuery, PortalContextQuestionsQueryVariables> & ({ variables: PortalContextQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextQuestionsQuery, PortalContextQuestionsQueryVariables>(PortalContextQuestionsDocument, options);
      }
export function usePortalContextQuestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextQuestionsQuery, PortalContextQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextQuestionsQuery, PortalContextQuestionsQueryVariables>(PortalContextQuestionsDocument, options);
        }
export function usePortalContextQuestionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextQuestionsQuery, PortalContextQuestionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextQuestionsQuery, PortalContextQuestionsQueryVariables>(PortalContextQuestionsDocument, options);
        }
export type PortalContextQuestionsQueryHookResult = ReturnType<typeof usePortalContextQuestionsQuery>;
export type PortalContextQuestionsLazyQueryHookResult = ReturnType<typeof usePortalContextQuestionsLazyQuery>;
export type PortalContextQuestionsSuspenseQueryHookResult = ReturnType<typeof usePortalContextQuestionsSuspenseQuery>;
export type PortalContextQuestionsQueryResult = ApolloReactCommon.QueryResult<PortalContextQuestionsQuery, PortalContextQuestionsQueryVariables>;
export function refetchPortalContextQuestionsQuery(variables: PortalContextQuestionsQueryVariables) {
      return { query: PortalContextQuestionsDocument, variables: variables }
    }
export const PortalContextUnitsDocument = gql`
    query portalContextUnits($assessmentCode: String!) {
  portalContextUnitsMany(
    limit: 0
    sort: UNITCODE_ASC
    filter: {assessmentCode: $assessmentCode}
  ) {
    code
    unitCode
    vendorCode
    firstDivisionCode
    secondDivisionCode
    data {
      label
      url
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextUnitsQuery__
 *
 * To run a query within a React component, call `usePortalContextUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextUnitsQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function usePortalContextUnitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextUnitsQuery, PortalContextUnitsQueryVariables> & ({ variables: PortalContextUnitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextUnitsQuery, PortalContextUnitsQueryVariables>(PortalContextUnitsDocument, options);
      }
export function usePortalContextUnitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextUnitsQuery, PortalContextUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextUnitsQuery, PortalContextUnitsQueryVariables>(PortalContextUnitsDocument, options);
        }
export function usePortalContextUnitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextUnitsQuery, PortalContextUnitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextUnitsQuery, PortalContextUnitsQueryVariables>(PortalContextUnitsDocument, options);
        }
export type PortalContextUnitsQueryHookResult = ReturnType<typeof usePortalContextUnitsQuery>;
export type PortalContextUnitsLazyQueryHookResult = ReturnType<typeof usePortalContextUnitsLazyQuery>;
export type PortalContextUnitsSuspenseQueryHookResult = ReturnType<typeof usePortalContextUnitsSuspenseQuery>;
export type PortalContextUnitsQueryResult = ApolloReactCommon.QueryResult<PortalContextUnitsQuery, PortalContextUnitsQueryVariables>;
export function refetchPortalContextUnitsQuery(variables: PortalContextUnitsQueryVariables) {
      return { query: PortalContextUnitsDocument, variables: variables }
    }
export const PortalContextVendorsDocument = gql`
    query portalContextVendors($assessmentCode: String!) {
  portalContextVendorsMany(
    limit: 0
    sort: VENDORCODE_ASC
    filter: {assessmentCode: $assessmentCode}
  ) {
    code
    assessmentCode
    vendorCode
    data {
      label
      vendorStatus
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextVendorsQuery__
 *
 * To run a query within a React component, call `usePortalContextVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextVendorsQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function usePortalContextVendorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextVendorsQuery, PortalContextVendorsQueryVariables> & ({ variables: PortalContextVendorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextVendorsQuery, PortalContextVendorsQueryVariables>(PortalContextVendorsDocument, options);
      }
export function usePortalContextVendorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextVendorsQuery, PortalContextVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextVendorsQuery, PortalContextVendorsQueryVariables>(PortalContextVendorsDocument, options);
        }
export function usePortalContextVendorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextVendorsQuery, PortalContextVendorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextVendorsQuery, PortalContextVendorsQueryVariables>(PortalContextVendorsDocument, options);
        }
export type PortalContextVendorsQueryHookResult = ReturnType<typeof usePortalContextVendorsQuery>;
export type PortalContextVendorsLazyQueryHookResult = ReturnType<typeof usePortalContextVendorsLazyQuery>;
export type PortalContextVendorsSuspenseQueryHookResult = ReturnType<typeof usePortalContextVendorsSuspenseQuery>;
export type PortalContextVendorsQueryResult = ApolloReactCommon.QueryResult<PortalContextVendorsQuery, PortalContextVendorsQueryVariables>;
export function refetchPortalContextVendorsQuery(variables: PortalContextVendorsQueryVariables) {
      return { query: PortalContextVendorsDocument, variables: variables }
    }
export const PortalContextFirstDivisionsDocument = gql`
    query portalContextFirstDivisions($assessmentCode: String!) {
  portalContextFirstDivisionsMany(
    limit: 0
    sort: FIRSTDIVISIONCODE_ASC
    filter: {assessmentCode: $assessmentCode}
  ) {
    code
    assessmentCode
    firstDivisionCode
    data {
      label
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextFirstDivisionsQuery__
 *
 * To run a query within a React component, call `usePortalContextFirstDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextFirstDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextFirstDivisionsQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function usePortalContextFirstDivisionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextFirstDivisionsQuery, PortalContextFirstDivisionsQueryVariables> & ({ variables: PortalContextFirstDivisionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextFirstDivisionsQuery, PortalContextFirstDivisionsQueryVariables>(PortalContextFirstDivisionsDocument, options);
      }
export function usePortalContextFirstDivisionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextFirstDivisionsQuery, PortalContextFirstDivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextFirstDivisionsQuery, PortalContextFirstDivisionsQueryVariables>(PortalContextFirstDivisionsDocument, options);
        }
export function usePortalContextFirstDivisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextFirstDivisionsQuery, PortalContextFirstDivisionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextFirstDivisionsQuery, PortalContextFirstDivisionsQueryVariables>(PortalContextFirstDivisionsDocument, options);
        }
export type PortalContextFirstDivisionsQueryHookResult = ReturnType<typeof usePortalContextFirstDivisionsQuery>;
export type PortalContextFirstDivisionsLazyQueryHookResult = ReturnType<typeof usePortalContextFirstDivisionsLazyQuery>;
export type PortalContextFirstDivisionsSuspenseQueryHookResult = ReturnType<typeof usePortalContextFirstDivisionsSuspenseQuery>;
export type PortalContextFirstDivisionsQueryResult = ApolloReactCommon.QueryResult<PortalContextFirstDivisionsQuery, PortalContextFirstDivisionsQueryVariables>;
export function refetchPortalContextFirstDivisionsQuery(variables: PortalContextFirstDivisionsQueryVariables) {
      return { query: PortalContextFirstDivisionsDocument, variables: variables }
    }
export const PortalContextSecondDivisionsDocument = gql`
    query portalContextSecondDivisions($assessmentCode: String!) {
  portalContextSecondDivisionsMany(
    limit: 0
    sort: SECONDDIVISIONCODE_ASC
    filter: {assessmentCode: $assessmentCode}
  ) {
    code
    assessmentCode
    firstDivisionCode
    secondDivisionCode
    data {
      label
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextSecondDivisionsQuery__
 *
 * To run a query within a React component, call `usePortalContextSecondDivisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextSecondDivisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextSecondDivisionsQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function usePortalContextSecondDivisionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextSecondDivisionsQuery, PortalContextSecondDivisionsQueryVariables> & ({ variables: PortalContextSecondDivisionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextSecondDivisionsQuery, PortalContextSecondDivisionsQueryVariables>(PortalContextSecondDivisionsDocument, options);
      }
export function usePortalContextSecondDivisionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextSecondDivisionsQuery, PortalContextSecondDivisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextSecondDivisionsQuery, PortalContextSecondDivisionsQueryVariables>(PortalContextSecondDivisionsDocument, options);
        }
export function usePortalContextSecondDivisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextSecondDivisionsQuery, PortalContextSecondDivisionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextSecondDivisionsQuery, PortalContextSecondDivisionsQueryVariables>(PortalContextSecondDivisionsDocument, options);
        }
export type PortalContextSecondDivisionsQueryHookResult = ReturnType<typeof usePortalContextSecondDivisionsQuery>;
export type PortalContextSecondDivisionsLazyQueryHookResult = ReturnType<typeof usePortalContextSecondDivisionsLazyQuery>;
export type PortalContextSecondDivisionsSuspenseQueryHookResult = ReturnType<typeof usePortalContextSecondDivisionsSuspenseQuery>;
export type PortalContextSecondDivisionsQueryResult = ApolloReactCommon.QueryResult<PortalContextSecondDivisionsQuery, PortalContextSecondDivisionsQueryVariables>;
export function refetchPortalContextSecondDivisionsQuery(variables: PortalContextSecondDivisionsQueryVariables) {
      return { query: PortalContextSecondDivisionsDocument, variables: variables }
    }
export const PortalContextTagsDocument = gql`
    query portalContextTags($assessmentCode: String!) {
  portalContextTagsMany(
    limit: 0
    sort: TAGCODE_ASC
    filter: {assessmentCode: $assessmentCode}
  ) {
    code
    tagCode
    assessmentCode
    data {
      label {
        EN
        FR
      }
    }
    comp {
      code
    }
  }
}
    `;

/**
 * __usePortalContextTagsQuery__
 *
 * To run a query within a React component, call `usePortalContextTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextTagsQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function usePortalContextTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextTagsQuery, PortalContextTagsQueryVariables> & ({ variables: PortalContextTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextTagsQuery, PortalContextTagsQueryVariables>(PortalContextTagsDocument, options);
      }
export function usePortalContextTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextTagsQuery, PortalContextTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextTagsQuery, PortalContextTagsQueryVariables>(PortalContextTagsDocument, options);
        }
export function usePortalContextTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextTagsQuery, PortalContextTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextTagsQuery, PortalContextTagsQueryVariables>(PortalContextTagsDocument, options);
        }
export type PortalContextTagsQueryHookResult = ReturnType<typeof usePortalContextTagsQuery>;
export type PortalContextTagsLazyQueryHookResult = ReturnType<typeof usePortalContextTagsLazyQuery>;
export type PortalContextTagsSuspenseQueryHookResult = ReturnType<typeof usePortalContextTagsSuspenseQuery>;
export type PortalContextTagsQueryResult = ApolloReactCommon.QueryResult<PortalContextTagsQuery, PortalContextTagsQueryVariables>;
export function refetchPortalContextTagsQuery(variables: PortalContextTagsQueryVariables) {
      return { query: PortalContextTagsDocument, variables: variables }
    }
export const PortalContextResponsesDocument = gql`
    query portalContextResponses($assessmentCode: String!, $categoryCode: String, $vendorCode: String, $unitCode: String, $firstDivisionCode: String, $secondDivisionCode: String, $questionCode: String, $tags: [String!]) {
  portalContextResponsesMany(
    limit: 0
    filter: {assessmentCode: $assessmentCode, categoryCode: $categoryCode, vendorCode: $vendorCode, unitCode: $unitCode, firstDivisionCode: $firstDivisionCode, secondDivisionCode: $secondDivisionCode, questionCode: $questionCode, tags: $tags}
  ) {
    unitCode
    vendorCode
    firstDivisionCode
    secondDivisionCode
    questionCode
    categoryCode
    data {
      answer
    }
  }
}
    `;

/**
 * __usePortalContextResponsesQuery__
 *
 * To run a query within a React component, call `usePortalContextResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalContextResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalContextResponsesQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      categoryCode: // value for 'categoryCode'
 *      vendorCode: // value for 'vendorCode'
 *      unitCode: // value for 'unitCode'
 *      firstDivisionCode: // value for 'firstDivisionCode'
 *      secondDivisionCode: // value for 'secondDivisionCode'
 *      questionCode: // value for 'questionCode'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function usePortalContextResponsesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PortalContextResponsesQuery, PortalContextResponsesQueryVariables> & ({ variables: PortalContextResponsesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PortalContextResponsesQuery, PortalContextResponsesQueryVariables>(PortalContextResponsesDocument, options);
      }
export function usePortalContextResponsesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PortalContextResponsesQuery, PortalContextResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PortalContextResponsesQuery, PortalContextResponsesQueryVariables>(PortalContextResponsesDocument, options);
        }
export function usePortalContextResponsesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PortalContextResponsesQuery, PortalContextResponsesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PortalContextResponsesQuery, PortalContextResponsesQueryVariables>(PortalContextResponsesDocument, options);
        }
export type PortalContextResponsesQueryHookResult = ReturnType<typeof usePortalContextResponsesQuery>;
export type PortalContextResponsesLazyQueryHookResult = ReturnType<typeof usePortalContextResponsesLazyQuery>;
export type PortalContextResponsesSuspenseQueryHookResult = ReturnType<typeof usePortalContextResponsesSuspenseQuery>;
export type PortalContextResponsesQueryResult = ApolloReactCommon.QueryResult<PortalContextResponsesQuery, PortalContextResponsesQueryVariables>;
export function refetchPortalContextResponsesQuery(variables: PortalContextResponsesQueryVariables) {
      return { query: PortalContextResponsesDocument, variables: variables }
    }
export const NewVendorDashboardDocument = gql`
    query newVendorDashboard($assessmentCode: String!, $sortBy: String!, $sortOrder: String!, $pageSize: Int!, $pageNum: Int!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    groupBy: "VENDOR_NAME"
    filterRole: false
    sortBy: $sortBy
    sortOrder: $sortOrder
    pageSize: $pageSize
    pageNum: $pageNum
  ) {
    edges {
      group_id
      units_in_group
      percent_in_group
      final_score
      preferred_vendor
    }
    meta {
      pages
    }
  }
}
    `;

/**
 * __useNewVendorDashboardQuery__
 *
 * To run a query within a React component, call `useNewVendorDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewVendorDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewVendorDashboardQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      sortBy: // value for 'sortBy'
 *      sortOrder: // value for 'sortOrder'
 *      pageSize: // value for 'pageSize'
 *      pageNum: // value for 'pageNum'
 *   },
 * });
 */
export function useNewVendorDashboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NewVendorDashboardQuery, NewVendorDashboardQueryVariables> & ({ variables: NewVendorDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewVendorDashboardQuery, NewVendorDashboardQueryVariables>(NewVendorDashboardDocument, options);
      }
export function useNewVendorDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewVendorDashboardQuery, NewVendorDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewVendorDashboardQuery, NewVendorDashboardQueryVariables>(NewVendorDashboardDocument, options);
        }
export function useNewVendorDashboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewVendorDashboardQuery, NewVendorDashboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewVendorDashboardQuery, NewVendorDashboardQueryVariables>(NewVendorDashboardDocument, options);
        }
export type NewVendorDashboardQueryHookResult = ReturnType<typeof useNewVendorDashboardQuery>;
export type NewVendorDashboardLazyQueryHookResult = ReturnType<typeof useNewVendorDashboardLazyQuery>;
export type NewVendorDashboardSuspenseQueryHookResult = ReturnType<typeof useNewVendorDashboardSuspenseQuery>;
export type NewVendorDashboardQueryResult = ApolloReactCommon.QueryResult<NewVendorDashboardQuery, NewVendorDashboardQueryVariables>;
export function refetchNewVendorDashboardQuery(variables: NewVendorDashboardQueryVariables) {
      return { query: NewVendorDashboardDocument, variables: variables }
    }
export const VendorComparisonDocument = gql`
    query vendorComparison($assessmentCode: String!) {
  preferredVendorComparison(assessmentCode: $assessmentCode) {
    preferredAvgScore
    nonPreferredAvgScore
    preferredMarketShare
    nonPreferredMarketShare
  }
}
    `;

/**
 * __useVendorComparisonQuery__
 *
 * To run a query within a React component, call `useVendorComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorComparisonQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useVendorComparisonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VendorComparisonQuery, VendorComparisonQueryVariables> & ({ variables: VendorComparisonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VendorComparisonQuery, VendorComparisonQueryVariables>(VendorComparisonDocument, options);
      }
export function useVendorComparisonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorComparisonQuery, VendorComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VendorComparisonQuery, VendorComparisonQueryVariables>(VendorComparisonDocument, options);
        }
export function useVendorComparisonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VendorComparisonQuery, VendorComparisonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VendorComparisonQuery, VendorComparisonQueryVariables>(VendorComparisonDocument, options);
        }
export type VendorComparisonQueryHookResult = ReturnType<typeof useVendorComparisonQuery>;
export type VendorComparisonLazyQueryHookResult = ReturnType<typeof useVendorComparisonLazyQuery>;
export type VendorComparisonSuspenseQueryHookResult = ReturnType<typeof useVendorComparisonSuspenseQuery>;
export type VendorComparisonQueryResult = ApolloReactCommon.QueryResult<VendorComparisonQuery, VendorComparisonQueryVariables>;
export function refetchVendorComparisonQuery(variables: VendorComparisonQueryVariables) {
      return { query: VendorComparisonDocument, variables: variables }
    }
export const SelectedAssessmentDocument = gql`
    query selectedAssessment($assessmentCode: String!, $unitCode: String!) {
  unitsMany(filter: {code: $unitCode}) {
    vendor_name
  }
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    groupBy: "UNIT_CODE"
    filterBy: "UNIT_CODE"
    filterText: $unitCode
    filterRole: true
  ) {
    edges {
      preferred_vendor
      total_score
      max_score
      final_score
      review_details {
        region_code
        region_label
        district_code
        district_label
      }
      category_scores {
        category_code
        category_label
        category_label_fr
        total_score
        max_score
      }
      best_category {
        category_code
        category_label
        category_label_fr
        total_score
        max_score
      }
      improvement_category {
        category_code
        category_label
        category_label_fr
        total_score
        max_score
      }
    }
  }
}
    `;

/**
 * __useSelectedAssessmentQuery__
 *
 * To run a query within a React component, call `useSelectedAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedAssessmentQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      unitCode: // value for 'unitCode'
 *   },
 * });
 */
export function useSelectedAssessmentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectedAssessmentQuery, SelectedAssessmentQueryVariables> & ({ variables: SelectedAssessmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectedAssessmentQuery, SelectedAssessmentQueryVariables>(SelectedAssessmentDocument, options);
      }
export function useSelectedAssessmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedAssessmentQuery, SelectedAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectedAssessmentQuery, SelectedAssessmentQueryVariables>(SelectedAssessmentDocument, options);
        }
export function useSelectedAssessmentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedAssessmentQuery, SelectedAssessmentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectedAssessmentQuery, SelectedAssessmentQueryVariables>(SelectedAssessmentDocument, options);
        }
export type SelectedAssessmentQueryHookResult = ReturnType<typeof useSelectedAssessmentQuery>;
export type SelectedAssessmentLazyQueryHookResult = ReturnType<typeof useSelectedAssessmentLazyQuery>;
export type SelectedAssessmentSuspenseQueryHookResult = ReturnType<typeof useSelectedAssessmentSuspenseQuery>;
export type SelectedAssessmentQueryResult = ApolloReactCommon.QueryResult<SelectedAssessmentQuery, SelectedAssessmentQueryVariables>;
export function refetchSelectedAssessmentQuery(variables: SelectedAssessmentQueryVariables) {
      return { query: SelectedAssessmentDocument, variables: variables }
    }
export const SelectedAssessmentGroupDocument = gql`
    query selectedAssessmentGroup($assessmentCode: String!, $groupBy: String!, $filterBy: String!, $filterText: String!) {
  assessmentSummaryManyGroup(
    assessmentCode: $assessmentCode
    groupBy: $groupBy
    filterBy: $filterBy
    filterText: $filterText
    filterRole: false
  ) {
    edges {
      group_id
      total_score
      max_score
      final_score
      category_scores {
        category_code
        category_label
        category_label_fr
        total_score
        max_score
        final_score
      }
      units_in_rank {
        score_90_and_above
        score_80_to_89
        score_70_to_79
        score_60_to_69
        score_59_and_below
      }
    }
  }
}
    `;

/**
 * __useSelectedAssessmentGroupQuery__
 *
 * To run a query within a React component, call `useSelectedAssessmentGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedAssessmentGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedAssessmentGroupQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      groupBy: // value for 'groupBy'
 *      filterBy: // value for 'filterBy'
 *      filterText: // value for 'filterText'
 *   },
 * });
 */
export function useSelectedAssessmentGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectedAssessmentGroupQuery, SelectedAssessmentGroupQueryVariables> & ({ variables: SelectedAssessmentGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectedAssessmentGroupQuery, SelectedAssessmentGroupQueryVariables>(SelectedAssessmentGroupDocument, options);
      }
export function useSelectedAssessmentGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedAssessmentGroupQuery, SelectedAssessmentGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectedAssessmentGroupQuery, SelectedAssessmentGroupQueryVariables>(SelectedAssessmentGroupDocument, options);
        }
export function useSelectedAssessmentGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedAssessmentGroupQuery, SelectedAssessmentGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectedAssessmentGroupQuery, SelectedAssessmentGroupQueryVariables>(SelectedAssessmentGroupDocument, options);
        }
export type SelectedAssessmentGroupQueryHookResult = ReturnType<typeof useSelectedAssessmentGroupQuery>;
export type SelectedAssessmentGroupLazyQueryHookResult = ReturnType<typeof useSelectedAssessmentGroupLazyQuery>;
export type SelectedAssessmentGroupSuspenseQueryHookResult = ReturnType<typeof useSelectedAssessmentGroupSuspenseQuery>;
export type SelectedAssessmentGroupQueryResult = ApolloReactCommon.QueryResult<SelectedAssessmentGroupQuery, SelectedAssessmentGroupQueryVariables>;
export function refetchSelectedAssessmentGroupQuery(variables: SelectedAssessmentGroupQueryVariables) {
      return { query: SelectedAssessmentGroupDocument, variables: variables }
    }
export const UnitVendorCodeDocument = gql`
    query unitVendorCode($unitCode: String!, $assessmentCode: String!) {
  unitsMany(filter: {code: $unitCode}) {
    code
    vendor_name
    vendor(assessmentCode: $assessmentCode) {
      displayName
    }
  }
}
    `;

/**
 * __useUnitVendorCodeQuery__
 *
 * To run a query within a React component, call `useUnitVendorCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnitVendorCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnitVendorCodeQuery({
 *   variables: {
 *      unitCode: // value for 'unitCode'
 *      assessmentCode: // value for 'assessmentCode'
 *   },
 * });
 */
export function useUnitVendorCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnitVendorCodeQuery, UnitVendorCodeQueryVariables> & ({ variables: UnitVendorCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnitVendorCodeQuery, UnitVendorCodeQueryVariables>(UnitVendorCodeDocument, options);
      }
export function useUnitVendorCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnitVendorCodeQuery, UnitVendorCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnitVendorCodeQuery, UnitVendorCodeQueryVariables>(UnitVendorCodeDocument, options);
        }
export function useUnitVendorCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UnitVendorCodeQuery, UnitVendorCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UnitVendorCodeQuery, UnitVendorCodeQueryVariables>(UnitVendorCodeDocument, options);
        }
export type UnitVendorCodeQueryHookResult = ReturnType<typeof useUnitVendorCodeQuery>;
export type UnitVendorCodeLazyQueryHookResult = ReturnType<typeof useUnitVendorCodeLazyQuery>;
export type UnitVendorCodeSuspenseQueryHookResult = ReturnType<typeof useUnitVendorCodeSuspenseQuery>;
export type UnitVendorCodeQueryResult = ApolloReactCommon.QueryResult<UnitVendorCodeQuery, UnitVendorCodeQueryVariables>;
export function refetchUnitVendorCodeQuery(variables: UnitVendorCodeQueryVariables) {
      return { query: UnitVendorCodeDocument, variables: variables }
    }
export const PerformanceReportDocument = gql`
    query performanceReport($assessmentCode: String!, $unitCode: String!) {
  assessmentSummariesGroup(
    assessmentCode: $assessmentCode
    groupBy: UNIT_CODE
    filterBy: UNIT_CODE
    filterText: $unitCode
  ) {
    edges {
      review_details {
        unit_name
        url
      }
      review_category_responses {
        code
        label
        label_fr
        order
        review(unitCode: $unitCode, assessmentCode: $assessmentCode) {
          period_label
          answers {
            name
            answer
            comments
            comments_fr
            screenshots
            question(assessmentCode: $assessmentCode) {
              name
              label
              number
              label_french
              required
              layout
              resources {
                url
                title
              }
              resources_french {
                url
                title
              }
              rationale_EN
              rationale_FR
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePerformanceReportQuery__
 *
 * To run a query within a React component, call `usePerformanceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePerformanceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePerformanceReportQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      unitCode: // value for 'unitCode'
 *   },
 * });
 */
export function usePerformanceReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PerformanceReportQuery, PerformanceReportQueryVariables> & ({ variables: PerformanceReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PerformanceReportQuery, PerformanceReportQueryVariables>(PerformanceReportDocument, options);
      }
export function usePerformanceReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PerformanceReportQuery, PerformanceReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PerformanceReportQuery, PerformanceReportQueryVariables>(PerformanceReportDocument, options);
        }
export function usePerformanceReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PerformanceReportQuery, PerformanceReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PerformanceReportQuery, PerformanceReportQueryVariables>(PerformanceReportDocument, options);
        }
export type PerformanceReportQueryHookResult = ReturnType<typeof usePerformanceReportQuery>;
export type PerformanceReportLazyQueryHookResult = ReturnType<typeof usePerformanceReportLazyQuery>;
export type PerformanceReportSuspenseQueryHookResult = ReturnType<typeof usePerformanceReportSuspenseQuery>;
export type PerformanceReportQueryResult = ApolloReactCommon.QueryResult<PerformanceReportQuery, PerformanceReportQueryVariables>;
export function refetchPerformanceReportQuery(variables: PerformanceReportQueryVariables) {
      return { query: PerformanceReportDocument, variables: variables }
    }
export const SeenNotificationsDocument = gql`
    query seenNotifications {
  seenNotifications {
    notification_id
  }
}
    `;

/**
 * __useSeenNotificationsQuery__
 *
 * To run a query within a React component, call `useSeenNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeenNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeenNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSeenNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SeenNotificationsQuery, SeenNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SeenNotificationsQuery, SeenNotificationsQueryVariables>(SeenNotificationsDocument, options);
      }
export function useSeenNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SeenNotificationsQuery, SeenNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SeenNotificationsQuery, SeenNotificationsQueryVariables>(SeenNotificationsDocument, options);
        }
export function useSeenNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SeenNotificationsQuery, SeenNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SeenNotificationsQuery, SeenNotificationsQueryVariables>(SeenNotificationsDocument, options);
        }
export type SeenNotificationsQueryHookResult = ReturnType<typeof useSeenNotificationsQuery>;
export type SeenNotificationsLazyQueryHookResult = ReturnType<typeof useSeenNotificationsLazyQuery>;
export type SeenNotificationsSuspenseQueryHookResult = ReturnType<typeof useSeenNotificationsSuspenseQuery>;
export type SeenNotificationsQueryResult = ApolloReactCommon.QueryResult<SeenNotificationsQuery, SeenNotificationsQueryVariables>;
export function refetchSeenNotificationsQuery(variables?: SeenNotificationsQueryVariables) {
      return { query: SeenNotificationsDocument, variables: variables }
    }
export const MarkAllAsReadDocument = gql`
    mutation markAllAsRead($ids: [String!]) {
  markAllAsRead(ids: $ids)
}
    `;
export type MarkAllAsReadMutationFn = ApolloReactCommon.MutationFunction<MarkAllAsReadMutation, MarkAllAsReadMutationVariables>;

/**
 * __useMarkAllAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsReadMutation, { data, loading, error }] = useMarkAllAsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMarkAllAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAllAsReadMutation, MarkAllAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAllAsReadMutation, MarkAllAsReadMutationVariables>(MarkAllAsReadDocument, options);
      }
export type MarkAllAsReadMutationHookResult = ReturnType<typeof useMarkAllAsReadMutation>;
export type MarkAllAsReadMutationResult = ApolloReactCommon.MutationResult<MarkAllAsReadMutation>;
export type MarkAllAsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkAllAsReadMutation, MarkAllAsReadMutationVariables>;
export const MarkAllAsUnreadDocument = gql`
    mutation markAllAsUnread {
  markAllAsUnread
}
    `;
export type MarkAllAsUnreadMutationFn = ApolloReactCommon.MutationFunction<MarkAllAsUnreadMutation, MarkAllAsUnreadMutationVariables>;

/**
 * __useMarkAllAsUnreadMutation__
 *
 * To run a mutation, you first call `useMarkAllAsUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllAsUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllAsUnreadMutation, { data, loading, error }] = useMarkAllAsUnreadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllAsUnreadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAllAsUnreadMutation, MarkAllAsUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAllAsUnreadMutation, MarkAllAsUnreadMutationVariables>(MarkAllAsUnreadDocument, options);
      }
export type MarkAllAsUnreadMutationHookResult = ReturnType<typeof useMarkAllAsUnreadMutation>;
export type MarkAllAsUnreadMutationResult = ApolloReactCommon.MutationResult<MarkAllAsUnreadMutation>;
export type MarkAllAsUnreadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkAllAsUnreadMutation, MarkAllAsUnreadMutationVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($lang: EnumContent_NotificationsLanguage) {
  contentNotificationMany(filter: {language: $lang, enabled: true}) {
    _id
    enabled
    categories {
      code
      label
    }
    post_date
    key
    description
    language
    button_label
    button_link
    legacy_id
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = ApolloReactCommon.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function refetchGetNotificationsQuery(variables?: GetNotificationsQueryVariables) {
      return { query: GetNotificationsDocument, variables: variables }
    }
export const GetWebinarDetailsDocument = gql`
    query getWebinarDetails($postId: String!, $lang: EnumContent_WebinarsLanguage) {
  contentWebinarMany(
    filter: {OR: [{legacy_id: $postId}, {key: $postId, language: $lang}]}
  ) {
    __typename
    _id
    title
    description
    key
    path
    alternate_path
    presenter
    post_date
    start_time
    body
    video {
      src
      caption
      thumbnail {
        src
        alt
      }
    }
    video_link
    preview_image {
      src
      alt
    }
    legacy_id
  }
}
    `;

/**
 * __useGetWebinarDetailsQuery__
 *
 * To run a query within a React component, call `useGetWebinarDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebinarDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebinarDetailsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetWebinarDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWebinarDetailsQuery, GetWebinarDetailsQueryVariables> & ({ variables: GetWebinarDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWebinarDetailsQuery, GetWebinarDetailsQueryVariables>(GetWebinarDetailsDocument, options);
      }
export function useGetWebinarDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWebinarDetailsQuery, GetWebinarDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWebinarDetailsQuery, GetWebinarDetailsQueryVariables>(GetWebinarDetailsDocument, options);
        }
export function useGetWebinarDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWebinarDetailsQuery, GetWebinarDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWebinarDetailsQuery, GetWebinarDetailsQueryVariables>(GetWebinarDetailsDocument, options);
        }
export type GetWebinarDetailsQueryHookResult = ReturnType<typeof useGetWebinarDetailsQuery>;
export type GetWebinarDetailsLazyQueryHookResult = ReturnType<typeof useGetWebinarDetailsLazyQuery>;
export type GetWebinarDetailsSuspenseQueryHookResult = ReturnType<typeof useGetWebinarDetailsSuspenseQuery>;
export type GetWebinarDetailsQueryResult = ApolloReactCommon.QueryResult<GetWebinarDetailsQuery, GetWebinarDetailsQueryVariables>;
export function refetchGetWebinarDetailsQuery(variables: GetWebinarDetailsQueryVariables) {
      return { query: GetWebinarDetailsDocument, variables: variables }
    }
export const GetProgramUpdateDetailsDocument = gql`
    query getProgramUpdateDetails($postId: String!, $lang: EnumContent_Program_UpdatesLanguage) {
  contentProgramUpdateMany(
    filter: {OR: [{legacy_id: $postId}, {key: $postId, language: $lang}]}
  ) {
    __typename
    _id
    title
    description
    new
    important
    body
    key
    path
    alternate_path
    preview_image {
      src
      alt
    }
    enabled
    language
    legacy_id
    hero_image {
      src
      alt
    }
    post_date
    created_date
    modified_date
  }
}
    `;

/**
 * __useGetProgramUpdateDetailsQuery__
 *
 * To run a query within a React component, call `useGetProgramUpdateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramUpdateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramUpdateDetailsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetProgramUpdateDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProgramUpdateDetailsQuery, GetProgramUpdateDetailsQueryVariables> & ({ variables: GetProgramUpdateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProgramUpdateDetailsQuery, GetProgramUpdateDetailsQueryVariables>(GetProgramUpdateDetailsDocument, options);
      }
export function useGetProgramUpdateDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgramUpdateDetailsQuery, GetProgramUpdateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProgramUpdateDetailsQuery, GetProgramUpdateDetailsQueryVariables>(GetProgramUpdateDetailsDocument, options);
        }
export function useGetProgramUpdateDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProgramUpdateDetailsQuery, GetProgramUpdateDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProgramUpdateDetailsQuery, GetProgramUpdateDetailsQueryVariables>(GetProgramUpdateDetailsDocument, options);
        }
export type GetProgramUpdateDetailsQueryHookResult = ReturnType<typeof useGetProgramUpdateDetailsQuery>;
export type GetProgramUpdateDetailsLazyQueryHookResult = ReturnType<typeof useGetProgramUpdateDetailsLazyQuery>;
export type GetProgramUpdateDetailsSuspenseQueryHookResult = ReturnType<typeof useGetProgramUpdateDetailsSuspenseQuery>;
export type GetProgramUpdateDetailsQueryResult = ApolloReactCommon.QueryResult<GetProgramUpdateDetailsQuery, GetProgramUpdateDetailsQueryVariables>;
export function refetchGetProgramUpdateDetailsQuery(variables: GetProgramUpdateDetailsQueryVariables) {
      return { query: GetProgramUpdateDetailsDocument, variables: variables }
    }
export const GetBusinessInsightDetailsDocument = gql`
    query getBusinessInsightDetails($postId: String!, $lang: EnumContent_Business_InsightsLanguage) {
  contentBusinessInsightMany(
    filter: {OR: [{legacy_id: $postId}, {key: $postId, language: $lang}]}
  ) {
    __typename
    _id
    title
    description
    new
    body
    key
    path
    alternate_path
    preview_image {
      src
      alt
    }
    enabled
    language
    legacy_id
    hero_image {
      src
      alt
    }
    post_date
    created_date
    modified_date
  }
}
    `;

/**
 * __useGetBusinessInsightDetailsQuery__
 *
 * To run a query within a React component, call `useGetBusinessInsightDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessInsightDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessInsightDetailsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetBusinessInsightDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBusinessInsightDetailsQuery, GetBusinessInsightDetailsQueryVariables> & ({ variables: GetBusinessInsightDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBusinessInsightDetailsQuery, GetBusinessInsightDetailsQueryVariables>(GetBusinessInsightDetailsDocument, options);
      }
export function useGetBusinessInsightDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBusinessInsightDetailsQuery, GetBusinessInsightDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBusinessInsightDetailsQuery, GetBusinessInsightDetailsQueryVariables>(GetBusinessInsightDetailsDocument, options);
        }
export function useGetBusinessInsightDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBusinessInsightDetailsQuery, GetBusinessInsightDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBusinessInsightDetailsQuery, GetBusinessInsightDetailsQueryVariables>(GetBusinessInsightDetailsDocument, options);
        }
export type GetBusinessInsightDetailsQueryHookResult = ReturnType<typeof useGetBusinessInsightDetailsQuery>;
export type GetBusinessInsightDetailsLazyQueryHookResult = ReturnType<typeof useGetBusinessInsightDetailsLazyQuery>;
export type GetBusinessInsightDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBusinessInsightDetailsSuspenseQuery>;
export type GetBusinessInsightDetailsQueryResult = ApolloReactCommon.QueryResult<GetBusinessInsightDetailsQuery, GetBusinessInsightDetailsQueryVariables>;
export function refetchGetBusinessInsightDetailsQuery(variables: GetBusinessInsightDetailsQueryVariables) {
      return { query: GetBusinessInsightDetailsDocument, variables: variables }
    }
export const TopByVendorDocument = gql`
    query topByVendor($assessmentCode: String!, $vendorName: String!) {
  assessmentSummaryTopByVendor(
    assessmentCode: $assessmentCode
    vendorName: $vendorName
  ) {
    final_score
  }
}
    `;

/**
 * __useTopByVendorQuery__
 *
 * To run a query within a React component, call `useTopByVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopByVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopByVendorQuery({
 *   variables: {
 *      assessmentCode: // value for 'assessmentCode'
 *      vendorName: // value for 'vendorName'
 *   },
 * });
 */
export function useTopByVendorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopByVendorQuery, TopByVendorQueryVariables> & ({ variables: TopByVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TopByVendorQuery, TopByVendorQueryVariables>(TopByVendorDocument, options);
      }
export function useTopByVendorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopByVendorQuery, TopByVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TopByVendorQuery, TopByVendorQueryVariables>(TopByVendorDocument, options);
        }
export function useTopByVendorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TopByVendorQuery, TopByVendorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TopByVendorQuery, TopByVendorQueryVariables>(TopByVendorDocument, options);
        }
export type TopByVendorQueryHookResult = ReturnType<typeof useTopByVendorQuery>;
export type TopByVendorLazyQueryHookResult = ReturnType<typeof useTopByVendorLazyQuery>;
export type TopByVendorSuspenseQueryHookResult = ReturnType<typeof useTopByVendorSuspenseQuery>;
export type TopByVendorQueryResult = ApolloReactCommon.QueryResult<TopByVendorQuery, TopByVendorQueryVariables>;
export function refetchTopByVendorQuery(variables: TopByVendorQueryVariables) {
      return { query: TopByVendorDocument, variables: variables }
    }
export const GetPreferredVendorsDocument = gql`
    query getPreferredVendors($lang: EnumContent_VendorLanguage!) {
  contentVendorMany(filter: {language: $lang}) {
    _id
    code
    title
    language
    website
    websiteMMSC
    websiteHACC
    email
    emailMMSC
    emailHACC
    description
    service_area
    location
    languages
    years_of_operation
    number_of_employees
    minimum_price
    maximum_price
    minimum_contract
    cancellation_notice
    dedicated_support_team
    services {
      code
      label
    }
    value_added_services {
      code
      label
    }
    created_by
    created_date
    modified_by
    modified_date
    preferred {
      HACC
      MMSC
      DEMO
    }
  }
}
    `;

/**
 * __useGetPreferredVendorsQuery__
 *
 * To run a query within a React component, call `useGetPreferredVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredVendorsQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetPreferredVendorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPreferredVendorsQuery, GetPreferredVendorsQueryVariables> & ({ variables: GetPreferredVendorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPreferredVendorsQuery, GetPreferredVendorsQueryVariables>(GetPreferredVendorsDocument, options);
      }
export function useGetPreferredVendorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPreferredVendorsQuery, GetPreferredVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPreferredVendorsQuery, GetPreferredVendorsQueryVariables>(GetPreferredVendorsDocument, options);
        }
export function useGetPreferredVendorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPreferredVendorsQuery, GetPreferredVendorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPreferredVendorsQuery, GetPreferredVendorsQueryVariables>(GetPreferredVendorsDocument, options);
        }
export type GetPreferredVendorsQueryHookResult = ReturnType<typeof useGetPreferredVendorsQuery>;
export type GetPreferredVendorsLazyQueryHookResult = ReturnType<typeof useGetPreferredVendorsLazyQuery>;
export type GetPreferredVendorsSuspenseQueryHookResult = ReturnType<typeof useGetPreferredVendorsSuspenseQuery>;
export type GetPreferredVendorsQueryResult = ApolloReactCommon.QueryResult<GetPreferredVendorsQuery, GetPreferredVendorsQueryVariables>;
export function refetchGetPreferredVendorsQuery(variables: GetPreferredVendorsQueryVariables) {
      return { query: GetPreferredVendorsDocument, variables: variables }
    }
export const GetProgramUpdatesDocument = gql`
    query getProgramUpdates($lang: EnumContent_Program_UpdatesLanguage) {
  contentProgramUpdateMany(filter: {language: $lang, enabled: true}) {
    _id
    title
    description
    new
    important
    body
    key
    path
    alternate_path
    preview_image {
      _id
      src
      alt
    }
    enabled
    language
    legacy_id
    hero_image {
      _id
      src
      alt
    }
    post_date
    created_date
    modified_date
    button_label
    button_link
    created_by
    modified_by
  }
}
    `;

/**
 * __useGetProgramUpdatesQuery__
 *
 * To run a query within a React component, call `useGetProgramUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramUpdatesQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetProgramUpdatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProgramUpdatesQuery, GetProgramUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProgramUpdatesQuery, GetProgramUpdatesQueryVariables>(GetProgramUpdatesDocument, options);
      }
export function useGetProgramUpdatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgramUpdatesQuery, GetProgramUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProgramUpdatesQuery, GetProgramUpdatesQueryVariables>(GetProgramUpdatesDocument, options);
        }
export function useGetProgramUpdatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProgramUpdatesQuery, GetProgramUpdatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProgramUpdatesQuery, GetProgramUpdatesQueryVariables>(GetProgramUpdatesDocument, options);
        }
export type GetProgramUpdatesQueryHookResult = ReturnType<typeof useGetProgramUpdatesQuery>;
export type GetProgramUpdatesLazyQueryHookResult = ReturnType<typeof useGetProgramUpdatesLazyQuery>;
export type GetProgramUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetProgramUpdatesSuspenseQuery>;
export type GetProgramUpdatesQueryResult = ApolloReactCommon.QueryResult<GetProgramUpdatesQuery, GetProgramUpdatesQueryVariables>;
export function refetchGetProgramUpdatesQuery(variables?: GetProgramUpdatesQueryVariables) {
      return { query: GetProgramUpdatesDocument, variables: variables }
    }
export const UpdateVendorCheckpointDocument = gql`
    mutation updateVendorCheckpoint($questionCodes: [String], $unitCodes: [String], $status: String, $assigned: String) {
  updateCheckpointState(
    questionCodes: $questionCodes
    unitCodes: $unitCodes
    status: $status
    assigned: $assigned
  )
}
    `;
export type UpdateVendorCheckpointMutationFn = ApolloReactCommon.MutationFunction<UpdateVendorCheckpointMutation, UpdateVendorCheckpointMutationVariables>;

/**
 * __useUpdateVendorCheckpointMutation__
 *
 * To run a mutation, you first call `useUpdateVendorCheckpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorCheckpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorCheckpointMutation, { data, loading, error }] = useUpdateVendorCheckpointMutation({
 *   variables: {
 *      questionCodes: // value for 'questionCodes'
 *      unitCodes: // value for 'unitCodes'
 *      status: // value for 'status'
 *      assigned: // value for 'assigned'
 *   },
 * });
 */
export function useUpdateVendorCheckpointMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVendorCheckpointMutation, UpdateVendorCheckpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateVendorCheckpointMutation, UpdateVendorCheckpointMutationVariables>(UpdateVendorCheckpointDocument, options);
      }
export type UpdateVendorCheckpointMutationHookResult = ReturnType<typeof useUpdateVendorCheckpointMutation>;
export type UpdateVendorCheckpointMutationResult = ApolloReactCommon.MutationResult<UpdateVendorCheckpointMutation>;
export type UpdateVendorCheckpointMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateVendorCheckpointMutation, UpdateVendorCheckpointMutationVariables>;
export const DealerNameFromTokenDocument = gql`
    query dealerNameFromToken {
  unitNameByUser
  unitCodeByUser
}
    `;

/**
 * __useDealerNameFromTokenQuery__
 *
 * To run a query within a React component, call `useDealerNameFromTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealerNameFromTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealerNameFromTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useDealerNameFromTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DealerNameFromTokenQuery, DealerNameFromTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DealerNameFromTokenQuery, DealerNameFromTokenQueryVariables>(DealerNameFromTokenDocument, options);
      }
export function useDealerNameFromTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DealerNameFromTokenQuery, DealerNameFromTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DealerNameFromTokenQuery, DealerNameFromTokenQueryVariables>(DealerNameFromTokenDocument, options);
        }
export function useDealerNameFromTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DealerNameFromTokenQuery, DealerNameFromTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DealerNameFromTokenQuery, DealerNameFromTokenQueryVariables>(DealerNameFromTokenDocument, options);
        }
export type DealerNameFromTokenQueryHookResult = ReturnType<typeof useDealerNameFromTokenQuery>;
export type DealerNameFromTokenLazyQueryHookResult = ReturnType<typeof useDealerNameFromTokenLazyQuery>;
export type DealerNameFromTokenSuspenseQueryHookResult = ReturnType<typeof useDealerNameFromTokenSuspenseQuery>;
export type DealerNameFromTokenQueryResult = ApolloReactCommon.QueryResult<DealerNameFromTokenQuery, DealerNameFromTokenQueryVariables>;
export function refetchDealerNameFromTokenQuery(variables?: DealerNameFromTokenQueryVariables) {
      return { query: DealerNameFromTokenDocument, variables: variables }
    }
export const VendorNameFromTokenDocument = gql`
    query vendorNameFromToken {
  portalContextVendorNameFromToken
}
    `;

/**
 * __useVendorNameFromTokenQuery__
 *
 * To run a query within a React component, call `useVendorNameFromTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorNameFromTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorNameFromTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useVendorNameFromTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VendorNameFromTokenQuery, VendorNameFromTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VendorNameFromTokenQuery, VendorNameFromTokenQueryVariables>(VendorNameFromTokenDocument, options);
      }
export function useVendorNameFromTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VendorNameFromTokenQuery, VendorNameFromTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VendorNameFromTokenQuery, VendorNameFromTokenQueryVariables>(VendorNameFromTokenDocument, options);
        }
export function useVendorNameFromTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VendorNameFromTokenQuery, VendorNameFromTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VendorNameFromTokenQuery, VendorNameFromTokenQueryVariables>(VendorNameFromTokenDocument, options);
        }
export type VendorNameFromTokenQueryHookResult = ReturnType<typeof useVendorNameFromTokenQuery>;
export type VendorNameFromTokenLazyQueryHookResult = ReturnType<typeof useVendorNameFromTokenLazyQuery>;
export type VendorNameFromTokenSuspenseQueryHookResult = ReturnType<typeof useVendorNameFromTokenSuspenseQuery>;
export type VendorNameFromTokenQueryResult = ApolloReactCommon.QueryResult<VendorNameFromTokenQuery, VendorNameFromTokenQueryVariables>;
export function refetchVendorNameFromTokenQuery(variables?: VendorNameFromTokenQueryVariables) {
      return { query: VendorNameFromTokenDocument, variables: variables }
    }
export const GetIsMultiDealerDocument = gql`
    query getIsMultiDealer {
  portalContextProgressReportIsMultiDealer
}
    `;

/**
 * __useGetIsMultiDealerQuery__
 *
 * To run a query within a React component, call `useGetIsMultiDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsMultiDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsMultiDealerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsMultiDealerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIsMultiDealerQuery, GetIsMultiDealerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIsMultiDealerQuery, GetIsMultiDealerQueryVariables>(GetIsMultiDealerDocument, options);
      }
export function useGetIsMultiDealerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIsMultiDealerQuery, GetIsMultiDealerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIsMultiDealerQuery, GetIsMultiDealerQueryVariables>(GetIsMultiDealerDocument, options);
        }
export function useGetIsMultiDealerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIsMultiDealerQuery, GetIsMultiDealerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIsMultiDealerQuery, GetIsMultiDealerQueryVariables>(GetIsMultiDealerDocument, options);
        }
export type GetIsMultiDealerQueryHookResult = ReturnType<typeof useGetIsMultiDealerQuery>;
export type GetIsMultiDealerLazyQueryHookResult = ReturnType<typeof useGetIsMultiDealerLazyQuery>;
export type GetIsMultiDealerSuspenseQueryHookResult = ReturnType<typeof useGetIsMultiDealerSuspenseQuery>;
export type GetIsMultiDealerQueryResult = ApolloReactCommon.QueryResult<GetIsMultiDealerQuery, GetIsMultiDealerQueryVariables>;
export function refetchGetIsMultiDealerQuery(variables?: GetIsMultiDealerQueryVariables) {
      return { query: GetIsMultiDealerDocument, variables: variables }
    }
export const GetDealerProgressHomeDocument = gql`
    query getDealerProgressHome {
  portalContextProgressReportByPriority {
    CRITICAL {
      ...ProgressReportItem
    }
    SIGNIFICANT {
      ...ProgressReportItem
    }
    FUNDAMENTAL {
      ...ProgressReportItem
    }
    PROGRESSIVE {
      ...ProgressReportItem
    }
    EVOLVED {
      ...ProgressReportItem
    }
  }
  portalContextProgressReportByStatus {
    todo {
      ...ProgressReportItem
    }
    revise {
      ...ProgressReportItem
    }
  }
}
    ${ProgressReportItemFragmentDoc}`;

/**
 * __useGetDealerProgressHomeQuery__
 *
 * To run a query within a React component, call `useGetDealerProgressHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerProgressHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerProgressHomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDealerProgressHomeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDealerProgressHomeQuery, GetDealerProgressHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealerProgressHomeQuery, GetDealerProgressHomeQueryVariables>(GetDealerProgressHomeDocument, options);
      }
export function useGetDealerProgressHomeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealerProgressHomeQuery, GetDealerProgressHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealerProgressHomeQuery, GetDealerProgressHomeQueryVariables>(GetDealerProgressHomeDocument, options);
        }
export function useGetDealerProgressHomeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealerProgressHomeQuery, GetDealerProgressHomeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealerProgressHomeQuery, GetDealerProgressHomeQueryVariables>(GetDealerProgressHomeDocument, options);
        }
export type GetDealerProgressHomeQueryHookResult = ReturnType<typeof useGetDealerProgressHomeQuery>;
export type GetDealerProgressHomeLazyQueryHookResult = ReturnType<typeof useGetDealerProgressHomeLazyQuery>;
export type GetDealerProgressHomeSuspenseQueryHookResult = ReturnType<typeof useGetDealerProgressHomeSuspenseQuery>;
export type GetDealerProgressHomeQueryResult = ApolloReactCommon.QueryResult<GetDealerProgressHomeQuery, GetDealerProgressHomeQueryVariables>;
export function refetchGetDealerProgressHomeQuery(variables?: GetDealerProgressHomeQueryVariables) {
      return { query: GetDealerProgressHomeDocument, variables: variables }
    }
export const GetDealerStatusReportDocument = gql`
    query getDealerStatusReport {
  portalContextProgressReportByStatus {
    todo {
      ...ProgressReportItem
    }
    revise {
      ...ProgressReportItem
    }
    inreview {
      ...ProgressReportItem
    }
    completed {
      ...ProgressReportItem
    }
  }
}
    ${ProgressReportItemFragmentDoc}`;

/**
 * __useGetDealerStatusReportQuery__
 *
 * To run a query within a React component, call `useGetDealerStatusReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerStatusReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerStatusReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDealerStatusReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDealerStatusReportQuery, GetDealerStatusReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDealerStatusReportQuery, GetDealerStatusReportQueryVariables>(GetDealerStatusReportDocument, options);
      }
export function useGetDealerStatusReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDealerStatusReportQuery, GetDealerStatusReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDealerStatusReportQuery, GetDealerStatusReportQueryVariables>(GetDealerStatusReportDocument, options);
        }
export function useGetDealerStatusReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetDealerStatusReportQuery, GetDealerStatusReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetDealerStatusReportQuery, GetDealerStatusReportQueryVariables>(GetDealerStatusReportDocument, options);
        }
export type GetDealerStatusReportQueryHookResult = ReturnType<typeof useGetDealerStatusReportQuery>;
export type GetDealerStatusReportLazyQueryHookResult = ReturnType<typeof useGetDealerStatusReportLazyQuery>;
export type GetDealerStatusReportSuspenseQueryHookResult = ReturnType<typeof useGetDealerStatusReportSuspenseQuery>;
export type GetDealerStatusReportQueryResult = ApolloReactCommon.QueryResult<GetDealerStatusReportQuery, GetDealerStatusReportQueryVariables>;
export function refetchGetDealerStatusReportQuery(variables?: GetDealerStatusReportQueryVariables) {
      return { query: GetDealerStatusReportDocument, variables: variables }
    }
export const GetProgressReportQuestionByCodeDocument = gql`
    query getProgressReportQuestionByCode($unitCode: String!, $questionCode: String!) {
  portalContextProgressReportQuestionById(
    unitCode: $unitCode
    questionCode: $questionCode
  ) {
    dealer {
      vendorCode
      vendorName
      firstDivisionCode
      secondDivisionCode
      dealerName
    }
    question {
      ...ProgressReportItem
    }
  }
}
    ${ProgressReportItemFragmentDoc}`;

/**
 * __useGetProgressReportQuestionByCodeQuery__
 *
 * To run a query within a React component, call `useGetProgressReportQuestionByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressReportQuestionByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressReportQuestionByCodeQuery({
 *   variables: {
 *      unitCode: // value for 'unitCode'
 *      questionCode: // value for 'questionCode'
 *   },
 * });
 */
export function useGetProgressReportQuestionByCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProgressReportQuestionByCodeQuery, GetProgressReportQuestionByCodeQueryVariables> & ({ variables: GetProgressReportQuestionByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProgressReportQuestionByCodeQuery, GetProgressReportQuestionByCodeQueryVariables>(GetProgressReportQuestionByCodeDocument, options);
      }
export function useGetProgressReportQuestionByCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProgressReportQuestionByCodeQuery, GetProgressReportQuestionByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProgressReportQuestionByCodeQuery, GetProgressReportQuestionByCodeQueryVariables>(GetProgressReportQuestionByCodeDocument, options);
        }
export function useGetProgressReportQuestionByCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProgressReportQuestionByCodeQuery, GetProgressReportQuestionByCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProgressReportQuestionByCodeQuery, GetProgressReportQuestionByCodeQueryVariables>(GetProgressReportQuestionByCodeDocument, options);
        }
export type GetProgressReportQuestionByCodeQueryHookResult = ReturnType<typeof useGetProgressReportQuestionByCodeQuery>;
export type GetProgressReportQuestionByCodeLazyQueryHookResult = ReturnType<typeof useGetProgressReportQuestionByCodeLazyQuery>;
export type GetProgressReportQuestionByCodeSuspenseQueryHookResult = ReturnType<typeof useGetProgressReportQuestionByCodeSuspenseQuery>;
export type GetProgressReportQuestionByCodeQueryResult = ApolloReactCommon.QueryResult<GetProgressReportQuestionByCodeQuery, GetProgressReportQuestionByCodeQueryVariables>;
export function refetchGetProgressReportQuestionByCodeQuery(variables: GetProgressReportQuestionByCodeQueryVariables) {
      return { query: GetProgressReportQuestionByCodeDocument, variables: variables }
    }
export const GetAssessmentLabelsDocument = gql`
    query getAssessmentLabels {
  portalContextAssessmentLabelOne {
    assessmentLabel {
      EN
      FR
    }
    categories {
      categoryCode
      categoryLabel {
        EN
        FR
      }
    }
    questions {
      questionCode
      categoryLabel {
        EN
        FR
      }
      improvement {
        EN
        FR
      }
      resource {
        EN {
          title
          url
        }
        FR {
          title
          url
        }
      }
      videoLink {
        EN
        FR
      }
      questionLabel {
        EN
        FR
      }
      questionRationale {
        EN
        FR
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentLabelsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssessmentLabelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAssessmentLabelsQuery, GetAssessmentLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAssessmentLabelsQuery, GetAssessmentLabelsQueryVariables>(GetAssessmentLabelsDocument, options);
      }
export function useGetAssessmentLabelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAssessmentLabelsQuery, GetAssessmentLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAssessmentLabelsQuery, GetAssessmentLabelsQueryVariables>(GetAssessmentLabelsDocument, options);
        }
export function useGetAssessmentLabelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAssessmentLabelsQuery, GetAssessmentLabelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAssessmentLabelsQuery, GetAssessmentLabelsQueryVariables>(GetAssessmentLabelsDocument, options);
        }
export type GetAssessmentLabelsQueryHookResult = ReturnType<typeof useGetAssessmentLabelsQuery>;
export type GetAssessmentLabelsLazyQueryHookResult = ReturnType<typeof useGetAssessmentLabelsLazyQuery>;
export type GetAssessmentLabelsSuspenseQueryHookResult = ReturnType<typeof useGetAssessmentLabelsSuspenseQuery>;
export type GetAssessmentLabelsQueryResult = ApolloReactCommon.QueryResult<GetAssessmentLabelsQuery, GetAssessmentLabelsQueryVariables>;
export function refetchGetAssessmentLabelsQuery(variables?: GetAssessmentLabelsQueryVariables) {
      return { query: GetAssessmentLabelsDocument, variables: variables }
    }
export const GetManagementProgressHomeDocument = gql`
    query getManagementProgressHome($division: String, $unitCode: String, $vendorCode: String) {
  portalContextManagementDealerFilters(
    division: $division
    unitCode: $unitCode
    vendorCode: $vendorCode
  ) {
    dealers {
      unitCode
      dealerName
      firstDivisionCode
      secondDivisionCode
    }
    divisions
    vendor {
      vendorCode
      vendorName
    }
  }
  portalContextManagementProgressHome(
    division: $division
    unitCode: $unitCode
    vendorCode: $vendorCode
  ) {
    CRITICAL {
      ...ManagementProgressHomeFragment
    }
    SIGNIFICANT {
      ...ManagementProgressHomeFragment
    }
    FUNDAMENTAL {
      ...ManagementProgressHomeFragment
    }
    PROGRESSIVE {
      ...ManagementProgressHomeFragment
    }
    EVOLVED {
      ...ManagementProgressHomeFragment
    }
  }
}
    ${ManagementProgressHomeFragmentFragmentDoc}`;

/**
 * __useGetManagementProgressHomeQuery__
 *
 * To run a query within a React component, call `useGetManagementProgressHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementProgressHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementProgressHomeQuery({
 *   variables: {
 *      division: // value for 'division'
 *      unitCode: // value for 'unitCode'
 *      vendorCode: // value for 'vendorCode'
 *   },
 * });
 */
export function useGetManagementProgressHomeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetManagementProgressHomeQuery, GetManagementProgressHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManagementProgressHomeQuery, GetManagementProgressHomeQueryVariables>(GetManagementProgressHomeDocument, options);
      }
export function useGetManagementProgressHomeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManagementProgressHomeQuery, GetManagementProgressHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManagementProgressHomeQuery, GetManagementProgressHomeQueryVariables>(GetManagementProgressHomeDocument, options);
        }
export function useGetManagementProgressHomeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManagementProgressHomeQuery, GetManagementProgressHomeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManagementProgressHomeQuery, GetManagementProgressHomeQueryVariables>(GetManagementProgressHomeDocument, options);
        }
export type GetManagementProgressHomeQueryHookResult = ReturnType<typeof useGetManagementProgressHomeQuery>;
export type GetManagementProgressHomeLazyQueryHookResult = ReturnType<typeof useGetManagementProgressHomeLazyQuery>;
export type GetManagementProgressHomeSuspenseQueryHookResult = ReturnType<typeof useGetManagementProgressHomeSuspenseQuery>;
export type GetManagementProgressHomeQueryResult = ApolloReactCommon.QueryResult<GetManagementProgressHomeQuery, GetManagementProgressHomeQueryVariables>;
export function refetchGetManagementProgressHomeQuery(variables?: GetManagementProgressHomeQueryVariables) {
      return { query: GetManagementProgressHomeDocument, variables: variables }
    }
export const GetManagementHomeSummaryDocument = gql`
    query getManagementHomeSummary($unitCode: String) {
  portalContextManagementProgressHomeSummary(unitCode: $unitCode) {
    averageScore
    averageScoreChange
    bestCategory {
      averageScore
      scoreChange
      category
    }
    worstCategory {
      averageScore
      scoreChange
      category
    }
  }
}
    `;

/**
 * __useGetManagementHomeSummaryQuery__
 *
 * To run a query within a React component, call `useGetManagementHomeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementHomeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementHomeSummaryQuery({
 *   variables: {
 *      unitCode: // value for 'unitCode'
 *   },
 * });
 */
export function useGetManagementHomeSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetManagementHomeSummaryQuery, GetManagementHomeSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManagementHomeSummaryQuery, GetManagementHomeSummaryQueryVariables>(GetManagementHomeSummaryDocument, options);
      }
export function useGetManagementHomeSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManagementHomeSummaryQuery, GetManagementHomeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManagementHomeSummaryQuery, GetManagementHomeSummaryQueryVariables>(GetManagementHomeSummaryDocument, options);
        }
export function useGetManagementHomeSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManagementHomeSummaryQuery, GetManagementHomeSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManagementHomeSummaryQuery, GetManagementHomeSummaryQueryVariables>(GetManagementHomeSummaryDocument, options);
        }
export type GetManagementHomeSummaryQueryHookResult = ReturnType<typeof useGetManagementHomeSummaryQuery>;
export type GetManagementHomeSummaryLazyQueryHookResult = ReturnType<typeof useGetManagementHomeSummaryLazyQuery>;
export type GetManagementHomeSummarySuspenseQueryHookResult = ReturnType<typeof useGetManagementHomeSummarySuspenseQuery>;
export type GetManagementHomeSummaryQueryResult = ApolloReactCommon.QueryResult<GetManagementHomeSummaryQuery, GetManagementHomeSummaryQueryVariables>;
export function refetchGetManagementHomeSummaryQuery(variables?: GetManagementHomeSummaryQueryVariables) {
      return { query: GetManagementHomeSummaryDocument, variables: variables }
    }
export const GetManagementDealerRanksDocument = gql`
    query getManagementDealerRanks {
  portalContextManagementDealerRanks {
    dealerName
    assessmentManagerRank
    score
    roundedScore
    previousScore
    tapEligible
  }
}
    `;

/**
 * __useGetManagementDealerRanksQuery__
 *
 * To run a query within a React component, call `useGetManagementDealerRanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementDealerRanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementDealerRanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagementDealerRanksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetManagementDealerRanksQuery, GetManagementDealerRanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManagementDealerRanksQuery, GetManagementDealerRanksQueryVariables>(GetManagementDealerRanksDocument, options);
      }
export function useGetManagementDealerRanksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManagementDealerRanksQuery, GetManagementDealerRanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManagementDealerRanksQuery, GetManagementDealerRanksQueryVariables>(GetManagementDealerRanksDocument, options);
        }
export function useGetManagementDealerRanksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManagementDealerRanksQuery, GetManagementDealerRanksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManagementDealerRanksQuery, GetManagementDealerRanksQueryVariables>(GetManagementDealerRanksDocument, options);
        }
export type GetManagementDealerRanksQueryHookResult = ReturnType<typeof useGetManagementDealerRanksQuery>;
export type GetManagementDealerRanksLazyQueryHookResult = ReturnType<typeof useGetManagementDealerRanksLazyQuery>;
export type GetManagementDealerRanksSuspenseQueryHookResult = ReturnType<typeof useGetManagementDealerRanksSuspenseQuery>;
export type GetManagementDealerRanksQueryResult = ApolloReactCommon.QueryResult<GetManagementDealerRanksQuery, GetManagementDealerRanksQueryVariables>;
export function refetchGetManagementDealerRanksQuery(variables?: GetManagementDealerRanksQueryVariables) {
      return { query: GetManagementDealerRanksDocument, variables: variables }
    }
export const GetManagementDivisionDisplayDocument = gql`
    query getManagementDivisionDisplay {
  portalContextManagementDivisionDisplay
}
    `;

/**
 * __useGetManagementDivisionDisplayQuery__
 *
 * To run a query within a React component, call `useGetManagementDivisionDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementDivisionDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementDivisionDisplayQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagementDivisionDisplayQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetManagementDivisionDisplayQuery, GetManagementDivisionDisplayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManagementDivisionDisplayQuery, GetManagementDivisionDisplayQueryVariables>(GetManagementDivisionDisplayDocument, options);
      }
export function useGetManagementDivisionDisplayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManagementDivisionDisplayQuery, GetManagementDivisionDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManagementDivisionDisplayQuery, GetManagementDivisionDisplayQueryVariables>(GetManagementDivisionDisplayDocument, options);
        }
export function useGetManagementDivisionDisplaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManagementDivisionDisplayQuery, GetManagementDivisionDisplayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManagementDivisionDisplayQuery, GetManagementDivisionDisplayQueryVariables>(GetManagementDivisionDisplayDocument, options);
        }
export type GetManagementDivisionDisplayQueryHookResult = ReturnType<typeof useGetManagementDivisionDisplayQuery>;
export type GetManagementDivisionDisplayLazyQueryHookResult = ReturnType<typeof useGetManagementDivisionDisplayLazyQuery>;
export type GetManagementDivisionDisplaySuspenseQueryHookResult = ReturnType<typeof useGetManagementDivisionDisplaySuspenseQuery>;
export type GetManagementDivisionDisplayQueryResult = ApolloReactCommon.QueryResult<GetManagementDivisionDisplayQuery, GetManagementDivisionDisplayQueryVariables>;
export function refetchGetManagementDivisionDisplayQuery(variables?: GetManagementDivisionDisplayQueryVariables) {
      return { query: GetManagementDivisionDisplayDocument, variables: variables }
    }
export const GetVendorProgressHomeDocument = gql`
    query getVendorProgressHome($unitCode: String) {
  portalContextVendorDealerFilters {
    dealers {
      unitCode
      dealerName
    }
  }
  portalContextVendorProgressHome(unitCode: $unitCode) {
    CRITICAL {
      ...ManagementProgressHomeFragment
    }
    SIGNIFICANT {
      ...ManagementProgressHomeFragment
    }
    FUNDAMENTAL {
      ...ManagementProgressHomeFragment
    }
    PROGRESSIVE {
      ...ManagementProgressHomeFragment
    }
    EVOLVED {
      ...ManagementProgressHomeFragment
    }
  }
  portalContextVendorProgressHomeRevisions(unitCode: $unitCode) {
    questionCode
    priority
    unitCode
    vendorCode
    categoryCode
    vendorName
    dealerName
    assigned
    status
    answerValue
  }
}
    ${ManagementProgressHomeFragmentFragmentDoc}`;

/**
 * __useGetVendorProgressHomeQuery__
 *
 * To run a query within a React component, call `useGetVendorProgressHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorProgressHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorProgressHomeQuery({
 *   variables: {
 *      unitCode: // value for 'unitCode'
 *   },
 * });
 */
export function useGetVendorProgressHomeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVendorProgressHomeQuery, GetVendorProgressHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVendorProgressHomeQuery, GetVendorProgressHomeQueryVariables>(GetVendorProgressHomeDocument, options);
      }
export function useGetVendorProgressHomeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVendorProgressHomeQuery, GetVendorProgressHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVendorProgressHomeQuery, GetVendorProgressHomeQueryVariables>(GetVendorProgressHomeDocument, options);
        }
export function useGetVendorProgressHomeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVendorProgressHomeQuery, GetVendorProgressHomeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVendorProgressHomeQuery, GetVendorProgressHomeQueryVariables>(GetVendorProgressHomeDocument, options);
        }
export type GetVendorProgressHomeQueryHookResult = ReturnType<typeof useGetVendorProgressHomeQuery>;
export type GetVendorProgressHomeLazyQueryHookResult = ReturnType<typeof useGetVendorProgressHomeLazyQuery>;
export type GetVendorProgressHomeSuspenseQueryHookResult = ReturnType<typeof useGetVendorProgressHomeSuspenseQuery>;
export type GetVendorProgressHomeQueryResult = ApolloReactCommon.QueryResult<GetVendorProgressHomeQuery, GetVendorProgressHomeQueryVariables>;
export function refetchGetVendorProgressHomeQuery(variables?: GetVendorProgressHomeQueryVariables) {
      return { query: GetVendorProgressHomeDocument, variables: variables }
    }
export const GetVendorHomeSummaryDocument = gql`
    query getVendorHomeSummary($unitCode: String) {
  portalContextVendorProgressHomeSummary(unitCode: $unitCode) {
    averageScore
    averageScoreChange
    bestCategory {
      averageScore
      scoreChange
      category
    }
    worstCategory {
      averageScore
      scoreChange
      category
    }
  }
}
    `;

/**
 * __useGetVendorHomeSummaryQuery__
 *
 * To run a query within a React component, call `useGetVendorHomeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorHomeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorHomeSummaryQuery({
 *   variables: {
 *      unitCode: // value for 'unitCode'
 *   },
 * });
 */
export function useGetVendorHomeSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVendorHomeSummaryQuery, GetVendorHomeSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVendorHomeSummaryQuery, GetVendorHomeSummaryQueryVariables>(GetVendorHomeSummaryDocument, options);
      }
export function useGetVendorHomeSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVendorHomeSummaryQuery, GetVendorHomeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVendorHomeSummaryQuery, GetVendorHomeSummaryQueryVariables>(GetVendorHomeSummaryDocument, options);
        }
export function useGetVendorHomeSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVendorHomeSummaryQuery, GetVendorHomeSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVendorHomeSummaryQuery, GetVendorHomeSummaryQueryVariables>(GetVendorHomeSummaryDocument, options);
        }
export type GetVendorHomeSummaryQueryHookResult = ReturnType<typeof useGetVendorHomeSummaryQuery>;
export type GetVendorHomeSummaryLazyQueryHookResult = ReturnType<typeof useGetVendorHomeSummaryLazyQuery>;
export type GetVendorHomeSummarySuspenseQueryHookResult = ReturnType<typeof useGetVendorHomeSummarySuspenseQuery>;
export type GetVendorHomeSummaryQueryResult = ApolloReactCommon.QueryResult<GetVendorHomeSummaryQuery, GetVendorHomeSummaryQueryVariables>;
export function refetchGetVendorHomeSummaryQuery(variables?: GetVendorHomeSummaryQueryVariables) {
      return { query: GetVendorHomeSummaryDocument, variables: variables }
    }
export const GetVendorDealerRanksDocument = gql`
    query getVendorDealerRanks {
  portalContextVendorDealerRanks {
    dealerName
    assessmentManagerRank
    score
    roundedScore
    previousScore
  }
}
    `;

/**
 * __useGetVendorDealerRanksQuery__
 *
 * To run a query within a React component, call `useGetVendorDealerRanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorDealerRanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorDealerRanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVendorDealerRanksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVendorDealerRanksQuery, GetVendorDealerRanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVendorDealerRanksQuery, GetVendorDealerRanksQueryVariables>(GetVendorDealerRanksDocument, options);
      }
export function useGetVendorDealerRanksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVendorDealerRanksQuery, GetVendorDealerRanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVendorDealerRanksQuery, GetVendorDealerRanksQueryVariables>(GetVendorDealerRanksDocument, options);
        }
export function useGetVendorDealerRanksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVendorDealerRanksQuery, GetVendorDealerRanksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVendorDealerRanksQuery, GetVendorDealerRanksQueryVariables>(GetVendorDealerRanksDocument, options);
        }
export type GetVendorDealerRanksQueryHookResult = ReturnType<typeof useGetVendorDealerRanksQuery>;
export type GetVendorDealerRanksLazyQueryHookResult = ReturnType<typeof useGetVendorDealerRanksLazyQuery>;
export type GetVendorDealerRanksSuspenseQueryHookResult = ReturnType<typeof useGetVendorDealerRanksSuspenseQuery>;
export type GetVendorDealerRanksQueryResult = ApolloReactCommon.QueryResult<GetVendorDealerRanksQuery, GetVendorDealerRanksQueryVariables>;
export function refetchGetVendorDealerRanksQuery(variables?: GetVendorDealerRanksQueryVariables) {
      return { query: GetVendorDealerRanksDocument, variables: variables }
    }
export const GetVendorStatusReportDocument = gql`
    query getVendorStatusReport($unitCode: String) {
  portalContextVendorDealerFilters {
    dealers {
      unitCode
      dealerName
    }
  }
  portalContextVendorProgressStatusReport(unitCode: $unitCode, groupBy: STATUS) {
    todo {
      ...ManagementProgressHomeFragment
    }
    revise {
      ...ManagementProgressHomeFragment
    }
    inreview {
      ...ManagementProgressHomeFragment
    }
    completed {
      ...ManagementProgressHomeFragment
    }
  }
}
    ${ManagementProgressHomeFragmentFragmentDoc}`;

/**
 * __useGetVendorStatusReportQuery__
 *
 * To run a query within a React component, call `useGetVendorStatusReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorStatusReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorStatusReportQuery({
 *   variables: {
 *      unitCode: // value for 'unitCode'
 *   },
 * });
 */
export function useGetVendorStatusReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVendorStatusReportQuery, GetVendorStatusReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVendorStatusReportQuery, GetVendorStatusReportQueryVariables>(GetVendorStatusReportDocument, options);
      }
export function useGetVendorStatusReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVendorStatusReportQuery, GetVendorStatusReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVendorStatusReportQuery, GetVendorStatusReportQueryVariables>(GetVendorStatusReportDocument, options);
        }
export function useGetVendorStatusReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVendorStatusReportQuery, GetVendorStatusReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVendorStatusReportQuery, GetVendorStatusReportQueryVariables>(GetVendorStatusReportDocument, options);
        }
export type GetVendorStatusReportQueryHookResult = ReturnType<typeof useGetVendorStatusReportQuery>;
export type GetVendorStatusReportLazyQueryHookResult = ReturnType<typeof useGetVendorStatusReportLazyQuery>;
export type GetVendorStatusReportSuspenseQueryHookResult = ReturnType<typeof useGetVendorStatusReportSuspenseQuery>;
export type GetVendorStatusReportQueryResult = ApolloReactCommon.QueryResult<GetVendorStatusReportQuery, GetVendorStatusReportQueryVariables>;
export function refetchGetVendorStatusReportQuery(variables?: GetVendorStatusReportQueryVariables) {
      return { query: GetVendorStatusReportDocument, variables: variables }
    }
export const GetOemProgressHomeDocument = gql`
    query getOemProgressHome($division: String, $unitCode: String, $status: String, $vendorCode: String) {
  portalContextOemDealerFilters(
    division: $division
    unitCode: $unitCode
    status: $status
    vendorCode: $vendorCode
  ) {
    dealers {
      unitCode
      dealerName
      firstDivisionCode
      secondDivisionCode
    }
    divisions
    status
    vendor {
      vendorCode
      vendorName
    }
  }
  portalContextOemProgressHome(
    division: $division
    unitCode: $unitCode
    status: $status
    vendorCode: $vendorCode
  ) {
    CRITICAL {
      ...ManagementProgressHomeFragment
    }
    SIGNIFICANT {
      ...ManagementProgressHomeFragment
    }
    FUNDAMENTAL {
      ...ManagementProgressHomeFragment
    }
    PROGRESSIVE {
      ...ManagementProgressHomeFragment
    }
    EVOLVED {
      ...ManagementProgressHomeFragment
    }
  }
}
    ${ManagementProgressHomeFragmentFragmentDoc}`;

/**
 * __useGetOemProgressHomeQuery__
 *
 * To run a query within a React component, call `useGetOemProgressHomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOemProgressHomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOemProgressHomeQuery({
 *   variables: {
 *      division: // value for 'division'
 *      unitCode: // value for 'unitCode'
 *      status: // value for 'status'
 *      vendorCode: // value for 'vendorCode'
 *   },
 * });
 */
export function useGetOemProgressHomeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOemProgressHomeQuery, GetOemProgressHomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOemProgressHomeQuery, GetOemProgressHomeQueryVariables>(GetOemProgressHomeDocument, options);
      }
export function useGetOemProgressHomeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOemProgressHomeQuery, GetOemProgressHomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOemProgressHomeQuery, GetOemProgressHomeQueryVariables>(GetOemProgressHomeDocument, options);
        }
export function useGetOemProgressHomeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOemProgressHomeQuery, GetOemProgressHomeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOemProgressHomeQuery, GetOemProgressHomeQueryVariables>(GetOemProgressHomeDocument, options);
        }
export type GetOemProgressHomeQueryHookResult = ReturnType<typeof useGetOemProgressHomeQuery>;
export type GetOemProgressHomeLazyQueryHookResult = ReturnType<typeof useGetOemProgressHomeLazyQuery>;
export type GetOemProgressHomeSuspenseQueryHookResult = ReturnType<typeof useGetOemProgressHomeSuspenseQuery>;
export type GetOemProgressHomeQueryResult = ApolloReactCommon.QueryResult<GetOemProgressHomeQuery, GetOemProgressHomeQueryVariables>;
export function refetchGetOemProgressHomeQuery(variables?: GetOemProgressHomeQueryVariables) {
      return { query: GetOemProgressHomeDocument, variables: variables }
    }
export const GetOemHomeSummaryDocument = gql`
    query getOemHomeSummary($division: String, $unitCode: String, $vendorCode: String) {
  portalContextOemProgressHomeSummary(
    division: $division
    unitCode: $unitCode
    vendorCode: $vendorCode
  ) {
    averageScore
    averageScoreChange
    bestCategory {
      averageScore
      scoreChange
      category
    }
    worstCategory {
      averageScore
      scoreChange
      category
    }
  }
}
    `;

/**
 * __useGetOemHomeSummaryQuery__
 *
 * To run a query within a React component, call `useGetOemHomeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOemHomeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOemHomeSummaryQuery({
 *   variables: {
 *      division: // value for 'division'
 *      unitCode: // value for 'unitCode'
 *      vendorCode: // value for 'vendorCode'
 *   },
 * });
 */
export function useGetOemHomeSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOemHomeSummaryQuery, GetOemHomeSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOemHomeSummaryQuery, GetOemHomeSummaryQueryVariables>(GetOemHomeSummaryDocument, options);
      }
export function useGetOemHomeSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOemHomeSummaryQuery, GetOemHomeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOemHomeSummaryQuery, GetOemHomeSummaryQueryVariables>(GetOemHomeSummaryDocument, options);
        }
export function useGetOemHomeSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOemHomeSummaryQuery, GetOemHomeSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOemHomeSummaryQuery, GetOemHomeSummaryQueryVariables>(GetOemHomeSummaryDocument, options);
        }
export type GetOemHomeSummaryQueryHookResult = ReturnType<typeof useGetOemHomeSummaryQuery>;
export type GetOemHomeSummaryLazyQueryHookResult = ReturnType<typeof useGetOemHomeSummaryLazyQuery>;
export type GetOemHomeSummarySuspenseQueryHookResult = ReturnType<typeof useGetOemHomeSummarySuspenseQuery>;
export type GetOemHomeSummaryQueryResult = ApolloReactCommon.QueryResult<GetOemHomeSummaryQuery, GetOemHomeSummaryQueryVariables>;
export function refetchGetOemHomeSummaryQuery(variables?: GetOemHomeSummaryQueryVariables) {
      return { query: GetOemHomeSummaryDocument, variables: variables }
    }
export const GetOemStatusReportDocument = gql`
    query getOemStatusReport($division: String, $unitCode: String, $status: String, $vendorCode: String) {
  portalContextOemDealerFilters {
    dealers {
      unitCode
      dealerName
      firstDivisionCode
      secondDivisionCode
    }
    divisions
    status
    vendor {
      vendorCode
      vendorName
    }
  }
  portalContextOemProgressStatusReport(
    unitCode: $unitCode
    division: $division
    status: $status
    vendorCode: $vendorCode
    groupBy: STATUS
  ) {
    todo {
      ...ManagementProgressHomeFragment
    }
    revise {
      ...ManagementProgressHomeFragment
    }
    inreview {
      ...ManagementProgressHomeFragment
    }
    completed {
      ...ManagementProgressHomeFragment
    }
  }
}
    ${ManagementProgressHomeFragmentFragmentDoc}`;

/**
 * __useGetOemStatusReportQuery__
 *
 * To run a query within a React component, call `useGetOemStatusReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOemStatusReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOemStatusReportQuery({
 *   variables: {
 *      division: // value for 'division'
 *      unitCode: // value for 'unitCode'
 *      status: // value for 'status'
 *      vendorCode: // value for 'vendorCode'
 *   },
 * });
 */
export function useGetOemStatusReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOemStatusReportQuery, GetOemStatusReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOemStatusReportQuery, GetOemStatusReportQueryVariables>(GetOemStatusReportDocument, options);
      }
export function useGetOemStatusReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOemStatusReportQuery, GetOemStatusReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOemStatusReportQuery, GetOemStatusReportQueryVariables>(GetOemStatusReportDocument, options);
        }
export function useGetOemStatusReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOemStatusReportQuery, GetOemStatusReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOemStatusReportQuery, GetOemStatusReportQueryVariables>(GetOemStatusReportDocument, options);
        }
export type GetOemStatusReportQueryHookResult = ReturnType<typeof useGetOemStatusReportQuery>;
export type GetOemStatusReportLazyQueryHookResult = ReturnType<typeof useGetOemStatusReportLazyQuery>;
export type GetOemStatusReportSuspenseQueryHookResult = ReturnType<typeof useGetOemStatusReportSuspenseQuery>;
export type GetOemStatusReportQueryResult = ApolloReactCommon.QueryResult<GetOemStatusReportQuery, GetOemStatusReportQueryVariables>;
export function refetchGetOemStatusReportQuery(variables?: GetOemStatusReportQueryVariables) {
      return { query: GetOemStatusReportDocument, variables: variables }
    }
export const GetOemDealerRanksDocument = gql`
    query getOemDealerRanks {
  portalContextOemDealerRanks {
    dealerName
    assessmentManagerRank
    score
    roundedScore
    previousScore
    tapEligible
  }
}
    `;

/**
 * __useGetOemDealerRanksQuery__
 *
 * To run a query within a React component, call `useGetOemDealerRanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOemDealerRanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOemDealerRanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOemDealerRanksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOemDealerRanksQuery, GetOemDealerRanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOemDealerRanksQuery, GetOemDealerRanksQueryVariables>(GetOemDealerRanksDocument, options);
      }
export function useGetOemDealerRanksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOemDealerRanksQuery, GetOemDealerRanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOemDealerRanksQuery, GetOemDealerRanksQueryVariables>(GetOemDealerRanksDocument, options);
        }
export function useGetOemDealerRanksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOemDealerRanksQuery, GetOemDealerRanksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOemDealerRanksQuery, GetOemDealerRanksQueryVariables>(GetOemDealerRanksDocument, options);
        }
export type GetOemDealerRanksQueryHookResult = ReturnType<typeof useGetOemDealerRanksQuery>;
export type GetOemDealerRanksLazyQueryHookResult = ReturnType<typeof useGetOemDealerRanksLazyQuery>;
export type GetOemDealerRanksSuspenseQueryHookResult = ReturnType<typeof useGetOemDealerRanksSuspenseQuery>;
export type GetOemDealerRanksQueryResult = ApolloReactCommon.QueryResult<GetOemDealerRanksQuery, GetOemDealerRanksQueryVariables>;
export function refetchGetOemDealerRanksQuery(variables?: GetOemDealerRanksQueryVariables) {
      return { query: GetOemDealerRanksDocument, variables: variables }
    }